export const cardListTest = {
    "T_01": {
        "id": "T_01",
        "face": {
            "front": {
                "name": "Battle droid",
                "type": "Unit - Ground",
                "cost": 0,
                "image": "https://swudb.com/images/cards/TTWI/T01.png",
                "isHorizontal": false
            }
        },
        "name": "Battle droid",
        "type": "Unit - Ground",
        "cost": 0,
        "rarity": "Token",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "TROOPER"
        ],
        "isToken": true
    },
    "T_02": {
        "id": "T_02",
        "face": {
            "front": {
                "name": "Clone trooper",
                "type": "Unit - Ground",
                "cost": 0,
                "image": "https://swudb.com/images/cards/TTWI/T02.png",
                "isHorizontal": false
            }
        },
        "name": "Clone trooper",
        "type": "Unit - Ground",
        "cost": 0,
        "rarity": "Token",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ],
        "isToken": true
    },
    "T_03": {
        "id": "T_03",
        "face": {
            "front": {
                "name": "Experience",
                "type": "Upgrade",
                "cost": 0,
                "image": "https://swudb.com/images/cards/GGTS/5.png",
                "isHorizontal": false
            }
        },
        "name": "Experience",
        "type": "Upgrade",
        "cost": 0,
        "rarity": "Token",
        "power": 0,
        "HP": 0,
        "aspects": [],
        "unique": false,
        "traits": [
            "LEARNED"
        ],
        "isToken": true
    },
    "T_04": {
        "id": "T_04",
        "face": {
            "front": {
                "name": "Shield",
                "type": "Upgrade",
                "cost": 0,
                "image": "https://swudb.com/images/cards/GGTS/6.png",
                "isHorizontal": false
            }
        },
        "name": "Shield",
        "type": "Upgrade",
        "cost": 0,
        "rarity": "Token",
        "power": 0,
        "HP": 0,
        "aspects": [],
        "unique": false,
        "traits": [
            "ARMOR"
        ],
        "isToken": true
    },
    "T_05": {
        "id": "T_05",
        "face": {
            "front": {
                "name": "TIE fighter",
                "type": "Unit - Space",
                "cost": 0,
                "image": "https://swudb.com/images/cards/TJTL/T01.png",
                "isHorizontal": false
            }
        },
        "name": "TIE fighter",
        "type": "Unit - Space",
        "cost": 0,
        "rarity": "Token",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "VEHICLE",
            "FIGHTER"
        ],
        "isToken": true
    },
    "T_06": {
        "id": "T_06",
        "face": {
            "front": {
                "name": "X-Wing",
                "type": "Unit - Space",
                "cost": 0,
                "image": "https://swudb.com/images/cards/TJTL/T02.png",
                "isHorizontal": false
            }
        },
        "name": "X-Wing",
        "type": "Unit - Space",
        "cost": 0,
        "rarity": "Token",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "VEHICLE",
            "FIGHTER"
        ],
        "isToken": true
    },
    "SOR_059": {
        "id": "SOR_059",
        "face": {
            "front": {
                "name": "2-1B Surgical Droid",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/059.png",
                "isHorizontal": false
            }
        },
        "name": "2-1B Surgical Droid",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "DROID"
        ]
    },
    "SOR_324": {
        "id": "SOR_324",
        "face": {
            "front": {
                "name": "2-1B Surgical Droid",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/324.png",
                "isHorizontal": false
            }
        },
        "name": "2-1B Surgical Droid",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "DROID"
        ]
    },
    "SOR_118": {
        "id": "SOR_118",
        "face": {
            "front": {
                "name": "97th Legion, Keeping the Peace on Sullust",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SOR/118.png",
                "isHorizontal": false
            }
        },
        "name": "97th Legion, Keeping the Peace on Sullust",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "SOR_382": {
        "id": "SOR_382",
        "face": {
            "front": {
                "name": "97th Legion, Keeping the Peace on Sullust",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SOR/382.png",
                "isHorizontal": false
            }
        },
        "name": "97th Legion, Keeping the Peace on Sullust",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "SOR_039": {
        "id": "SOR_039",
        "face": {
            "front": {
                "name": "AT-AT Suppressor",
                "type": "Unit - Ground",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/SOR/039.png",
                "isHorizontal": false
            }
        },
        "name": "AT-AT Suppressor",
        "type": "Unit - Ground",
        "cost": 8,
        "rarity": "Uncommon",
        "power": 8,
        "HP": 8,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "WALKER"
        ]
    },
    "SOR_305": {
        "id": "SOR_305",
        "face": {
            "front": {
                "name": "AT-AT Suppressor",
                "type": "Unit - Ground",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/SOR/305.png",
                "isHorizontal": false
            }
        },
        "name": "AT-AT Suppressor",
        "type": "Unit - Ground",
        "cost": 8,
        "rarity": "Uncommon",
        "power": 8,
        "HP": 8,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "WALKER"
        ]
    },
    "SOR_232": {
        "id": "SOR_232",
        "face": {
            "front": {
                "name": "AT-ST",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/232.png",
                "isHorizontal": false
            }
        },
        "name": "AT-ST",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 6,
        "HP": 7,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "WALKER"
        ]
    },
    "SOR_493": {
        "id": "SOR_493",
        "face": {
            "front": {
                "name": "AT-ST",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/493.png",
                "isHorizontal": false
            }
        },
        "name": "AT-ST",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 6,
        "HP": 7,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "WALKER"
        ]
    },
    "SOR_037": {
        "id": "SOR_037",
        "face": {
            "front": {
                "name": "Academy Defense Walker",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/037.png",
                "isHorizontal": false
            }
        },
        "name": "Academy Defense Walker",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "WALKER"
        ]
    },
    "SOR_303": {
        "id": "SOR_303",
        "face": {
            "front": {
                "name": "Academy Defense Walker",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/303.png",
                "isHorizontal": false
            }
        },
        "name": "Academy Defense Walker",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "WALKER"
        ]
    },
    "SOR_120": {
        "id": "SOR_120",
        "face": {
            "front": {
                "name": "Academy Training",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/120.png",
                "isHorizontal": false
            }
        },
        "name": "Academy Training",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "LEARNED"
        ]
    },
    "SOR_384": {
        "id": "SOR_384",
        "face": {
            "front": {
                "name": "Academy Training",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/384.png",
                "isHorizontal": false
            }
        },
        "name": "Academy Training",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "LEARNED"
        ]
    },
    "SOR_029": {
        "id": "SOR_029",
        "face": {
            "front": {
                "name": "Administrator's Tower, Cloud City",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SOR/029-r.png",
                "isHorizontal": true
            }
        },
        "name": "Administrator's Tower, Cloud City",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": []
    },
    "SOR_295": {
        "id": "SOR_295",
        "face": {
            "front": {
                "name": "Administrator's Tower, Cloud City",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SOR/295-r.png",
                "isHorizontal": true
            }
        },
        "name": "Administrator's Tower, Cloud City",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": []
    },
    "SOR_097": {
        "id": "SOR_097",
        "face": {
            "front": {
                "name": "Admiral Ackbar, Brilliant Strategist",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/097.png",
                "isHorizontal": false
            }
        },
        "name": "Admiral Ackbar, Brilliant Strategist",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Rare",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "OFFICIAL"
        ]
    },
    "SOR_361": {
        "id": "SOR_361",
        "face": {
            "front": {
                "name": "Admiral Ackbar, Brilliant Strategist",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/361.png",
                "isHorizontal": false
            }
        },
        "name": "Admiral Ackbar, Brilliant Strategist",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Rare",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "OFFICIAL"
        ]
    },
    "SOR_226": {
        "id": "SOR_226",
        "face": {
            "front": {
                "name": "Admiral Motti, Brazen and Scornful",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/226.png",
                "isHorizontal": false
            }
        },
        "name": "Admiral Motti, Brazen and Scornful",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Special",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "SOR_129": {
        "id": "SOR_129",
        "face": {
            "front": {
                "name": "Admiral Ozzel, Overconfident",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/129.png",
                "isHorizontal": false
            }
        },
        "name": "Admiral Ozzel, Overconfident",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "SOR_393": {
        "id": "SOR_393",
        "face": {
            "front": {
                "name": "Admiral Ozzel, Overconfident",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/393.png",
                "isHorizontal": false
            }
        },
        "name": "Admiral Ozzel, Overconfident",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "SOR_079": {
        "id": "SOR_079",
        "face": {
            "front": {
                "name": "Admiral Piett, Captain of the Executor",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/079.png",
                "isHorizontal": false
            }
        },
        "name": "Admiral Piett, Captain of the Executor",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "SOR_344": {
        "id": "SOR_344",
        "face": {
            "front": {
                "name": "Admiral Piett, Captain of the Executor",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/344.png",
                "isHorizontal": false
            }
        },
        "name": "Admiral Piett, Captain of the Executor",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "SOR_115": {
        "id": "SOR_115",
        "face": {
            "front": {
                "name": "Agent Kallus, Seeking the Rebels",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/115.png",
                "isHorizontal": false
            }
        },
        "name": "Agent Kallus, Seeking the Rebels",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Rare",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Command"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "SOR_379": {
        "id": "SOR_379",
        "face": {
            "front": {
                "name": "Agent Kallus, Seeking the Rebels",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/379.png",
                "isHorizontal": false
            }
        },
        "name": "Agent Kallus, Seeking the Rebels",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Rare",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Command"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "SOR_155": {
        "id": "SOR_155",
        "face": {
            "front": {
                "name": "Aggression",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/155.png",
                "isHorizontal": false
            }
        },
        "name": "Aggression",
        "type": "Event",
        "cost": 4,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SOR_418": {
        "id": "SOR_418",
        "face": {
            "front": {
                "name": "Aggression",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/418.png",
                "isHorizontal": false
            }
        },
        "name": "Aggression",
        "type": "Event",
        "cost": 4,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SOR_093": {
        "id": "SOR_093",
        "face": {
            "front": {
                "name": "Alliance Dispatcher",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/093.png",
                "isHorizontal": false
            }
        },
        "name": "Alliance Dispatcher",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 2,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL"
        ]
    },
    "SOR_357": {
        "id": "SOR_357",
        "face": {
            "front": {
                "name": "Alliance Dispatcher",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/357.png",
                "isHorizontal": false
            }
        },
        "name": "Alliance Dispatcher",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 2,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL"
        ]
    },
    "SOR_237": {
        "id": "SOR_237",
        "face": {
            "front": {
                "name": "Alliance X-Wing",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/237.png",
                "isHorizontal": false
            }
        },
        "name": "Alliance X-Wing",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_496": {
        "id": "SOR_496",
        "face": {
            "front": {
                "name": "Alliance X-Wing",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/496.png",
                "isHorizontal": false
            }
        },
        "name": "Alliance X-Wing",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_161": {
        "id": "SOR_161",
        "face": {
            "front": {
                "name": "Ardent Sympathizer",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/161.png",
                "isHorizontal": false
            }
        },
        "name": "Ardent Sympathizer",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TROOPER"
        ]
    },
    "SOR_424": {
        "id": "SOR_424",
        "face": {
            "front": {
                "name": "Ardent Sympathizer",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/424.png",
                "isHorizontal": false
            }
        },
        "name": "Ardent Sympathizer",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TROOPER"
        ]
    },
    "SOR_218": {
        "id": "SOR_218",
        "face": {
            "front": {
                "name": "Asteroid Sanctuary",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/218.png",
                "isHorizontal": false
            }
        },
        "name": "Asteroid Sanctuary",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "SOR_480": {
        "id": "SOR_480",
        "face": {
            "front": {
                "name": "Asteroid Sanctuary",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/480.png",
                "isHorizontal": false
            }
        },
        "name": "Asteroid Sanctuary",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "SOR_106": {
        "id": "SOR_106",
        "face": {
            "front": {
                "name": "Attack Pattern Delta",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/106.png",
                "isHorizontal": false
            }
        },
        "name": "Attack Pattern Delta",
        "type": "Event",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Command"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_370": {
        "id": "SOR_370",
        "face": {
            "front": {
                "name": "Attack Pattern Delta",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/370.png",
                "isHorizontal": false
            }
        },
        "name": "Attack Pattern Delta",
        "type": "Event",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Command"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_195": {
        "id": "SOR_195",
        "face": {
            "front": {
                "name": "Auzituck Liberator Gunship",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/195.png",
                "isHorizontal": false
            }
        },
        "name": "Auzituck Liberator Gunship",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_457": {
        "id": "SOR_457",
        "face": {
            "front": {
                "name": "Auzituck Liberator Gunship",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/457.png",
                "isHorizontal": false
            }
        },
        "name": "Auzituck Liberator Gunship",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_040": {
        "id": "SOR_040",
        "face": {
            "front": {
                "name": "Avenger, Hunting Star Destroyer",
                "type": "Unit - Space",
                "cost": 9,
                "image": "https://cdn.swu-db.com/images/cards/SOR/040.png",
                "isHorizontal": false
            }
        },
        "name": "Avenger, Hunting Star Destroyer",
        "type": "Unit - Space",
        "cost": 9,
        "rarity": "Legendary",
        "power": 8,
        "HP": 8,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "SOR_306": {
        "id": "SOR_306",
        "face": {
            "front": {
                "name": "Avenger, Hunting Star Destroyer",
                "type": "Unit - Space",
                "cost": 9,
                "image": "https://cdn.swu-db.com/images/cards/SOR/306.png",
                "isHorizontal": false
            }
        },
        "name": "Avenger, Hunting Star Destroyer",
        "type": "Unit - Space",
        "cost": 9,
        "rarity": "Legendary",
        "power": 8,
        "HP": 8,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "SOR_094": {
        "id": "SOR_094",
        "face": {
            "front": {
                "name": "Bail Organa, Rebel Councilor",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/094.png",
                "isHorizontal": false
            }
        },
        "name": "Bail Organa, Rebel Councilor",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Rare",
        "power": 1,
        "HP": 2,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "OFFICIAL"
        ]
    },
    "SOR_358": {
        "id": "SOR_358",
        "face": {
            "front": {
                "name": "Bail Organa, Rebel Councilor",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/358.png",
                "isHorizontal": false
            }
        },
        "name": "Bail Organa, Rebel Councilor",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Rare",
        "power": 1,
        "HP": 2,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "OFFICIAL"
        ]
    },
    "SOR_199": {
        "id": "SOR_199",
        "face": {
            "front": {
                "name": "Bamboozle",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/199.png",
                "isHorizontal": false
            }
        },
        "name": "Bamboozle",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "SOR_461": {
        "id": "SOR_461",
        "face": {
            "front": {
                "name": "Bamboozle",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/461.png",
                "isHorizontal": false
            }
        },
        "name": "Bamboozle",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "SOR_095": {
        "id": "SOR_095",
        "face": {
            "front": {
                "name": "Battlefield Marine",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/095.png",
                "isHorizontal": false
            }
        },
        "name": "Battlefield Marine",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "TROOPER"
        ]
    },
    "SOR_359": {
        "id": "SOR_359",
        "face": {
            "front": {
                "name": "Battlefield Marine",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/359.png",
                "isHorizontal": false
            }
        },
        "name": "Battlefield Marine",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "TROOPER"
        ]
    },
    "SOR_065": {
        "id": "SOR_065",
        "face": {
            "front": {
                "name": "Baze Malbus, Temple Guardian",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/065.png",
                "isHorizontal": false
            }
        },
        "name": "Baze Malbus, Temple Guardian",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Vigilance"
        ],
        "unique": true,
        "traits": [
            "FRINGE"
        ]
    },
    "SOR_330": {
        "id": "SOR_330",
        "face": {
            "front": {
                "name": "Baze Malbus, Temple Guardian",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/330.png",
                "isHorizontal": false
            }
        },
        "name": "Baze Malbus, Temple Guardian",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Vigilance"
        ],
        "unique": true,
        "traits": [
            "FRINGE"
        ]
    },
    "SOR_056": {
        "id": "SOR_056",
        "face": {
            "front": {
                "name": "Bendu, The One in the Middle",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/056.png",
                "isHorizontal": false
            }
        },
        "name": "Bendu, The One in the Middle",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Rare",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Vigilance"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "CREATURE"
        ]
    },
    "SOR_321": {
        "id": "SOR_321",
        "face": {
            "front": {
                "name": "Bendu, The One in the Middle",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/321.png",
                "isHorizontal": false
            }
        },
        "name": "Bendu, The One in the Middle",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Rare",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Vigilance"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "CREATURE"
        ]
    },
    "SOR_156": {
        "id": "SOR_156",
        "face": {
            "front": {
                "name": "Benthic \"Two Tubes\", Partisan Lieutenant",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/156.png",
                "isHorizontal": false
            }
        },
        "name": "Benthic \"Two Tubes\", Partisan Lieutenant",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Aggression"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "TROOPER"
        ]
    },
    "SOR_419": {
        "id": "SOR_419",
        "face": {
            "front": {
                "name": "Benthic \"Two Tubes\", Partisan Lieutenant",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/419.png",
                "isHorizontal": false
            }
        },
        "name": "Benthic \"Two Tubes\", Partisan Lieutenant",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Aggression"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "TROOPER"
        ]
    },
    "SOR_177": {
        "id": "SOR_177",
        "face": {
            "front": {
                "name": "Bib Fortuna, Jabba's Majordomo",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/177.png",
                "isHorizontal": false
            }
        },
        "name": "Bib Fortuna, Jabba's Majordomo",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "TWI'LEK"
        ]
    },
    "SOR_440": {
        "id": "SOR_440",
        "face": {
            "front": {
                "name": "Bib Fortuna, Jabba's Majordomo",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/440.png",
                "isHorizontal": false
            }
        },
        "name": "Bib Fortuna, Jabba's Majordomo",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "TWI'LEK"
        ]
    },
    "SOR_147": {
        "id": "SOR_147",
        "face": {
            "front": {
                "name": "Black One, Scourge of Starkiller Base",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/147.png",
                "isHorizontal": false
            }
        },
        "name": "Black One, Scourge of Starkiller Base",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Legendary",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_410": {
        "id": "SOR_410",
        "face": {
            "front": {
                "name": "Black One, Scourge of Starkiller Base",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/410.png",
                "isHorizontal": false
            }
        },
        "name": "Black One, Scourge of Starkiller Base",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Legendary",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_088": {
        "id": "SOR_088",
        "face": {
            "front": {
                "name": "Blizzard Assault AT-AT",
                "type": "Unit - Ground",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/SOR/088.png",
                "isHorizontal": false
            }
        },
        "name": "Blizzard Assault AT-AT",
        "type": "Unit - Ground",
        "cost": 8,
        "rarity": "Uncommon",
        "power": 9,
        "HP": 9,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "WALKER"
        ]
    },
    "SOR_352": {
        "id": "SOR_352",
        "face": {
            "front": {
                "name": "Blizzard Assault AT-AT",
                "type": "Unit - Ground",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/SOR/352.png",
                "isHorizontal": false
            }
        },
        "name": "Blizzard Assault AT-AT",
        "type": "Unit - Ground",
        "cost": 8,
        "rarity": "Uncommon",
        "power": 9,
        "HP": 9,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "WALKER"
        ]
    },
    "SOR_015": {
        "id": "SOR_015",
        "face": {
            "front": {
                "name": "Boba Fett, Collecting the Bounty",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/015-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Boba Fett, Collecting the Bounty",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SOR/015-b.png"
            }
        },
        "name": "Boba Fett, Collecting the Bounty",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SOR_179": {
        "id": "SOR_179",
        "face": {
            "front": {
                "name": "Boba Fett, Disintegrator",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/179.png",
                "isHorizontal": false
            }
        },
        "name": "Boba Fett, Disintegrator",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Legendary",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SOR_265": {
        "id": "SOR_265",
        "face": {
            "front": {
                "name": "Boba Fett, Collecting the Bounty",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/265-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Boba Fett, Collecting the Bounty",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SOR/265-b.png"
            }
        },
        "name": "Boba Fett, Collecting the Bounty",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SOR_281": {
        "id": "SOR_281",
        "face": {
            "front": {
                "name": "Boba Fett, Collecting the Bounty",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/281-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Boba Fett, Collecting the Bounty",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SOR/281-b.png"
            }
        },
        "name": "Boba Fett, Collecting the Bounty",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SOR_442": {
        "id": "SOR_442",
        "face": {
            "front": {
                "name": "Boba Fett, Disintegrator",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/442.png",
                "isHorizontal": false
            }
        },
        "name": "Boba Fett, Disintegrator",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Legendary",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SOR_201": {
        "id": "SOR_201",
        "face": {
            "front": {
                "name": "Bodhi Rook, Imperial Defector",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/201.png",
                "isHorizontal": false
            }
        },
        "name": "Bodhi Rook, Imperial Defector",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Rare",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "REBEL"
        ]
    },
    "SOR_463": {
        "id": "SOR_463",
        "face": {
            "front": {
                "name": "Bodhi Rook, Imperial Defector",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/463.png",
                "isHorizontal": false
            }
        },
        "name": "Bodhi Rook, Imperial Defector",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Rare",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "REBEL"
        ]
    },
    "SOR_173": {
        "id": "SOR_173",
        "face": {
            "front": {
                "name": "Bombing Run",
                "type": "Event",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/173.png",
                "isHorizontal": false
            }
        },
        "name": "Bombing Run",
        "type": "Event",
        "cost": 5,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_436": {
        "id": "SOR_436",
        "face": {
            "front": {
                "name": "Bombing Run",
                "type": "Event",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/436.png",
                "isHorizontal": false
            }
        },
        "name": "Bombing Run",
        "type": "Event",
        "cost": 5,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_182": {
        "id": "SOR_182",
        "face": {
            "front": {
                "name": "Bossk, Deadly Stalker",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/182.png",
                "isHorizontal": false
            }
        },
        "name": "Bossk, Deadly Stalker",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SOR_445": {
        "id": "SOR_445",
        "face": {
            "front": {
                "name": "Bossk, Deadly Stalker",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/445.png",
                "isHorizontal": false
            }
        },
        "name": "Bossk, Deadly Stalker",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SOR_183": {
        "id": "SOR_183",
        "face": {
            "front": {
                "name": "Bounty Hunter Crew",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/183.png",
                "isHorizontal": false
            }
        },
        "name": "Bounty Hunter Crew",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SOR_446": {
        "id": "SOR_446",
        "face": {
            "front": {
                "name": "Bounty Hunter Crew",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/446.png",
                "isHorizontal": false
            }
        },
        "name": "Bounty Hunter Crew",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SOR_099": {
        "id": "SOR_099",
        "face": {
            "front": {
                "name": "Bright Hope, The Last Transport",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/099.png",
                "isHorizontal": false
            }
        },
        "name": "Bright Hope, The Last Transport",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 6,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SOR_363": {
        "id": "SOR_363",
        "face": {
            "front": {
                "name": "Bright Hope, The Last Transport",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/363.png",
                "isHorizontal": false
            }
        },
        "name": "Bright Hope, The Last Transport",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 6,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SOR_238": {
        "id": "SOR_238",
        "face": {
            "front": {
                "name": "C-3P0, Protocol Droid",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/238.png",
                "isHorizontal": false
            }
        },
        "name": "C-3P0, Protocol Droid",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Special",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "DROID"
        ]
    },
    "SOR_202": {
        "id": "SOR_202",
        "face": {
            "front": {
                "name": "Cantina Bouncer",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/202.png",
                "isHorizontal": false
            }
        },
        "name": "Cantina Bouncer",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "FRINGE"
        ]
    },
    "SOR_464": {
        "id": "SOR_464",
        "face": {
            "front": {
                "name": "Cantina Bouncer",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/464.png",
                "isHorizontal": false
            }
        },
        "name": "Cantina Bouncer",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "FRINGE"
        ]
    },
    "SOR_157": {
        "id": "SOR_157",
        "face": {
            "front": {
                "name": "Cantina Braggart",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/157.png",
                "isHorizontal": false
            }
        },
        "name": "Cantina Braggart",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 3,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SOR_420": {
        "id": "SOR_420",
        "face": {
            "front": {
                "name": "Cantina Braggart",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/420.png",
                "isHorizontal": false
            }
        },
        "name": "Cantina Braggart",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 3,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SOR_020": {
        "id": "SOR_020",
        "face": {
            "front": {
                "name": "Capital City, Lothal",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SOR/020-r.png",
                "isHorizontal": true
            }
        },
        "name": "Capital City, Lothal",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": []
    },
    "SOR_286": {
        "id": "SOR_286",
        "face": {
            "front": {
                "name": "Capital City, Lothal",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SOR/286-r.png",
                "isHorizontal": true
            }
        },
        "name": "Capital City, Lothal",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": []
    },
    "SOR_068": {
        "id": "SOR_068",
        "face": {
            "front": {
                "name": "Cargo Juggernaut",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/068.png",
                "isHorizontal": false
            }
        },
        "name": "Cargo Juggernaut",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "VEHICLE",
            "TANK"
        ]
    },
    "SOR_333": {
        "id": "SOR_333",
        "face": {
            "front": {
                "name": "Cargo Juggernaut",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/333.png",
                "isHorizontal": false
            }
        },
        "name": "Cargo Juggernaut",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "VEHICLE",
            "TANK"
        ]
    },
    "SOR_178": {
        "id": "SOR_178",
        "face": {
            "front": {
                "name": "Cartel Spacer",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/178.png",
                "isHorizontal": false
            }
        },
        "name": "Cartel Spacer",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_441": {
        "id": "SOR_441",
        "face": {
            "front": {
                "name": "Cartel Spacer",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/441.png",
                "isHorizontal": false
            }
        },
        "name": "Cartel Spacer",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_013": {
        "id": "SOR_013",
        "face": {
            "front": {
                "name": "Cassian Andor, Dedicated to the Rebellion",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/013-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Cassian Andor, Dedicated to the Rebellion",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SOR/013-b.png"
            }
        },
        "name": "Cassian Andor, Dedicated to the Rebellion",
        "type": "Leader",
        "cost": 6,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL"
        ]
    },
    "SOR_263": {
        "id": "SOR_263",
        "face": {
            "front": {
                "name": "Cassian Andor, Dedicated to the Rebellion",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/263-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Cassian Andor, Dedicated to the Rebellion",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SOR/263-b.png"
            }
        },
        "name": "Cassian Andor, Dedicated to the Rebellion",
        "type": "Leader",
        "cost": 6,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL"
        ]
    },
    "SOR_279": {
        "id": "SOR_279",
        "face": {
            "front": {
                "name": "Cassian Andor, Dedicated to the Rebellion",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/279-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Cassian Andor, Dedicated to the Rebellion",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SOR/279-b.png"
            }
        },
        "name": "Cassian Andor, Dedicated to the Rebellion",
        "type": "Leader",
        "cost": 6,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL"
        ]
    },
    "SOR_026": {
        "id": "SOR_026",
        "face": {
            "front": {
                "name": "Catacombs of Cadera, Jedha",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SOR/026-r.png",
                "isHorizontal": true
            }
        },
        "name": "Catacombs of Cadera, Jedha",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": []
    },
    "SOR_292": {
        "id": "SOR_292",
        "face": {
            "front": {
                "name": "Catacombs of Cadera, Jedha",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SOR/292-r.png",
                "isHorizontal": true
            }
        },
        "name": "Catacombs of Cadera, Jedha",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": []
    },
    "SOR_229": {
        "id": "SOR_229",
        "face": {
            "front": {
                "name": "Cell Block Guard",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/229.png",
                "isHorizontal": false
            }
        },
        "name": "Cell Block Guard",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "SOR_490": {
        "id": "SOR_490",
        "face": {
            "front": {
                "name": "Cell Block Guard",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/490.png",
                "isHorizontal": false
            }
        },
        "name": "Cell Block Guard",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "SOR_224": {
        "id": "SOR_224",
        "face": {
            "front": {
                "name": "Change of Heart",
                "type": "Event",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/224.png",
                "isHorizontal": false
            }
        },
        "name": "Change of Heart",
        "type": "Event",
        "cost": 6,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "SOR_486": {
        "id": "SOR_486",
        "face": {
            "front": {
                "name": "Change of Heart",
                "type": "Event",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/486.png",
                "isHorizontal": false
            }
        },
        "name": "Change of Heart",
        "type": "Event",
        "cost": 6,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "SOR_003": {
        "id": "SOR_003",
        "face": {
            "front": {
                "name": "Chewbacca, Walking Carpet",
                "type": "Leader",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SOR/003-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Chewbacca, Walking Carpet",
                "type": "Leader",
                "cost": "7",
                "image": "https://cdn.swu-db.com/images/cards/SOR/003-b.png"
            }
        },
        "name": "Chewbacca, Walking Carpet",
        "type": "Leader",
        "cost": 7,
        "rarity": "Common",
        "power": 2,
        "HP": 9,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "WOOKIEE"
        ]
    },
    "SOR_196": {
        "id": "SOR_196",
        "face": {
            "front": {
                "name": "Chewbacca, Loyal Companion",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/196.png",
                "isHorizontal": false
            }
        },
        "name": "Chewbacca, Loyal Companion",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "WOOKIEE"
        ]
    },
    "SOR_255": {
        "id": "SOR_255",
        "face": {
            "front": {
                "name": "Chewbacca, Walking Carpet",
                "type": "Leader",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SOR/255-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Chewbacca, Walking Carpet",
                "type": "Leader",
                "cost": "7",
                "image": "https://cdn.swu-db.com/images/cards/SOR/255-b.png"
            }
        },
        "name": "Chewbacca, Walking Carpet",
        "type": "Leader",
        "cost": 7,
        "rarity": "Common",
        "power": 2,
        "HP": 9,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "WOOKIEE"
        ]
    },
    "SOR_271": {
        "id": "SOR_271",
        "face": {
            "front": {
                "name": "Chewbacca, Walking Carpet",
                "type": "Leader",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SOR/271-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Chewbacca, Walking Carpet",
                "type": "Leader",
                "cost": "7",
                "image": "https://cdn.swu-db.com/images/cards/SOR/271-b.png"
            }
        },
        "name": "Chewbacca, Walking Carpet",
        "type": "Leader",
        "cost": 7,
        "rarity": "Common",
        "power": 2,
        "HP": 9,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "WOOKIEE"
        ]
    },
    "SOR_458": {
        "id": "SOR_458",
        "face": {
            "front": {
                "name": "Chewbacca, Loyal Companion",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/458.png",
                "isHorizontal": false
            }
        },
        "name": "Chewbacca, Loyal Companion",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "WOOKIEE"
        ]
    },
    "SOR_185": {
        "id": "SOR_185",
        "face": {
            "front": {
                "name": "Chimaera, Flagship of the Seventh Fleet",
                "type": "Unit - Space",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/SOR/185.png",
                "isHorizontal": false
            }
        },
        "name": "Chimaera, Flagship of the Seventh Fleet",
        "type": "Unit - Space",
        "cost": 8,
        "rarity": "Rare",
        "power": 8,
        "HP": 7,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "SOR_448": {
        "id": "SOR_448",
        "face": {
            "front": {
                "name": "Chimaera, Flagship of the Seventh Fleet",
                "type": "Unit - Space",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/SOR/448.png",
                "isHorizontal": false
            }
        },
        "name": "Chimaera, Flagship of the Seventh Fleet",
        "type": "Unit - Space",
        "cost": 8,
        "rarity": "Rare",
        "power": 8,
        "HP": 7,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "SOR_004": {
        "id": "SOR_004",
        "face": {
            "front": {
                "name": "Chirrut Îmwe, One With the Force",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/004-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Chirrut Îmwe, One With the Force",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SOR/004-b.png"
            }
        },
        "name": "Chirrut Îmwe, One With the Force",
        "type": "Leader",
        "cost": 5,
        "rarity": "Rare",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "REBEL"
        ]
    },
    "SOR_256": {
        "id": "SOR_256",
        "face": {
            "front": {
                "name": "Chirrut Îmwe, One With the Force",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/256-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Chirrut Îmwe, One With the Force",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SOR/256-b.png"
            }
        },
        "name": "Chirrut Îmwe, One With the Force",
        "type": "Leader",
        "cost": 5,
        "rarity": "Rare",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "REBEL"
        ]
    },
    "SOR_272": {
        "id": "SOR_272",
        "face": {
            "front": {
                "name": "Chirrut Îmwe, One With the Force",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/272-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Chirrut Îmwe, One With the Force",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SOR/272-b.png"
            }
        },
        "name": "Chirrut Îmwe, One With the Force",
        "type": "Leader",
        "cost": 5,
        "rarity": "Rare",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "REBEL"
        ]
    },
    "SOR_188": {
        "id": "SOR_188",
        "face": {
            "front": {
                "name": "Chopper, Metal Menace",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/188.png",
                "isHorizontal": false
            }
        },
        "name": "Chopper, Metal Menace",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Rare",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "DROID",
            "SPECTRE"
        ]
    },
    "SOR_451": {
        "id": "SOR_451",
        "face": {
            "front": {
                "name": "Chopper, Metal Menace",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/451.png",
                "isHorizontal": false
            }
        },
        "name": "Chopper, Metal Menace",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Rare",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "DROID",
            "SPECTRE"
        ]
    },
    "SOR_030": {
        "id": "SOR_030",
        "face": {
            "front": {
                "name": "Chopper Base, Atollon",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SOR/030-r.png",
                "isHorizontal": true
            }
        },
        "name": "Chopper Base, Atollon",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": []
    },
    "SOR_296": {
        "id": "SOR_296",
        "face": {
            "front": {
                "name": "Chopper Base, Atollon",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SOR/296-r.png",
                "isHorizontal": true
            }
        },
        "name": "Chopper Base, Atollon",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": []
    },
    "SOR_063": {
        "id": "SOR_063",
        "face": {
            "front": {
                "name": "Cloud City Wing Guard",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/063.png",
                "isHorizontal": false
            }
        },
        "name": "Cloud City Wing Guard",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "TROOPER"
        ]
    },
    "SOR_328": {
        "id": "SOR_328",
        "face": {
            "front": {
                "name": "Cloud City Wing Guard",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/328.png",
                "isHorizontal": false
            }
        },
        "name": "Cloud City Wing Guard",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "TROOPER"
        ]
    },
    "SOR_109": {
        "id": "SOR_109",
        "face": {
            "front": {
                "name": "Colonel Yularen, ISB Director",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/109.png",
                "isHorizontal": false
            }
        },
        "name": "Colonel Yularen, ISB Director",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Command"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "SOR_373": {
        "id": "SOR_373",
        "face": {
            "front": {
                "name": "Colonel Yularen, ISB Director",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/373.png",
                "isHorizontal": false
            }
        },
        "name": "Colonel Yularen, ISB Director",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Command"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "SOR_107": {
        "id": "SOR_107",
        "face": {
            "front": {
                "name": "Command",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/107.png",
                "isHorizontal": false
            }
        },
        "name": "Command",
        "type": "Event",
        "cost": 4,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Command"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SOR_371": {
        "id": "SOR_371",
        "face": {
            "front": {
                "name": "Command",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/371.png",
                "isHorizontal": false
            }
        },
        "name": "Command",
        "type": "Event",
        "cost": 4,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Command"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SOR_023": {
        "id": "SOR_023",
        "face": {
            "front": {
                "name": "Command Center, Death Star",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SOR/023-r.png",
                "isHorizontal": true
            }
        },
        "name": "Command Center, Death Star",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": []
    },
    "SOR_289": {
        "id": "SOR_289",
        "face": {
            "front": {
                "name": "Command Center, Death Star",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SOR/289-r.png",
                "isHorizontal": true
            }
        },
        "name": "Command Center, Death Star",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": []
    },
    "SOR_251": {
        "id": "SOR_251",
        "face": {
            "front": {
                "name": "Confiscate",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/251.png",
                "isHorizontal": false
            }
        },
        "name": "Confiscate",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [],
        "unique": false,
        "traits": [
            "LAW"
        ]
    },
    "SOR_509": {
        "id": "SOR_509",
        "face": {
            "front": {
                "name": "Confiscate",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/509.png",
                "isHorizontal": false
            }
        },
        "name": "Confiscate",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [],
        "unique": false,
        "traits": [
            "LAW"
        ]
    },
    "SOR_112": {
        "id": "SOR_112",
        "face": {
            "front": {
                "name": "Consortium StarViper",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/112.png",
                "isHorizontal": false
            }
        },
        "name": "Consortium StarViper",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_376": {
        "id": "SOR_376",
        "face": {
            "front": {
                "name": "Consortium StarViper",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/376.png",
                "isHorizontal": false
            }
        },
        "name": "Consortium StarViper",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_046": {
        "id": "SOR_046",
        "face": {
            "front": {
                "name": "Consular Security Force",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/046.png",
                "isHorizontal": false
            }
        },
        "name": "Consular Security Force",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "TROOPER"
        ]
    },
    "SOR_312": {
        "id": "SOR_312",
        "face": {
            "front": {
                "name": "Consular Security Force",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/312.png",
                "isHorizontal": false
            }
        },
        "name": "Consular Security Force",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "TROOPER"
        ]
    },
    "SOR_250": {
        "id": "SOR_250",
        "face": {
            "front": {
                "name": "Corellian Freighter",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/250.png",
                "isHorizontal": false
            }
        },
        "name": "Corellian Freighter",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 4,
        "aspects": [],
        "unique": false,
        "traits": [
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SOR_508": {
        "id": "SOR_508",
        "face": {
            "front": {
                "name": "Corellian Freighter",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/508.png",
                "isHorizontal": false
            }
        },
        "name": "Corellian Freighter",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 4,
        "aspects": [],
        "unique": false,
        "traits": [
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SOR_038": {
        "id": "SOR_038",
        "face": {
            "front": {
                "name": "Count Dooku, Darth Tyranus",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SOR/038.png",
                "isHorizontal": false
            }
        },
        "name": "Count Dooku, Darth Tyranus",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Rare",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "SEPARATIST",
            "SITH"
        ]
    },
    "SOR_304": {
        "id": "SOR_304",
        "face": {
            "front": {
                "name": "Count Dooku, Darth Tyranus",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SOR/304.png",
                "isHorizontal": false
            }
        },
        "name": "Count Dooku, Darth Tyranus",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Rare",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "SEPARATIST",
            "SITH"
        ]
    },
    "SOR_207": {
        "id": "SOR_207",
        "face": {
            "front": {
                "name": "Crafty Smuggler",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/207.png",
                "isHorizontal": false
            }
        },
        "name": "Crafty Smuggler",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SOR_469": {
        "id": "SOR_469",
        "face": {
            "front": {
                "name": "Crafty Smuggler",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/469.png",
                "isHorizontal": false
            }
        },
        "name": "Crafty Smuggler",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SOR_203": {
        "id": "SOR_203",
        "face": {
            "front": {
                "name": "Cunning",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/203.png",
                "isHorizontal": false
            }
        },
        "name": "Cunning",
        "type": "Event",
        "cost": 4,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SOR_465": {
        "id": "SOR_465",
        "face": {
            "front": {
                "name": "Cunning",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/465.png",
                "isHorizontal": false
            }
        },
        "name": "Cunning",
        "type": "Event",
        "cost": 4,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SOR_021": {
        "id": "SOR_021",
        "face": {
            "front": {
                "name": "Dagobah Swamp, Dagobah",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SOR/021-r.png",
                "isHorizontal": true
            }
        },
        "name": "Dagobah Swamp, Dagobah",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": []
    },
    "SOR_287": {
        "id": "SOR_287",
        "face": {
            "front": {
                "name": "Dagobah Swamp, Dagobah",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SOR/287-r.png",
                "isHorizontal": true
            }
        },
        "name": "Dagobah Swamp, Dagobah",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": []
    },
    "SOR_010": {
        "id": "SOR_010",
        "face": {
            "front": {
                "name": "Darth Vader, Dark Lord of the Sith",
                "type": "Leader",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SOR/010-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Darth Vader, Dark Lord of the Sith",
                "type": "Leader",
                "cost": "7",
                "image": "https://cdn.swu-db.com/images/cards/SOR/010-b.png"
            }
        },
        "name": "Darth Vader, Dark Lord of the Sith",
        "type": "Leader",
        "cost": 7,
        "rarity": "Special",
        "power": 5,
        "HP": 8,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "IMPERIAL",
            "SITH"
        ]
    },
    "SOR_087": {
        "id": "SOR_087",
        "face": {
            "front": {
                "name": "Darth Vader, Commanding the First Legion",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SOR/087.png",
                "isHorizontal": false
            }
        },
        "name": "Darth Vader, Commanding the First Legion",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Legendary",
        "power": 5,
        "HP": 7,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "IMPERIAL",
            "SITH"
        ]
    },
    "SOR_351": {
        "id": "SOR_351",
        "face": {
            "front": {
                "name": "Darth Vader, Commanding the First Legion",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SOR/351.png",
                "isHorizontal": false
            }
        },
        "name": "Darth Vader, Commanding the First Legion",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Legendary",
        "power": 5,
        "HP": 7,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "IMPERIAL",
            "SITH"
        ]
    },
    "SOR_128": {
        "id": "SOR_128",
        "face": {
            "front": {
                "name": "Death Star Stormtrooper",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/128.png",
                "isHorizontal": false
            }
        },
        "name": "Death Star Stormtrooper",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 3,
        "HP": 1,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "SOR_392": {
        "id": "SOR_392",
        "face": {
            "front": {
                "name": "Death Star Stormtrooper",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/392.png",
                "isHorizontal": false
            }
        },
        "name": "Death Star Stormtrooper",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 3,
        "HP": 1,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "SOR_033": {
        "id": "SOR_033",
        "face": {
            "front": {
                "name": "Death Trooper",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/033.png",
                "isHorizontal": false
            }
        },
        "name": "Death Trooper",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "SOR_299": {
        "id": "SOR_299",
        "face": {
            "front": {
                "name": "Death Trooper",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/299.png",
                "isHorizontal": false
            }
        },
        "name": "Death Trooper",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "SOR_034": {
        "id": "SOR_034",
        "face": {
            "front": {
                "name": "Del Meeko, Providing Overwatch",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/034.png",
                "isHorizontal": false
            }
        },
        "name": "Del Meeko, Providing Overwatch",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Rare",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "SOR_300": {
        "id": "SOR_300",
        "face": {
            "front": {
                "name": "Del Meeko, Providing Overwatch",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/300.png",
                "isHorizontal": false
            }
        },
        "name": "Del Meeko, Providing Overwatch",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Rare",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "SOR_090": {
        "id": "SOR_090",
        "face": {
            "front": {
                "name": "Devastator, Inescapable",
                "type": "Unit - Space",
                "cost": 10,
                "image": "https://cdn.swu-db.com/images/cards/SOR/090.png",
                "isHorizontal": false
            }
        },
        "name": "Devastator, Inescapable",
        "type": "Unit - Space",
        "cost": 10,
        "rarity": "Legendary",
        "power": 10,
        "HP": 10,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "SOR_354": {
        "id": "SOR_354",
        "face": {
            "front": {
                "name": "Devastator, Inescapable",
                "type": "Unit - Space",
                "cost": 10,
                "image": "https://cdn.swu-db.com/images/cards/SOR/354.png",
                "isHorizontal": false
            }
        },
        "name": "Devastator, Inescapable",
        "type": "Unit - Space",
        "cost": 10,
        "rarity": "Legendary",
        "power": 10,
        "HP": 10,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "SOR_070": {
        "id": "SOR_070",
        "face": {
            "front": {
                "name": "Devotion",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/070.png",
                "isHorizontal": false
            }
        },
        "name": "Devotion",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SOR_335": {
        "id": "SOR_335",
        "face": {
            "front": {
                "name": "Devotion",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/335.png",
                "isHorizontal": false
            }
        },
        "name": "Devotion",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SOR_001": {
        "id": "SOR_001",
        "face": {
            "front": {
                "name": "Director Krennic, Aspiring to Authority",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/001-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Director Krennic, Aspiring to Authority",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SOR/001-b.png"
            }
        },
        "name": "Director Krennic, Aspiring to Authority",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 2,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "SOR_253": {
        "id": "SOR_253",
        "face": {
            "front": {
                "name": "Director Krennic, Aspiring to Authority",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/253-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Director Krennic, Aspiring to Authority",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SOR/253-b.png"
            }
        },
        "name": "Director Krennic, Aspiring to Authority",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 2,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "SOR_269": {
        "id": "SOR_269",
        "face": {
            "front": {
                "name": "Director Krennic, Aspiring to Authority",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/269-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Director Krennic, Aspiring to Authority",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SOR/269-b.png"
            }
        },
        "name": "Director Krennic, Aspiring to Authority",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 2,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "SOR_162": {
        "id": "SOR_162",
        "face": {
            "front": {
                "name": "Disabling Fang Fighter",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/162.png",
                "isHorizontal": false
            }
        },
        "name": "Disabling Fang Fighter",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_425": {
        "id": "SOR_425",
        "face": {
            "front": {
                "name": "Disabling Fang Fighter",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/425.png",
                "isHorizontal": false
            }
        },
        "name": "Disabling Fang Fighter",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_216": {
        "id": "SOR_216",
        "face": {
            "front": {
                "name": "Disarm",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/216.png",
                "isHorizontal": false
            }
        },
        "name": "Disarm",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_478": {
        "id": "SOR_478",
        "face": {
            "front": {
                "name": "Disarm",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/478.png",
                "isHorizontal": false
            }
        },
        "name": "Disarm",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_060": {
        "id": "SOR_060",
        "face": {
            "front": {
                "name": "Distant Patroller",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/060.png",
                "isHorizontal": false
            }
        },
        "name": "Distant Patroller",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_325": {
        "id": "SOR_325",
        "face": {
            "front": {
                "name": "Distant Patroller",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/325.png",
                "isHorizontal": false
            }
        },
        "name": "Distant Patroller",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_223": {
        "id": "SOR_223",
        "face": {
            "front": {
                "name": "Don't Get Cocky",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/223.png",
                "isHorizontal": false
            }
        },
        "name": "Don't Get Cocky",
        "type": "Event",
        "cost": 4,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "SOR_485": {
        "id": "SOR_485",
        "face": {
            "front": {
                "name": "Don't Get Cocky",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/485.png",
                "isHorizontal": false
            }
        },
        "name": "Don't Get Cocky",
        "type": "Event",
        "cost": 4,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "SOR_024": {
        "id": "SOR_024",
        "face": {
            "front": {
                "name": "Echo Base, Hoth",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SOR/024-r.png",
                "isHorizontal": true
            }
        },
        "name": "Echo Base, Hoth",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": []
    },
    "SOR_290": {
        "id": "SOR_290",
        "face": {
            "front": {
                "name": "Echo Base, Hoth",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SOR/290-r.png",
                "isHorizontal": true
            }
        },
        "name": "Echo Base, Hoth",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": []
    },
    "SOR_098": {
        "id": "SOR_098",
        "face": {
            "front": {
                "name": "Echo Base Defender",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/098.png",
                "isHorizontal": false
            }
        },
        "name": "Echo Base Defender",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 4,
        "HP": 3,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "TROOPER"
        ]
    },
    "SOR_362": {
        "id": "SOR_362",
        "face": {
            "front": {
                "name": "Echo Base Defender",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/362.png",
                "isHorizontal": false
            }
        },
        "name": "Echo Base Defender",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 4,
        "HP": 3,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "TROOPER"
        ]
    },
    "SOR_071": {
        "id": "SOR_071",
        "face": {
            "front": {
                "name": "Electrostaff",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/071.png",
                "isHorizontal": false
            }
        },
        "name": "Electrostaff",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Rare",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "ITEM",
            "WEAPON"
        ]
    },
    "SOR_336": {
        "id": "SOR_336",
        "face": {
            "front": {
                "name": "Electrostaff",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/336.png",
                "isHorizontal": false
            }
        },
        "name": "Electrostaff",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Rare",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "ITEM",
            "WEAPON"
        ]
    },
    "SOR_006": {
        "id": "SOR_006",
        "face": {
            "front": {
                "name": "Emperor Palpatine, Galactic Ruler",
                "type": "Leader",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/SOR/006-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Emperor Palpatine, Galactic Ruler",
                "type": "Leader",
                "cost": "8",
                "image": "https://cdn.swu-db.com/images/cards/SOR/006-b.png"
            }
        },
        "name": "Emperor Palpatine, Galactic Ruler",
        "type": "Leader",
        "cost": 8,
        "rarity": "Rare",
        "power": 4,
        "HP": 10,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "IMPERIAL",
            "SITH",
            "OFFICIAL"
        ]
    },
    "SOR_135": {
        "id": "SOR_135",
        "face": {
            "front": {
                "name": "Emperor Palpatine, Master of the Dark Side",
                "type": "Unit - Ground",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/SOR/135.png",
                "isHorizontal": false
            }
        },
        "name": "Emperor Palpatine, Master of the Dark Side",
        "type": "Unit - Ground",
        "cost": 8,
        "rarity": "Rare",
        "power": 6,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "IMPERIAL",
            "SITH",
            "OFFICIAL"
        ]
    },
    "SOR_257": {
        "id": "SOR_257",
        "face": {
            "front": {
                "name": "Emperor Palpatine, Galactic Ruler",
                "type": "Leader",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/SOR/257-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Emperor Palpatine, Galactic Ruler",
                "type": "Leader",
                "cost": "8",
                "image": "https://cdn.swu-db.com/images/cards/SOR/257-b.png"
            }
        },
        "name": "Emperor Palpatine, Galactic Ruler",
        "type": "Leader",
        "cost": 8,
        "rarity": "Rare",
        "power": 4,
        "HP": 10,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "IMPERIAL",
            "SITH",
            "OFFICIAL"
        ]
    },
    "SOR_273": {
        "id": "SOR_273",
        "face": {
            "front": {
                "name": "Emperor Palpatine, Galactic Ruler",
                "type": "Leader",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/SOR/273-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Emperor Palpatine, Galactic Ruler",
                "type": "Leader",
                "cost": "8",
                "image": "https://cdn.swu-db.com/images/cards/SOR/273-b.png"
            }
        },
        "name": "Emperor Palpatine, Galactic Ruler",
        "type": "Leader",
        "cost": 8,
        "rarity": "Rare",
        "power": 4,
        "HP": 10,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "IMPERIAL",
            "SITH",
            "OFFICIAL"
        ]
    },
    "SOR_399": {
        "id": "SOR_399",
        "face": {
            "front": {
                "name": "Emperor Palpatine, Master of the Dark Side",
                "type": "Unit - Ground",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/SOR/399.png",
                "isHorizontal": false
            }
        },
        "name": "Emperor Palpatine, Master of the Dark Side",
        "type": "Unit - Ground",
        "cost": 8,
        "rarity": "Rare",
        "power": 6,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "IMPERIAL",
            "SITH",
            "OFFICIAL"
        ]
    },
    "SOR_082": {
        "id": "SOR_082",
        "face": {
            "front": {
                "name": "Emperor's Royal Guard",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/082.png",
                "isHorizontal": false
            }
        },
        "name": "Emperor's Royal Guard",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Rare",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL"
        ]
    },
    "SOR_347": {
        "id": "SOR_347",
        "face": {
            "front": {
                "name": "Emperor's Royal Guard",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/347.png",
                "isHorizontal": false
            }
        },
        "name": "Emperor's Royal Guard",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Rare",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL"
        ]
    },
    "SOR_022": {
        "id": "SOR_022",
        "face": {
            "front": {
                "name": "Energy Conversion Lab, Eadu",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SOR/022-r.png",
                "isHorizontal": true
            }
        },
        "name": "Energy Conversion Lab, Eadu",
        "type": "Base",
        "cost": 0,
        "rarity": "Rare",
        "power": 0,
        "HP": 25,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": []
    },
    "SOR_288": {
        "id": "SOR_288",
        "face": {
            "front": {
                "name": "Energy Conversion Lab, Eadu",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SOR/288-r.png",
                "isHorizontal": true
            }
        },
        "name": "Energy Conversion Lab, Eadu",
        "type": "Base",
        "cost": 0,
        "rarity": "Rare",
        "power": 0,
        "HP": 25,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": []
    },
    "SOR_072": {
        "id": "SOR_072",
        "face": {
            "front": {
                "name": "Entrenched",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/072.png",
                "isHorizontal": false
            }
        },
        "name": "Entrenched",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "CONDITION"
        ]
    },
    "SOR_337": {
        "id": "SOR_337",
        "face": {
            "front": {
                "name": "Entrenched",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/337.png",
                "isHorizontal": false
            }
        },
        "name": "Entrenched",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "CONDITION"
        ]
    },
    "SOR_114": {
        "id": "SOR_114",
        "face": {
            "front": {
                "name": "Escort Skiff",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/114.png",
                "isHorizontal": false
            }
        },
        "name": "Escort Skiff",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "SPEEDER"
        ]
    },
    "SOR_378": {
        "id": "SOR_378",
        "face": {
            "front": {
                "name": "Escort Skiff",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/378.png",
                "isHorizontal": false
            }
        },
        "name": "Escort Skiff",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "SPEEDER"
        ]
    },
    "SOR_192": {
        "id": "SOR_192",
        "face": {
            "front": {
                "name": "Ezra Bridger, Resourceful Troublemaker",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/192.png",
                "isHorizontal": false
            }
        },
        "name": "Ezra Bridger, Resourceful Troublemaker",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "REBEL",
            "SPECTRE"
        ]
    },
    "SOR_454": {
        "id": "SOR_454",
        "face": {
            "front": {
                "name": "Ezra Bridger, Resourceful Troublemaker",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/454.png",
                "isHorizontal": false
            }
        },
        "name": "Ezra Bridger, Resourceful Troublemaker",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "REBEL",
            "SPECTRE"
        ]
    },
    "SOR_137": {
        "id": "SOR_137",
        "face": {
            "front": {
                "name": "Fallen Lightsaber",
                "type": "Upgrade",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/137.png",
                "isHorizontal": false
            }
        },
        "name": "Fallen Lightsaber",
        "type": "Upgrade",
        "cost": 3,
        "rarity": "Rare",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "ITEM",
            "WEAPON",
            "LIGHTSABER"
        ]
    },
    "SOR_400": {
        "id": "SOR_400",
        "face": {
            "front": {
                "name": "Fallen Lightsaber",
                "type": "Upgrade",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/400.png",
                "isHorizontal": false
            }
        },
        "name": "Fallen Lightsaber",
        "type": "Upgrade",
        "cost": 3,
        "rarity": "Rare",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "ITEM",
            "WEAPON",
            "LIGHTSABER"
        ]
    },
    "SOR_184": {
        "id": "SOR_184",
        "face": {
            "front": {
                "name": "Fett's Firespray, Pursuing the Bounty",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/184.png",
                "isHorizontal": false
            }
        },
        "name": "Fett's Firespray, Pursuing the Bounty",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Rare",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SOR_447": {
        "id": "SOR_447",
        "face": {
            "front": {
                "name": "Fett's Firespray, Pursuing the Bounty",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/447.png",
                "isHorizontal": false
            }
        },
        "name": "Fett's Firespray, Pursuing the Bounty",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Rare",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SOR_131": {
        "id": "SOR_131",
        "face": {
            "front": {
                "name": "Fifth Brother, Fear Hunter",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/131.png",
                "isHorizontal": false
            }
        },
        "name": "Fifth Brother, Fear Hunter",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "IMPERIAL",
            "INQUISITOR"
        ]
    },
    "SOR_395": {
        "id": "SOR_395",
        "face": {
            "front": {
                "name": "Fifth Brother, Fear Hunter",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/395.png",
                "isHorizontal": false
            }
        },
        "name": "Fifth Brother, Fear Hunter",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "IMPERIAL",
            "INQUISITOR"
        ]
    },
    "SOR_143": {
        "id": "SOR_143",
        "face": {
            "front": {
                "name": "Fighters For Freedom",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/143.png",
                "isHorizontal": false
            }
        },
        "name": "Fighters For Freedom",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "TROOPER"
        ]
    },
    "SOR_406": {
        "id": "SOR_406",
        "face": {
            "front": {
                "name": "Fighters For Freedom",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/406.png",
                "isHorizontal": false
            }
        },
        "name": "Fighters For Freedom",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "TROOPER"
        ]
    },
    "SOR_130": {
        "id": "SOR_130",
        "face": {
            "front": {
                "name": "First Legion Snowtrooper",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/130.png",
                "isHorizontal": false
            }
        },
        "name": "First Legion Snowtrooper",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "SOR_394": {
        "id": "SOR_394",
        "face": {
            "front": {
                "name": "First Legion Snowtrooper",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/394.png",
                "isHorizontal": false
            }
        },
        "name": "First Legion Snowtrooper",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "SOR_240": {
        "id": "SOR_240",
        "face": {
            "front": {
                "name": "Fleet Lieutenant",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/240.png",
                "isHorizontal": false
            }
        },
        "name": "Fleet Lieutenant",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "TROOPER"
        ]
    },
    "SOR_498": {
        "id": "SOR_498",
        "face": {
            "front": {
                "name": "Fleet Lieutenant",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/498.png",
                "isHorizontal": false
            }
        },
        "name": "Fleet Lieutenant",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "TROOPER"
        ]
    },
    "SOR_152": {
        "id": "SOR_152",
        "face": {
            "front": {
                "name": "For a Cause I Believe In",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/152.png",
                "isHorizontal": false
            }
        },
        "name": "For a Cause I Believe In",
        "type": "Event",
        "cost": 3,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SOR_415": {
        "id": "SOR_415",
        "face": {
            "front": {
                "name": "For a Cause I Believe In",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/415.png",
                "isHorizontal": false
            }
        },
        "name": "For a Cause I Believe In",
        "type": "Event",
        "cost": 3,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SOR_139": {
        "id": "SOR_139",
        "face": {
            "front": {
                "name": "Force Choke",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/139.png",
                "isHorizontal": false
            }
        },
        "name": "Force Choke",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "FORCE"
        ]
    },
    "SOR_402": {
        "id": "SOR_402",
        "face": {
            "front": {
                "name": "Force Choke",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/402.png",
                "isHorizontal": false
            }
        },
        "name": "Force Choke",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "FORCE"
        ]
    },
    "SOR_138": {
        "id": "SOR_138",
        "face": {
            "front": {
                "name": "Force Lightning",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/138.png",
                "isHorizontal": false
            }
        },
        "name": "Force Lightning",
        "type": "Event",
        "cost": 1,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "FORCE"
        ]
    },
    "SOR_401": {
        "id": "SOR_401",
        "face": {
            "front": {
                "name": "Force Lightning",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/401.png",
                "isHorizontal": false
            }
        },
        "name": "Force Lightning",
        "type": "Event",
        "cost": 1,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "FORCE"
        ]
    },
    "SOR_167": {
        "id": "SOR_167",
        "face": {
            "front": {
                "name": "Force Throw",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/167.png",
                "isHorizontal": false
            }
        },
        "name": "Force Throw",
        "type": "Event",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "FORCE"
        ]
    },
    "SOR_430": {
        "id": "SOR_430",
        "face": {
            "front": {
                "name": "Force Throw",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/430.png",
                "isHorizontal": false
            }
        },
        "name": "Force Throw",
        "type": "Event",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "FORCE"
        ]
    },
    "SOR_175": {
        "id": "SOR_175",
        "face": {
            "front": {
                "name": "Forced Surrender",
                "type": "Event",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/175.png",
                "isHorizontal": false
            }
        },
        "name": "Forced Surrender",
        "type": "Event",
        "cost": 6,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "SOR_438": {
        "id": "SOR_438",
        "face": {
            "front": {
                "name": "Forced Surrender",
                "type": "Event",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/438.png",
                "isHorizontal": false
            }
        },
        "name": "Forced Surrender",
        "type": "Event",
        "cost": 6,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "SOR_249": {
        "id": "SOR_249",
        "face": {
            "front": {
                "name": "Frontier AT-RT",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/249.png",
                "isHorizontal": false
            }
        },
        "name": "Frontier AT-RT",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 5,
        "aspects": [],
        "unique": false,
        "traits": [
            "VEHICLE",
            "WALKER"
        ]
    },
    "SOR_507": {
        "id": "SOR_507",
        "face": {
            "front": {
                "name": "Frontier AT-RT",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/507.png",
                "isHorizontal": false
            }
        },
        "name": "Frontier AT-RT",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 5,
        "aspects": [],
        "unique": false,
        "traits": [
            "VEHICLE",
            "WALKER"
        ]
    },
    "SOR_110": {
        "id": "SOR_110",
        "face": {
            "front": {
                "name": "Frontline Shuttle",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/110.png",
                "isHorizontal": false
            }
        },
        "name": "Frontline Shuttle",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Rare",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SOR_374": {
        "id": "SOR_374",
        "face": {
            "front": {
                "name": "Frontline Shuttle",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/374.png",
                "isHorizontal": false
            }
        },
        "name": "Frontline Shuttle",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Rare",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SOR_235": {
        "id": "SOR_235",
        "face": {
            "front": {
                "name": "Galactic Ambition",
                "type": "Event",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SOR/235.png",
                "isHorizontal": false
            }
        },
        "name": "Galactic Ambition",
        "type": "Event",
        "cost": 7,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SOR_495": {
        "id": "SOR_495",
        "face": {
            "front": {
                "name": "Galactic Ambition",
                "type": "Event",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SOR/495.png",
                "isHorizontal": false
            }
        },
        "name": "Galactic Ambition",
        "type": "Event",
        "cost": 7,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SOR_211": {
        "id": "SOR_211",
        "face": {
            "front": {
                "name": "Gamorrean Guards",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/211.png",
                "isHorizontal": false
            }
        },
        "name": "Gamorrean Guards",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SOR_473": {
        "id": "SOR_473",
        "face": {
            "front": {
                "name": "Gamorrean Guards",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/473.png",
                "isHorizontal": false
            }
        },
        "name": "Gamorrean Guards",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SOR_242": {
        "id": "SOR_242",
        "face": {
            "front": {
                "name": "General Dodonna, Massassi Group Commander",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/242.png",
                "isHorizontal": false
            }
        },
        "name": "General Dodonna, Massassi Group Commander",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "OFFICIAL"
        ]
    },
    "SOR_500": {
        "id": "SOR_500",
        "face": {
            "front": {
                "name": "General Dodonna, Massassi Group Commander",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/500.png",
                "isHorizontal": false
            }
        },
        "name": "General Dodonna, Massassi Group Commander",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "OFFICIAL"
        ]
    },
    "SOR_105": {
        "id": "SOR_105",
        "face": {
            "front": {
                "name": "General Krell, Heartless Tactician",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/105.png",
                "isHorizontal": false
            }
        },
        "name": "General Krell, Heartless Tactician",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Rare",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Command",
            "Command"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "SOR_369": {
        "id": "SOR_369",
        "face": {
            "front": {
                "name": "General Krell, Heartless Tactician",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/369.png",
                "isHorizontal": false
            }
        },
        "name": "General Krell, Heartless Tactician",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Rare",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Command",
            "Command"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "SOR_080": {
        "id": "SOR_080",
        "face": {
            "front": {
                "name": "General Tagge, Concerned Commander",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/080.png",
                "isHorizontal": false
            }
        },
        "name": "General Tagge, Concerned Commander",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "SOR_345": {
        "id": "SOR_345",
        "face": {
            "front": {
                "name": "General Tagge, Concerned Commander",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/345.png",
                "isHorizontal": false
            }
        },
        "name": "General Tagge, Concerned Commander",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "SOR_230": {
        "id": "SOR_230",
        "face": {
            "front": {
                "name": "General Veers, Blizzard Force Commander",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/230.png",
                "isHorizontal": false
            }
        },
        "name": "General Veers, Blizzard Force Commander",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "SOR_491": {
        "id": "SOR_491",
        "face": {
            "front": {
                "name": "General Veers, Blizzard Force Commander",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/491.png",
                "isHorizontal": false
            }
        },
        "name": "General Veers, Blizzard Force Commander",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "SOR_036": {
        "id": "SOR_036",
        "face": {
            "front": {
                "name": "Gideon Hask, Ruthless Loyalist",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/036.png",
                "isHorizontal": false
            }
        },
        "name": "Gideon Hask, Ruthless Loyalist",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Rare",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "SOR_302": {
        "id": "SOR_302",
        "face": {
            "front": {
                "name": "Gideon Hask, Ruthless Loyalist",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/302.png",
                "isHorizontal": false
            }
        },
        "name": "Gideon Hask, Ruthless Loyalist",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Rare",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "SOR_086": {
        "id": "SOR_086",
        "face": {
            "front": {
                "name": "Gladiator Star Destroyer",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/086.png",
                "isHorizontal": false
            }
        },
        "name": "Gladiator Star Destroyer",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Common",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "SOR_350": {
        "id": "SOR_350",
        "face": {
            "front": {
                "name": "Gladiator Star Destroyer",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/350.png",
                "isHorizontal": false
            }
        },
        "name": "Gladiator Star Destroyer",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Common",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "SOR_016": {
        "id": "SOR_016",
        "face": {
            "front": {
                "name": "Grand Admiral Thrawn, Patient and Insightful",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/016-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Grand Admiral Thrawn, Patient and Insightful",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SOR/016-b.png"
            }
        },
        "name": "Grand Admiral Thrawn, Patient and Insightful",
        "type": "Leader",
        "cost": 6,
        "rarity": "Rare",
        "power": 3,
        "HP": 9,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "SOR_266": {
        "id": "SOR_266",
        "face": {
            "front": {
                "name": "Grand Admiral Thrawn, Patient and Insightful",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/266-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Grand Admiral Thrawn, Patient and Insightful",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SOR/266-b.png"
            }
        },
        "name": "Grand Admiral Thrawn, Patient and Insightful",
        "type": "Leader",
        "cost": 6,
        "rarity": "Rare",
        "power": 3,
        "HP": 9,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "SOR_282": {
        "id": "SOR_282",
        "face": {
            "front": {
                "name": "Grand Admiral Thrawn, Patient and Insightful",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/282-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Grand Admiral Thrawn, Patient and Insightful",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SOR/282-b.png"
            }
        },
        "name": "Grand Admiral Thrawn, Patient and Insightful",
        "type": "Leader",
        "cost": 6,
        "rarity": "Rare",
        "power": 3,
        "HP": 9,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "SOR_011": {
        "id": "SOR_011",
        "face": {
            "front": {
                "name": "Grand Inquisitor, Hunting The Jedi",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/011-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Grand Inquisitor, Hunting The Jedi",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SOR/011-b.png"
            }
        },
        "name": "Grand Inquisitor, Hunting The Jedi",
        "type": "Leader",
        "cost": 6,
        "rarity": "Rare",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "IMPERIAL",
            "INQUISITOR"
        ]
    },
    "SOR_261": {
        "id": "SOR_261",
        "face": {
            "front": {
                "name": "Grand Inquisitor, Hunting The Jedi",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/261-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Grand Inquisitor, Hunting The Jedi",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SOR/261-b.png"
            }
        },
        "name": "Grand Inquisitor, Hunting The Jedi",
        "type": "Leader",
        "cost": 6,
        "rarity": "Rare",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "IMPERIAL",
            "INQUISITOR"
        ]
    },
    "SOR_277": {
        "id": "SOR_277",
        "face": {
            "front": {
                "name": "Grand Inquisitor, Hunting The Jedi",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/277-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Grand Inquisitor, Hunting The Jedi",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SOR/277-b.png"
            }
        },
        "name": "Grand Inquisitor, Hunting The Jedi",
        "type": "Leader",
        "cost": 6,
        "rarity": "Rare",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "IMPERIAL",
            "INQUISITOR"
        ]
    },
    "SOR_007": {
        "id": "SOR_007",
        "face": {
            "front": {
                "name": "Grand Moff Tarkin, Oversector Governor",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/007-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Grand Moff Tarkin, Oversector Governor",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SOR/007-b.png"
            }
        },
        "name": "Grand Moff Tarkin, Oversector Governor",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 2,
        "HP": 7,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "SOR_084": {
        "id": "SOR_084",
        "face": {
            "front": {
                "name": "Grand Moff Tarkin, Death Star Overseer",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/084.png",
                "isHorizontal": false
            }
        },
        "name": "Grand Moff Tarkin, Death Star Overseer",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Special",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "SOR_258": {
        "id": "SOR_258",
        "face": {
            "front": {
                "name": "Grand Moff Tarkin, Oversector Governor",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/258-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Grand Moff Tarkin, Oversector Governor",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SOR/258-b.png"
            }
        },
        "name": "Grand Moff Tarkin, Oversector Governor",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 2,
        "HP": 7,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "SOR_274": {
        "id": "SOR_274",
        "face": {
            "front": {
                "name": "Grand Moff Tarkin, Oversector Governor",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/274-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Grand Moff Tarkin, Oversector Governor",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SOR/274-b.png"
            }
        },
        "name": "Grand Moff Tarkin, Oversector Governor",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 2,
        "HP": 7,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "SOR_204": {
        "id": "SOR_204",
        "face": {
            "front": {
                "name": "Greedo, Slow on the Draw",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/204.png",
                "isHorizontal": false
            }
        },
        "name": "Greedo, Slow on the Draw",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 1,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SOR_466": {
        "id": "SOR_466",
        "face": {
            "front": {
                "name": "Greedo, Slow on the Draw",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/466.png",
                "isHorizontal": false
            }
        },
        "name": "Greedo, Slow on the Draw",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 1,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SOR_141": {
        "id": "SOR_141",
        "face": {
            "front": {
                "name": "Green Squadron A-Wing",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/141.png",
                "isHorizontal": false
            }
        },
        "name": "Green Squadron A-Wing",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_404": {
        "id": "SOR_404",
        "face": {
            "front": {
                "name": "Green Squadron A-Wing",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/404.png",
                "isHorizontal": false
            }
        },
        "name": "Green Squadron A-Wing",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_061": {
        "id": "SOR_061",
        "face": {
            "front": {
                "name": "Guardian of the Whills",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/061.png",
                "isHorizontal": false
            }
        },
        "name": "Guardian of the Whills",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "FORCE",
            "FRINGE"
        ]
    },
    "SOR_326": {
        "id": "SOR_326",
        "face": {
            "front": {
                "name": "Guardian of the Whills",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/326.png",
                "isHorizontal": false
            }
        },
        "name": "Guardian of the Whills",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "FORCE",
            "FRINGE"
        ]
    },
    "SOR_148": {
        "id": "SOR_148",
        "face": {
            "front": {
                "name": "Guerilla Attack Pod",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/148.png",
                "isHorizontal": false
            }
        },
        "name": "Guerilla Attack Pod",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "WALKER"
        ]
    },
    "SOR_411": {
        "id": "SOR_411",
        "face": {
            "front": {
                "name": "Guerilla Attack Pod",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/411.png",
                "isHorizontal": false
            }
        },
        "name": "Guerilla Attack Pod",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "WALKER"
        ]
    },
    "SOR_017": {
        "id": "SOR_017",
        "face": {
            "front": {
                "name": "Han Solo, Audacious Smuggler",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/017-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Han Solo, Audacious Smuggler",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SOR/017-b.png"
            }
        },
        "name": "Han Solo, Audacious Smuggler",
        "type": "Leader",
        "cost": 6,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SOR_198": {
        "id": "SOR_198",
        "face": {
            "front": {
                "name": "Han Solo, Reluctant Hero",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SOR/198.png",
                "isHorizontal": false
            }
        },
        "name": "Han Solo, Reluctant Hero",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Rare",
        "power": 6,
        "HP": 6,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SOR_267": {
        "id": "SOR_267",
        "face": {
            "front": {
                "name": "Han Solo, Audacious Smuggler",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/267-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Han Solo, Audacious Smuggler",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SOR/267-b.png"
            }
        },
        "name": "Han Solo, Audacious Smuggler",
        "type": "Leader",
        "cost": 6,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SOR_283": {
        "id": "SOR_283",
        "face": {
            "front": {
                "name": "Han Solo, Audacious Smuggler",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/283-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Han Solo, Audacious Smuggler",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SOR/283-b.png"
            }
        },
        "name": "Han Solo, Audacious Smuggler",
        "type": "Leader",
        "cost": 6,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SOR_460": {
        "id": "SOR_460",
        "face": {
            "front": {
                "name": "Han Solo, Reluctant Hero",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SOR/460.png",
                "isHorizontal": false
            }
        },
        "name": "Han Solo, Reluctant Hero",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Rare",
        "power": 6,
        "HP": 6,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SOR_121": {
        "id": "SOR_121",
        "face": {
            "front": {
                "name": "Hardpoint Heavy Blaster",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/121.png",
                "isHorizontal": false
            }
        },
        "name": "Hardpoint Heavy Blaster",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "MODIFICATION",
            "WEAPON"
        ]
    },
    "SOR_385": {
        "id": "SOR_385",
        "face": {
            "front": {
                "name": "Hardpoint Heavy Blaster",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/385.png",
                "isHorizontal": false
            }
        },
        "name": "Hardpoint Heavy Blaster",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "MODIFICATION",
            "WEAPON"
        ]
    },
    "SOR_008": {
        "id": "SOR_008",
        "face": {
            "front": {
                "name": "Hera Syndulla, Spectre Two",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/008-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Hera Syndulla, Spectre Two",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SOR/008-b.png"
            }
        },
        "name": "Hera Syndulla, Spectre Two",
        "type": "Leader",
        "cost": 6,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "TWI'LEK",
            "SPECTRE"
        ]
    },
    "SOR_259": {
        "id": "SOR_259",
        "face": {
            "front": {
                "name": "Hera Syndulla, Spectre Two",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/259-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Hera Syndulla, Spectre Two",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SOR/259-b.png"
            }
        },
        "name": "Hera Syndulla, Spectre Two",
        "type": "Leader",
        "cost": 6,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "TWI'LEK",
            "SPECTRE"
        ]
    },
    "SOR_275": {
        "id": "SOR_275",
        "face": {
            "front": {
                "name": "Hera Syndulla, Spectre Two",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/275-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Hera Syndulla, Spectre Two",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SOR/275-b.png"
            }
        },
        "name": "Hera Syndulla, Spectre Two",
        "type": "Leader",
        "cost": 6,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "TWI'LEK",
            "SPECTRE"
        ]
    },
    "SOR_150": {
        "id": "SOR_150",
        "face": {
            "front": {
                "name": "Heroic Sacrifice",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/150.png",
                "isHorizontal": false
            }
        },
        "name": "Heroic Sacrifice",
        "type": "Event",
        "cost": 1,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_413": {
        "id": "SOR_413",
        "face": {
            "front": {
                "name": "Heroic Sacrifice",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/413.png",
                "isHorizontal": false
            }
        },
        "name": "Heroic Sacrifice",
        "type": "Event",
        "cost": 1,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_102": {
        "id": "SOR_102",
        "face": {
            "front": {
                "name": "Home One, Alliance Flagship",
                "type": "Unit - Space",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/SOR/102.png",
                "isHorizontal": false
            }
        },
        "name": "Home One, Alliance Flagship",
        "type": "Unit - Space",
        "cost": 8,
        "rarity": "Legendary",
        "power": 7,
        "HP": 7,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "SOR_366": {
        "id": "SOR_366",
        "face": {
            "front": {
                "name": "Home One, Alliance Flagship",
                "type": "Unit - Space",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/SOR/366.png",
                "isHorizontal": false
            }
        },
        "name": "Home One, Alliance Flagship",
        "type": "Unit - Space",
        "cost": 8,
        "rarity": "Legendary",
        "power": 7,
        "HP": 7,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "SOR_113": {
        "id": "SOR_113",
        "face": {
            "front": {
                "name": "Homestead Militia",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/113.png",
                "isHorizontal": false
            }
        },
        "name": "Homestead Militia",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "TROOPER"
        ]
    },
    "SOR_377": {
        "id": "SOR_377",
        "face": {
            "front": {
                "name": "Homestead Militia",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/377.png",
                "isHorizontal": false
            }
        },
        "name": "Homestead Militia",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "TROOPER"
        ]
    },
    "SOR_233": {
        "id": "SOR_233",
        "face": {
            "front": {
                "name": "I Am Your Father",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/233.png",
                "isHorizontal": false
            }
        },
        "name": "I Am Your Father",
        "type": "Event",
        "cost": 3,
        "rarity": "Special",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "SOR_187": {
        "id": "SOR_187",
        "face": {
            "front": {
                "name": "I Had No Choice",
                "type": "Event",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SOR/187.png",
                "isHorizontal": false
            }
        },
        "name": "I Had No Choice",
        "type": "Event",
        "cost": 7,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "SOR_450": {
        "id": "SOR_450",
        "face": {
            "front": {
                "name": "I Had No Choice",
                "type": "Event",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SOR/450.png",
                "isHorizontal": false
            }
        },
        "name": "I Had No Choice",
        "type": "Event",
        "cost": 7,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "SOR_012": {
        "id": "SOR_012",
        "face": {
            "front": {
                "name": "IG-88, Ruthless Bounty Hunter",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/012-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "IG-88, Ruthless Bounty Hunter",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SOR/012-b.png"
            }
        },
        "name": "IG-88, Ruthless Bounty Hunter",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "DROID",
            "BOUNTY HUNTER"
        ]
    },
    "SOR_262": {
        "id": "SOR_262",
        "face": {
            "front": {
                "name": "IG-88, Ruthless Bounty Hunter",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/262-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "IG-88, Ruthless Bounty Hunter",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SOR/262-b.png"
            }
        },
        "name": "IG-88, Ruthless Bounty Hunter",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "DROID",
            "BOUNTY HUNTER"
        ]
    },
    "SOR_278": {
        "id": "SOR_278",
        "face": {
            "front": {
                "name": "IG-88, Ruthless Bounty Hunter",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/278-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "IG-88, Ruthless Bounty Hunter",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SOR/278-b.png"
            }
        },
        "name": "IG-88, Ruthless Bounty Hunter",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "DROID",
            "BOUNTY HUNTER"
        ]
    },
    "SOR_176": {
        "id": "SOR_176",
        "face": {
            "front": {
                "name": "ISB Agent",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/176.png",
                "isHorizontal": false
            }
        },
        "name": "ISB Agent",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL"
        ]
    },
    "SOR_439": {
        "id": "SOR_439",
        "face": {
            "front": {
                "name": "ISB Agent",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/439.png",
                "isHorizontal": false
            }
        },
        "name": "ISB Agent",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL"
        ]
    },
    "SOR_002": {
        "id": "SOR_002",
        "face": {
            "front": {
                "name": "Iden Versio, Infero Squad Commander",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/002-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Iden Versio, Infero Squad Commander",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SOR/002-b.png"
            }
        },
        "name": "Iden Versio, Infero Squad Commander",
        "type": "Leader",
        "cost": 6,
        "rarity": "Rare",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "SOR_254": {
        "id": "SOR_254",
        "face": {
            "front": {
                "name": "Iden Versio, Infero Squad Commander",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/254-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Iden Versio, Infero Squad Commander",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SOR/254-b.png"
            }
        },
        "name": "Iden Versio, Infero Squad Commander",
        "type": "Leader",
        "cost": 6,
        "rarity": "Rare",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "SOR_270": {
        "id": "SOR_270",
        "face": {
            "front": {
                "name": "Iden Versio, Infero Squad Commander",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/270-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Iden Versio, Infero Squad Commander",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SOR/270-b.png"
            }
        },
        "name": "Iden Versio, Infero Squad Commander",
        "type": "Leader",
        "cost": 6,
        "rarity": "Rare",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "SOR_132": {
        "id": "SOR_132",
        "face": {
            "front": {
                "name": "Imperial Interceptor",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/132.png",
                "isHorizontal": false
            }
        },
        "name": "Imperial Interceptor",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_396": {
        "id": "SOR_396",
        "face": {
            "front": {
                "name": "Imperial Interceptor",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/396.png",
                "isHorizontal": false
            }
        },
        "name": "Imperial Interceptor",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_031": {
        "id": "SOR_031",
        "face": {
            "front": {
                "name": "Inferno Four, Unforgetting",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/031.png",
                "isHorizontal": false
            }
        },
        "name": "Inferno Four, Unforgetting",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_297": {
        "id": "SOR_297",
        "face": {
            "front": {
                "name": "Inferno Four, Unforgetting",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/297.png",
                "isHorizontal": false
            }
        },
        "name": "Inferno Four, Unforgetting",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_166": {
        "id": "SOR_166",
        "face": {
            "front": {
                "name": "Infiltrator's Skill",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/166.png",
                "isHorizontal": false
            }
        },
        "name": "Infiltrator's Skill",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "LEARNED"
        ]
    },
    "SOR_429": {
        "id": "SOR_429",
        "face": {
            "front": {
                "name": "Infiltrator's Skill",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/429.png",
                "isHorizontal": false
            }
        },
        "name": "Infiltrator's Skill",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "LEARNED"
        ]
    },
    "SOR_075": {
        "id": "SOR_075",
        "face": {
            "front": {
                "name": "It Binds All Things",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/075.png",
                "isHorizontal": false
            }
        },
        "name": "It Binds All Things",
        "type": "Event",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "FORCE"
        ]
    },
    "SOR_340": {
        "id": "SOR_340",
        "face": {
            "front": {
                "name": "It Binds All Things",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/340.png",
                "isHorizontal": false
            }
        },
        "name": "It Binds All Things",
        "type": "Event",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "FORCE"
        ]
    },
    "SOR_181": {
        "id": "SOR_181",
        "face": {
            "front": {
                "name": "Jabba the Hutt, Cunning Daimyo",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/181.png",
                "isHorizontal": false
            }
        },
        "name": "Jabba the Hutt, Cunning Daimyo",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 2,
        "HP": 8,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "HUTT"
        ]
    },
    "SOR_444": {
        "id": "SOR_444",
        "face": {
            "front": {
                "name": "Jabba the Hutt, Cunning Daimyo",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/444.png",
                "isHorizontal": false
            }
        },
        "name": "Jabba the Hutt, Cunning Daimyo",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 2,
        "HP": 8,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "HUTT"
        ]
    },
    "SOR_205": {
        "id": "SOR_205",
        "face": {
            "front": {
                "name": "Jawa Scavenger",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/205.png",
                "isHorizontal": false
            }
        },
        "name": "Jawa Scavenger",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "JAWA"
        ]
    },
    "SOR_467": {
        "id": "SOR_467",
        "face": {
            "front": {
                "name": "Jawa Scavenger",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/467.png",
                "isHorizontal": false
            }
        },
        "name": "Jawa Scavenger",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "JAWA"
        ]
    },
    "SOR_158": {
        "id": "SOR_158",
        "face": {
            "front": {
                "name": "Jedha Agitator",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/158.png",
                "isHorizontal": false
            }
        },
        "name": "Jedha Agitator",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "REBEL"
        ]
    },
    "SOR_421": {
        "id": "SOR_421",
        "face": {
            "front": {
                "name": "Jedha Agitator",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/421.png",
                "isHorizontal": false
            }
        },
        "name": "Jedha Agitator",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "REBEL"
        ]
    },
    "SOR_028": {
        "id": "SOR_028",
        "face": {
            "front": {
                "name": "Jedha City, Jedha",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SOR/028-r.png",
                "isHorizontal": true
            }
        },
        "name": "Jedha City, Jedha",
        "type": "Base",
        "cost": 0,
        "rarity": "Rare",
        "power": 0,
        "HP": 25,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": []
    },
    "SOR_294": {
        "id": "SOR_294",
        "face": {
            "front": {
                "name": "Jedha City, Jedha",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SOR/294-r.png",
                "isHorizontal": true
            }
        },
        "name": "Jedha City, Jedha",
        "type": "Base",
        "cost": 0,
        "rarity": "Rare",
        "power": 0,
        "HP": 25,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": []
    },
    "SOR_054": {
        "id": "SOR_054",
        "face": {
            "front": {
                "name": "Jedi Lightsaber",
                "type": "Upgrade",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/054.png",
                "isHorizontal": false
            }
        },
        "name": "Jedi Lightsaber",
        "type": "Upgrade",
        "cost": 3,
        "rarity": "Rare",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "ITEM",
            "WEAPON",
            "LIGHTSABER"
        ]
    },
    "SOR_319": {
        "id": "SOR_319",
        "face": {
            "front": {
                "name": "Jedi Lightsaber",
                "type": "Upgrade",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/319.png",
                "isHorizontal": false
            }
        },
        "name": "Jedi Lightsaber",
        "type": "Upgrade",
        "cost": 3,
        "rarity": "Rare",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "ITEM",
            "WEAPON",
            "LIGHTSABER"
        ]
    },
    "SOR_018": {
        "id": "SOR_018",
        "face": {
            "front": {
                "name": "Jyn Erso, Resisting Oppression",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/018-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Jyn Erso, Resisting Oppression",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SOR/018-b.png"
            }
        },
        "name": "Jyn Erso, Resisting Oppression",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL"
        ]
    },
    "SOR_268": {
        "id": "SOR_268",
        "face": {
            "front": {
                "name": "Jyn Erso, Resisting Oppression",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/268-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Jyn Erso, Resisting Oppression",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SOR/268-b.png"
            }
        },
        "name": "Jyn Erso, Resisting Oppression",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL"
        ]
    },
    "SOR_284": {
        "id": "SOR_284",
        "face": {
            "front": {
                "name": "Jyn Erso, Resisting Oppression",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/284-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Jyn Erso, Resisting Oppression",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SOR/284-b.png"
            }
        },
        "name": "Jyn Erso, Resisting Oppression",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL"
        ]
    },
    "SOR_145": {
        "id": "SOR_145",
        "face": {
            "front": {
                "name": "K-2SO, Cassian's Counterpart",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/145.png",
                "isHorizontal": false
            }
        },
        "name": "K-2SO, Cassian's Counterpart",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "DROID"
        ]
    },
    "SOR_408": {
        "id": "SOR_408",
        "face": {
            "front": {
                "name": "K-2SO, Cassian's Counterpart",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/408.png",
                "isHorizontal": false
            }
        },
        "name": "K-2SO, Cassian's Counterpart",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "DROID"
        ]
    },
    "SOR_047": {
        "id": "SOR_047",
        "face": {
            "front": {
                "name": "Kanan Jarrus, Revealed Jedi",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/047.png",
                "isHorizontal": false
            }
        },
        "name": "Kanan Jarrus, Revealed Jedi",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REBEL",
            "SPECTRE"
        ]
    },
    "SOR_313": {
        "id": "SOR_313",
        "face": {
            "front": {
                "name": "Kanan Jarrus, Revealed Jedi",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/313.png",
                "isHorizontal": false
            }
        },
        "name": "Kanan Jarrus, Revealed Jedi",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REBEL",
            "SPECTRE"
        ]
    },
    "SOR_151": {
        "id": "SOR_151",
        "face": {
            "front": {
                "name": "Karabast",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/151.png",
                "isHorizontal": false
            }
        },
        "name": "Karabast",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "SPECTRE"
        ]
    },
    "SOR_414": {
        "id": "SOR_414",
        "face": {
            "front": {
                "name": "Karabast",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/414.png",
                "isHorizontal": false
            }
        },
        "name": "Karabast",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "SPECTRE"
        ]
    },
    "SOR_169": {
        "id": "SOR_169",
        "face": {
            "front": {
                "name": "Keep Fighting",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/169.png",
                "isHorizontal": false
            }
        },
        "name": "Keep Fighting",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_432": {
        "id": "SOR_432",
        "face": {
            "front": {
                "name": "Keep Fighting",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/432.png",
                "isHorizontal": false
            }
        },
        "name": "Keep Fighting",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_027": {
        "id": "SOR_027",
        "face": {
            "front": {
                "name": "Kestro City, Vardos",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SOR/027-r.png",
                "isHorizontal": true
            }
        },
        "name": "Kestro City, Vardos",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": []
    },
    "SOR_293": {
        "id": "SOR_293",
        "face": {
            "front": {
                "name": "Kestro City, Vardos",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SOR/293-r.png",
                "isHorizontal": true
            }
        },
        "name": "Kestro City, Vardos",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": []
    },
    "SOR_197": {
        "id": "SOR_197",
        "face": {
            "front": {
                "name": "Lando Calrissian, Responsible Businessman",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/197.png",
                "isHorizontal": false
            }
        },
        "name": "Lando Calrissian, Responsible Businessman",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Rare",
        "power": 6,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "OFFICIAL"
        ]
    },
    "SOR_459": {
        "id": "SOR_459",
        "face": {
            "front": {
                "name": "Lando Calrissian, Responsible Businessman",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/459.png",
                "isHorizontal": false
            }
        },
        "name": "Lando Calrissian, Responsible Businessman",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Rare",
        "power": 6,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "OFFICIAL"
        ]
    },
    "SOR_009": {
        "id": "SOR_009",
        "face": {
            "front": {
                "name": "Leia Organa, Alliance General",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/009-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Leia Organa, Alliance General",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SOR/009-b.png"
            }
        },
        "name": "Leia Organa, Alliance General",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "OFFICIAL"
        ]
    },
    "SOR_189": {
        "id": "SOR_189",
        "face": {
            "front": {
                "name": "Leia Organa, Defiant Princess",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/189.png",
                "isHorizontal": false
            }
        },
        "name": "Leia Organa, Defiant Princess",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Special",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "OFFICIAL"
        ]
    },
    "SOR_260": {
        "id": "SOR_260",
        "face": {
            "front": {
                "name": "Leia Organa, Alliance General",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/260-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Leia Organa, Alliance General",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SOR/260-b.png"
            }
        },
        "name": "Leia Organa, Alliance General",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "OFFICIAL"
        ]
    },
    "SOR_276": {
        "id": "SOR_276",
        "face": {
            "front": {
                "name": "Leia Organa, Alliance General",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/276-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Leia Organa, Alliance General",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SOR/276-b.png"
            }
        },
        "name": "Leia Organa, Alliance General",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "OFFICIAL"
        ]
    },
    "SOR_035": {
        "id": "SOR_035",
        "face": {
            "front": {
                "name": "Lieutenant Childsen, Death Star Prison Warden",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/035.png",
                "isHorizontal": false
            }
        },
        "name": "Lieutenant Childsen, Death Star Prison Warden",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "SOR_301": {
        "id": "SOR_301",
        "face": {
            "front": {
                "name": "Lieutenant Childsen, Death Star Prison Warden",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/301.png",
                "isHorizontal": false
            }
        },
        "name": "Lieutenant Childsen, Death Star Prison Warden",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "SOR_190": {
        "id": "SOR_190",
        "face": {
            "front": {
                "name": "Lothal Insurgent",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/190.png",
                "isHorizontal": false
            }
        },
        "name": "Lothal Insurgent",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL"
        ]
    },
    "SOR_452": {
        "id": "SOR_452",
        "face": {
            "front": {
                "name": "Lothal Insurgent",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/452.png",
                "isHorizontal": false
            }
        },
        "name": "Lothal Insurgent",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL"
        ]
    },
    "SOR_005": {
        "id": "SOR_005",
        "face": {
            "front": {
                "name": "Luke Skywalker, Faithful Friend",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/005-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Luke Skywalker, Faithful Friend",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SOR/005-b.png"
            }
        },
        "name": "Luke Skywalker, Faithful Friend",
        "type": "Leader",
        "cost": 6,
        "rarity": "Special",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "REBEL"
        ]
    },
    "SOR_051": {
        "id": "SOR_051",
        "face": {
            "front": {
                "name": "Luke Skywalker, Jedi Knight",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SOR/051.png",
                "isHorizontal": false
            }
        },
        "name": "Luke Skywalker, Jedi Knight",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Legendary",
        "power": 6,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REBEL"
        ]
    },
    "SOR_317": {
        "id": "SOR_317",
        "face": {
            "front": {
                "name": "Luke Skywalker, Jedi Knight",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SOR/317.png",
                "isHorizontal": false
            }
        },
        "name": "Luke Skywalker, Jedi Knight",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Legendary",
        "power": 6,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REBEL"
        ]
    },
    "SOR_053": {
        "id": "SOR_053",
        "face": {
            "front": {
                "name": "Luke's Lightsaber",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/053.png",
                "isHorizontal": false
            }
        },
        "name": "Luke's Lightsaber",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Special",
        "power": 3,
        "HP": 1,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "ITEM",
            "WEAPON",
            "LIGHTSABER"
        ]
    },
    "SOR_149": {
        "id": "SOR_149",
        "face": {
            "front": {
                "name": "Mace Windu, Party Crasher",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SOR/149.png",
                "isHorizontal": false
            }
        },
        "name": "Mace Windu, Party Crasher",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Legendary",
        "power": 5,
        "HP": 7,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "SOR_412": {
        "id": "SOR_412",
        "face": {
            "front": {
                "name": "Mace Windu, Party Crasher",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SOR/412.png",
                "isHorizontal": false
            }
        },
        "name": "Mace Windu, Party Crasher",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Legendary",
        "power": 5,
        "HP": 7,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "SOR_076": {
        "id": "SOR_076",
        "face": {
            "front": {
                "name": "Make an Opening",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/076.png",
                "isHorizontal": false
            }
        },
        "name": "Make an Opening",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_341": {
        "id": "SOR_341",
        "face": {
            "front": {
                "name": "Make an Opening",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/341.png",
                "isHorizontal": false
            }
        },
        "name": "Make an Opening",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_234": {
        "id": "SOR_234",
        "face": {
            "front": {
                "name": "Maximum Firepower",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/234.png",
                "isHorizontal": false
            }
        },
        "name": "Maximum Firepower",
        "type": "Event",
        "cost": 4,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "TACTIC"
        ]
    },
    "SOR_494": {
        "id": "SOR_494",
        "face": {
            "front": {
                "name": "Maximum Firepower",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/494.png",
                "isHorizontal": false
            }
        },
        "name": "Maximum Firepower",
        "type": "Event",
        "cost": 4,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "TACTIC"
        ]
    },
    "SOR_245": {
        "id": "SOR_245",
        "face": {
            "front": {
                "name": "Medal Ceremony",
                "type": "Event",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SOR/245.png",
                "isHorizontal": false
            }
        },
        "name": "Medal Ceremony",
        "type": "Event",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL"
        ]
    },
    "SOR_503": {
        "id": "SOR_503",
        "face": {
            "front": {
                "name": "Medal Ceremony",
                "type": "Event",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SOR/503.png",
                "isHorizontal": false
            }
        },
        "name": "Medal Ceremony",
        "type": "Event",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL"
        ]
    },
    "SOR_117": {
        "id": "SOR_117",
        "face": {
            "front": {
                "name": "Mercenary Company",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/117.png",
                "isHorizontal": false
            }
        },
        "name": "Mercenary Company",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "TROOPER"
        ]
    },
    "SOR_381": {
        "id": "SOR_381",
        "face": {
            "front": {
                "name": "Mercenary Company",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/381.png",
                "isHorizontal": false
            }
        },
        "name": "Mercenary Company",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "TROOPER"
        ]
    },
    "SOR_193": {
        "id": "SOR_193",
        "face": {
            "front": {
                "name": "Millennium Falcon, Piece Of Junk",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/193.png",
                "isHorizontal": false
            }
        },
        "name": "Millennium Falcon, Piece Of Junk",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Legendary",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SOR_455": {
        "id": "SOR_455",
        "face": {
            "front": {
                "name": "Millennium Falcon, Piece Of Junk",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/455.png",
                "isHorizontal": false
            }
        },
        "name": "Millennium Falcon, Piece Of Junk",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Legendary",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SOR_206": {
        "id": "SOR_206",
        "face": {
            "front": {
                "name": "Mining Guild TIE Fighter",
                "type": "Unit - Space",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/206.png",
                "isHorizontal": false
            }
        },
        "name": "Mining Guild TIE Fighter",
        "type": "Unit - Space",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 2,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_468": {
        "id": "SOR_468",
        "face": {
            "front": {
                "name": "Mining Guild TIE Fighter",
                "type": "Unit - Space",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/468.png",
                "isHorizontal": false
            }
        },
        "name": "Mining Guild TIE Fighter",
        "type": "Unit - Space",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 2,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_171": {
        "id": "SOR_171",
        "face": {
            "front": {
                "name": "Mission Briefing",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/171.png",
                "isHorizontal": false
            }
        },
        "name": "Mission Briefing",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "SOR_434": {
        "id": "SOR_434",
        "face": {
            "front": {
                "name": "Mission Briefing",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/434.png",
                "isHorizontal": false
            }
        },
        "name": "Mission Briefing",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "SOR_073": {
        "id": "SOR_073",
        "face": {
            "front": {
                "name": "Moment of Peace",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/073.png",
                "isHorizontal": false
            }
        },
        "name": "Moment of Peace",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SOR_338": {
        "id": "SOR_338",
        "face": {
            "front": {
                "name": "Moment of Peace",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/338.png",
                "isHorizontal": false
            }
        },
        "name": "Moment of Peace",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SOR_096": {
        "id": "SOR_096",
        "face": {
            "front": {
                "name": "Mon Mothma, Voice of the Rebellion",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/096.png",
                "isHorizontal": false
            }
        },
        "name": "Mon Mothma, Voice of the Rebellion",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Command"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "OFFICIAL"
        ]
    },
    "SOR_360": {
        "id": "SOR_360",
        "face": {
            "front": {
                "name": "Mon Mothma, Voice of the Rebellion",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/360.png",
                "isHorizontal": false
            }
        },
        "name": "Mon Mothma, Voice of the Rebellion",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Command"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "OFFICIAL"
        ]
    },
    "SOR_186": {
        "id": "SOR_186",
        "face": {
            "front": {
                "name": "No Good to Me Dead",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/186.png",
                "isHorizontal": false
            }
        },
        "name": "No Good to Me Dead",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "SOR_449": {
        "id": "SOR_449",
        "face": {
            "front": {
                "name": "No Good to Me Dead",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/449.png",
                "isHorizontal": false
            }
        },
        "name": "No Good to Me Dead",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "SOR_049": {
        "id": "SOR_049",
        "face": {
            "front": {
                "name": "Obi-Wan Kenobi, Following Fate",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/049.png",
                "isHorizontal": false
            }
        },
        "name": "Obi-Wan Kenobi, Following Fate",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI"
        ]
    },
    "SOR_315": {
        "id": "SOR_315",
        "face": {
            "front": {
                "name": "Obi-Wan Kenobi, Following Fate",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/315.png",
                "isHorizontal": false
            }
        },
        "name": "Obi-Wan Kenobi, Following Fate",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI"
        ]
    },
    "SOR_165": {
        "id": "SOR_165",
        "face": {
            "front": {
                "name": "Occupier Siege Tank",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/165.png",
                "isHorizontal": false
            }
        },
        "name": "Occupier Siege Tank",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Common",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "TANK"
        ]
    },
    "SOR_428": {
        "id": "SOR_428",
        "face": {
            "front": {
                "name": "Occupier Siege Tank",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/428.png",
                "isHorizontal": false
            }
        },
        "name": "Occupier Siege Tank",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Common",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "TANK"
        ]
    },
    "SOR_172": {
        "id": "SOR_172",
        "face": {
            "front": {
                "name": "Open Fire",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/172.png",
                "isHorizontal": false
            }
        },
        "name": "Open Fire",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_435": {
        "id": "SOR_435",
        "face": {
            "front": {
                "name": "Open Fire",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/435.png",
                "isHorizontal": false
            }
        },
        "name": "Open Fire",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_208": {
        "id": "SOR_208",
        "face": {
            "front": {
                "name": "Outer Rim Headhunter",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/208.png",
                "isHorizontal": false
            }
        },
        "name": "Outer Rim Headhunter",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_470": {
        "id": "SOR_470",
        "face": {
            "front": {
                "name": "Outer Rim Headhunter",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/470.png",
                "isHorizontal": false
            }
        },
        "name": "Outer Rim Headhunter",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_221": {
        "id": "SOR_221",
        "face": {
            "front": {
                "name": "Outmaneuver",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/221.png",
                "isHorizontal": false
            }
        },
        "name": "Outmaneuver",
        "type": "Event",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_483": {
        "id": "SOR_483",
        "face": {
            "front": {
                "name": "Outmaneuver",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/483.png",
                "isHorizontal": false
            }
        },
        "name": "Outmaneuver",
        "type": "Event",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_092": {
        "id": "SOR_092",
        "face": {
            "front": {
                "name": "Overwhelming Barrage",
                "type": "Event",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/092.png",
                "isHorizontal": false
            }
        },
        "name": "Overwhelming Barrage",
        "type": "Event",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_356": {
        "id": "SOR_356",
        "face": {
            "front": {
                "name": "Overwhelming Barrage",
                "type": "Event",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/356.png",
                "isHorizontal": false
            }
        },
        "name": "Overwhelming Barrage",
        "type": "Event",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_159": {
        "id": "SOR_159",
        "face": {
            "front": {
                "name": "Partisan Insurgent",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/159.png",
                "isHorizontal": false
            }
        },
        "name": "Partisan Insurgent",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "TROOPER"
        ]
    },
    "SOR_422": {
        "id": "SOR_422",
        "face": {
            "front": {
                "name": "Partisan Insurgent",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/422.png",
                "isHorizontal": false
            }
        },
        "name": "Partisan Insurgent",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "TROOPER"
        ]
    },
    "SOR_111": {
        "id": "SOR_111",
        "face": {
            "front": {
                "name": "Patrolling V-Wing",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/111.png",
                "isHorizontal": false
            }
        },
        "name": "Patrolling V-Wing",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_375": {
        "id": "SOR_375",
        "face": {
            "front": {
                "name": "Patrolling V-Wing",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/375.png",
                "isHorizontal": false
            }
        },
        "name": "Patrolling V-Wing",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_209": {
        "id": "SOR_209",
        "face": {
            "front": {
                "name": "Pirated Starfighter",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/209.png",
                "isHorizontal": false
            }
        },
        "name": "Pirated Starfighter",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_471": {
        "id": "SOR_471",
        "face": {
            "front": {
                "name": "Pirated Starfighter",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/471.png",
                "isHorizontal": false
            }
        },
        "name": "Pirated Starfighter",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_170": {
        "id": "SOR_170",
        "face": {
            "front": {
                "name": "Power Failure",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/170.png",
                "isHorizontal": false
            }
        },
        "name": "Power Failure",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_433": {
        "id": "SOR_433",
        "face": {
            "front": {
                "name": "Power Failure",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/433.png",
                "isHorizontal": false
            }
        },
        "name": "Power Failure",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_041": {
        "id": "SOR_041",
        "face": {
            "front": {
                "name": "Power of the Dark Side",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/041.png",
                "isHorizontal": false
            }
        },
        "name": "Power of the Dark Side",
        "type": "Event",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SOR_307": {
        "id": "SOR_307",
        "face": {
            "front": {
                "name": "Power of the Dark Side",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/307.png",
                "isHorizontal": false
            }
        },
        "name": "Power of the Dark Side",
        "type": "Event",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SOR_168": {
        "id": "SOR_168",
        "face": {
            "front": {
                "name": "Precision Fire",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/168.png",
                "isHorizontal": false
            }
        },
        "name": "Precision Fire",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_431": {
        "id": "SOR_431",
        "face": {
            "front": {
                "name": "Precision Fire",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/431.png",
                "isHorizontal": false
            }
        },
        "name": "Precision Fire",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_125": {
        "id": "SOR_125",
        "face": {
            "front": {
                "name": "Prepare For Takeoff",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/125.png",
                "isHorizontal": false
            }
        },
        "name": "Prepare For Takeoff",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "SOR_389": {
        "id": "SOR_389",
        "face": {
            "front": {
                "name": "Prepare For Takeoff",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/389.png",
                "isHorizontal": false
            }
        },
        "name": "Prepare For Takeoff",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "SOR_057": {
        "id": "SOR_057",
        "face": {
            "front": {
                "name": "Protector",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/057.png",
                "isHorizontal": false
            }
        },
        "name": "Protector",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Vigilance",
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SOR_322": {
        "id": "SOR_322",
        "face": {
            "front": {
                "name": "Protector",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/322.png",
                "isHorizontal": false
            }
        },
        "name": "Protector",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Vigilance",
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SOR_236": {
        "id": "SOR_236",
        "face": {
            "front": {
                "name": "R2-D2, Ignoring Protocol",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/236.png",
                "isHorizontal": false
            }
        },
        "name": "R2-D2, Ignoring Protocol",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Special",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "DROID"
        ]
    },
    "SOR_154": {
        "id": "SOR_154",
        "face": {
            "front": {
                "name": "Rallying Cry",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/154.png",
                "isHorizontal": false
            }
        },
        "name": "Rallying Cry",
        "type": "Event",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_417": {
        "id": "SOR_417",
        "face": {
            "front": {
                "name": "Rallying Cry",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/417.png",
                "isHorizontal": false
            }
        },
        "name": "Rallying Cry",
        "type": "Event",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_103": {
        "id": "SOR_103",
        "face": {
            "front": {
                "name": "Rebel Assault",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/103.png",
                "isHorizontal": false
            }
        },
        "name": "Rebel Assault",
        "type": "Event",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "TACTIC"
        ]
    },
    "SOR_367": {
        "id": "SOR_367",
        "face": {
            "front": {
                "name": "Rebel Assault",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/367.png",
                "isHorizontal": false
            }
        },
        "name": "Rebel Assault",
        "type": "Event",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "TACTIC"
        ]
    },
    "SOR_239": {
        "id": "SOR_239",
        "face": {
            "front": {
                "name": "Rebel Pathfinder",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/239.png",
                "isHorizontal": false
            }
        },
        "name": "Rebel Pathfinder",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "TROOPER"
        ]
    },
    "SOR_497": {
        "id": "SOR_497",
        "face": {
            "front": {
                "name": "Rebel Pathfinder",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/497.png",
                "isHorizontal": false
            }
        },
        "name": "Rebel Pathfinder",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "TROOPER"
        ]
    },
    "SOR_123": {
        "id": "SOR_123",
        "face": {
            "front": {
                "name": "Recruit",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/123.png",
                "isHorizontal": false
            }
        },
        "name": "Recruit",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "SOR_387": {
        "id": "SOR_387",
        "face": {
            "front": {
                "name": "Recruit",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/387.png",
                "isHorizontal": false
            }
        },
        "name": "Recruit",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "SOR_144": {
        "id": "SOR_144",
        "face": {
            "front": {
                "name": "Red Three, Unstoppable",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/144.png",
                "isHorizontal": false
            }
        },
        "name": "Red Three, Unstoppable",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Rare",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_407": {
        "id": "SOR_407",
        "face": {
            "front": {
                "name": "Red Three, Unstoppable",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/407.png",
                "isHorizontal": false
            }
        },
        "name": "Red Three, Unstoppable",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Rare",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_052": {
        "id": "SOR_052",
        "face": {
            "front": {
                "name": "Redemption, Medical Frigate",
                "type": "Unit - Space",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/SOR/052.png",
                "isHorizontal": false
            }
        },
        "name": "Redemption, Medical Frigate",
        "type": "Unit - Space",
        "cost": 8,
        "rarity": "Rare",
        "power": 6,
        "HP": 9,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "SOR_318": {
        "id": "SOR_318",
        "face": {
            "front": {
                "name": "Redemption, Medical Frigate",
                "type": "Unit - Space",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/SOR/318.png",
                "isHorizontal": false
            }
        },
        "name": "Redemption, Medical Frigate",
        "type": "Unit - Space",
        "cost": 8,
        "rarity": "Rare",
        "power": 6,
        "HP": 9,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "SOR_062": {
        "id": "SOR_062",
        "face": {
            "front": {
                "name": "Regional Governor",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/062.png",
                "isHorizontal": false
            }
        },
        "name": "Regional Governor",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "SOR_327": {
        "id": "SOR_327",
        "face": {
            "front": {
                "name": "Regional Governor",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/327.png",
                "isHorizontal": false
            }
        },
        "name": "Regional Governor",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "SOR_243": {
        "id": "SOR_243",
        "face": {
            "front": {
                "name": "Regional Sympathizers",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/243.png",
                "isHorizontal": false
            }
        },
        "name": "Regional Sympathizers",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL"
        ]
    },
    "SOR_501": {
        "id": "SOR_501",
        "face": {
            "front": {
                "name": "Regional Sympathizers",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/501.png",
                "isHorizontal": false
            }
        },
        "name": "Regional Sympathizers",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL"
        ]
    },
    "SOR_119": {
        "id": "SOR_119",
        "face": {
            "front": {
                "name": "Reinforcement Walker",
                "type": "Unit - Ground",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/SOR/119.png",
                "isHorizontal": false
            }
        },
        "name": "Reinforcement Walker",
        "type": "Unit - Ground",
        "cost": 8,
        "rarity": "Uncommon",
        "power": 6,
        "HP": 9,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "VEHICLE",
            "WALKER"
        ]
    },
    "SOR_383": {
        "id": "SOR_383",
        "face": {
            "front": {
                "name": "Reinforcement Walker",
                "type": "Unit - Ground",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/SOR/383.png",
                "isHorizontal": false
            }
        },
        "name": "Reinforcement Walker",
        "type": "Unit - Ground",
        "cost": 8,
        "rarity": "Uncommon",
        "power": 6,
        "HP": 9,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "VEHICLE",
            "WALKER"
        ]
    },
    "SOR_089": {
        "id": "SOR_089",
        "face": {
            "front": {
                "name": "Relentless, Konstantine's Folly",
                "type": "Unit - Space",
                "cost": 9,
                "image": "https://cdn.swu-db.com/images/cards/SOR/089.png",
                "isHorizontal": false
            }
        },
        "name": "Relentless, Konstantine's Folly",
        "type": "Unit - Space",
        "cost": 9,
        "rarity": "Rare",
        "power": 8,
        "HP": 8,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "SOR_353": {
        "id": "SOR_353",
        "face": {
            "front": {
                "name": "Relentless, Konstantine's Folly",
                "type": "Unit - Space",
                "cost": 9,
                "image": "https://cdn.swu-db.com/images/cards/SOR/353.png",
                "isHorizontal": false
            }
        },
        "name": "Relentless, Konstantine's Folly",
        "type": "Unit - Space",
        "cost": 9,
        "rarity": "Rare",
        "power": 8,
        "HP": 8,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "SOR_074": {
        "id": "SOR_074",
        "face": {
            "front": {
                "name": "Repair",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/074.png",
                "isHorizontal": false
            }
        },
        "name": "Repair",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "SOR_339": {
        "id": "SOR_339",
        "face": {
            "front": {
                "name": "Repair",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/339.png",
                "isHorizontal": false
            }
        },
        "name": "Repair",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "SOR_069": {
        "id": "SOR_069",
        "face": {
            "front": {
                "name": "Resilient",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/069.png",
                "isHorizontal": false
            }
        },
        "name": "Resilient",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 3,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SOR_334": {
        "id": "SOR_334",
        "face": {
            "front": {
                "name": "Resilient",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/334.png",
                "isHorizontal": false
            }
        },
        "name": "Resilient",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 3,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SOR_252": {
        "id": "SOR_252",
        "face": {
            "front": {
                "name": "Restock",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/252.png",
                "isHorizontal": false
            }
        },
        "name": "Restock",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "SOR_510": {
        "id": "SOR_510",
        "face": {
            "front": {
                "name": "Restock",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/510.png",
                "isHorizontal": false
            }
        },
        "name": "Restock",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "SOR_044": {
        "id": "SOR_044",
        "face": {
            "front": {
                "name": "Restored ARC-170",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/044.png",
                "isHorizontal": false
            }
        },
        "name": "Restored ARC-170",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_310": {
        "id": "SOR_310",
        "face": {
            "front": {
                "name": "Restored ARC-170",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/310.png",
                "isHorizontal": false
            }
        },
        "name": "Restored ARC-170",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_126": {
        "id": "SOR_126",
        "face": {
            "front": {
                "name": "Resupply",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/126.png",
                "isHorizontal": false
            }
        },
        "name": "Resupply",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "SOR_390": {
        "id": "SOR_390",
        "face": {
            "front": {
                "name": "Resupply",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/390.png",
                "isHorizontal": false
            }
        },
        "name": "Resupply",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "SOR_194": {
        "id": "SOR_194",
        "face": {
            "front": {
                "name": "Rogue Operative",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/194.png",
                "isHorizontal": false
            }
        },
        "name": "Rogue Operative",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "TROOPER"
        ]
    },
    "SOR_456": {
        "id": "SOR_456",
        "face": {
            "front": {
                "name": "Rogue Operative",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/456.png",
                "isHorizontal": false
            }
        },
        "name": "Rogue Operative",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "TROOPER"
        ]
    },
    "SOR_101": {
        "id": "SOR_101",
        "face": {
            "front": {
                "name": "Rogue Squadron Skirmisher",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/101.png",
                "isHorizontal": false
            }
        },
        "name": "Rogue Squadron Skirmisher",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "SPEEDER"
        ]
    },
    "SOR_365": {
        "id": "SOR_365",
        "face": {
            "front": {
                "name": "Rogue Squadron Skirmisher",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/365.png",
                "isHorizontal": false
            }
        },
        "name": "Rogue Squadron Skirmisher",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "SPEEDER"
        ]
    },
    "SOR_067": {
        "id": "SOR_067",
        "face": {
            "front": {
                "name": "Rugged Survivors",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/067.png",
                "isHorizontal": false
            }
        },
        "name": "Rugged Survivors",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "FRINGE"
        ]
    },
    "SOR_332": {
        "id": "SOR_332",
        "face": {
            "front": {
                "name": "Rugged Survivors",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/332.png",
                "isHorizontal": false
            }
        },
        "name": "Rugged Survivors",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "FRINGE"
        ]
    },
    "SOR_085": {
        "id": "SOR_085",
        "face": {
            "front": {
                "name": "Rukh, Thrawn's Assassin",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/085.png",
                "isHorizontal": false
            }
        },
        "name": "Rukh, Thrawn's Assassin",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Rare",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL"
        ]
    },
    "SOR_349": {
        "id": "SOR_349",
        "face": {
            "front": {
                "name": "Rukh, Thrawn's Assassin",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/349.png",
                "isHorizontal": false
            }
        },
        "name": "Rukh, Thrawn's Assassin",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Rare",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL"
        ]
    },
    "SOR_134": {
        "id": "SOR_134",
        "face": {
            "front": {
                "name": "Ruthless Raider",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/134.png",
                "isHorizontal": false
            }
        },
        "name": "Ruthless Raider",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "SOR_398": {
        "id": "SOR_398",
        "face": {
            "front": {
                "name": "Ruthless Raider",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/398.png",
                "isHorizontal": false
            }
        },
        "name": "Ruthless Raider",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "SOR_014": {
        "id": "SOR_014",
        "face": {
            "front": {
                "name": "Sabine Wren, Galvanized Revolutionary",
                "type": "Leader",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/014-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Sabine Wren, Galvanized Revolutionary",
                "type": "Leader",
                "cost": "4",
                "image": "https://cdn.swu-db.com/images/cards/SOR/014-b.png"
            }
        },
        "name": "Sabine Wren, Galvanized Revolutionary",
        "type": "Leader",
        "cost": 4,
        "rarity": "Common",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "REBEL",
            "SPECTRE"
        ]
    },
    "SOR_142": {
        "id": "SOR_142",
        "face": {
            "front": {
                "name": "Sabine Wren, Explosives Artist",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/142.png",
                "isHorizontal": false
            }
        },
        "name": "Sabine Wren, Explosives Artist",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "REBEL",
            "SPECTRE"
        ]
    },
    "SOR_264": {
        "id": "SOR_264",
        "face": {
            "front": {
                "name": "Sabine Wren, Galvanized Revolutionary",
                "type": "Leader",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/264-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Sabine Wren, Galvanized Revolutionary",
                "type": "Leader",
                "cost": "4",
                "image": "https://cdn.swu-db.com/images/cards/SOR/264-b.png"
            }
        },
        "name": "Sabine Wren, Galvanized Revolutionary",
        "type": "Leader",
        "cost": 4,
        "rarity": "Common",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "REBEL",
            "SPECTRE"
        ]
    },
    "SOR_280": {
        "id": "SOR_280",
        "face": {
            "front": {
                "name": "Sabine Wren, Galvanized Revolutionary",
                "type": "Leader",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/280-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Sabine Wren, Galvanized Revolutionary",
                "type": "Leader",
                "cost": "4",
                "image": "https://cdn.swu-db.com/images/cards/SOR/280-b.png"
            }
        },
        "name": "Sabine Wren, Galvanized Revolutionary",
        "type": "Leader",
        "cost": 4,
        "rarity": "Common",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "REBEL",
            "SPECTRE"
        ]
    },
    "SOR_405": {
        "id": "SOR_405",
        "face": {
            "front": {
                "name": "Sabine Wren, Explosives Artist",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/405.png",
                "isHorizontal": false
            }
        },
        "name": "Sabine Wren, Explosives Artist",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "REBEL",
            "SPECTRE"
        ]
    },
    "SOR_153": {
        "id": "SOR_153",
        "face": {
            "front": {
                "name": "Saw Gerrera, Extremist",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/153.png",
                "isHorizontal": false
            }
        },
        "name": "Saw Gerrera, Extremist",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Aggression"
        ],
        "unique": true,
        "traits": [
            "REBEL"
        ]
    },
    "SOR_416": {
        "id": "SOR_416",
        "face": {
            "front": {
                "name": "Saw Gerrera, Extremist",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/416.png",
                "isHorizontal": false
            }
        },
        "name": "Saw Gerrera, Extremist",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Aggression"
        ],
        "unique": true,
        "traits": [
            "REBEL"
        ]
    },
    "SOR_032": {
        "id": "SOR_032",
        "face": {
            "front": {
                "name": "Scout Bike Pursuer",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/032.png",
                "isHorizontal": false
            }
        },
        "name": "Scout Bike Pursuer",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "SOR_298": {
        "id": "SOR_298",
        "face": {
            "front": {
                "name": "Scout Bike Pursuer",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/298.png",
                "isHorizontal": false
            }
        },
        "name": "Scout Bike Pursuer",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "SOR_042": {
        "id": "SOR_042",
        "face": {
            "front": {
                "name": "Search Your Feelings",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/042.png",
                "isHorizontal": false
            }
        },
        "name": "Search Your Feelings",
        "type": "Event",
        "cost": 4,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SOR_308": {
        "id": "SOR_308",
        "face": {
            "front": {
                "name": "Search Your Feelings",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/308.png",
                "isHorizontal": false
            }
        },
        "name": "Search Your Feelings",
        "type": "Event",
        "cost": 4,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SOR_081": {
        "id": "SOR_081",
        "face": {
            "front": {
                "name": "Seasoned Shoretrooper",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/081.png",
                "isHorizontal": false
            }
        },
        "name": "Seasoned Shoretrooper",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "SOR_346": {
        "id": "SOR_346",
        "face": {
            "front": {
                "name": "Seasoned Shoretrooper",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/346.png",
                "isHorizontal": false
            }
        },
        "name": "Seasoned Shoretrooper",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "SOR_019": {
        "id": "SOR_019",
        "face": {
            "front": {
                "name": "Security Complex, Scarif",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SOR/019-r.png",
                "isHorizontal": true
            }
        },
        "name": "Security Complex, Scarif",
        "type": "Base",
        "cost": 0,
        "rarity": "Rare",
        "power": 0,
        "HP": 25,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": []
    },
    "SOR_285": {
        "id": "SOR_285",
        "face": {
            "front": {
                "name": "Security Complex, Scarif",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SOR/285-r.png",
                "isHorizontal": true
            }
        },
        "name": "Security Complex, Scarif",
        "type": "Base",
        "cost": 0,
        "rarity": "Rare",
        "power": 0,
        "HP": 25,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": []
    },
    "SOR_180": {
        "id": "SOR_180",
        "face": {
            "front": {
                "name": "Seventh Fleet Defender",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/180.png",
                "isHorizontal": false
            }
        },
        "name": "Seventh Fleet Defender",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_443": {
        "id": "SOR_443",
        "face": {
            "front": {
                "name": "Seventh Fleet Defender",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/443.png",
                "isHorizontal": false
            }
        },
        "name": "Seventh Fleet Defender",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_133": {
        "id": "SOR_133",
        "face": {
            "front": {
                "name": "Seventh Sister, Implacable Inquisitor",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/133.png",
                "isHorizontal": false
            }
        },
        "name": "Seventh Sister, Implacable Inquisitor",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Rare",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "IMPERIAL",
            "INQUISITOR"
        ]
    },
    "SOR_397": {
        "id": "SOR_397",
        "face": {
            "front": {
                "name": "Seventh Sister, Implacable Inquisitor",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/397.png",
                "isHorizontal": false
            }
        },
        "name": "Seventh Sister, Implacable Inquisitor",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Rare",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "IMPERIAL",
            "INQUISITOR"
        ]
    },
    "SOR_217": {
        "id": "SOR_217",
        "face": {
            "front": {
                "name": "Shoot First",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/217.png",
                "isHorizontal": false
            }
        },
        "name": "Shoot First",
        "type": "Event",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "SOR_479": {
        "id": "SOR_479",
        "face": {
            "front": {
                "name": "Shoot First",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/479.png",
                "isHorizontal": false
            }
        },
        "name": "Shoot First",
        "type": "Event",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "SOR_174": {
        "id": "SOR_174",
        "face": {
            "front": {
                "name": "Smoke and Cinders",
                "type": "Event",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/174.png",
                "isHorizontal": false
            }
        },
        "name": "Smoke and Cinders",
        "type": "Event",
        "cost": 5,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "DISASTER"
        ]
    },
    "SOR_437": {
        "id": "SOR_437",
        "face": {
            "front": {
                "name": "Smoke and Cinders",
                "type": "Event",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/437.png",
                "isHorizontal": false
            }
        },
        "name": "Smoke and Cinders",
        "type": "Event",
        "cost": 5,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "DISASTER"
        ]
    },
    "SOR_214": {
        "id": "SOR_214",
        "face": {
            "front": {
                "name": "Smuggling Compartment",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/214.png",
                "isHorizontal": false
            }
        },
        "name": "Smuggling Compartment",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "MODIFICATION"
        ]
    },
    "SOR_476": {
        "id": "SOR_476",
        "face": {
            "front": {
                "name": "Smuggling Compartment",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/476.png",
                "isHorizontal": false
            }
        },
        "name": "Smuggling Compartment",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "MODIFICATION"
        ]
    },
    "SOR_215": {
        "id": "SOR_215",
        "face": {
            "front": {
                "name": "Snapshot Reflexes",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/215.png",
                "isHorizontal": false
            }
        },
        "name": "Snapshot Reflexes",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "LEARNED"
        ]
    },
    "SOR_477": {
        "id": "SOR_477",
        "face": {
            "front": {
                "name": "Snapshot Reflexes",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/477.png",
                "isHorizontal": false
            }
        },
        "name": "Snapshot Reflexes",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "LEARNED"
        ]
    },
    "SOR_219": {
        "id": "SOR_219",
        "face": {
            "front": {
                "name": "Sneak Attack",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/219.png",
                "isHorizontal": false
            }
        },
        "name": "Sneak Attack",
        "type": "Event",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "SOR_481": {
        "id": "SOR_481",
        "face": {
            "front": {
                "name": "Sneak Attack",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/481.png",
                "isHorizontal": false
            }
        },
        "name": "Sneak Attack",
        "type": "Event",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "SOR_244": {
        "id": "SOR_244",
        "face": {
            "front": {
                "name": "Snowspeeder",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/244.png",
                "isHorizontal": false
            }
        },
        "name": "Snowspeeder",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "SPEEDER"
        ]
    },
    "SOR_502": {
        "id": "SOR_502",
        "face": {
            "front": {
                "name": "Snowspeeder",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/502.png",
                "isHorizontal": false
            }
        },
        "name": "Snowspeeder",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "SPEEDER"
        ]
    },
    "SOR_227": {
        "id": "SOR_227",
        "face": {
            "front": {
                "name": "Snowtrooper Lieutenant",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/227.png",
                "isHorizontal": false
            }
        },
        "name": "Snowtrooper Lieutenant",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "SOR_488": {
        "id": "SOR_488",
        "face": {
            "front": {
                "name": "Snowtrooper Lieutenant",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/488.png",
                "isHorizontal": false
            }
        },
        "name": "Snowtrooper Lieutenant",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "SOR_200": {
        "id": "SOR_200",
        "face": {
            "front": {
                "name": "Spark of Rebellion",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/200.png",
                "isHorizontal": false
            }
        },
        "name": "Spark of Rebellion",
        "type": "Event",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "SPECTRE"
        ]
    },
    "SOR_462": {
        "id": "SOR_462",
        "face": {
            "front": {
                "name": "Spark of Rebellion",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/462.png",
                "isHorizontal": false
            }
        },
        "name": "Spark of Rebellion",
        "type": "Event",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "SPECTRE"
        ]
    },
    "SOR_140": {
        "id": "SOR_140",
        "face": {
            "front": {
                "name": "SpecForce Soldier",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/140.png",
                "isHorizontal": false
            }
        },
        "name": "SpecForce Soldier",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "TROOPER"
        ]
    },
    "SOR_403": {
        "id": "SOR_403",
        "face": {
            "front": {
                "name": "SpecForce Soldier",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/403.png",
                "isHorizontal": false
            }
        },
        "name": "SpecForce Soldier",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "TROOPER"
        ]
    },
    "SOR_163": {
        "id": "SOR_163",
        "face": {
            "front": {
                "name": "Star Wing Scout",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/163.png",
                "isHorizontal": false
            }
        },
        "name": "Star Wing Scout",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 1,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_426": {
        "id": "SOR_426",
        "face": {
            "front": {
                "name": "Star Wing Scout",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/426.png",
                "isHorizontal": false
            }
        },
        "name": "Star Wing Scout",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 1,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_116": {
        "id": "SOR_116",
        "face": {
            "front": {
                "name": "Steadfast Battalion",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/116.png",
                "isHorizontal": false
            }
        },
        "name": "Steadfast Battalion",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Common",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TROOPER"
        ]
    },
    "SOR_380": {
        "id": "SOR_380",
        "face": {
            "front": {
                "name": "Steadfast Battalion",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/380.png",
                "isHorizontal": false
            }
        },
        "name": "Steadfast Battalion",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Common",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TROOPER"
        ]
    },
    "SOR_212": {
        "id": "SOR_212",
        "face": {
            "front": {
                "name": "Strafing Gunship",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/212.png",
                "isHorizontal": false
            }
        },
        "name": "Strafing Gunship",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Rare",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_474": {
        "id": "SOR_474",
        "face": {
            "front": {
                "name": "Strafing Gunship",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/474.png",
                "isHorizontal": false
            }
        },
        "name": "Strafing Gunship",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Rare",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_127": {
        "id": "SOR_127",
        "face": {
            "front": {
                "name": "Strike True",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/127.png",
                "isHorizontal": false
            }
        },
        "name": "Strike True",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_391": {
        "id": "SOR_391",
        "face": {
            "front": {
                "name": "Strike True",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/391.png",
                "isHorizontal": false
            }
        },
        "name": "Strike True",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_043": {
        "id": "SOR_043",
        "face": {
            "front": {
                "name": "Superlaser Blast",
                "type": "Event",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/SOR/043.png",
                "isHorizontal": false
            }
        },
        "name": "Superlaser Blast",
        "type": "Event",
        "cost": 8,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "DISASTER",
            "TACTIC"
        ]
    },
    "SOR_309": {
        "id": "SOR_309",
        "face": {
            "front": {
                "name": "Superlaser Blast",
                "type": "Event",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/SOR/309.png",
                "isHorizontal": false
            }
        },
        "name": "Superlaser Blast",
        "type": "Event",
        "cost": 8,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "DISASTER",
            "TACTIC"
        ]
    },
    "SOR_083": {
        "id": "SOR_083",
        "face": {
            "front": {
                "name": "Superlaser Technician",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/083.png",
                "isHorizontal": false
            }
        },
        "name": "Superlaser Technician",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL"
        ]
    },
    "SOR_348": {
        "id": "SOR_348",
        "face": {
            "front": {
                "name": "Superlaser Technician",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/348.png",
                "isHorizontal": false
            }
        },
        "name": "Superlaser Technician",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL"
        ]
    },
    "SOR_220": {
        "id": "SOR_220",
        "face": {
            "front": {
                "name": "Surprise Strike",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/220.png",
                "isHorizontal": false
            }
        },
        "name": "Surprise Strike",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_482": {
        "id": "SOR_482",
        "face": {
            "front": {
                "name": "Surprise Strike",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/482.png",
                "isHorizontal": false
            }
        },
        "name": "Surprise Strike",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_210": {
        "id": "SOR_210",
        "face": {
            "front": {
                "name": "Swoop Racer",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/210.png",
                "isHorizontal": false
            }
        },
        "name": "Swoop Racer",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 4,
        "HP": 3,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "FRINGE"
        ]
    },
    "SOR_472": {
        "id": "SOR_472",
        "face": {
            "front": {
                "name": "Swoop Racer",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/472.png",
                "isHorizontal": false
            }
        },
        "name": "Swoop Racer",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 4,
        "HP": 3,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "FRINGE"
        ]
    },
    "SOR_213": {
        "id": "SOR_213",
        "face": {
            "front": {
                "name": "Syndicate Lackeys",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/213.png",
                "isHorizontal": false
            }
        },
        "name": "Syndicate Lackeys",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Common",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SOR_475": {
        "id": "SOR_475",
        "face": {
            "front": {
                "name": "Syndicate Lackeys",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/475.png",
                "isHorizontal": false
            }
        },
        "name": "Syndicate Lackeys",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Common",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SOR_066": {
        "id": "SOR_066",
        "face": {
            "front": {
                "name": "System Patrol Craft",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/066.png",
                "isHorizontal": false
            }
        },
        "name": "System Patrol Craft",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_331": {
        "id": "SOR_331",
        "face": {
            "front": {
                "name": "System Patrol Craft",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/331.png",
                "isHorizontal": false
            }
        },
        "name": "System Patrol Craft",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_231": {
        "id": "SOR_231",
        "face": {
            "front": {
                "name": "TIE Advanced",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/231.png",
                "isHorizontal": false
            }
        },
        "name": "TIE Advanced",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_492": {
        "id": "SOR_492",
        "face": {
            "front": {
                "name": "TIE Advanced",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/492.png",
                "isHorizontal": false
            }
        },
        "name": "TIE Advanced",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_225": {
        "id": "SOR_225",
        "face": {
            "front": {
                "name": "TIE/ln Fighter",
                "type": "Unit - Space",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/225.png",
                "isHorizontal": false
            }
        },
        "name": "TIE/ln Fighter",
        "type": "Unit - Space",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_487": {
        "id": "SOR_487",
        "face": {
            "front": {
                "name": "TIE/ln Fighter",
                "type": "Unit - Space",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/487.png",
                "isHorizontal": false
            }
        },
        "name": "TIE/ln Fighter",
        "type": "Unit - Space",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_124": {
        "id": "SOR_124",
        "face": {
            "front": {
                "name": "Tactical Advantage",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/124.png",
                "isHorizontal": false
            }
        },
        "name": "Tactical Advantage",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_388": {
        "id": "SOR_388",
        "face": {
            "front": {
                "name": "Tactical Advantage",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/388.png",
                "isHorizontal": false
            }
        },
        "name": "Tactical Advantage",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_077": {
        "id": "SOR_077",
        "face": {
            "front": {
                "name": "Takedown",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/077.png",
                "isHorizontal": false
            }
        },
        "name": "Takedown",
        "type": "Event",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_342": {
        "id": "SOR_342",
        "face": {
            "front": {
                "name": "Takedown",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/342.png",
                "isHorizontal": false
            }
        },
        "name": "Takedown",
        "type": "Event",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_025": {
        "id": "SOR_025",
        "face": {
            "front": {
                "name": "Tarkintown, Lothal",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SOR/025-r.png",
                "isHorizontal": true
            }
        },
        "name": "Tarkintown, Lothal",
        "type": "Base",
        "cost": 0,
        "rarity": "Rare",
        "power": 0,
        "HP": 25,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": []
    },
    "SOR_291": {
        "id": "SOR_291",
        "face": {
            "front": {
                "name": "Tarkintown, Lothal",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SOR/291-r.png",
                "isHorizontal": true
            }
        },
        "name": "Tarkintown, Lothal",
        "type": "Base",
        "cost": 0,
        "rarity": "Rare",
        "power": 0,
        "HP": 25,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": []
    },
    "SOR_091": {
        "id": "SOR_091",
        "face": {
            "front": {
                "name": "The Emperor's Legion",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/091.png",
                "isHorizontal": false
            }
        },
        "name": "The Emperor's Legion",
        "type": "Event",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "SUPPLY"
        ]
    },
    "SOR_355": {
        "id": "SOR_355",
        "face": {
            "front": {
                "name": "The Emperor's Legion",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/355.png",
                "isHorizontal": false
            }
        },
        "name": "The Emperor's Legion",
        "type": "Event",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "SUPPLY"
        ]
    },
    "SOR_055": {
        "id": "SOR_055",
        "face": {
            "front": {
                "name": "The Force Is With Me",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/055.png",
                "isHorizontal": false
            }
        },
        "name": "The Force Is With Me",
        "type": "Event",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "FORCE"
        ]
    },
    "SOR_320": {
        "id": "SOR_320",
        "face": {
            "front": {
                "name": "The Force Is With Me",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/320.png",
                "isHorizontal": false
            }
        },
        "name": "The Force Is With Me",
        "type": "Event",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "FORCE"
        ]
    },
    "SOR_050": {
        "id": "SOR_050",
        "face": {
            "front": {
                "name": "The Ghost, Spectre Home Base",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/050.png",
                "isHorizontal": false
            }
        },
        "name": "The Ghost, Spectre Home Base",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Uncommon",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "TRANSPORT",
            "SPECTRE"
        ]
    },
    "SOR_316": {
        "id": "SOR_316",
        "face": {
            "front": {
                "name": "The Ghost, Spectre Home Base",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SOR/316.png",
                "isHorizontal": false
            }
        },
        "name": "The Ghost, Spectre Home Base",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Uncommon",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "TRANSPORT",
            "SPECTRE"
        ]
    },
    "SOR_122": {
        "id": "SOR_122",
        "face": {
            "front": {
                "name": "Traitorous",
                "type": "Upgrade",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/122.png",
                "isHorizontal": false
            }
        },
        "name": "Traitorous",
        "type": "Upgrade",
        "cost": 5,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SOR_386": {
        "id": "SOR_386",
        "face": {
            "front": {
                "name": "Traitorous",
                "type": "Upgrade",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/386.png",
                "isHorizontal": false
            }
        },
        "name": "Traitorous",
        "type": "Upgrade",
        "cost": 5,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SOR_104": {
        "id": "SOR_104",
        "face": {
            "front": {
                "name": "U-Wing Reinforcement",
                "type": "Event",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SOR/104.png",
                "isHorizontal": false
            }
        },
        "name": "U-Wing Reinforcement",
        "type": "Event",
        "cost": 7,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "SOR_368": {
        "id": "SOR_368",
        "face": {
            "front": {
                "name": "U-Wing Reinforcement",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/368.png",
                "isHorizontal": false
            }
        },
        "name": "U-Wing Reinforcement",
        "type": "Event",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "SOR_247": {
        "id": "SOR_247",
        "face": {
            "front": {
                "name": "Underworld Thug",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/247.png",
                "isHorizontal": false
            }
        },
        "name": "Underworld Thug",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SOR_505": {
        "id": "SOR_505",
        "face": {
            "front": {
                "name": "Underworld Thug",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/505.png",
                "isHorizontal": false
            }
        },
        "name": "Underworld Thug",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SOR_136": {
        "id": "SOR_136",
        "face": {
            "front": {
                "name": "Vader's Lightsaber",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/136.png",
                "isHorizontal": false
            }
        },
        "name": "Vader's Lightsaber",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Special",
        "power": 3,
        "HP": 1,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "ITEM",
            "WEAPON",
            "LIGHTSABER"
        ]
    },
    "SOR_191": {
        "id": "SOR_191",
        "face": {
            "front": {
                "name": "Vanguard Ace",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/191.png",
                "isHorizontal": false
            }
        },
        "name": "Vanguard Ace",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "NEW REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_453": {
        "id": "SOR_453",
        "face": {
            "front": {
                "name": "Vanguard Ace",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/453.png",
                "isHorizontal": false
            }
        },
        "name": "Vanguard Ace",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "NEW REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_108": {
        "id": "SOR_108",
        "face": {
            "front": {
                "name": "Vanguard Infantry",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/108.png",
                "isHorizontal": false
            }
        },
        "name": "Vanguard Infantry",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 2,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TROOPER"
        ]
    },
    "SOR_372": {
        "id": "SOR_372",
        "face": {
            "front": {
                "name": "Vanguard Infantry",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SOR/372.png",
                "isHorizontal": false
            }
        },
        "name": "Vanguard Infantry",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 2,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TROOPER"
        ]
    },
    "SOR_078": {
        "id": "SOR_078",
        "face": {
            "front": {
                "name": "Vanquish",
                "type": "Event",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/078.png",
                "isHorizontal": false
            }
        },
        "name": "Vanquish",
        "type": "Event",
        "cost": 5,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_343": {
        "id": "SOR_343",
        "face": {
            "front": {
                "name": "Vanquish",
                "type": "Event",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/343.png",
                "isHorizontal": false
            }
        },
        "name": "Vanquish",
        "type": "Event",
        "cost": 5,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SOR_058": {
        "id": "SOR_058",
        "face": {
            "front": {
                "name": "Vigilance",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/058.png",
                "isHorizontal": false
            }
        },
        "name": "Vigilance",
        "type": "Event",
        "cost": 4,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance",
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SOR_323": {
        "id": "SOR_323",
        "face": {
            "front": {
                "name": "Vigilance",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/323.png",
                "isHorizontal": false
            }
        },
        "name": "Vigilance",
        "type": "Event",
        "cost": 4,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance",
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SOR_048": {
        "id": "SOR_048",
        "face": {
            "front": {
                "name": "Vigilant Honor Guards",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/048.png",
                "isHorizontal": false
            }
        },
        "name": "Vigilant Honor Guards",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL"
        ]
    },
    "SOR_314": {
        "id": "SOR_314",
        "face": {
            "front": {
                "name": "Vigilant Honor Guards",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/314.png",
                "isHorizontal": false
            }
        },
        "name": "Vigilant Honor Guards",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL"
        ]
    },
    "SOR_228": {
        "id": "SOR_228",
        "face": {
            "front": {
                "name": "Viper Probe Droid",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/228.png",
                "isHorizontal": false
            }
        },
        "name": "Viper Probe Droid",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "DROID"
        ]
    },
    "SOR_489": {
        "id": "SOR_489",
        "face": {
            "front": {
                "name": "Viper Probe Droid",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/489.png",
                "isHorizontal": false
            }
        },
        "name": "Viper Probe Droid",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "DROID"
        ]
    },
    "SOR_248": {
        "id": "SOR_248",
        "face": {
            "front": {
                "name": "Volunteer Soldier",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/248.png",
                "isHorizontal": false
            }
        },
        "name": "Volunteer Soldier",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [],
        "unique": false,
        "traits": [
            "TROOPER"
        ]
    },
    "SOR_506": {
        "id": "SOR_506",
        "face": {
            "front": {
                "name": "Volunteer Soldier",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/506.png",
                "isHorizontal": false
            }
        },
        "name": "Volunteer Soldier",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [],
        "unique": false,
        "traits": [
            "TROOPER"
        ]
    },
    "SOR_164": {
        "id": "SOR_164",
        "face": {
            "front": {
                "name": "Wampa",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/164.png",
                "isHorizontal": false
            }
        },
        "name": "Wampa",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "CREATURE"
        ]
    },
    "SOR_427": {
        "id": "SOR_427",
        "face": {
            "front": {
                "name": "Wampa",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SOR/427.png",
                "isHorizontal": false
            }
        },
        "name": "Wampa",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "CREATURE"
        ]
    },
    "SOR_222": {
        "id": "SOR_222",
        "face": {
            "front": {
                "name": "Waylay",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/222.png",
                "isHorizontal": false
            }
        },
        "name": "Waylay",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "SOR_484": {
        "id": "SOR_484",
        "face": {
            "front": {
                "name": "Waylay",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/484.png",
                "isHorizontal": false
            }
        },
        "name": "Waylay",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "SOR_100": {
        "id": "SOR_100",
        "face": {
            "front": {
                "name": "Wedge Antilles, Star of the Rebellion",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/100.png",
                "isHorizontal": false
            }
        },
        "name": "Wedge Antilles, Star of the Rebellion",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Rare",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL"
        ]
    },
    "SOR_364": {
        "id": "SOR_364",
        "face": {
            "front": {
                "name": "Wedge Antilles, Star of the Rebellion",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/364.png",
                "isHorizontal": false
            }
        },
        "name": "Wedge Antilles, Star of the Rebellion",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Rare",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL"
        ]
    },
    "SOR_064": {
        "id": "SOR_064",
        "face": {
            "front": {
                "name": "Wilderness Fighter",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/064.png",
                "isHorizontal": false
            }
        },
        "name": "Wilderness Fighter",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TROOPER"
        ]
    },
    "SOR_329": {
        "id": "SOR_329",
        "face": {
            "front": {
                "name": "Wilderness Fighter",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/329.png",
                "isHorizontal": false
            }
        },
        "name": "Wilderness Fighter",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TROOPER"
        ]
    },
    "SOR_241": {
        "id": "SOR_241",
        "face": {
            "front": {
                "name": "Wing Leader",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/241.png",
                "isHorizontal": false
            }
        },
        "name": "Wing Leader",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_499": {
        "id": "SOR_499",
        "face": {
            "front": {
                "name": "Wing Leader",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/499.png",
                "isHorizontal": false
            }
        },
        "name": "Wing Leader",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SOR_160": {
        "id": "SOR_160",
        "face": {
            "front": {
                "name": "Wolffe, Suspicious Veteran",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/160.png",
                "isHorizontal": false
            }
        },
        "name": "Wolffe, Suspicious Veteran",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Aggression"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "CLONE"
        ]
    },
    "SOR_423": {
        "id": "SOR_423",
        "face": {
            "front": {
                "name": "Wolffe, Suspicious Veteran",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SOR/423.png",
                "isHorizontal": false
            }
        },
        "name": "Wolffe, Suspicious Veteran",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Aggression"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "CLONE"
        ]
    },
    "SOR_045": {
        "id": "SOR_045",
        "face": {
            "front": {
                "name": "Yoda, Old Master",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/045.png",
                "isHorizontal": false
            }
        },
        "name": "Yoda, Old Master",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI"
        ]
    },
    "SOR_311": {
        "id": "SOR_311",
        "face": {
            "front": {
                "name": "Yoda, Old Master",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/311.png",
                "isHorizontal": false
            }
        },
        "name": "Yoda, Old Master",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI"
        ]
    },
    "SOR_246": {
        "id": "SOR_246",
        "face": {
            "front": {
                "name": "You're My Only Hope",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/246.png",
                "isHorizontal": false
            }
        },
        "name": "You're My Only Hope",
        "type": "Event",
        "cost": 3,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "SOR_504": {
        "id": "SOR_504",
        "face": {
            "front": {
                "name": "You're My Only Hope",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SOR/504.png",
                "isHorizontal": false
            }
        },
        "name": "You're My Only Hope",
        "type": "Event",
        "cost": 3,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "SOR_146": {
        "id": "SOR_146",
        "face": {
            "front": {
                "name": "Zeb Orrelios, Headstrong Warrior",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/146.png",
                "isHorizontal": false
            }
        },
        "name": "Zeb Orrelios, Headstrong Warrior",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "SPECTRE"
        ]
    },
    "SOR_409": {
        "id": "SOR_409",
        "face": {
            "front": {
                "name": "Zeb Orrelios, Headstrong Warrior",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SOR/409.png",
                "isHorizontal": false
            }
        },
        "name": "Zeb Orrelios, Headstrong Warrior",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "SPECTRE"
        ]
    },
    "SHD_188": {
        "id": "SHD_188",
        "face": {
            "front": {
                "name": "4-LOM, Bounty Hunter for Hire",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/188.png",
                "isHorizontal": false
            }
        },
        "name": "4-LOM, Bounty Hunter for Hire",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "DROID",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_457": {
        "id": "SHD_457",
        "face": {
            "front": {
                "name": "4-LOM, Bounty Hunter for Hire",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/457.png",
                "isHorizontal": false
            }
        },
        "name": "4-LOM, Bounty Hunter for Hire",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "DROID",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_207": {
        "id": "SHD_207",
        "face": {
            "front": {
                "name": "A New Adventure",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/207.png",
                "isHorizontal": false
            }
        },
        "name": "A New Adventure",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "SHD_475": {
        "id": "SHD_475",
        "face": {
            "front": {
                "name": "A New Adventure",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/475.png",
                "isHorizontal": false
            }
        },
        "name": "A New Adventure",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "SHD_101": {
        "id": "SHD_101",
        "face": {
            "front": {
                "name": "Adelphi Patrol Wing",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/101.png",
                "isHorizontal": false
            }
        },
        "name": "Adelphi Patrol Wing",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "NEW REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_370": {
        "id": "SHD_370",
        "face": {
            "front": {
                "name": "Adelphi Patrol Wing",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/370.png",
                "isHorizontal": false
            }
        },
        "name": "Adelphi Patrol Wing",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "NEW REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_243": {
        "id": "SHD_243",
        "face": {
            "front": {
                "name": "Altering the Deal",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/243.png",
                "isHorizontal": false
            }
        },
        "name": "Altering the Deal",
        "type": "Event",
        "cost": 1,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "SHD_506": {
        "id": "SHD_506",
        "face": {
            "front": {
                "name": "Altering the Deal",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/506.png",
                "isHorizontal": false
            }
        },
        "name": "Altering the Deal",
        "type": "Event",
        "cost": 1,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "SHD_175": {
        "id": "SHD_175",
        "face": {
            "front": {
                "name": "Armed to the Teeth",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/175.png",
                "isHorizontal": false
            }
        },
        "name": "Armed to the Teeth",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "SUPPLY",
            "WEAPON"
        ]
    },
    "SHD_444": {
        "id": "SHD_444",
        "face": {
            "front": {
                "name": "Armed to the Teeth",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/444.png",
                "isHorizontal": false
            }
        },
        "name": "Armed to the Teeth",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "SUPPLY",
            "WEAPON"
        ]
    },
    "SHD_122": {
        "id": "SHD_122",
        "face": {
            "front": {
                "name": "Arquitens Assault Cruiser",
                "type": "Unit - Space",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/SHD/122.png",
                "isHorizontal": false
            }
        },
        "name": "Arquitens Assault Cruiser",
        "type": "Unit - Space",
        "cost": 8,
        "rarity": "Rare",
        "power": 7,
        "HP": 8,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "SHD_391": {
        "id": "SHD_391",
        "face": {
            "front": {
                "name": "Arquitens Assault Cruiser",
                "type": "Unit - Space",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/SHD/391.png",
                "isHorizontal": false
            }
        },
        "name": "Arquitens Assault Cruiser",
        "type": "Unit - Space",
        "cost": 8,
        "rarity": "Rare",
        "power": 7,
        "HP": 8,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "SHD_184": {
        "id": "SHD_184",
        "face": {
            "front": {
                "name": "Bazine Netal, Spy for the First Order",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/184.png",
                "isHorizontal": false
            }
        },
        "name": "Bazine Netal, Spy for the First Order",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_453": {
        "id": "SHD_453",
        "face": {
            "front": {
                "name": "Bazine Netal, Spy for the First Order",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/453.png",
                "isHorizontal": false
            }
        },
        "name": "Bazine Netal, Spy for the First Order",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_237": {
        "id": "SHD_237",
        "face": {
            "front": {
                "name": "Black Sun Starfighter",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/237.png",
                "isHorizontal": false
            }
        },
        "name": "Black Sun Starfighter",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_502": {
        "id": "SHD_502",
        "face": {
            "front": {
                "name": "Black Sun Starfighter",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/502.png",
                "isHorizontal": false
            }
        },
        "name": "Black Sun Starfighter",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_012": {
        "id": "SHD_012",
        "face": {
            "front": {
                "name": "Bo-Katan Kryze, Princess in Exile",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/012-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Bo-Katan Kryze, Princess in Exile",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SHD/012-b.png"
            }
        },
        "name": "Bo-Katan Kryze, Princess in Exile",
        "type": "Leader",
        "cost": 6,
        "rarity": "Rare",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN"
        ]
    },
    "SHD_157": {
        "id": "SHD_157",
        "face": {
            "front": {
                "name": "Bo-Katan Kryze, Fighting For Mandalore",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/157.png",
                "isHorizontal": false
            }
        },
        "name": "Bo-Katan Kryze, Fighting For Mandalore",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Aggression"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "TROOPER"
        ]
    },
    "SHD_274": {
        "id": "SHD_274",
        "face": {
            "front": {
                "name": "Bo-Katan Kryze, Princess in Exile",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/274-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Bo-Katan Kryze, Princess in Exile",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SHD/274-b.png"
            }
        },
        "name": "Bo-Katan Kryze, Princess in Exile",
        "type": "Leader",
        "cost": 6,
        "rarity": "Rare",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN"
        ]
    },
    "SHD_291": {
        "id": "SHD_291",
        "face": {
            "front": {
                "name": "Bo-Katan Kryze, Princess in Exile",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/291-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Bo-Katan Kryze, Princess in Exile",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SHD/291-b.png"
            }
        },
        "name": "Bo-Katan Kryze, Princess in Exile",
        "type": "Leader",
        "cost": 6,
        "rarity": "Rare",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN"
        ]
    },
    "SHD_426": {
        "id": "SHD_426",
        "face": {
            "front": {
                "name": "Bo-Katan Kryze, Fighting For Mandalore",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/426.png",
                "isHorizontal": false
            }
        },
        "name": "Bo-Katan Kryze, Fighting For Mandalore",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Aggression"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "TROOPER"
        ]
    },
    "SHD_008": {
        "id": "SHD_008",
        "face": {
            "front": {
                "name": "Boba Fett, Daimyo",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/008-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Boba Fett, Daimyo",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SHD/008-b.png"
            }
        },
        "name": "Boba Fett, Daimyo",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_270": {
        "id": "SHD_270",
        "face": {
            "front": {
                "name": "Boba Fett, Daimyo",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/270-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Boba Fett, Daimyo",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SHD/270-b.png"
            }
        },
        "name": "Boba Fett, Daimyo",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_287": {
        "id": "SHD_287",
        "face": {
            "front": {
                "name": "Boba Fett, Daimyo",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/287-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Boba Fett, Daimyo",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SHD/287-b.png"
            }
        },
        "name": "Boba Fett, Daimyo",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_224": {
        "id": "SHD_224",
        "face": {
            "front": {
                "name": "Boba Fett's Armor",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/224.png",
                "isHorizontal": false
            }
        },
        "name": "Boba Fett's Armor",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Rare",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "ITEM",
            "ARMOR"
        ]
    },
    "SHD_491": {
        "id": "SHD_491",
        "face": {
            "front": {
                "name": "Boba Fett's Armor",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/491.png",
                "isHorizontal": false
            }
        },
        "name": "Boba Fett's Armor",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Rare",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "ITEM",
            "ARMOR"
        ]
    },
    "SHD_010": {
        "id": "SHD_010",
        "face": {
            "front": {
                "name": "Bossk, Hunting His Prey",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/010-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Bossk, Hunting His Prey",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SHD/010-b.png"
            }
        },
        "name": "Bossk, Hunting His Prey",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_272": {
        "id": "SHD_272",
        "face": {
            "front": {
                "name": "Bossk, Hunting His Prey",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/272-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Bossk, Hunting His Prey",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SHD/272-b.png"
            }
        },
        "name": "Bossk, Hunting His Prey",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_289": {
        "id": "SHD_289",
        "face": {
            "front": {
                "name": "Bossk, Hunting His Prey",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/289-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Bossk, Hunting His Prey",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SHD/289-b.png"
            }
        },
        "name": "Bossk, Hunting His Prey",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_254": {
        "id": "SHD_254",
        "face": {
            "front": {
                "name": "Bounty Guild Initiate",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/254.png",
                "isHorizontal": false
            }
        },
        "name": "Bounty Guild Initiate",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 2,
        "aspects": [],
        "unique": false,
        "traits": [
            "BOUNTY HUNTER"
        ]
    },
    "SHD_515": {
        "id": "SHD_515",
        "face": {
            "front": {
                "name": "Bounty Guild Initiate",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/515.png",
                "isHorizontal": false
            }
        },
        "name": "Bounty Guild Initiate",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 2,
        "aspects": [],
        "unique": false,
        "traits": [
            "BOUNTY HUNTER"
        ]
    },
    "SHD_123": {
        "id": "SHD_123",
        "face": {
            "front": {
                "name": "Bounty Hunter's Quarry",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/123.png",
                "isHorizontal": false
            }
        },
        "name": "Bounty Hunter's Quarry",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "BOUNTY",
            "CONDITION"
        ]
    },
    "SHD_392": {
        "id": "SHD_392",
        "face": {
            "front": {
                "name": "Bounty Hunter's Quarry",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/392.png",
                "isHorizontal": false
            }
        },
        "name": "Bounty Hunter's Quarry",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "BOUNTY",
            "CONDITION"
        ]
    },
    "SHD_228": {
        "id": "SHD_228",
        "face": {
            "front": {
                "name": "Bounty Posting",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/228.png",
                "isHorizontal": false
            }
        },
        "name": "Bounty Posting",
        "type": "Event",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "SHD_495": {
        "id": "SHD_495",
        "face": {
            "front": {
                "name": "Bounty Posting",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/495.png",
                "isHorizontal": false
            }
        },
        "name": "Bounty Posting",
        "type": "Event",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "SHD_182": {
        "id": "SHD_182",
        "face": {
            "front": {
                "name": "Bravado",
                "type": "Event",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/182.png",
                "isHorizontal": false
            }
        },
        "name": "Bravado",
        "type": "Event",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SHD_451": {
        "id": "SHD_451",
        "face": {
            "front": {
                "name": "Bravado",
                "type": "Event",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/451.png",
                "isHorizontal": false
            }
        },
        "name": "Bravado",
        "type": "Event",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SHD_038": {
        "id": "SHD_038",
        "face": {
            "front": {
                "name": "Brutal Traditions",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/038.png",
                "isHorizontal": false
            }
        },
        "name": "Brutal Traditions",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 2,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "LEARNED"
        ]
    },
    "SHD_315": {
        "id": "SHD_315",
        "face": {
            "front": {
                "name": "Brutal Traditions",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/315.png",
                "isHorizontal": false
            }
        },
        "name": "Brutal Traditions",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 2,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "LEARNED"
        ]
    },
    "SHD_014": {
        "id": "SHD_014",
        "face": {
            "front": {
                "name": "Cad Bane, He Who Needs No Introduction",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/014-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Cad Bane, He Who Needs No Introduction",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SHD/014-b.png"
            }
        },
        "name": "Cad Bane, He Who Needs No Introduction",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 2,
        "HP": 8,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_276": {
        "id": "SHD_276",
        "face": {
            "front": {
                "name": "Cad Bane, He Who Needs No Introduction",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/276-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Cad Bane, He Who Needs No Introduction",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SHD/276-b.png"
            }
        },
        "name": "Cad Bane, He Who Needs No Introduction",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 2,
        "HP": 8,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_293": {
        "id": "SHD_293",
        "face": {
            "front": {
                "name": "Cad Bane, He Who Needs No Introduction",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/293-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Cad Bane, He Who Needs No Introduction",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SHD/293-b.png"
            }
        },
        "name": "Cad Bane, He Who Needs No Introduction",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 2,
        "HP": 8,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_039": {
        "id": "SHD_039",
        "face": {
            "front": {
                "name": "Calculated Lethality",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/039.png",
                "isHorizontal": false
            }
        },
        "name": "Calculated Lethality",
        "type": "Event",
        "cost": 4,
        "rarity": "Special",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_066": {
        "id": "SHD_066",
        "face": {
            "front": {
                "name": "Cargo Juggernaut",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/066.png",
                "isHorizontal": false
            }
        },
        "name": "Cargo Juggernaut",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "VEHICLE",
            "TANK"
        ]
    },
    "SHD_340": {
        "id": "SHD_340",
        "face": {
            "front": {
                "name": "Cargo Juggernaut",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/340.png",
                "isHorizontal": false
            }
        },
        "name": "Cargo Juggernaut",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "VEHICLE",
            "TANK"
        ]
    },
    "SHD_195": {
        "id": "SHD_195",
        "face": {
            "front": {
                "name": "Cartel Turncoat",
                "type": "Unit - Space",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/195.png",
                "isHorizontal": false
            }
        },
        "name": "Cartel Turncoat",
        "type": "Unit - Space",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_464": {
        "id": "SHD_464",
        "face": {
            "front": {
                "name": "Cartel Turncoat",
                "type": "Unit - Space",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/464.png",
                "isHorizontal": false
            }
        },
        "name": "Cartel Turncoat",
        "type": "Unit - Space",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_148": {
        "id": "SHD_148",
        "face": {
            "front": {
                "name": "Cassian Andor, Rebellions Are Built On Hope",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/148.png",
                "isHorizontal": false
            }
        },
        "name": "Cassian Andor, Rebellions Are Built On Hope",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL"
        ]
    },
    "SHD_417": {
        "id": "SHD_417",
        "face": {
            "front": {
                "name": "Cassian Andor, Rebellions Are Built On Hope",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/417.png",
                "isHorizontal": false
            }
        },
        "name": "Cassian Andor, Rebellions Are Built On Hope",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL"
        ]
    },
    "SHD_238": {
        "id": "SHD_238",
        "face": {
            "front": {
                "name": "Cell Block Guard",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/238.png",
                "isHorizontal": false
            }
        },
        "name": "Cell Block Guard",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Special",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "SHD_216": {
        "id": "SHD_216",
        "face": {
            "front": {
                "name": "Chain Code Collector",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/216.png",
                "isHorizontal": false
            }
        },
        "name": "Chain Code Collector",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 4,
        "HP": 2,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_484": {
        "id": "SHD_484",
        "face": {
            "front": {
                "name": "Chain Code Collector",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/484.png",
                "isHorizontal": false
            }
        },
        "name": "Chain Code Collector",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 4,
        "HP": 2,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_050": {
        "id": "SHD_050",
        "face": {
            "front": {
                "name": "Chewbacca, Pykesbane",
                "type": "Unit - Ground",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/SHD/050.png",
                "isHorizontal": false
            }
        },
        "name": "Chewbacca, Pykesbane",
        "type": "Unit - Ground",
        "cost": 8,
        "rarity": "Rare",
        "power": 4,
        "HP": 10,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "WOOKIEE"
        ]
    },
    "SHD_325": {
        "id": "SHD_325",
        "face": {
            "front": {
                "name": "Chewbacca, Pykesbane",
                "type": "Unit - Ground",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/SHD/325.png",
                "isHorizontal": false
            }
        },
        "name": "Chewbacca, Pykesbane",
        "type": "Unit - Ground",
        "cost": 8,
        "rarity": "Rare",
        "power": 4,
        "HP": 10,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "WOOKIEE"
        ]
    },
    "SHD_132": {
        "id": "SHD_132",
        "face": {
            "front": {
                "name": "Choose Sides",
                "type": "Event",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SHD/132.png",
                "isHorizontal": false
            }
        },
        "name": "Choose Sides",
        "type": "Event",
        "cost": 7,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "SHD_401": {
        "id": "SHD_401",
        "face": {
            "front": {
                "name": "Choose Sides",
                "type": "Event",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SHD/401.png",
                "isHorizontal": false
            }
        },
        "name": "Choose Sides",
        "type": "Event",
        "cost": 7,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "SHD_169": {
        "id": "SHD_169",
        "face": {
            "front": {
                "name": "Clan Challengers",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/169.png",
                "isHorizontal": false
            }
        },
        "name": "Clan Challengers",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN",
            "TROOPER"
        ]
    },
    "SHD_438": {
        "id": "SHD_438",
        "face": {
            "front": {
                "name": "Clan Challengers",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/438.png",
                "isHorizontal": false
            }
        },
        "name": "Clan Challengers",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN",
            "TROOPER"
        ]
    },
    "SHD_035": {
        "id": "SHD_035",
        "face": {
            "front": {
                "name": "Clan Saxon Gauntlet",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/035.png",
                "isHorizontal": false
            }
        },
        "name": "Clan Saxon Gauntlet",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SHD_312": {
        "id": "SHD_312",
        "face": {
            "front": {
                "name": "Clan Saxon Gauntlet",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/312.png",
                "isHorizontal": false
            }
        },
        "name": "Clan Saxon Gauntlet",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SHD_040": {
        "id": "SHD_040",
        "face": {
            "front": {
                "name": "Clan Wren Rescuer",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/040.png",
                "isHorizontal": false
            }
        },
        "name": "Clan Wren Rescuer",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 2,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN",
            "TROOPER"
        ]
    },
    "SHD_316": {
        "id": "SHD_316",
        "face": {
            "front": {
                "name": "Clan Wren Rescuer",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/316.png",
                "isHorizontal": false
            }
        },
        "name": "Clan Wren Rescuer",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 2,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN",
            "TROOPER"
        ]
    },
    "SHD_095": {
        "id": "SHD_095",
        "face": {
            "front": {
                "name": "Clone Deserter",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/095.png",
                "isHorizontal": false
            }
        },
        "name": "Clone Deserter",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "CLONE"
        ]
    },
    "SHD_364": {
        "id": "SHD_364",
        "face": {
            "front": {
                "name": "Clone Deserter",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/364.png",
                "isHorizontal": false
            }
        },
        "name": "Clone Deserter",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "CLONE"
        ]
    },
    "SHD_210": {
        "id": "SHD_210",
        "face": {
            "front": {
                "name": "Cloud-Rider",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/210.png",
                "isHorizontal": false
            }
        },
        "name": "Cloud-Rider",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 3,
        "HP": 1,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_478": {
        "id": "SHD_478",
        "face": {
            "front": {
                "name": "Cloud-Rider",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/478.png",
                "isHorizontal": false
            }
        },
        "name": "Cloud-Rider",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 3,
        "HP": 1,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_115": {
        "id": "SHD_115",
        "face": {
            "front": {
                "name": "Cobb Vanth, The Marshal",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/115.png",
                "isHorizontal": false
            }
        },
        "name": "Cobb Vanth, The Marshal",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Rare",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Command"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "OFFICIAL"
        ]
    },
    "SHD_384": {
        "id": "SHD_384",
        "face": {
            "front": {
                "name": "Cobb Vanth, The Marshal",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/384.png",
                "isHorizontal": false
            }
        },
        "name": "Cobb Vanth, The Marshal",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Rare",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Command"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "OFFICIAL"
        ]
    },
    "SHD_111": {
        "id": "SHD_111",
        "face": {
            "front": {
                "name": "Collections Starhopper",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/111.png",
                "isHorizontal": false
            }
        },
        "name": "Collections Starhopper",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_380": {
        "id": "SHD_380",
        "face": {
            "front": {
                "name": "Collections Starhopper",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/380.png",
                "isHorizontal": false
            }
        },
        "name": "Collections Starhopper",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_127": {
        "id": "SHD_127",
        "face": {
            "front": {
                "name": "Commission",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/127.png",
                "isHorizontal": false
            }
        },
        "name": "Commission",
        "type": "Event",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "SHD_396": {
        "id": "SHD_396",
        "face": {
            "front": {
                "name": "Commission",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/396.png",
                "isHorizontal": false
            }
        },
        "name": "Commission",
        "type": "Event",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "SHD_042": {
        "id": "SHD_042",
        "face": {
            "front": {
                "name": "Concord Dawn Interceptors",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/042.png",
                "isHorizontal": false
            }
        },
        "name": "Concord Dawn Interceptors",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_318": {
        "id": "SHD_318",
        "face": {
            "front": {
                "name": "Concord Dawn Interceptors",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/318.png",
                "isHorizontal": false
            }
        },
        "name": "Concord Dawn Interceptors",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_262": {
        "id": "SHD_262",
        "face": {
            "front": {
                "name": "Confiscate",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/262.png",
                "isHorizontal": false
            }
        },
        "name": "Confiscate",
        "type": "Event",
        "cost": 1,
        "rarity": "Special",
        "power": 0,
        "HP": 0,
        "aspects": [],
        "unique": false,
        "traits": [
            "LAW"
        ]
    },
    "SHD_025": {
        "id": "SHD_025",
        "face": {
            "front": {
                "name": "Coronet City, Corellia",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SHD/025-r.png",
                "isHorizontal": true
            }
        },
        "name": "Coronet City, Corellia",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": []
    },
    "SHD_303": {
        "id": "SHD_303",
        "face": {
            "front": {
                "name": "Coronet City, Corellia",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SHD/303-r.png",
                "isHorizontal": true
            }
        },
        "name": "Coronet City, Corellia",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": []
    },
    "SHD_199": {
        "id": "SHD_199",
        "face": {
            "front": {
                "name": "Coruscant Dissident",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/199.png",
                "isHorizontal": false
            }
        },
        "name": "Coruscant Dissident",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "TWI'LEK"
        ]
    },
    "SHD_467": {
        "id": "SHD_467",
        "face": {
            "front": {
                "name": "Coruscant Dissident",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/467.png",
                "isHorizontal": false
            }
        },
        "name": "Coruscant Dissident",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "TWI'LEK"
        ]
    },
    "SHD_075": {
        "id": "SHD_075",
        "face": {
            "front": {
                "name": "Covert Strength",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/075.png",
                "isHorizontal": false
            }
        },
        "name": "Covert Strength",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_348": {
        "id": "SHD_348",
        "face": {
            "front": {
                "name": "Covert Strength",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/348.png",
                "isHorizontal": false
            }
        },
        "name": "Covert Strength",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_171": {
        "id": "SHD_171",
        "face": {
            "front": {
                "name": "Covetous Rivals",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/171.png",
                "isHorizontal": false
            }
        },
        "name": "Covetous Rivals",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "BOUNTY HUNTER"
        ]
    },
    "SHD_440": {
        "id": "SHD_440",
        "face": {
            "front": {
                "name": "Covetous Rivals",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/440.png",
                "isHorizontal": false
            }
        },
        "name": "Covetous Rivals",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "BOUNTY HUNTER"
        ]
    },
    "SHD_209": {
        "id": "SHD_209",
        "face": {
            "front": {
                "name": "Criminal Muscle",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/209.png",
                "isHorizontal": false
            }
        },
        "name": "Criminal Muscle",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_477": {
        "id": "SHD_477",
        "face": {
            "front": {
                "name": "Criminal Muscle",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/477.png",
                "isHorizontal": false
            }
        },
        "name": "Criminal Muscle",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_156": {
        "id": "SHD_156",
        "face": {
            "front": {
                "name": "Cripple Authority",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/156.png",
                "isHorizontal": false
            }
        },
        "name": "Cripple Authority",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "SHD_425": {
        "id": "SHD_425",
        "face": {
            "front": {
                "name": "Cripple Authority",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/425.png",
                "isHorizontal": false
            }
        },
        "name": "Cripple Authority",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "SHD_087": {
        "id": "SHD_087",
        "face": {
            "front": {
                "name": "Crosshair, Following Orders",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/087.png",
                "isHorizontal": false
            }
        },
        "name": "Crosshair, Following Orders",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 6,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "CLONE",
            "TROOPER"
        ]
    },
    "SHD_356": {
        "id": "SHD_356",
        "face": {
            "front": {
                "name": "Crosshair, Following Orders",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/356.png",
                "isHorizontal": false
            }
        },
        "name": "Crosshair, Following Orders",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 6,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "CLONE",
            "TROOPER"
        ]
    },
    "SHD_213": {
        "id": "SHD_213",
        "face": {
            "front": {
                "name": "DJ, Blatant Thief",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/213.png",
                "isHorizontal": false
            }
        },
        "name": "DJ, Blatant Thief",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Legendary",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_481": {
        "id": "SHD_481",
        "face": {
            "front": {
                "name": "DJ, Blatant Thief",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/481.png",
                "isHorizontal": false
            }
        },
        "name": "DJ, Blatant Thief",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Legendary",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_178": {
        "id": "SHD_178",
        "face": {
            "front": {
                "name": "Daring Raid",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/178.png",
                "isHorizontal": false
            }
        },
        "name": "Daring Raid",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_447": {
        "id": "SHD_447",
        "face": {
            "front": {
                "name": "Daring Raid",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/447.png",
                "isHorizontal": false
            }
        },
        "name": "Daring Raid",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_176": {
        "id": "SHD_176",
        "face": {
            "front": {
                "name": "Death Mark",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/176.png",
                "isHorizontal": false
            }
        },
        "name": "Death Mark",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "BOUNTY",
            "CONDITION"
        ]
    },
    "SHD_445": {
        "id": "SHD_445",
        "face": {
            "front": {
                "name": "Death Mark",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/445.png",
                "isHorizontal": false
            }
        },
        "name": "Death Mark",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "BOUNTY",
            "CONDITION"
        ]
    },
    "SHD_030": {
        "id": "SHD_030",
        "face": {
            "front": {
                "name": "Death Trooper",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/030.png",
                "isHorizontal": false
            }
        },
        "name": "Death Trooper",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Special",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "SHD_023": {
        "id": "SHD_023",
        "face": {
            "front": {
                "name": "Death Watch Hideout, Concordia",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SHD/023-r.png",
                "isHorizontal": true
            }
        },
        "name": "Death Watch Hideout, Concordia",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": []
    },
    "SHD_301": {
        "id": "SHD_301",
        "face": {
            "front": {
                "name": "Death Watch Hideout, Concordia",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SHD/301-r.png",
                "isHorizontal": true
            }
        },
        "name": "Death Watch Hideout, Concordia",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": []
    },
    "SHD_136": {
        "id": "SHD_136",
        "face": {
            "front": {
                "name": "Death Watch Loyalist",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/136.png",
                "isHorizontal": false
            }
        },
        "name": "Death Watch Loyalist",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN",
            "TROOPER"
        ]
    },
    "SHD_405": {
        "id": "SHD_405",
        "face": {
            "front": {
                "name": "Death Watch Loyalist",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/405.png",
                "isHorizontal": false
            }
        },
        "name": "Death Watch Loyalist",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN",
            "TROOPER"
        ]
    },
    "SHD_133": {
        "id": "SHD_133",
        "face": {
            "front": {
                "name": "Dengar, The Demolisher",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/133.png",
                "isHorizontal": false
            }
        },
        "name": "Dengar, The Demolisher",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_402": {
        "id": "SHD_402",
        "face": {
            "front": {
                "name": "Dengar, The Demolisher",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/402.png",
                "isHorizontal": false
            }
        },
        "name": "Dengar, The Demolisher",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_152": {
        "id": "SHD_152",
        "face": {
            "front": {
                "name": "Desperado Freighter",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/152.png",
                "isHorizontal": false
            }
        },
        "name": "Desperado Freighter",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SHD_421": {
        "id": "SHD_421",
        "face": {
            "front": {
                "name": "Desperado Freighter",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/421.png",
                "isHorizontal": false
            }
        },
        "name": "Desperado Freighter",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SHD_179": {
        "id": "SHD_179",
        "face": {
            "front": {
                "name": "Desperate Attack",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/179.png",
                "isHorizontal": false
            }
        },
        "name": "Desperate Attack",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_448": {
        "id": "SHD_448",
        "face": {
            "front": {
                "name": "Desperate Attack",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/448.png",
                "isHorizontal": false
            }
        },
        "name": "Desperate Attack",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_180": {
        "id": "SHD_180",
        "face": {
            "front": {
                "name": "Detention Block Rescue",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/180.png",
                "isHorizontal": false
            }
        },
        "name": "Detention Block Rescue",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "SHD_449": {
        "id": "SHD_449",
        "face": {
            "front": {
                "name": "Detention Block Rescue",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/449.png",
                "isHorizontal": false
            }
        },
        "name": "Detention Block Rescue",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "SHD_166": {
        "id": "SHD_166",
        "face": {
            "front": {
                "name": "Disabling Fang Fighter",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/166.png",
                "isHorizontal": false
            }
        },
        "name": "Disabling Fang Fighter",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_435": {
        "id": "SHD_435",
        "face": {
            "front": {
                "name": "Disabling Fang Fighter",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/435.png",
                "isHorizontal": false
            }
        },
        "name": "Disabling Fang Fighter",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_120": {
        "id": "SHD_120",
        "face": {
            "front": {
                "name": "Discerning Veteran",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/120.png",
                "isHorizontal": false
            }
        },
        "name": "Discerning Veteran",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "BOUNTY HUNTER"
        ]
    },
    "SHD_389": {
        "id": "SHD_389",
        "face": {
            "front": {
                "name": "Discerning Veteran",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/389.png",
                "isHorizontal": false
            }
        },
        "name": "Discerning Veteran",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "BOUNTY HUNTER"
        ]
    },
    "SHD_015": {
        "id": "SHD_015",
        "face": {
            "front": {
                "name": "Doctor Aphra, Rapacious Archaeologist",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/015-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Doctor Aphra, Rapacious Archaeologist",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SHD/015-b.png"
            }
        },
        "name": "Doctor Aphra, Rapacious Archaeologist",
        "type": "Leader",
        "cost": 5,
        "rarity": "Rare",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FRINGE"
        ]
    },
    "SHD_277": {
        "id": "SHD_277",
        "face": {
            "front": {
                "name": "Doctor Aphra, Rapacious Archaeologist",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/277-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Doctor Aphra, Rapacious Archaeologist",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SHD/277-b.png"
            }
        },
        "name": "Doctor Aphra, Rapacious Archaeologist",
        "type": "Leader",
        "cost": 5,
        "rarity": "Rare",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FRINGE"
        ]
    },
    "SHD_294": {
        "id": "SHD_294",
        "face": {
            "front": {
                "name": "Doctor Aphra, Rapacious Archaeologist",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/294-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Doctor Aphra, Rapacious Archaeologist",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SHD/294-b.png"
            }
        },
        "name": "Doctor Aphra, Rapacious Archaeologist",
        "type": "Leader",
        "cost": 5,
        "rarity": "Rare",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FRINGE"
        ]
    },
    "SHD_185": {
        "id": "SHD_185",
        "face": {
            "front": {
                "name": "Doctor Evazan, Wanted on Twelve Systems",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/185.png",
                "isHorizontal": false
            }
        },
        "name": "Doctor Evazan, Wanted on Twelve Systems",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_454": {
        "id": "SHD_454",
        "face": {
            "front": {
                "name": "Doctor Evazan, Wanted on Twelve Systems",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/454.png",
                "isHorizontal": false
            }
        },
        "name": "Doctor Evazan, Wanted on Twelve Systems",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_028": {
        "id": "SHD_028",
        "face": {
            "front": {
                "name": "Doctor Pershing, Experimenting With Life",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/028.png",
                "isHorizontal": false
            }
        },
        "name": "Doctor Pershing, Experimenting With Life",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL"
        ]
    },
    "SHD_306": {
        "id": "SHD_306",
        "face": {
            "front": {
                "name": "Doctor Pershing, Experimenting With Life",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/306.png",
                "isHorizontal": false
            }
        },
        "name": "Doctor Pershing, Experimenting With Life",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL"
        ]
    },
    "SHD_192": {
        "id": "SHD_192",
        "face": {
            "front": {
                "name": "Dryden Vos, Offering No Escape",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SHD/192.png",
                "isHorizontal": false
            }
        },
        "name": "Dryden Vos, Offering No Escape",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Legendary",
        "power": 5,
        "HP": 7,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_461": {
        "id": "SHD_461",
        "face": {
            "front": {
                "name": "Dryden Vos, Offering No Escape",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SHD/461.png",
                "isHorizontal": false
            }
        },
        "name": "Dryden Vos, Offering No Escape",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Legendary",
        "power": 5,
        "HP": 7,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_099": {
        "id": "SHD_099",
        "face": {
            "front": {
                "name": "Echo, Restored",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/099.png",
                "isHorizontal": false
            }
        },
        "name": "Echo, Restored",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "CLONE"
        ]
    },
    "SHD_368": {
        "id": "SHD_368",
        "face": {
            "front": {
                "name": "Echo, Restored",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/368.png",
                "isHorizontal": false
            }
        },
        "name": "Echo, Restored",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "CLONE"
        ]
    },
    "SHD_059": {
        "id": "SHD_059",
        "face": {
            "front": {
                "name": "Embo, Stoic and Resolute",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/059.png",
                "isHorizontal": false
            }
        },
        "name": "Embo, Stoic and Resolute",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Vigilance"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_334": {
        "id": "SHD_334",
        "face": {
            "front": {
                "name": "Embo, Stoic and Resolute",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/334.png",
                "isHorizontal": false
            }
        },
        "name": "Embo, Stoic and Resolute",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Vigilance"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_109": {
        "id": "SHD_109",
        "face": {
            "front": {
                "name": "Endless Legions",
                "type": "Event",
                "cost": 14,
                "image": "https://cdn.swu-db.com/images/cards/SHD/109.png",
                "isHorizontal": false
            }
        },
        "name": "Endless Legions",
        "type": "Event",
        "cost": 14,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Command"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "SHD_378": {
        "id": "SHD_378",
        "face": {
            "front": {
                "name": "Endless Legions",
                "type": "Event",
                "cost": 14,
                "image": "https://cdn.swu-db.com/images/cards/SHD/378.png",
                "isHorizontal": false
            }
        },
        "name": "Endless Legions",
        "type": "Event",
        "cost": 14,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Command"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "SHD_108": {
        "id": "SHD_108",
        "face": {
            "front": {
                "name": "Enforced Loyalty",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/108.png",
                "isHorizontal": false
            }
        },
        "name": "Enforced Loyalty",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Command"
        ],
        "unique": false,
        "traits": [
            "LAW"
        ]
    },
    "SHD_377": {
        "id": "SHD_377",
        "face": {
            "front": {
                "name": "Enforced Loyalty",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/377.png",
                "isHorizontal": false
            }
        },
        "name": "Enforced Loyalty",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Command"
        ],
        "unique": false,
        "traits": [
            "LAW"
        ]
    },
    "SHD_219": {
        "id": "SHD_219",
        "face": {
            "front": {
                "name": "Enfys Nest, Marauder",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/219.png",
                "isHorizontal": false
            }
        },
        "name": "Enfys Nest, Marauder",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Uncommon",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_487": {
        "id": "SHD_487",
        "face": {
            "front": {
                "name": "Enfys Nest, Marauder",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/487.png",
                "isHorizontal": false
            }
        },
        "name": "Enfys Nest, Marauder",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Uncommon",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_107": {
        "id": "SHD_107",
        "face": {
            "front": {
                "name": "Enterprising Lackeys",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/107.png",
                "isHorizontal": false
            }
        },
        "name": "Enterprising Lackeys",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Command",
            "Command"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_376": {
        "id": "SHD_376",
        "face": {
            "front": {
                "name": "Enterprising Lackeys",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/376.png",
                "isHorizontal": false
            }
        },
        "name": "Enterprising Lackeys",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Command",
            "Command"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_222": {
        "id": "SHD_222",
        "face": {
            "front": {
                "name": "Enticing Reward",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/222.png",
                "isHorizontal": false
            }
        },
        "name": "Enticing Reward",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "BOUNTY",
            "CONDITION"
        ]
    },
    "SHD_490": {
        "id": "SHD_490",
        "face": {
            "front": {
                "name": "Enticing Reward",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/490.png",
                "isHorizontal": false
            }
        },
        "name": "Enticing Reward",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "BOUNTY",
            "CONDITION"
        ]
    },
    "SHD_088": {
        "id": "SHD_088",
        "face": {
            "front": {
                "name": "Ephant Mon, Head of Security",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/088.png",
                "isHorizontal": false
            }
        },
        "name": "Ephant Mon, Head of Security",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_357": {
        "id": "SHD_357",
        "face": {
            "front": {
                "name": "Ephant Mon, Head of Security",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/357.png",
                "isHorizontal": false
            }
        },
        "name": "Ephant Mon, Head of Security",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_233": {
        "id": "SHD_233",
        "face": {
            "front": {
                "name": "Evacuate",
                "type": "Event",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/233.png",
                "isHorizontal": false
            }
        },
        "name": "Evacuate",
        "type": "Event",
        "cost": 6,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "LAW"
        ]
    },
    "SHD_500": {
        "id": "SHD_500",
        "face": {
            "front": {
                "name": "Evacuate",
                "type": "Event",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/500.png",
                "isHorizontal": false
            }
        },
        "name": "Evacuate",
        "type": "Event",
        "cost": 6,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "LAW"
        ]
    },
    "SHD_077": {
        "id": "SHD_077",
        "face": {
            "front": {
                "name": "Evidence of the Crime",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/077.png",
                "isHorizontal": false
            }
        },
        "name": "Evidence of the Crime",
        "type": "Event",
        "cost": 3,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "SHD_350": {
        "id": "SHD_350",
        "face": {
            "front": {
                "name": "Evidence of the Crime",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/350.png",
                "isHorizontal": false
            }
        },
        "name": "Evidence of the Crime",
        "type": "Event",
        "cost": 3,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "SHD_078": {
        "id": "SHD_078",
        "face": {
            "front": {
                "name": "Fell the Dragon",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/078.png",
                "isHorizontal": false
            }
        },
        "name": "Fell the Dragon",
        "type": "Event",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_351": {
        "id": "SHD_351",
        "face": {
            "front": {
                "name": "Fell the Dragon",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/351.png",
                "isHorizontal": false
            }
        },
        "name": "Fell the Dragon",
        "type": "Event",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_067": {
        "id": "SHD_067",
        "face": {
            "front": {
                "name": "Fenn Rau, Protector of Concord Dawn",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/067.png",
                "isHorizontal": false
            }
        },
        "name": "Fenn Rau, Protector of Concord Dawn",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Uncommon",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Vigilance"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN"
        ]
    },
    "SHD_341": {
        "id": "SHD_341",
        "face": {
            "front": {
                "name": "Fenn Rau, Protector of Concord Dawn",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/341.png",
                "isHorizontal": false
            }
        },
        "name": "Fenn Rau, Protector of Concord Dawn",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Uncommon",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Vigilance"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN"
        ]
    },
    "SHD_016": {
        "id": "SHD_016",
        "face": {
            "front": {
                "name": "Fennec Shand, Honoring the Deal",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/016-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Fennec Shand, Honoring the Deal",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SHD/016-b.png"
            }
        },
        "name": "Fennec Shand, Honoring the Deal",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_220": {
        "id": "SHD_220",
        "face": {
            "front": {
                "name": "Fennec Shand, Loyal Sharpshooter",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SHD/220.png",
                "isHorizontal": false
            }
        },
        "name": "Fennec Shand, Loyal Sharpshooter",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_278": {
        "id": "SHD_278",
        "face": {
            "front": {
                "name": "Fennec Shand, Honoring the Deal",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/278-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Fennec Shand, Honoring the Deal",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SHD/278-b.png"
            }
        },
        "name": "Fennec Shand, Honoring the Deal",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_295": {
        "id": "SHD_295",
        "face": {
            "front": {
                "name": "Fennec Shand, Honoring the Deal",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/295-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Fennec Shand, Honoring the Deal",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SHD/295-b.png"
            }
        },
        "name": "Fennec Shand, Honoring the Deal",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_488": {
        "id": "SHD_488",
        "face": {
            "front": {
                "name": "Fennec Shand, Loyal Sharpshooter",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SHD/488.png",
                "isHorizontal": false
            }
        },
        "name": "Fennec Shand, Loyal Sharpshooter",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_208": {
        "id": "SHD_208",
        "face": {
            "front": {
                "name": "Final Showdown",
                "type": "Event",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/208.png",
                "isHorizontal": false
            }
        },
        "name": "Final Showdown",
        "type": "Event",
        "cost": 6,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "SHD_476": {
        "id": "SHD_476",
        "face": {
            "front": {
                "name": "Final Showdown",
                "type": "Event",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/476.png",
                "isHorizontal": false
            }
        },
        "name": "Final Showdown",
        "type": "Event",
        "cost": 6,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "SHD_092": {
        "id": "SHD_092",
        "face": {
            "front": {
                "name": "Finalizer, Might of the First Order",
                "type": "Unit - Space",
                "cost": 11,
                "image": "https://cdn.swu-db.com/images/cards/SHD/092.png",
                "isHorizontal": false
            }
        },
        "name": "Finalizer, Might of the First Order",
        "type": "Unit - Space",
        "cost": 11,
        "rarity": "Legendary",
        "power": 11,
        "HP": 11,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FIRST ORDER",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "SHD_361": {
        "id": "SHD_361",
        "face": {
            "front": {
                "name": "Finalizer, Might of the First Order",
                "type": "Unit - Space",
                "cost": 11,
                "image": "https://cdn.swu-db.com/images/cards/SHD/361.png",
                "isHorizontal": false
            }
        },
        "name": "Finalizer, Might of the First Order",
        "type": "Unit - Space",
        "cost": 11,
        "rarity": "Legendary",
        "power": 11,
        "HP": 11,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FIRST ORDER",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "SHD_003": {
        "id": "SHD_003",
        "face": {
            "front": {
                "name": "Finn, This is a Rescue",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/003-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Finn, This is a Rescue",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SHD/003-b.png"
            }
        },
        "name": "Finn, This is a Rescue",
        "type": "Leader",
        "cost": 5,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "TROOPER"
        ]
    },
    "SHD_265": {
        "id": "SHD_265",
        "face": {
            "front": {
                "name": "Finn, This is a Rescue",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/265-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Finn, This is a Rescue",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SHD/265-b.png"
            }
        },
        "name": "Finn, This is a Rescue",
        "type": "Leader",
        "cost": 5,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "TROOPER"
        ]
    },
    "SHD_283": {
        "id": "SHD_283",
        "face": {
            "front": {
                "name": "Finn, This is a Rescue",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/283-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Finn, This is a Rescue",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SHD/283-b.png"
            }
        },
        "name": "Finn, This is a Rescue",
        "type": "Leader",
        "cost": 5,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "TROOPER"
        ]
    },
    "SHD_036": {
        "id": "SHD_036",
        "face": {
            "front": {
                "name": "First Light, Headquarters of the Crimson Dawn",
                "type": "Unit - Space",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SHD/036.png",
                "isHorizontal": false
            }
        },
        "name": "First Light, Headquarters of the Crimson Dawn",
        "type": "Unit - Space",
        "cost": 7,
        "rarity": "Rare",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SHD_313": {
        "id": "SHD_313",
        "face": {
            "front": {
                "name": "First Light, Headquarters of the Crimson Dawn",
                "type": "Unit - Space",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SHD/313.png",
                "isHorizontal": false
            }
        },
        "name": "First Light, Headquarters of the Crimson Dawn",
        "type": "Unit - Space",
        "cost": 7,
        "rarity": "Rare",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SHD_056": {
        "id": "SHD_056",
        "face": {
            "front": {
                "name": "Follower of The Way",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/056.png",
                "isHorizontal": false
            }
        },
        "name": "Follower of The Way",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN"
        ]
    },
    "SHD_331": {
        "id": "SHD_331",
        "face": {
            "front": {
                "name": "Follower of The Way",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/331.png",
                "isHorizontal": false
            }
        },
        "name": "Follower of The Way",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN"
        ]
    },
    "SHD_069": {
        "id": "SHD_069",
        "face": {
            "front": {
                "name": "Foundling",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/069.png",
                "isHorizontal": false
            }
        },
        "name": "Foundling",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN"
        ]
    },
    "SHD_343": {
        "id": "SHD_343",
        "face": {
            "front": {
                "name": "Foundling",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/343.png",
                "isHorizontal": false
            }
        },
        "name": "Foundling",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN"
        ]
    },
    "SHD_097": {
        "id": "SHD_097",
        "face": {
            "front": {
                "name": "Freetown Backup",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/097.png",
                "isHorizontal": false
            }
        },
        "name": "Freetown Backup",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "FRINGE"
        ]
    },
    "SHD_366": {
        "id": "SHD_366",
        "face": {
            "front": {
                "name": "Freetown Backup",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/366.png",
                "isHorizontal": false
            }
        },
        "name": "Freetown Backup",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "FRINGE"
        ]
    },
    "SHD_214": {
        "id": "SHD_214",
        "face": {
            "front": {
                "name": "Frontier Trader",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/214.png",
                "isHorizontal": false
            }
        },
        "name": "Frontier Trader",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "JAWA"
        ]
    },
    "SHD_482": {
        "id": "SHD_482",
        "face": {
            "front": {
                "name": "Frontier Trader",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/482.png",
                "isHorizontal": false
            }
        },
        "name": "Frontier Trader",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "JAWA"
        ]
    },
    "SHD_193": {
        "id": "SHD_193",
        "face": {
            "front": {
                "name": "Frozen in Carbonite",
                "type": "Upgrade",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/193.png",
                "isHorizontal": false
            }
        },
        "name": "Frozen in Carbonite",
        "type": "Upgrade",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "CONDITION"
        ]
    },
    "SHD_462": {
        "id": "SHD_462",
        "face": {
            "front": {
                "name": "Frozen in Carbonite",
                "type": "Upgrade",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/462.png",
                "isHorizontal": false
            }
        },
        "name": "Frozen in Carbonite",
        "type": "Upgrade",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "CONDITION"
        ]
    },
    "SHD_211": {
        "id": "SHD_211",
        "face": {
            "front": {
                "name": "Fugitive Wookiee",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/211.png",
                "isHorizontal": false
            }
        },
        "name": "Fugitive Wookiee",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "WOOKIEE"
        ]
    },
    "SHD_479": {
        "id": "SHD_479",
        "face": {
            "front": {
                "name": "Fugitive Wookiee",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/479.png",
                "isHorizontal": false
            }
        },
        "name": "Fugitive Wookiee",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "WOOKIEE"
        ]
    },
    "SHD_112": {
        "id": "SHD_112",
        "face": {
            "front": {
                "name": "Gamorrean Retainer",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/112.png",
                "isHorizontal": false
            }
        },
        "name": "Gamorrean Retainer",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_381": {
        "id": "SHD_381",
        "face": {
            "front": {
                "name": "Gamorrean Retainer",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/381.png",
                "isHorizontal": false
            }
        },
        "name": "Gamorrean Retainer",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_001": {
        "id": "SHD_001",
        "face": {
            "front": {
                "name": "Gar Saxon, Viceroy of Mandalore",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/001-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Gar Saxon, Viceroy of Mandalore",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SHD/001-b.png"
            }
        },
        "name": "Gar Saxon, Viceroy of Mandalore",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "MANDALORIAN",
            "OFFICIAL"
        ]
    },
    "SHD_263": {
        "id": "SHD_263",
        "face": {
            "front": {
                "name": "Gar Saxon, Viceroy of Mandalore",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/263-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Gar Saxon, Viceroy of Mandalore",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SHD/263-b.png"
            }
        },
        "name": "Gar Saxon, Viceroy of Mandalore",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "MANDALORIAN",
            "OFFICIAL"
        ]
    },
    "SHD_281": {
        "id": "SHD_281",
        "face": {
            "front": {
                "name": "Gar Saxon, Viceroy of Mandalore",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/281-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Gar Saxon, Viceroy of Mandalore",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SHD/281-b.png"
            }
        },
        "name": "Gar Saxon, Viceroy of Mandalore",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "MANDALORIAN",
            "OFFICIAL"
        ]
    },
    "SHD_103": {
        "id": "SHD_103",
        "face": {
            "front": {
                "name": "General Rieekan, Defensive Strategist",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/103.png",
                "isHorizontal": false
            }
        },
        "name": "General Rieekan, Defensive Strategist",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Rare",
        "power": 5,
        "HP": 7,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "OFFICIAL"
        ]
    },
    "SHD_372": {
        "id": "SHD_372",
        "face": {
            "front": {
                "name": "General Rieekan, Defensive Strategist",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/372.png",
                "isHorizontal": false
            }
        },
        "name": "General Rieekan, Defensive Strategist",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Rare",
        "power": 5,
        "HP": 7,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "OFFICIAL"
        ]
    },
    "SHD_081": {
        "id": "SHD_081",
        "face": {
            "front": {
                "name": "General Tagge, Concerned Commander",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/081.png",
                "isHorizontal": false
            }
        },
        "name": "General Tagge, Concerned Commander",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Special",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "SHD_048": {
        "id": "SHD_048",
        "face": {
            "front": {
                "name": "Gentle Giant",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/048.png",
                "isHorizontal": false
            }
        },
        "name": "Gentle Giant",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 2,
        "HP": 8,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "WOOKIEE"
        ]
    },
    "SHD_323": {
        "id": "SHD_323",
        "face": {
            "front": {
                "name": "Gentle Giant",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/323.png",
                "isHorizontal": false
            }
        },
        "name": "Gentle Giant",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 2,
        "HP": 8,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "WOOKIEE"
        ]
    },
    "SHD_242": {
        "id": "SHD_242",
        "face": {
            "front": {
                "name": "Gideon's Light Cruiser, Dark Troopers' Station",
                "type": "Unit - Space",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/SHD/242.png",
                "isHorizontal": false
            }
        },
        "name": "Gideon's Light Cruiser, Dark Troopers' Station",
        "type": "Unit - Space",
        "cost": 8,
        "rarity": "Special",
        "power": 7,
        "HP": 8,
        "aspects": [
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "SHD_144": {
        "id": "SHD_144",
        "face": {
            "front": {
                "name": "Give In to Your Anger",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/144.png",
                "isHorizontal": false
            }
        },
        "name": "Give In to Your Anger",
        "type": "Event",
        "cost": 1,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SHD_413": {
        "id": "SHD_413",
        "face": {
            "front": {
                "name": "Give In to Your Anger",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/413.png",
                "isHorizontal": false
            }
        },
        "name": "Give In to Your Anger",
        "type": "Event",
        "cost": 1,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SHD_245": {
        "id": "SHD_245",
        "face": {
            "front": {
                "name": "Greef Karga, Affable Commissioner",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/245.png",
                "isHorizontal": false
            }
        },
        "name": "Greef Karga, Affable Commissioner",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Special",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "OFFICIAL"
        ]
    },
    "SHD_246": {
        "id": "SHD_246",
        "face": {
            "front": {
                "name": "Grey Squadron Y-Wing",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/246.png",
                "isHorizontal": false
            }
        },
        "name": "Grey Squadron Y-Wing",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_508": {
        "id": "SHD_508",
        "face": {
            "front": {
                "name": "Grey Squadron Y-Wing",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/508.png",
                "isHorizontal": false
            }
        },
        "name": "Grey Squadron Y-Wing",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_196": {
        "id": "SHD_196",
        "face": {
            "front": {
                "name": "Grogu, Irresistible",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/196.png",
                "isHorizontal": false
            }
        },
        "name": "Grogu, Irresistible",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Special",
        "power": 0,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE"
        ]
    },
    "SHD_134": {
        "id": "SHD_134",
        "face": {
            "front": {
                "name": "Guavian Antagonizer",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/134.png",
                "isHorizontal": false
            }
        },
        "name": "Guavian Antagonizer",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "TROOPER"
        ]
    },
    "SHD_403": {
        "id": "SHD_403",
        "face": {
            "front": {
                "name": "Guavian Antagonizer",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/403.png",
                "isHorizontal": false
            }
        },
        "name": "Guavian Antagonizer",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "TROOPER"
        ]
    },
    "SHD_173": {
        "id": "SHD_173",
        "face": {
            "front": {
                "name": "Guild Target",
                "type": "Upgrade",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SHD/173.png",
                "isHorizontal": false
            }
        },
        "name": "Guild Target",
        "type": "Upgrade",
        "cost": 0,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "BOUNTY",
            "CONDITION"
        ]
    },
    "SHD_442": {
        "id": "SHD_442",
        "face": {
            "front": {
                "name": "Guild Target",
                "type": "Upgrade",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SHD/442.png",
                "isHorizontal": false
            }
        },
        "name": "Guild Target",
        "type": "Upgrade",
        "cost": 0,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "BOUNTY",
            "CONDITION"
        ]
    },
    "SHD_060": {
        "id": "SHD_060",
        "face": {
            "front": {
                "name": "HWK-290 Freighter",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/060.png",
                "isHorizontal": false
            }
        },
        "name": "HWK-290 Freighter",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SHD_335": {
        "id": "SHD_335",
        "face": {
            "front": {
                "name": "HWK-290 Freighter",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/335.png",
                "isHorizontal": false
            }
        },
        "name": "HWK-290 Freighter",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SHD_013": {
        "id": "SHD_013",
        "face": {
            "front": {
                "name": "Han Solo, Worth the Risk",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/013-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Han Solo, Worth the Risk",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SHD/013-b.png"
            }
        },
        "name": "Han Solo, Worth the Risk",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_275": {
        "id": "SHD_275",
        "face": {
            "front": {
                "name": "Han Solo, Worth the Risk",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/275-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Han Solo, Worth the Risk",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SHD/275-b.png"
            }
        },
        "name": "Han Solo, Worth the Risk",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_292": {
        "id": "SHD_292",
        "face": {
            "front": {
                "name": "Han Solo, Worth the Risk",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/292-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Han Solo, Worth the Risk",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SHD/292-b.png"
            }
        },
        "name": "Han Solo, Worth the Risk",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_145": {
        "id": "SHD_145",
        "face": {
            "front": {
                "name": "Headhunting",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/145.png",
                "isHorizontal": false
            }
        },
        "name": "Headhunting",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_414": {
        "id": "SHD_414",
        "face": {
            "front": {
                "name": "Headhunting",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/414.png",
                "isHorizontal": false
            }
        },
        "name": "Headhunting",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_146": {
        "id": "SHD_146",
        "face": {
            "front": {
                "name": "Heroic Renegade",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/146.png",
                "isHorizontal": false
            }
        },
        "name": "Heroic Renegade",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_415": {
        "id": "SHD_415",
        "face": {
            "front": {
                "name": "Heroic Renegade",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/415.png",
                "isHorizontal": false
            }
        },
        "name": "Heroic Renegade",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_155": {
        "id": "SHD_155",
        "face": {
            "front": {
                "name": "Heroic Resolve",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/155.png",
                "isHorizontal": false
            }
        },
        "name": "Heroic Resolve",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Rare",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SHD_424": {
        "id": "SHD_424",
        "face": {
            "front": {
                "name": "Heroic Resolve",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/424.png",
                "isHorizontal": false
            }
        },
        "name": "Heroic Resolve",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Rare",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SHD_005": {
        "id": "SHD_005",
        "face": {
            "front": {
                "name": "Hondo Ohnaka, That's Good Business",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/005-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Hondo Ohnaka, That's Good Business",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SHD/005-b.png"
            }
        },
        "name": "Hondo Ohnaka, That's Good Business",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 3,
        "HP": 7,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_267": {
        "id": "SHD_267",
        "face": {
            "front": {
                "name": "Hondo Ohnaka, That's Good Business",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/267-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Hondo Ohnaka, That's Good Business",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SHD/267-b.png"
            }
        },
        "name": "Hondo Ohnaka, That's Good Business",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 3,
        "HP": 7,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_285": {
        "id": "SHD_285",
        "face": {
            "front": {
                "name": "Hondo Ohnaka, That's Good Business",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/285-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Hondo Ohnaka, That's Good Business",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SHD/285-b.png"
            }
        },
        "name": "Hondo Ohnaka, That's Good Business",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 3,
        "HP": 7,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_174": {
        "id": "SHD_174",
        "face": {
            "front": {
                "name": "Hotshot DL-44 Blaster",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/174.png",
                "isHorizontal": false
            }
        },
        "name": "Hotshot DL-44 Blaster",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Rare",
        "power": 2,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "ITEM",
            "WEAPON"
        ]
    },
    "SHD_443": {
        "id": "SHD_443",
        "face": {
            "front": {
                "name": "Hotshot DL-44 Blaster",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/443.png",
                "isHorizontal": false
            }
        },
        "name": "Hotshot DL-44 Blaster",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Rare",
        "power": 2,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "ITEM",
            "WEAPON"
        ]
    },
    "SHD_162": {
        "id": "SHD_162",
        "face": {
            "front": {
                "name": "House Kast Soldier",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/162.png",
                "isHorizontal": false
            }
        },
        "name": "House Kast Soldier",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN",
            "TROOPER"
        ]
    },
    "SHD_431": {
        "id": "SHD_431",
        "face": {
            "front": {
                "name": "House Kast Soldier",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/431.png",
                "isHorizontal": false
            }
        },
        "name": "House Kast Soldier",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN",
            "TROOPER"
        ]
    },
    "SHD_009": {
        "id": "SHD_009",
        "face": {
            "front": {
                "name": "Hunter, Outcast Sergeant",
                "type": "Leader",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SHD/009-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Hunter, Outcast Sergeant",
                "type": "Leader",
                "cost": "7",
                "image": "https://cdn.swu-db.com/images/cards/SHD/009-b.png"
            }
        },
        "name": "Hunter, Outcast Sergeant",
        "type": "Leader",
        "cost": 7,
        "rarity": "Rare",
        "power": 5,
        "HP": 8,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "CLONE"
        ]
    },
    "SHD_271": {
        "id": "SHD_271",
        "face": {
            "front": {
                "name": "Hunter, Outcast Sergeant",
                "type": "Leader",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SHD/271-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Hunter, Outcast Sergeant",
                "type": "Leader",
                "cost": "7",
                "image": "https://cdn.swu-db.com/images/cards/SHD/271-b.png"
            }
        },
        "name": "Hunter, Outcast Sergeant",
        "type": "Leader",
        "cost": 7,
        "rarity": "Rare",
        "power": 5,
        "HP": 8,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "CLONE"
        ]
    },
    "SHD_288": {
        "id": "SHD_288",
        "face": {
            "front": {
                "name": "Hunter, Outcast Sergeant",
                "type": "Leader",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SHD/288-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Hunter, Outcast Sergeant",
                "type": "Leader",
                "cost": "7",
                "image": "https://cdn.swu-db.com/images/cards/SHD/288-b.png"
            }
        },
        "name": "Hunter, Outcast Sergeant",
        "type": "Leader",
        "cost": 7,
        "rarity": "Rare",
        "power": 5,
        "HP": 8,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "CLONE"
        ]
    },
    "SHD_186": {
        "id": "SHD_186",
        "face": {
            "front": {
                "name": "Hunter of the Haxion Brood",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/186.png",
                "isHorizontal": false
            }
        },
        "name": "Hunter of the Haxion Brood",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 4,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_455": {
        "id": "SHD_455",
        "face": {
            "front": {
                "name": "Hunter of the Haxion Brood",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/455.png",
                "isHorizontal": false
            }
        },
        "name": "Hunter of the Haxion Brood",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 4,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_168": {
        "id": "SHD_168",
        "face": {
            "front": {
                "name": "Hunting Nexu",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/168.png",
                "isHorizontal": false
            }
        },
        "name": "Hunting Nexu",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "CREATURE"
        ]
    },
    "SHD_437": {
        "id": "SHD_437",
        "face": {
            "front": {
                "name": "Hunting Nexu",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/437.png",
                "isHorizontal": false
            }
        },
        "name": "Hunting Nexu",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "CREATURE"
        ]
    },
    "SHD_240": {
        "id": "SHD_240",
        "face": {
            "front": {
                "name": "Hutt's Henchmen",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/240.png",
                "isHorizontal": false
            }
        },
        "name": "Hutt's Henchmen",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_504": {
        "id": "SHD_504",
        "face": {
            "front": {
                "name": "Hutt's Henchmen",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/504.png",
                "isHorizontal": false
            }
        },
        "name": "Hutt's Henchmen",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_027": {
        "id": "SHD_027",
        "face": {
            "front": {
                "name": "Hylobon Enforcer",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/027.png",
                "isHorizontal": false
            }
        },
        "name": "Hylobon Enforcer",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_305": {
        "id": "SHD_305",
        "face": {
            "front": {
                "name": "Hylobon Enforcer",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/305.png",
                "isHorizontal": false
            }
        },
        "name": "Hylobon Enforcer",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_170": {
        "id": "SHD_170",
        "face": {
            "front": {
                "name": "IG-11, I Cannot Be Captured",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/170.png",
                "isHorizontal": false
            }
        },
        "name": "IG-11, I Cannot Be Captured",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 6,
        "HP": 5,
        "aspects": [
            "Aggression"
        ],
        "unique": true,
        "traits": [
            "DROID",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_439": {
        "id": "SHD_439",
        "face": {
            "front": {
                "name": "IG-11, I Cannot Be Captured",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/439.png",
                "isHorizontal": false
            }
        },
        "name": "IG-11, I Cannot Be Captured",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 6,
        "HP": 5,
        "aspects": [
            "Aggression"
        ],
        "unique": true,
        "traits": [
            "DROID",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_072": {
        "id": "SHD_072",
        "face": {
            "front": {
                "name": "Imprisoned",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/072.png",
                "isHorizontal": false
            }
        },
        "name": "Imprisoned",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "CONDITION",
            "LAW"
        ]
    },
    "SHD_345": {
        "id": "SHD_345",
        "face": {
            "front": {
                "name": "Imprisoned",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/345.png",
                "isHorizontal": false
            }
        },
        "name": "Imprisoned",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "CONDITION",
            "LAW"
        ]
    },
    "SHD_234": {
        "id": "SHD_234",
        "face": {
            "front": {
                "name": "Incinerator Trooper",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/234.png",
                "isHorizontal": false
            }
        },
        "name": "Incinerator Trooper",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Special",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "SHD_104": {
        "id": "SHD_104",
        "face": {
            "front": {
                "name": "Inspiring Mentor",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/104.png",
                "isHorizontal": false
            }
        },
        "name": "Inspiring Mentor",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Rare",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SHD_373": {
        "id": "SHD_373",
        "face": {
            "front": {
                "name": "Inspiring Mentor",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/373.png",
                "isHorizontal": false
            }
        },
        "name": "Inspiring Mentor",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Rare",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SHD_006": {
        "id": "SHD_006",
        "face": {
            "front": {
                "name": "Jabba the Hutt, His High Exaltdeness",
                "type": "Leader",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SHD/006-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Jabba the Hutt, His High Exaltdeness",
                "type": "Leader",
                "cost": "7",
                "image": "https://cdn.swu-db.com/images/cards/SHD/006-b.png"
            }
        },
        "name": "Jabba the Hutt, His High Exaltdeness",
        "type": "Leader",
        "cost": 7,
        "rarity": "Rare",
        "power": 2,
        "HP": 12,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "HUTT"
        ]
    },
    "SHD_268": {
        "id": "SHD_268",
        "face": {
            "front": {
                "name": "Jabba the Hutt, His High Exaltdeness",
                "type": "Leader",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SHD/268-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Jabba the Hutt, His High Exaltdeness",
                "type": "Leader",
                "cost": "7",
                "image": "https://cdn.swu-db.com/images/cards/SHD/268-b.png"
            }
        },
        "name": "Jabba the Hutt, His High Exaltdeness",
        "type": "Leader",
        "cost": 7,
        "rarity": "Rare",
        "power": 2,
        "HP": 12,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "HUTT"
        ]
    },
    "SHD_286": {
        "id": "SHD_286",
        "face": {
            "front": {
                "name": "Jabba the Hutt, His High Exaltdeness",
                "type": "Leader",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SHD/286-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Jabba the Hutt, His High Exaltdeness",
                "type": "Leader",
                "cost": "7",
                "image": "https://cdn.swu-db.com/images/cards/SHD/286-b.png"
            }
        },
        "name": "Jabba the Hutt, His High Exaltdeness",
        "type": "Leader",
        "cost": 7,
        "rarity": "Rare",
        "power": 2,
        "HP": 12,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "HUTT"
        ]
    },
    "SHD_026": {
        "id": "SHD_026",
        "face": {
            "front": {
                "name": "Jabba's Palace, Tatooine",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SHD/026-r.png",
                "isHorizontal": true
            }
        },
        "name": "Jabba's Palace, Tatooine",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": []
    },
    "SHD_304": {
        "id": "SHD_304",
        "face": {
            "front": {
                "name": "Jabba's Palace, Tatooine",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SHD/304-r.png",
                "isHorizontal": true
            }
        },
        "name": "Jabba's Palace, Tatooine",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": []
    },
    "SHD_091": {
        "id": "SHD_091",
        "face": {
            "front": {
                "name": "Jabba's Rancor, Pateesa",
                "type": "Unit - Ground",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/SHD/091.png",
                "isHorizontal": false
            }
        },
        "name": "Jabba's Rancor, Pateesa",
        "type": "Unit - Ground",
        "cost": 8,
        "rarity": "Uncommon",
        "power": 9,
        "HP": 9,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "CREATURE"
        ]
    },
    "SHD_360": {
        "id": "SHD_360",
        "face": {
            "front": {
                "name": "Jabba's Rancor, Pateesa",
                "type": "Unit - Ground",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/SHD/360.png",
                "isHorizontal": false
            }
        },
        "name": "Jabba's Rancor, Pateesa",
        "type": "Unit - Ground",
        "cost": 8,
        "rarity": "Uncommon",
        "power": 9,
        "HP": 9,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "CREATURE"
        ]
    },
    "SHD_138": {
        "id": "SHD_138",
        "face": {
            "front": {
                "name": "Jango Fett, Renowned Bounty Hunter",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/138.png",
                "isHorizontal": false
            }
        },
        "name": "Jango Fett, Renowned Bounty Hunter",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_407": {
        "id": "SHD_407",
        "face": {
            "front": {
                "name": "Jango Fett, Renowned Bounty Hunter",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/407.png",
                "isHorizontal": false
            }
        },
        "name": "Jango Fett, Renowned Bounty Hunter",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_225": {
        "id": "SHD_225",
        "face": {
            "front": {
                "name": "Jetpack",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/225.png",
                "isHorizontal": false
            }
        },
        "name": "Jetpack",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "ITEM",
            "ARMOR"
        ]
    },
    "SHD_492": {
        "id": "SHD_492",
        "face": {
            "front": {
                "name": "Jetpack",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/492.png",
                "isHorizontal": false
            }
        },
        "name": "Jetpack",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "ITEM",
            "ARMOR"
        ]
    },
    "SHD_147": {
        "id": "SHD_147",
        "face": {
            "front": {
                "name": "Ketsu Onyo, Old Friend",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/147.png",
                "isHorizontal": false
            }
        },
        "name": "Ketsu Onyo, Old Friend",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_416": {
        "id": "SHD_416",
        "face": {
            "front": {
                "name": "Ketsu Onyo, Old Friend",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/416.png",
                "isHorizontal": false
            }
        },
        "name": "Ketsu Onyo, Old Friend",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_118": {
        "id": "SHD_118",
        "face": {
            "front": {
                "name": "Kihrazx Heavy Fighter",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/118.png",
                "isHorizontal": false
            }
        },
        "name": "Kihrazx Heavy Fighter",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_387": {
        "id": "SHD_387",
        "face": {
            "front": {
                "name": "Kihrazx Heavy Fighter",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/387.png",
                "isHorizontal": false
            }
        },
        "name": "Kihrazx Heavy Fighter",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_183": {
        "id": "SHD_183",
        "face": {
            "front": {
                "name": "Kintan Intimidator",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/183.png",
                "isHorizontal": false
            }
        },
        "name": "Kintan Intimidator",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_452": {
        "id": "SHD_452",
        "face": {
            "front": {
                "name": "Kintan Intimidator",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/452.png",
                "isHorizontal": false
            }
        },
        "name": "Kintan Intimidator",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_150": {
        "id": "SHD_150",
        "face": {
            "front": {
                "name": "Koska Reeves, Loyal Nite Owl",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/150.png",
                "isHorizontal": false
            }
        },
        "name": "Koska Reeves, Loyal Nite Owl",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "TROOPER"
        ]
    },
    "SHD_419": {
        "id": "SHD_419",
        "face": {
            "front": {
                "name": "Koska Reeves, Loyal Nite Owl",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/419.png",
                "isHorizontal": false
            }
        },
        "name": "Koska Reeves, Loyal Nite Owl",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "TROOPER"
        ]
    },
    "SHD_241": {
        "id": "SHD_241",
        "face": {
            "front": {
                "name": "Kragan Gorr, Warbird Captain",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/241.png",
                "isHorizontal": false
            }
        },
        "name": "Kragan Gorr, Warbird Captain",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Rare",
        "power": 6,
        "HP": 6,
        "aspects": [
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_505": {
        "id": "SHD_505",
        "face": {
            "front": {
                "name": "Kragan Gorr, Warbird Captain",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/505.png",
                "isHorizontal": false
            }
        },
        "name": "Kragan Gorr, Warbird Captain",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Rare",
        "power": 6,
        "HP": 6,
        "aspects": [
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_172": {
        "id": "SHD_172",
        "face": {
            "front": {
                "name": "Krayt Dragon",
                "type": "Unit - Ground",
                "cost": 9,
                "image": "https://cdn.swu-db.com/images/cards/SHD/172.png",
                "isHorizontal": false
            }
        },
        "name": "Krayt Dragon",
        "type": "Unit - Ground",
        "cost": 9,
        "rarity": "Legendary",
        "power": 10,
        "HP": 10,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "CREATURE"
        ]
    },
    "SHD_441": {
        "id": "SHD_441",
        "face": {
            "front": {
                "name": "Krayt Dragon",
                "type": "Unit - Ground",
                "cost": 9,
                "image": "https://cdn.swu-db.com/images/cards/SHD/441.png",
                "isHorizontal": false
            }
        },
        "name": "Krayt Dragon",
        "type": "Unit - Ground",
        "cost": 9,
        "rarity": "Legendary",
        "power": 10,
        "HP": 10,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "CREATURE"
        ]
    },
    "SHD_139": {
        "id": "SHD_139",
        "face": {
            "front": {
                "name": "Krrsantan, Muscle for Hire",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/139.png",
                "isHorizontal": false
            }
        },
        "name": "Krrsantan, Muscle for Hire",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 7,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "WOOKIEE",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_408": {
        "id": "SHD_408",
        "face": {
            "front": {
                "name": "Krrsantan, Muscle for Hire",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/408.png",
                "isHorizontal": false
            }
        },
        "name": "Krrsantan, Muscle for Hire",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 7,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "WOOKIEE",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_041": {
        "id": "SHD_041",
        "face": {
            "front": {
                "name": "Kuiil, I Have Spoken",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/041.png",
                "isHorizontal": false
            }
        },
        "name": "Kuiil, I Have Spoken",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FRINGE"
        ]
    },
    "SHD_317": {
        "id": "SHD_317",
        "face": {
            "front": {
                "name": "Kuiil, I Have Spoken",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/317.png",
                "isHorizontal": false
            }
        },
        "name": "Kuiil, I Have Spoken",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FRINGE"
        ]
    },
    "SHD_011": {
        "id": "SHD_011",
        "face": {
            "front": {
                "name": "Kylo Ren, Rash and Deadly",
                "type": "Leader",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/011-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Kylo Ren, Rash and Deadly",
                "type": "Leader",
                "cost": "4",
                "image": "https://cdn.swu-db.com/images/cards/SHD/011-b.png"
            }
        },
        "name": "Kylo Ren, Rash and Deadly",
        "type": "Leader",
        "cost": 4,
        "rarity": "Rare",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "FIRST ORDER"
        ]
    },
    "SHD_141": {
        "id": "SHD_141",
        "face": {
            "front": {
                "name": "Kylo Ren, Killing the Past",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/141.png",
                "isHorizontal": false
            }
        },
        "name": "Kylo Ren, Killing the Past",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Legendary",
        "power": 6,
        "HP": 7,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "FIRST ORDER"
        ]
    },
    "SHD_273": {
        "id": "SHD_273",
        "face": {
            "front": {
                "name": "Kylo Ren, Rash and Deadly",
                "type": "Leader",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/273-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Kylo Ren, Rash and Deadly",
                "type": "Leader",
                "cost": "4",
                "image": "https://cdn.swu-db.com/images/cards/SHD/273-b.png"
            }
        },
        "name": "Kylo Ren, Rash and Deadly",
        "type": "Leader",
        "cost": 4,
        "rarity": "Rare",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "FIRST ORDER"
        ]
    },
    "SHD_290": {
        "id": "SHD_290",
        "face": {
            "front": {
                "name": "Kylo Ren, Rash and Deadly",
                "type": "Leader",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/290-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Kylo Ren, Rash and Deadly",
                "type": "Leader",
                "cost": "4",
                "image": "https://cdn.swu-db.com/images/cards/SHD/290-b.png"
            }
        },
        "name": "Kylo Ren, Rash and Deadly",
        "type": "Leader",
        "cost": 4,
        "rarity": "Rare",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "FIRST ORDER"
        ]
    },
    "SHD_410": {
        "id": "SHD_410",
        "face": {
            "front": {
                "name": "Kylo Ren, Killing the Past",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/410.png",
                "isHorizontal": false
            }
        },
        "name": "Kylo Ren, Killing the Past",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Legendary",
        "power": 6,
        "HP": 7,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "FIRST ORDER"
        ]
    },
    "SHD_135": {
        "id": "SHD_135",
        "face": {
            "front": {
                "name": "Kylo's TIE Silencer, Ruthlessly Efficient",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/135.png",
                "isHorizontal": false
            }
        },
        "name": "Kylo's TIE Silencer, Ruthlessly Efficient",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Legendary",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FIRST ORDER",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_404": {
        "id": "SHD_404",
        "face": {
            "front": {
                "name": "Kylo's TIE Silencer, Ruthlessly Efficient",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/404.png",
                "isHorizontal": false
            }
        },
        "name": "Kylo's TIE Silencer, Ruthlessly Efficient",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Legendary",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FIRST ORDER",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_197": {
        "id": "SHD_197",
        "face": {
            "front": {
                "name": "L3-37, Droid Revolutionary",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/197.png",
                "isHorizontal": false
            }
        },
        "name": "L3-37, Droid Revolutionary",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "DROID"
        ]
    },
    "SHD_465": {
        "id": "SHD_465",
        "face": {
            "front": {
                "name": "L3-37, Droid Revolutionary",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/465.png",
                "isHorizontal": false
            }
        },
        "name": "L3-37, Droid Revolutionary",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "DROID"
        ]
    },
    "SHD_255": {
        "id": "SHD_255",
        "face": {
            "front": {
                "name": "Lady Proxima, White Worm Matriarch",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/255.png",
                "isHorizontal": false
            }
        },
        "name": "Lady Proxima, White Worm Matriarch",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 4,
        "aspects": [],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_516": {
        "id": "SHD_516",
        "face": {
            "front": {
                "name": "Lady Proxima, White Worm Matriarch",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/516.png",
                "isHorizontal": false
            }
        },
        "name": "Lady Proxima, White Worm Matriarch",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 4,
        "aspects": [],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_017": {
        "id": "SHD_017",
        "face": {
            "front": {
                "name": "Lando Calrissian, With Impeccable Taste",
                "type": "Leader",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/017-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Lando Calrissian, With Impeccable Taste",
                "type": "Leader",
                "cost": "4",
                "image": "https://cdn.swu-db.com/images/cards/SHD/017-b.png"
            }
        },
        "name": "Lando Calrissian, With Impeccable Taste",
        "type": "Leader",
        "cost": 4,
        "rarity": "Rare",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_279": {
        "id": "SHD_279",
        "face": {
            "front": {
                "name": "Lando Calrissian, With Impeccable Taste",
                "type": "Leader",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/279-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Lando Calrissian, With Impeccable Taste",
                "type": "Leader",
                "cost": "4",
                "image": "https://cdn.swu-db.com/images/cards/SHD/279-b.png"
            }
        },
        "name": "Lando Calrissian, With Impeccable Taste",
        "type": "Leader",
        "cost": 4,
        "rarity": "Rare",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_296": {
        "id": "SHD_296",
        "face": {
            "front": {
                "name": "Lando Calrissian, With Impeccable Taste",
                "type": "Leader",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/296-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Lando Calrissian, With Impeccable Taste",
                "type": "Leader",
                "cost": "4",
                "image": "https://cdn.swu-db.com/images/cards/SHD/296-b.png"
            }
        },
        "name": "Lando Calrissian, With Impeccable Taste",
        "type": "Leader",
        "cost": 4,
        "rarity": "Rare",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_124": {
        "id": "SHD_124",
        "face": {
            "front": {
                "name": "Legal Authority",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/124.png",
                "isHorizontal": false
            }
        },
        "name": "Legal Authority",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 2,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "LAW"
        ]
    },
    "SHD_393": {
        "id": "SHD_393",
        "face": {
            "front": {
                "name": "Legal Authority",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/393.png",
                "isHorizontal": false
            }
        },
        "name": "Legal Authority",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 2,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "LAW"
        ]
    },
    "SHD_205": {
        "id": "SHD_205",
        "face": {
            "front": {
                "name": "Let the Wookiee Win",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/205.png",
                "isHorizontal": false
            }
        },
        "name": "Let the Wookiee Win",
        "type": "Event",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "SHD_473": {
        "id": "SHD_473",
        "face": {
            "front": {
                "name": "Let the Wookiee Win",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/473.png",
                "isHorizontal": false
            }
        },
        "name": "Let the Wookiee Win",
        "type": "Event",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "SHD_200": {
        "id": "SHD_200",
        "face": {
            "front": {
                "name": "Liberated Slaves",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/200.png",
                "isHorizontal": false
            }
        },
        "name": "Liberated Slaves",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "DROID",
            "TWI'LEK",
            "WOOKIEE"
        ]
    },
    "SHD_468": {
        "id": "SHD_468",
        "face": {
            "front": {
                "name": "Liberated Slaves",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/468.png",
                "isHorizontal": false
            }
        },
        "name": "Liberated Slaves",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "DROID",
            "TWI'LEK",
            "WOOKIEE"
        ]
    },
    "SHD_032": {
        "id": "SHD_032",
        "face": {
            "front": {
                "name": "Lom Pyke, Dealer in Truths",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/032.png",
                "isHorizontal": false
            }
        },
        "name": "Lom Pyke, Dealer in Truths",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_309": {
        "id": "SHD_309",
        "face": {
            "front": {
                "name": "Lom Pyke, Dealer in Truths",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/309.png",
                "isHorizontal": false
            }
        },
        "name": "Lom Pyke, Dealer in Truths",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_227": {
        "id": "SHD_227",
        "face": {
            "front": {
                "name": "Look the Other Way",
                "type": "Event",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SHD/227.png",
                "isHorizontal": false
            }
        },
        "name": "Look the Other Way",
        "type": "Event",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "SHD_494": {
        "id": "SHD_494",
        "face": {
            "front": {
                "name": "Look the Other Way",
                "type": "Event",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SHD/494.png",
                "isHorizontal": false
            }
        },
        "name": "Look the Other Way",
        "type": "Event",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "SHD_187": {
        "id": "SHD_187",
        "face": {
            "front": {
                "name": "Lurking TIE Phantom",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/187.png",
                "isHorizontal": false
            }
        },
        "name": "Lurking TIE Phantom",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_456": {
        "id": "SHD_456",
        "face": {
            "front": {
                "name": "Lurking TIE Phantom",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/456.png",
                "isHorizontal": false
            }
        },
        "name": "Lurking TIE Phantom",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_229": {
        "id": "SHD_229",
        "face": {
            "front": {
                "name": "Ma Klounkee",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/229.png",
                "isHorizontal": false
            }
        },
        "name": "Ma Klounkee",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "TRICK"
        ]
    },
    "SHD_496": {
        "id": "SHD_496",
        "face": {
            "front": {
                "name": "Ma Klounkee",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/496.png",
                "isHorizontal": false
            }
        },
        "name": "Ma Klounkee",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "TRICK"
        ]
    },
    "SHD_073": {
        "id": "SHD_073",
        "face": {
            "front": {
                "name": "Mandalorian Armor",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/073.png",
                "isHorizontal": false
            }
        },
        "name": "Mandalorian Armor",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Rare",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "ITEM",
            "ARMOR"
        ]
    },
    "SHD_346": {
        "id": "SHD_346",
        "face": {
            "front": {
                "name": "Mandalorian Armor",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/346.png",
                "isHorizontal": false
            }
        },
        "name": "Mandalorian Armor",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Rare",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "ITEM",
            "ARMOR"
        ]
    },
    "SHD_258": {
        "id": "SHD_258",
        "face": {
            "front": {
                "name": "Mandalorian Warrior",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/258.png",
                "isHorizontal": false
            }
        },
        "name": "Mandalorian Warrior",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [],
        "unique": true,
        "traits": [
            "MANDALORIAN"
        ]
    },
    "SHD_519": {
        "id": "SHD_519",
        "face": {
            "front": {
                "name": "Mandalorian Warrior",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/519.png",
                "isHorizontal": false
            }
        },
        "name": "Mandalorian Warrior",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [],
        "unique": true,
        "traits": [
            "MANDALORIAN"
        ]
    },
    "SHD_090": {
        "id": "SHD_090",
        "face": {
            "front": {
                "name": "Maul, Shadow Collective Visionary",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SHD/090.png",
                "isHorizontal": false
            }
        },
        "name": "Maul, Shadow Collective Visionary",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Rare",
        "power": 7,
        "HP": 6,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "UNDERWORLD"
        ]
    },
    "SHD_359": {
        "id": "SHD_359",
        "face": {
            "front": {
                "name": "Maul, Shadow Collective Visionary",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SHD/359.png",
                "isHorizontal": false
            }
        },
        "name": "Maul, Shadow Collective Visionary",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Rare",
        "power": 7,
        "HP": 6,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "UNDERWORLD"
        ]
    },
    "SHD_096": {
        "id": "SHD_096",
        "face": {
            "front": {
                "name": "Maz Kanata, Pirate Queen",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/096.png",
                "isHorizontal": false
            }
        },
        "name": "Maz Kanata, Pirate Queen",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Rare",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_365": {
        "id": "SHD_365",
        "face": {
            "front": {
                "name": "Maz Kanata, Pirate Queen",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/365.png",
                "isHorizontal": false
            }
        },
        "name": "Maz Kanata, Pirate Queen",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Rare",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_021": {
        "id": "SHD_021",
        "face": {
            "front": {
                "name": "Maz Kanata's Castle, Takodana",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SHD/021-r.png",
                "isHorizontal": true
            }
        },
        "name": "Maz Kanata's Castle, Takodana",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": []
    },
    "SHD_299": {
        "id": "SHD_299",
        "face": {
            "front": {
                "name": "Maz Kanata's Castle, Takodana",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SHD/299-r.png",
                "isHorizontal": true
            }
        },
        "name": "Maz Kanata's Castle, Takodana",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": []
    },
    "SHD_121": {
        "id": "SHD_121",
        "face": {
            "front": {
                "name": "Mercenary Company",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/121.png",
                "isHorizontal": false
            }
        },
        "name": "Mercenary Company",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "TROOPER"
        ]
    },
    "SHD_390": {
        "id": "SHD_390",
        "face": {
            "front": {
                "name": "Mercenary Company",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/390.png",
                "isHorizontal": false
            }
        },
        "name": "Mercenary Company",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "TROOPER"
        ]
    },
    "SHD_256": {
        "id": "SHD_256",
        "face": {
            "front": {
                "name": "Mercenary Gunship",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/256.png",
                "isHorizontal": false
            }
        },
        "name": "Mercenary Gunship",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 2,
        "aspects": [],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_517": {
        "id": "SHD_517",
        "face": {
            "front": {
                "name": "Mercenary Gunship",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/517.png",
                "isHorizontal": false
            }
        },
        "name": "Mercenary Gunship",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 2,
        "aspects": [],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_054": {
        "id": "SHD_054",
        "face": {
            "front": {
                "name": "Midnight Repairs",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/054.png",
                "isHorizontal": false
            }
        },
        "name": "Midnight Repairs",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance",
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_329": {
        "id": "SHD_329",
        "face": {
            "front": {
                "name": "Midnight Repairs",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/329.png",
                "isHorizontal": false
            }
        },
        "name": "Midnight Repairs",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance",
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_163": {
        "id": "SHD_163",
        "face": {
            "front": {
                "name": "Migs Mayfeld, Triggerman",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/163.png",
                "isHorizontal": false
            }
        },
        "name": "Migs Mayfeld, Triggerman",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Aggression"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_432": {
        "id": "SHD_432",
        "face": {
            "front": {
                "name": "Migs Mayfeld, Triggerman",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/432.png",
                "isHorizontal": false
            }
        },
        "name": "Migs Mayfeld, Triggerman",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Aggression"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_204": {
        "id": "SHD_204",
        "face": {
            "front": {
                "name": "Millennium Falcon, Lando's Pride",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/204.png",
                "isHorizontal": false
            }
        },
        "name": "Millennium Falcon, Lando's Pride",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Uncommon",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SHD_472": {
        "id": "SHD_472",
        "face": {
            "front": {
                "name": "Millennium Falcon, Lando's Pride",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/472.png",
                "isHorizontal": false
            }
        },
        "name": "Millennium Falcon, Lando's Pride",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Uncommon",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SHD_100": {
        "id": "SHD_100",
        "face": {
            "front": {
                "name": "Modded Cohort",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/100.png",
                "isHorizontal": false
            }
        },
        "name": "Modded Cohort",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_369": {
        "id": "SHD_369",
        "face": {
            "front": {
                "name": "Modded Cohort",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/369.png",
                "isHorizontal": false
            }
        },
        "name": "Modded Cohort",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_007": {
        "id": "SHD_007",
        "face": {
            "front": {
                "name": "Moff Gideon, Formidable Commander",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/007-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Moff Gideon, Formidable Commander",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SHD/007-b.png"
            }
        },
        "name": "Moff Gideon, Formidable Commander",
        "type": "Leader",
        "cost": 5,
        "rarity": "Special",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "SHD_269": {
        "id": "SHD_269",
        "face": {
            "front": {
                "name": "Moff Gideon, Formidable Commander",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/269-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Moff Gideon, Formidable Commander",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SHD/269-b.png"
            }
        },
        "name": "Moff Gideon, Formidable Commander",
        "type": "Leader",
        "cost": 5,
        "rarity": "Special",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "SHD_055": {
        "id": "SHD_055",
        "face": {
            "front": {
                "name": "Moisture Farmer",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/055.png",
                "isHorizontal": false
            }
        },
        "name": "Moisture Farmer",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 4,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "FRINGE"
        ]
    },
    "SHD_330": {
        "id": "SHD_330",
        "face": {
            "front": {
                "name": "Moisture Farmer",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/330.png",
                "isHorizontal": false
            }
        },
        "name": "Moisture Farmer",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 4,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "FRINGE"
        ]
    },
    "SHD_130": {
        "id": "SHD_130",
        "face": {
            "front": {
                "name": "Moment of Glory",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/130.png",
                "isHorizontal": false
            }
        },
        "name": "Moment of Glory",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_399": {
        "id": "SHD_399",
        "face": {
            "front": {
                "name": "Moment of Glory",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/399.png",
                "isHorizontal": false
            }
        },
        "name": "Moment of Glory",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_051": {
        "id": "SHD_051",
        "face": {
            "front": {
                "name": "Mystic Reflection",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/051.png",
                "isHorizontal": false
            }
        },
        "name": "Mystic Reflection",
        "type": "Event",
        "cost": 1,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "FORCE"
        ]
    },
    "SHD_326": {
        "id": "SHD_326",
        "face": {
            "front": {
                "name": "Mystic Reflection",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/326.png",
                "isHorizontal": false
            }
        },
        "name": "Mystic Reflection",
        "type": "Event",
        "cost": 1,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "FORCE"
        ]
    },
    "SHD_022": {
        "id": "SHD_022",
        "face": {
            "front": {
                "name": "Nevarro City, Nevarro",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SHD/022-r.png",
                "isHorizontal": true
            }
        },
        "name": "Nevarro City, Nevarro",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": []
    },
    "SHD_300": {
        "id": "SHD_300",
        "face": {
            "front": {
                "name": "Nevarro City, Nevarro",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SHD/300-r.png",
                "isHorizontal": true
            }
        },
        "name": "Nevarro City, Nevarro",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": []
    },
    "SHD_062": {
        "id": "SHD_062",
        "face": {
            "front": {
                "name": "Niima Outpost Constables",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/062.png",
                "isHorizontal": false
            }
        },
        "name": "Niima Outpost Constables",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 2,
        "HP": 6,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "FRINGE"
        ]
    },
    "SHD_337": {
        "id": "SHD_337",
        "face": {
            "front": {
                "name": "Niima Outpost Constables",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/337.png",
                "isHorizontal": false
            }
        },
        "name": "Niima Outpost Constables",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 2,
        "HP": 6,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "FRINGE"
        ]
    },
    "SHD_149": {
        "id": "SHD_149",
        "face": {
            "front": {
                "name": "Nite Owl Skirmisher",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/149.png",
                "isHorizontal": false
            }
        },
        "name": "Nite Owl Skirmisher",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 4,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN",
            "TROOPER"
        ]
    },
    "SHD_418": {
        "id": "SHD_418",
        "face": {
            "front": {
                "name": "Nite Owl Skirmisher",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/418.png",
                "isHorizontal": false
            }
        },
        "name": "Nite Owl Skirmisher",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 4,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN",
            "TROOPER"
        ]
    },
    "SHD_244": {
        "id": "SHD_244",
        "face": {
            "front": {
                "name": "No Bargain",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/244.png",
                "isHorizontal": false
            }
        },
        "name": "No Bargain",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "SHD_507": {
        "id": "SHD_507",
        "face": {
            "front": {
                "name": "No Bargain",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/507.png",
                "isHorizontal": false
            }
        },
        "name": "No Bargain",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "SHD_198": {
        "id": "SHD_198",
        "face": {
            "front": {
                "name": "Omega, Part of the Squad",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/198.png",
                "isHorizontal": false
            }
        },
        "name": "Omega, Part of the Squad",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "CLONE"
        ]
    },
    "SHD_466": {
        "id": "SHD_466",
        "face": {
            "front": {
                "name": "Omega, Part of the Squad",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/466.png",
                "isHorizontal": false
            }
        },
        "name": "Omega, Part of the Squad",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "CLONE"
        ]
    },
    "SHD_128": {
        "id": "SHD_128",
        "face": {
            "front": {
                "name": "Outflank",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/128.png",
                "isHorizontal": false
            }
        },
        "name": "Outflank",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_397": {
        "id": "SHD_397",
        "face": {
            "front": {
                "name": "Outflank",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/397.png",
                "isHorizontal": false
            }
        },
        "name": "Outflank",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_082": {
        "id": "SHD_082",
        "face": {
            "front": {
                "name": "Outland TIE Vanguard",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/082.png",
                "isHorizontal": false
            }
        },
        "name": "Outland TIE Vanguard",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_354": {
        "id": "SHD_354",
        "face": {
            "front": {
                "name": "Outland TIE Vanguard",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/354.png",
                "isHorizontal": false
            }
        },
        "name": "Outland TIE Vanguard",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_116": {
        "id": "SHD_116",
        "face": {
            "front": {
                "name": "Outlaw Corona",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/116.png",
                "isHorizontal": false
            }
        },
        "name": "Outlaw Corona",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "SHD_385": {
        "id": "SHD_385",
        "face": {
            "front": {
                "name": "Outlaw Corona",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/385.png",
                "isHorizontal": false
            }
        },
        "name": "Outlaw Corona",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "SHD_094": {
        "id": "SHD_094",
        "face": {
            "front": {
                "name": "Palpatine's Return",
                "type": "Event",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/094.png",
                "isHorizontal": false
            }
        },
        "name": "Palpatine's Return",
        "type": "Event",
        "cost": 6,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "FORCE",
            "PLAN"
        ]
    },
    "SHD_363": {
        "id": "SHD_363",
        "face": {
            "front": {
                "name": "Palpatine's Return",
                "type": "Event",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/363.png",
                "isHorizontal": false
            }
        },
        "name": "Palpatine's Return",
        "type": "Event",
        "cost": 6,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "FORCE",
            "PLAN"
        ]
    },
    "SHD_084": {
        "id": "SHD_084",
        "face": {
            "front": {
                "name": "Phase-III Dark Trooper",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/084.png",
                "isHorizontal": false
            }
        },
        "name": "Phase-III Dark Trooper",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Special",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "DROID",
            "TROOPER"
        ]
    },
    "SHD_181": {
        "id": "SHD_181",
        "face": {
            "front": {
                "name": "Pillage",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/181.png",
                "isHorizontal": false
            }
        },
        "name": "Pillage",
        "type": "Event",
        "cost": 4,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_450": {
        "id": "SHD_450",
        "face": {
            "front": {
                "name": "Pillage",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/450.png",
                "isHorizontal": false
            }
        },
        "name": "Pillage",
        "type": "Event",
        "cost": 4,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_089": {
        "id": "SHD_089",
        "face": {
            "front": {
                "name": "Pirate Battle Tank",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/089.png",
                "isHorizontal": false
            }
        },
        "name": "Pirate Battle Tank",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TANK"
        ]
    },
    "SHD_358": {
        "id": "SHD_358",
        "face": {
            "front": {
                "name": "Pirate Battle Tank",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/358.png",
                "isHorizontal": false
            }
        },
        "name": "Pirate Battle Tank",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TANK"
        ]
    },
    "SHD_153": {
        "id": "SHD_153",
        "face": {
            "front": {
                "name": "Poe Dameron, Quick to Improvise",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/153.png",
                "isHorizontal": false
            }
        },
        "name": "Poe Dameron, Quick to Improvise",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Legendary",
        "power": 6,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE"
        ]
    },
    "SHD_422": {
        "id": "SHD_422",
        "face": {
            "front": {
                "name": "Poe Dameron, Quick to Improvise",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/422.png",
                "isHorizontal": false
            }
        },
        "name": "Poe Dameron, Quick to Improvise",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Legendary",
        "power": 6,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE"
        ]
    },
    "SHD_142": {
        "id": "SHD_142",
        "face": {
            "front": {
                "name": "Pre Vizsla, Power Hungry",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SHD/142.png",
                "isHorizontal": false
            }
        },
        "name": "Pre Vizsla, Power Hungry",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Rare",
        "power": 8,
        "HP": 7,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "TROOPER"
        ]
    },
    "SHD_411": {
        "id": "SHD_411",
        "face": {
            "front": {
                "name": "Pre Vizsla, Power Hungry",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SHD/411.png",
                "isHorizontal": false
            }
        },
        "name": "Pre Vizsla, Power Hungry",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Rare",
        "power": 8,
        "HP": 7,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "TROOPER"
        ]
    },
    "SHD_125": {
        "id": "SHD_125",
        "face": {
            "front": {
                "name": "Price on Your Head",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/125.png",
                "isHorizontal": false
            }
        },
        "name": "Price on Your Head",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "BOUNTY",
            "CONDITION"
        ]
    },
    "SHD_394": {
        "id": "SHD_394",
        "face": {
            "front": {
                "name": "Price on Your Head",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/394.png",
                "isHorizontal": false
            }
        },
        "name": "Price on Your Head",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "BOUNTY",
            "CONDITION"
        ]
    },
    "SHD_201": {
        "id": "SHD_201",
        "face": {
            "front": {
                "name": "Principled Outlaw",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/201.png",
                "isHorizontal": false
            }
        },
        "name": "Principled Outlaw",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_469": {
        "id": "SHD_469",
        "face": {
            "front": {
                "name": "Principled Outlaw",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/469.png",
                "isHorizontal": false
            }
        },
        "name": "Principled Outlaw",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_113": {
        "id": "SHD_113",
        "face": {
            "front": {
                "name": "Privateer Crew",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/113.png",
                "isHorizontal": false
            }
        },
        "name": "Privateer Crew",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_382": {
        "id": "SHD_382",
        "face": {
            "front": {
                "name": "Privateer Crew",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/382.png",
                "isHorizontal": false
            }
        },
        "name": "Privateer Crew",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_212": {
        "id": "SHD_212",
        "face": {
            "front": {
                "name": "Privateer Scyk",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/212.png",
                "isHorizontal": false
            }
        },
        "name": "Privateer Scyk",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_480": {
        "id": "SHD_480",
        "face": {
            "front": {
                "name": "Privateer Scyk",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/480.png",
                "isHorizontal": false
            }
        },
        "name": "Privateer Scyk",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_247": {
        "id": "SHD_247",
        "face": {
            "front": {
                "name": "Protector of the Throne",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/247.png",
                "isHorizontal": false
            }
        },
        "name": "Protector of the Throne",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN"
        ]
    },
    "SHD_509": {
        "id": "SHD_509",
        "face": {
            "front": {
                "name": "Protector of the Throne",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/509.png",
                "isHorizontal": false
            }
        },
        "name": "Protector of the Throne",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN"
        ]
    },
    "SHD_068": {
        "id": "SHD_068",
        "face": {
            "front": {
                "name": "Public Enemy",
                "type": "Upgrade",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SHD/068.png",
                "isHorizontal": false
            }
        },
        "name": "Public Enemy",
        "type": "Upgrade",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "BOUNTY",
            "CONDITION"
        ]
    },
    "SHD_342": {
        "id": "SHD_342",
        "face": {
            "front": {
                "name": "Public Enemy",
                "type": "Upgrade",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SHD/342.png",
                "isHorizontal": false
            }
        },
        "name": "Public Enemy",
        "type": "Upgrade",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "BOUNTY",
            "CONDITION"
        ]
    },
    "SHD_137": {
        "id": "SHD_137",
        "face": {
            "front": {
                "name": "Punishing One, Dengar's Jumpmaster",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/137.png",
                "isHorizontal": false
            }
        },
        "name": "Punishing One, Dengar's Jumpmaster",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SHD_406": {
        "id": "SHD_406",
        "face": {
            "front": {
                "name": "Punishing One, Dengar's Jumpmaster",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/406.png",
                "isHorizontal": false
            }
        },
        "name": "Punishing One, Dengar's Jumpmaster",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SHD_029": {
        "id": "SHD_029",
        "face": {
            "front": {
                "name": "Pyke Sentinel",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/029.png",
                "isHorizontal": false
            }
        },
        "name": "Pyke Sentinel",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_307": {
        "id": "SHD_307",
        "face": {
            "front": {
                "name": "Pyke Sentinel",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/307.png",
                "isHorizontal": false
            }
        },
        "name": "Pyke Sentinel",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_002": {
        "id": "SHD_002",
        "face": {
            "front": {
                "name": "Qi'ra, I Alone Survived",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/002-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Qi'ra, I Alone Survived",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SHD/002-b.png"
            }
        },
        "name": "Qi'ra, I Alone Survived",
        "type": "Leader",
        "cost": 5,
        "rarity": "Rare",
        "power": 0,
        "HP": 8,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_202": {
        "id": "SHD_202",
        "face": {
            "front": {
                "name": "Qi'ra, Playing Her Part",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/202.png",
                "isHorizontal": false
            }
        },
        "name": "Qi'ra, Playing Her Part",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_264": {
        "id": "SHD_264",
        "face": {
            "front": {
                "name": "Qi'ra, I Alone Survived",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/264-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Qi'ra, I Alone Survived",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SHD/264-b.png"
            }
        },
        "name": "Qi'ra, I Alone Survived",
        "type": "Leader",
        "cost": 5,
        "rarity": "Rare",
        "power": 0,
        "HP": 8,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_282": {
        "id": "SHD_282",
        "face": {
            "front": {
                "name": "Qi'ra, I Alone Survived",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/282-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Qi'ra, I Alone Survived",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/SHD/282-b.png"
            }
        },
        "name": "Qi'ra, I Alone Survived",
        "type": "Leader",
        "cost": 5,
        "rarity": "Rare",
        "power": 0,
        "HP": 8,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_470": {
        "id": "SHD_470",
        "face": {
            "front": {
                "name": "Qi'ra, Playing Her Part",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/470.png",
                "isHorizontal": false
            }
        },
        "name": "Qi'ra, Playing Her Part",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_044": {
        "id": "SHD_044",
        "face": {
            "front": {
                "name": "Razor Crest, Reliable Gunship",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/044.png",
                "isHorizontal": false
            }
        },
        "name": "Razor Crest, Reliable Gunship",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Special",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SHD_160": {
        "id": "SHD_160",
        "face": {
            "front": {
                "name": "Reckless Gunslinger",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/160.png",
                "isHorizontal": false
            }
        },
        "name": "Reckless Gunslinger",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_429": {
        "id": "SHD_429",
        "face": {
            "front": {
                "name": "Reckless Gunslinger",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/429.png",
                "isHorizontal": false
            }
        },
        "name": "Reckless Gunslinger",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_232": {
        "id": "SHD_232",
        "face": {
            "front": {
                "name": "Relentless Pursuit",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/232.png",
                "isHorizontal": false
            }
        },
        "name": "Relentless Pursuit",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_499": {
        "id": "SHD_499",
        "face": {
            "front": {
                "name": "Relentless Pursuit",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/499.png",
                "isHorizontal": false
            }
        },
        "name": "Relentless Pursuit",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_093": {
        "id": "SHD_093",
        "face": {
            "front": {
                "name": "Remnant Reserves",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/093.png",
                "isHorizontal": false
            }
        },
        "name": "Remnant Reserves",
        "type": "Event",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "SHD_362": {
        "id": "SHD_362",
        "face": {
            "front": {
                "name": "Remnant Reserves",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/362.png",
                "isHorizontal": false
            }
        },
        "name": "Remnant Reserves",
        "type": "Event",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "SHD_019": {
        "id": "SHD_019",
        "face": {
            "front": {
                "name": "Remnant Science Facility, Nevarro",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SHD/019-r.png",
                "isHorizontal": true
            }
        },
        "name": "Remnant Science Facility, Nevarro",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": []
    },
    "SHD_297": {
        "id": "SHD_297",
        "face": {
            "front": {
                "name": "Remnant Science Facility, Nevarro",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SHD/297-r.png",
                "isHorizontal": true
            }
        },
        "name": "Remnant Science Facility, Nevarro",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": []
    },
    "SHD_020": {
        "id": "SHD_020",
        "face": {
            "front": {
                "name": "Remote Village, Sorgan",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SHD/020-r.png",
                "isHorizontal": true
            }
        },
        "name": "Remote Village, Sorgan",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": []
    },
    "SHD_298": {
        "id": "SHD_298",
        "face": {
            "front": {
                "name": "Remote Village, Sorgan",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SHD/298-r.png",
                "isHorizontal": true
            }
        },
        "name": "Remote Village, Sorgan",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": []
    },
    "SHD_117": {
        "id": "SHD_117",
        "face": {
            "front": {
                "name": "Reputable Hunter",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/117.png",
                "isHorizontal": false
            }
        },
        "name": "Reputable Hunter",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "BOUNTY HUNTER"
        ]
    },
    "SHD_386": {
        "id": "SHD_386",
        "face": {
            "front": {
                "name": "Reputable Hunter",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/386.png",
                "isHorizontal": false
            }
        },
        "name": "Reputable Hunter",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "BOUNTY HUNTER"
        ]
    },
    "SHD_070": {
        "id": "SHD_070",
        "face": {
            "front": {
                "name": "Resilient",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/070.png",
                "isHorizontal": false
            }
        },
        "name": "Resilient",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Special",
        "power": 0,
        "HP": 3,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SHD_218": {
        "id": "SHD_218",
        "face": {
            "front": {
                "name": "Resourceful Pursuers",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/218.png",
                "isHorizontal": false
            }
        },
        "name": "Resourceful Pursuers",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Common",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "BOUNTY HUNTER"
        ]
    },
    "SHD_486": {
        "id": "SHD_486",
        "face": {
            "front": {
                "name": "Resourceful Pursuers",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/486.png",
                "isHorizontal": false
            }
        },
        "name": "Resourceful Pursuers",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Common",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "BOUNTY HUNTER"
        ]
    },
    "SHD_004": {
        "id": "SHD_004",
        "face": {
            "front": {
                "name": "Rey, More Than a Scavenger",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/004-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Rey, More Than a Scavenger",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SHD/004-b.png"
            }
        },
        "name": "Rey, More Than a Scavenger",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 2,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "FRINGE"
        ]
    },
    "SHD_046": {
        "id": "SHD_046",
        "face": {
            "front": {
                "name": "Rey, Keeping the Past",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/046.png",
                "isHorizontal": false
            }
        },
        "name": "Rey, Keeping the Past",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Legendary",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "RESISTANCE"
        ]
    },
    "SHD_266": {
        "id": "SHD_266",
        "face": {
            "front": {
                "name": "Rey, More Than a Scavenger",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/266-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Rey, More Than a Scavenger",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SHD/266-b.png"
            }
        },
        "name": "Rey, More Than a Scavenger",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 2,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "FRINGE"
        ]
    },
    "SHD_284": {
        "id": "SHD_284",
        "face": {
            "front": {
                "name": "Rey, More Than a Scavenger",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/284-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Rey, More Than a Scavenger",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SHD/284-b.png"
            }
        },
        "name": "Rey, More Than a Scavenger",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 2,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "FRINGE"
        ]
    },
    "SHD_321": {
        "id": "SHD_321",
        "face": {
            "front": {
                "name": "Rey, Keeping the Past",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/321.png",
                "isHorizontal": false
            }
        },
        "name": "Rey, Keeping the Past",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Legendary",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "RESISTANCE"
        ]
    },
    "SHD_164": {
        "id": "SHD_164",
        "face": {
            "front": {
                "name": "Rhokai Gunship",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/164.png",
                "isHorizontal": false
            }
        },
        "name": "Rhokai Gunship",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_433": {
        "id": "SHD_433",
        "face": {
            "front": {
                "name": "Rhokai Gunship",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/433.png",
                "isHorizontal": false
            }
        },
        "name": "Rhokai Gunship",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_261": {
        "id": "SHD_261",
        "face": {
            "front": {
                "name": "Rich Reward",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/261.png",
                "isHorizontal": false
            }
        },
        "name": "Rich Reward",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [],
        "unique": false,
        "traits": [
            "BOUNTY",
            "CONDITION"
        ]
    },
    "SHD_522": {
        "id": "SHD_522",
        "face": {
            "front": {
                "name": "Rich Reward",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/522.png",
                "isHorizontal": false
            }
        },
        "name": "Rich Reward",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [],
        "unique": false,
        "traits": [
            "BOUNTY",
            "CONDITION"
        ]
    },
    "SHD_057": {
        "id": "SHD_057",
        "face": {
            "front": {
                "name": "Rickety Quadjumper",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/057.png",
                "isHorizontal": false
            }
        },
        "name": "Rickety Quadjumper",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SHD_332": {
        "id": "SHD_332",
        "face": {
            "front": {
                "name": "Rickety Quadjumper",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/332.png",
                "isHorizontal": false
            }
        },
        "name": "Rickety Quadjumper",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SHD_079": {
        "id": "SHD_079",
        "face": {
            "front": {
                "name": "Rival's Fall",
                "type": "Event",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/079.png",
                "isHorizontal": false
            }
        },
        "name": "Rival's Fall",
        "type": "Event",
        "cost": 6,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_352": {
        "id": "SHD_352",
        "face": {
            "front": {
                "name": "Rival's Fall",
                "type": "Event",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/352.png",
                "isHorizontal": false
            }
        },
        "name": "Rival's Fall",
        "type": "Event",
        "cost": 6,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_045": {
        "id": "SHD_045",
        "face": {
            "front": {
                "name": "Rose Tico, Dedicated to the Cause",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/045.png",
                "isHorizontal": false
            }
        },
        "name": "Rose Tico, Dedicated to the Cause",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE"
        ]
    },
    "SHD_320": {
        "id": "SHD_320",
        "face": {
            "front": {
                "name": "Rose Tico, Dedicated to the Cause",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/320.png",
                "isHorizontal": false
            }
        },
        "name": "Rose Tico, Dedicated to the Cause",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE"
        ]
    },
    "SHD_106": {
        "id": "SHD_106",
        "face": {
            "front": {
                "name": "Rule with Respect",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/106.png",
                "isHorizontal": false
            }
        },
        "name": "Rule with Respect",
        "type": "Event",
        "cost": 4,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "SHD_375": {
        "id": "SHD_375",
        "face": {
            "front": {
                "name": "Rule with Respect",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/375.png",
                "isHorizontal": false
            }
        },
        "name": "Rule with Respect",
        "type": "Event",
        "cost": 4,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "SHD_235": {
        "id": "SHD_235",
        "face": {
            "front": {
                "name": "Ruthless Assassin",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/235.png",
                "isHorizontal": false
            }
        },
        "name": "Ruthless Assassin",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_501": {
        "id": "SHD_501",
        "face": {
            "front": {
                "name": "Ruthless Assassin",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/501.png",
                "isHorizontal": false
            }
        },
        "name": "Ruthless Assassin",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_143": {
        "id": "SHD_143",
        "face": {
            "front": {
                "name": "Ruthlessness",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/143.png",
                "isHorizontal": false
            }
        },
        "name": "Ruthlessness",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Rare",
        "power": 2,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SHD_412": {
        "id": "SHD_412",
        "face": {
            "front": {
                "name": "Ruthlessness",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/412.png",
                "isHorizontal": false
            }
        },
        "name": "Ruthlessness",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Rare",
        "power": 2,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SHD_080": {
        "id": "SHD_080",
        "face": {
            "front": {
                "name": "Salacious Crumb, Obnoxious Pet",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/080.png",
                "isHorizontal": false
            }
        },
        "name": "Salacious Crumb, Obnoxious Pet",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "CREATURE"
        ]
    },
    "SHD_353": {
        "id": "SHD_353",
        "face": {
            "front": {
                "name": "Salacious Crumb, Obnoxious Pet",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/353.png",
                "isHorizontal": false
            }
        },
        "name": "Salacious Crumb, Obnoxious Pet",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "CREATURE"
        ]
    },
    "SHD_114": {
        "id": "SHD_114",
        "face": {
            "front": {
                "name": "Scanning Officer",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/114.png",
                "isHorizontal": false
            }
        },
        "name": "Scanning Officer",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "OFFICER"
        ]
    },
    "SHD_383": {
        "id": "SHD_383",
        "face": {
            "front": {
                "name": "Scanning Officer",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/383.png",
                "isHorizontal": false
            }
        },
        "name": "Scanning Officer",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "OFFICER"
        ]
    },
    "SHD_083": {
        "id": "SHD_083",
        "face": {
            "front": {
                "name": "Seasoned Shoretrooper",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/083.png",
                "isHorizontal": false
            }
        },
        "name": "Seasoned Shoretrooper",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Special",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "SHD_053": {
        "id": "SHD_053",
        "face": {
            "front": {
                "name": "Second Chance",
                "type": "Upgrade",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/053.png",
                "isHorizontal": false
            }
        },
        "name": "Second Chance",
        "type": "Upgrade",
        "cost": 4,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance",
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "SHD_328": {
        "id": "SHD_328",
        "face": {
            "front": {
                "name": "Second Chance",
                "type": "Upgrade",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/328.png",
                "isHorizontal": false
            }
        },
        "name": "Second Chance",
        "type": "Upgrade",
        "cost": 4,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance",
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "SHD_189": {
        "id": "SHD_189",
        "face": {
            "front": {
                "name": "Slaver's Freighter",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/189.png",
                "isHorizontal": false
            }
        },
        "name": "Slaver's Freighter",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SHD_458": {
        "id": "SHD_458",
        "face": {
            "front": {
                "name": "Slaver's Freighter",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/458.png",
                "isHorizontal": false
            }
        },
        "name": "Slaver's Freighter",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SHD_252": {
        "id": "SHD_252",
        "face": {
            "front": {
                "name": "Smuggler's Aid",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/252.png",
                "isHorizontal": false
            }
        },
        "name": "Smuggler's Aid",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "SHD_513": {
        "id": "SHD_513",
        "face": {
            "front": {
                "name": "Smuggler's Aid",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/513.png",
                "isHorizontal": false
            }
        },
        "name": "Smuggler's Aid",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "SHD_215": {
        "id": "SHD_215",
        "face": {
            "front": {
                "name": "Smuggler's Starfighter",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/215.png",
                "isHorizontal": false
            }
        },
        "name": "Smuggler's Starfighter",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SHD_483": {
        "id": "SHD_483",
        "face": {
            "front": {
                "name": "Smuggler's Starfighter",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/483.png",
                "isHorizontal": false
            }
        },
        "name": "Smuggler's Starfighter",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SHD_223": {
        "id": "SHD_223",
        "face": {
            "front": {
                "name": "Snapshot Reflexes",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/223.png",
                "isHorizontal": false
            }
        },
        "name": "Snapshot Reflexes",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Special",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "LEARNED"
        ]
    },
    "SHD_236": {
        "id": "SHD_236",
        "face": {
            "front": {
                "name": "Snowtrooper Lieutenant",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/236.png",
                "isHorizontal": false
            }
        },
        "name": "Snowtrooper Lieutenant",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Special",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "SHD_206": {
        "id": "SHD_206",
        "face": {
            "front": {
                "name": "Spare the Target",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/206.png",
                "isHorizontal": false
            }
        },
        "name": "Spare the Target",
        "type": "Event",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_474": {
        "id": "SHD_474",
        "face": {
            "front": {
                "name": "Spare the Target",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/474.png",
                "isHorizontal": false
            }
        },
        "name": "Spare the Target",
        "type": "Event",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_105": {
        "id": "SHD_105",
        "face": {
            "front": {
                "name": "Spark of Hope",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/105.png",
                "isHorizontal": false
            }
        },
        "name": "Spark of Hope",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SHD_374": {
        "id": "SHD_374",
        "face": {
            "front": {
                "name": "Spark of Hope",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/374.png",
                "isHorizontal": false
            }
        },
        "name": "Spark of Hope",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "SHD_024": {
        "id": "SHD_024",
        "face": {
            "front": {
                "name": "Spice Mines, Kessel",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SHD/024-r.png",
                "isHorizontal": true
            }
        },
        "name": "Spice Mines, Kessel",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": []
    },
    "SHD_302": {
        "id": "SHD_302",
        "face": {
            "front": {
                "name": "Spice Mines, Kessel",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SHD/302-r.png",
                "isHorizontal": true
            }
        },
        "name": "Spice Mines, Kessel",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": []
    },
    "SHD_161": {
        "id": "SHD_161",
        "face": {
            "front": {
                "name": "Stolen Landspeeder",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/161.png",
                "isHorizontal": false
            }
        },
        "name": "Stolen Landspeeder",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Rare",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "SPEEDER"
        ]
    },
    "SHD_430": {
        "id": "SHD_430",
        "face": {
            "front": {
                "name": "Stolen Landspeeder",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/430.png",
                "isHorizontal": false
            }
        },
        "name": "Stolen Landspeeder",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Rare",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "SPEEDER"
        ]
    },
    "SHD_260": {
        "id": "SHD_260",
        "face": {
            "front": {
                "name": "Street Gang Recruiter",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/260.png",
                "isHorizontal": false
            }
        },
        "name": "Street Gang Recruiter",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 4,
        "aspects": [],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_521": {
        "id": "SHD_521",
        "face": {
            "front": {
                "name": "Street Gang Recruiter",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/521.png",
                "isHorizontal": false
            }
        },
        "name": "Street Gang Recruiter",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 4,
        "aspects": [],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_052": {
        "id": "SHD_052",
        "face": {
            "front": {
                "name": "Sugi, Hired Guardian",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/052.png",
                "isHorizontal": false
            }
        },
        "name": "Sugi, Hired Guardian",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Vigilance"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_327": {
        "id": "SHD_327",
        "face": {
            "front": {
                "name": "Sugi, Hired Guardian",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/327.png",
                "isHorizontal": false
            }
        },
        "name": "Sugi, Hired Guardian",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Vigilance"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_098": {
        "id": "SHD_098",
        "face": {
            "front": {
                "name": "Sundari Peacekeeper",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/098.png",
                "isHorizontal": false
            }
        },
        "name": "Sundari Peacekeeper",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 5,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN",
            "TROOPER"
        ]
    },
    "SHD_367": {
        "id": "SHD_367",
        "face": {
            "front": {
                "name": "Sundari Peacekeeper",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/367.png",
                "isHorizontal": false
            }
        },
        "name": "Sundari Peacekeeper",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 5,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN",
            "TROOPER"
        ]
    },
    "SHD_034": {
        "id": "SHD_034",
        "face": {
            "front": {
                "name": "Supercommando Squad",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/034.png",
                "isHorizontal": false
            }
        },
        "name": "Supercommando Squad",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "MANDALORIAN",
            "TROOPER"
        ]
    },
    "SHD_311": {
        "id": "SHD_311",
        "face": {
            "front": {
                "name": "Supercommando Squad",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/311.png",
                "isHorizontal": false
            }
        },
        "name": "Supercommando Squad",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "MANDALORIAN",
            "TROOPER"
        ]
    },
    "SHD_085": {
        "id": "SHD_085",
        "face": {
            "front": {
                "name": "Superlaser Technician",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/085.png",
                "isHorizontal": false
            }
        },
        "name": "Superlaser Technician",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Special",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL"
        ]
    },
    "SHD_037": {
        "id": "SHD_037",
        "face": {
            "front": {
                "name": "Supreme Leader Snoke, Shadow Ruler",
                "type": "Unit - Ground",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/SHD/037.png",
                "isHorizontal": false
            }
        },
        "name": "Supreme Leader Snoke, Shadow Ruler",
        "type": "Unit - Ground",
        "cost": 8,
        "rarity": "Legendary",
        "power": 6,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "FIRST ORDER",
            "OFFICIAL"
        ]
    },
    "SHD_314": {
        "id": "SHD_314",
        "face": {
            "front": {
                "name": "Supreme Leader Snoke, Shadow Ruler",
                "type": "Unit - Ground",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/SHD/314.png",
                "isHorizontal": false
            }
        },
        "name": "Supreme Leader Snoke, Shadow Ruler",
        "type": "Unit - Ground",
        "cost": 8,
        "rarity": "Legendary",
        "power": 6,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "FIRST ORDER",
            "OFFICIAL"
        ]
    },
    "SHD_231": {
        "id": "SHD_231",
        "face": {
            "front": {
                "name": "Surprise Strike",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/231.png",
                "isHorizontal": false
            }
        },
        "name": "Surprise Strike",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_498": {
        "id": "SHD_498",
        "face": {
            "front": {
                "name": "Surprise Strike",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/498.png",
                "isHorizontal": false
            }
        },
        "name": "Surprise Strike",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_064": {
        "id": "SHD_064",
        "face": {
            "front": {
                "name": "Survivors' Gauntlet",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/064.png",
                "isHorizontal": false
            }
        },
        "name": "Survivors' Gauntlet",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SHD_338": {
        "id": "SHD_338",
        "face": {
            "front": {
                "name": "Survivors' Gauntlet",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/338.png",
                "isHorizontal": false
            }
        },
        "name": "Survivors' Gauntlet",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SHD_230": {
        "id": "SHD_230",
        "face": {
            "front": {
                "name": "Swoop Down",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/230.png",
                "isHorizontal": false
            }
        },
        "name": "Swoop Down",
        "type": "Event",
        "cost": 1,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_497": {
        "id": "SHD_497",
        "face": {
            "front": {
                "name": "Swoop Down",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/497.png",
                "isHorizontal": false
            }
        },
        "name": "Swoop Down",
        "type": "Event",
        "cost": 1,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_033": {
        "id": "SHD_033",
        "face": {
            "front": {
                "name": "Synara San, Loyal to Kragan",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/033.png",
                "isHorizontal": false
            }
        },
        "name": "Synara San, Loyal to Kragan",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_310": {
        "id": "SHD_310",
        "face": {
            "front": {
                "name": "Synara San, Loyal to Kragan",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/310.png",
                "isHorizontal": false
            }
        },
        "name": "Synara San, Loyal to Kragan",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_063": {
        "id": "SHD_063",
        "face": {
            "front": {
                "name": "System Patrol Craft",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/063.png",
                "isHorizontal": false
            }
        },
        "name": "System Patrol Craft",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Special",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_131": {
        "id": "SHD_131",
        "face": {
            "front": {
                "name": "Take Captive",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/131.png",
                "isHorizontal": false
            }
        },
        "name": "Take Captive",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_400": {
        "id": "SHD_400",
        "face": {
            "front": {
                "name": "Take Captive",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/400.png",
                "isHorizontal": false
            }
        },
        "name": "Take Captive",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_250": {
        "id": "SHD_250",
        "face": {
            "front": {
                "name": "Tarfful, Kashyyyk Chieftan",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SHD/250.png",
                "isHorizontal": false
            }
        },
        "name": "Tarfful, Kashyyyk Chieftan",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Rare",
        "power": 3,
        "HP": 9,
        "aspects": [
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "WOOKIEE"
        ]
    },
    "SHD_512": {
        "id": "SHD_512",
        "face": {
            "front": {
                "name": "Tarfful, Kashyyyk Chieftan",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/SHD/512.png",
                "isHorizontal": false
            }
        },
        "name": "Tarfful, Kashyyyk Chieftan",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Rare",
        "power": 3,
        "HP": 9,
        "aspects": [
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "WOOKIEE"
        ]
    },
    "SHD_248": {
        "id": "SHD_248",
        "face": {
            "front": {
                "name": "Tech, Source of Insight",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/248.png",
                "isHorizontal": false
            }
        },
        "name": "Tech, Source of Insight",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Rare",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "CLONE"
        ]
    },
    "SHD_510": {
        "id": "SHD_510",
        "face": {
            "front": {
                "name": "Tech, Source of Insight",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/510.png",
                "isHorizontal": false
            }
        },
        "name": "Tech, Source of Insight",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Rare",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "CLONE"
        ]
    },
    "SHD_047": {
        "id": "SHD_047",
        "face": {
            "front": {
                "name": "The Armorer, Survival Is Strength",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/047.png",
                "isHorizontal": false
            }
        },
        "name": "The Armorer, Survival Is Strength",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN"
        ]
    },
    "SHD_322": {
        "id": "SHD_322",
        "face": {
            "front": {
                "name": "The Armorer, Survival Is Strength",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/322.png",
                "isHorizontal": false
            }
        },
        "name": "The Armorer, Survival Is Strength",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN"
        ]
    },
    "SHD_159": {
        "id": "SHD_159",
        "face": {
            "front": {
                "name": "The Chaos of War",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/159.png",
                "isHorizontal": false
            }
        },
        "name": "The Chaos of War",
        "type": "Event",
        "cost": 3,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "SHD_428": {
        "id": "SHD_428",
        "face": {
            "front": {
                "name": "The Chaos of War",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/428.png",
                "isHorizontal": false
            }
        },
        "name": "The Chaos of War",
        "type": "Event",
        "cost": 3,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "SHD_031": {
        "id": "SHD_031",
        "face": {
            "front": {
                "name": "The Client, Dictated by Discretion",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/031.png",
                "isHorizontal": false
            }
        },
        "name": "The Client, Dictated by Discretion",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "SHD_308": {
        "id": "SHD_308",
        "face": {
            "front": {
                "name": "The Client, Dictated by Discretion",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/308.png",
                "isHorizontal": false
            }
        },
        "name": "The Client, Dictated by Discretion",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "SHD_126": {
        "id": "SHD_126",
        "face": {
            "front": {
                "name": "The Darksaber",
                "type": "Upgrade",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/126.png",
                "isHorizontal": false
            }
        },
        "name": "The Darksaber",
        "type": "Upgrade",
        "cost": 4,
        "rarity": "Legendary",
        "power": 4,
        "HP": 3,
        "aspects": [
            "Command"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "ITEM",
            "WEAPON"
        ]
    },
    "SHD_395": {
        "id": "SHD_395",
        "face": {
            "front": {
                "name": "The Darksaber",
                "type": "Upgrade",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/395.png",
                "isHorizontal": false
            }
        },
        "name": "The Darksaber",
        "type": "Upgrade",
        "cost": 4,
        "rarity": "Legendary",
        "power": 4,
        "HP": 3,
        "aspects": [
            "Command"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "ITEM",
            "WEAPON"
        ]
    },
    "SHD_018": {
        "id": "SHD_018",
        "face": {
            "front": {
                "name": "The Mandalorian, Sworn to the Creed",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/018-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "The Mandalorian, Sworn to the Creed",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SHD/018-b.png"
            }
        },
        "name": "The Mandalorian, Sworn to the Creed",
        "type": "Leader",
        "cost": 6,
        "rarity": "Special",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_049": {
        "id": "SHD_049",
        "face": {
            "front": {
                "name": "The Mandalorian, Wherever I Go, He Goes",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/049.png",
                "isHorizontal": false
            }
        },
        "name": "The Mandalorian, Wherever I Go, He Goes",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Legendary",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_280": {
        "id": "SHD_280",
        "face": {
            "front": {
                "name": "The Mandalorian, Sworn to the Creed",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/280-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "The Mandalorian, Sworn to the Creed",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/SHD/280-b.png"
            }
        },
        "name": "The Mandalorian, Sworn to the Creed",
        "type": "Leader",
        "cost": 6,
        "rarity": "Special",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_324": {
        "id": "SHD_324",
        "face": {
            "front": {
                "name": "The Mandalorian, Wherever I Go, He Goes",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/324.png",
                "isHorizontal": false
            }
        },
        "name": "The Mandalorian, Wherever I Go, He Goes",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Legendary",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_251": {
        "id": "SHD_251",
        "face": {
            "front": {
                "name": "The Mandalorian's Rifle",
                "type": "Upgrade",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/251.png",
                "isHorizontal": false
            }
        },
        "name": "The Mandalorian's Rifle",
        "type": "Upgrade",
        "cost": 3,
        "rarity": "Special",
        "power": 3,
        "HP": 0,
        "aspects": [
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "ITEM",
            "WEAPON"
        ]
    },
    "SHD_102": {
        "id": "SHD_102",
        "face": {
            "front": {
                "name": "The Marauder, Shuttling the Bad Batch",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/102.png",
                "isHorizontal": false
            }
        },
        "name": "The Marauder, Shuttling the Bad Batch",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Rare",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SHD_371": {
        "id": "SHD_371",
        "face": {
            "front": {
                "name": "The Marauder, Shuttling the Bad Batch",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/371.png",
                "isHorizontal": false
            }
        },
        "name": "The Marauder, Shuttling the Bad Batch",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Rare",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SHD_253": {
        "id": "SHD_253",
        "face": {
            "front": {
                "name": "This Is The Way",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/253.png",
                "isHorizontal": false
            }
        },
        "name": "This Is The Way",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN"
        ]
    },
    "SHD_514": {
        "id": "SHD_514",
        "face": {
            "front": {
                "name": "This Is The Way",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/514.png",
                "isHorizontal": false
            }
        },
        "name": "This Is The Way",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN"
        ]
    },
    "SHD_129": {
        "id": "SHD_129",
        "face": {
            "front": {
                "name": "Timely Intervention",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/129.png",
                "isHorizontal": false
            }
        },
        "name": "Timely Intervention",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_398": {
        "id": "SHD_398",
        "face": {
            "front": {
                "name": "Timely Intervention",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/398.png",
                "isHorizontal": false
            }
        },
        "name": "Timely Intervention",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_217": {
        "id": "SHD_217",
        "face": {
            "front": {
                "name": "Tobias Beckett, I Trust No One",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/217.png",
                "isHorizontal": false
            }
        },
        "name": "Tobias Beckett, I Trust No One",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_485": {
        "id": "SHD_485",
        "face": {
            "front": {
                "name": "Tobias Beckett, I Trust No One",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/485.png",
                "isHorizontal": false
            }
        },
        "name": "Tobias Beckett, I Trust No One",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_071": {
        "id": "SHD_071",
        "face": {
            "front": {
                "name": "Top Target",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/071.png",
                "isHorizontal": false
            }
        },
        "name": "Top Target",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "BOUNTY",
            "CONDITION"
        ]
    },
    "SHD_344": {
        "id": "SHD_344",
        "face": {
            "front": {
                "name": "Top Target",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/344.png",
                "isHorizontal": false
            }
        },
        "name": "Top Target",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "BOUNTY",
            "CONDITION"
        ]
    },
    "SHD_239": {
        "id": "SHD_239",
        "face": {
            "front": {
                "name": "Toro Calican, Ambitious Upstart",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/239.png",
                "isHorizontal": false
            }
        },
        "name": "Toro Calican, Ambitious Upstart",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "BOUNTY HUNTER"
        ]
    },
    "SHD_503": {
        "id": "SHD_503",
        "face": {
            "front": {
                "name": "Toro Calican, Ambitious Upstart",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/503.png",
                "isHorizontal": false
            }
        },
        "name": "Toro Calican, Ambitious Upstart",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "BOUNTY HUNTER"
        ]
    },
    "SHD_140": {
        "id": "SHD_140",
        "face": {
            "front": {
                "name": "Trandoshan Hunters",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/140.png",
                "isHorizontal": false
            }
        },
        "name": "Trandoshan Hunters",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Common",
        "power": 6,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_409": {
        "id": "SHD_409",
        "face": {
            "front": {
                "name": "Trandoshan Hunters",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/409.png",
                "isHorizontal": false
            }
        },
        "name": "Trandoshan Hunters",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Common",
        "power": 6,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_194": {
        "id": "SHD_194",
        "face": {
            "front": {
                "name": "Triple Dark Raid",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/194.png",
                "isHorizontal": false
            }
        },
        "name": "Triple Dark Raid",
        "type": "Event",
        "cost": 3,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_463": {
        "id": "SHD_463",
        "face": {
            "front": {
                "name": "Triple Dark Raid",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/463.png",
                "isHorizontal": false
            }
        },
        "name": "Triple Dark Raid",
        "type": "Event",
        "cost": 3,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "SHD_259": {
        "id": "SHD_259",
        "face": {
            "front": {
                "name": "Twin Pod Cloud Car",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/259.png",
                "isHorizontal": false
            }
        },
        "name": "Twin Pod Cloud Car",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [],
        "unique": false,
        "traits": [
            "FRINGE",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_520": {
        "id": "SHD_520",
        "face": {
            "front": {
                "name": "Twin Pod Cloud Car",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/520.png",
                "isHorizontal": false
            }
        },
        "name": "Twin Pod Cloud Car",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [],
        "unique": false,
        "traits": [
            "FRINGE",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_257": {
        "id": "SHD_257",
        "face": {
            "front": {
                "name": "Underworld Thug",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/257.png",
                "isHorizontal": false
            }
        },
        "name": "Underworld Thug",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_518": {
        "id": "SHD_518",
        "face": {
            "front": {
                "name": "Underworld Thug",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/518.png",
                "isHorizontal": false
            }
        },
        "name": "Underworld Thug",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_076": {
        "id": "SHD_076",
        "face": {
            "front": {
                "name": "Unexpected Escape",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/076.png",
                "isHorizontal": false
            }
        },
        "name": "Unexpected Escape",
        "type": "Event",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "SHD_349": {
        "id": "SHD_349",
        "face": {
            "front": {
                "name": "Unexpected Escape",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/349.png",
                "isHorizontal": false
            }
        },
        "name": "Unexpected Escape",
        "type": "Event",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "SHD_165": {
        "id": "SHD_165",
        "face": {
            "front": {
                "name": "Unlicensed Headhunter",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/165.png",
                "isHorizontal": false
            }
        },
        "name": "Unlicensed Headhunter",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_434": {
        "id": "SHD_434",
        "face": {
            "front": {
                "name": "Unlicensed Headhunter",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/434.png",
                "isHorizontal": false
            }
        },
        "name": "Unlicensed Headhunter",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_226": {
        "id": "SHD_226",
        "face": {
            "front": {
                "name": "Unrefusable Offer",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/226.png",
                "isHorizontal": false
            }
        },
        "name": "Unrefusable Offer",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "BOUNTY",
            "CONDITION"
        ]
    },
    "SHD_493": {
        "id": "SHD_493",
        "face": {
            "front": {
                "name": "Unrefusable Offer",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/493.png",
                "isHorizontal": false
            }
        },
        "name": "Unrefusable Offer",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "BOUNTY",
            "CONDITION"
        ]
    },
    "SHD_058": {
        "id": "SHD_058",
        "face": {
            "front": {
                "name": "Val, Loyal to the End",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/058.png",
                "isHorizontal": false
            }
        },
        "name": "Val, Loyal to the End",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Vigilance"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_333": {
        "id": "SHD_333",
        "face": {
            "front": {
                "name": "Val, Loyal to the End",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/333.png",
                "isHorizontal": false
            }
        },
        "name": "Val, Loyal to the End",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Vigilance"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_151": {
        "id": "SHD_151",
        "face": {
            "front": {
                "name": "Valiant Assault Ship",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/151.png",
                "isHorizontal": false
            }
        },
        "name": "Valiant Assault Ship",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SHD_420": {
        "id": "SHD_420",
        "face": {
            "front": {
                "name": "Valiant Assault Ship",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/420.png",
                "isHorizontal": false
            }
        },
        "name": "Valiant Assault Ship",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SHD_177": {
        "id": "SHD_177",
        "face": {
            "front": {
                "name": "Vambrace Flamethrower",
                "type": "Upgrade",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/177.png",
                "isHorizontal": false
            }
        },
        "name": "Vambrace Flamethrower",
        "type": "Upgrade",
        "cost": 3,
        "rarity": "Rare",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "ITEM",
            "ARMOR",
            "WEAPON"
        ]
    },
    "SHD_446": {
        "id": "SHD_446",
        "face": {
            "front": {
                "name": "Vambrace Flamethrower",
                "type": "Upgrade",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/446.png",
                "isHorizontal": false
            }
        },
        "name": "Vambrace Flamethrower",
        "type": "Upgrade",
        "cost": 3,
        "rarity": "Rare",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "ITEM",
            "ARMOR",
            "WEAPON"
        ]
    },
    "SHD_074": {
        "id": "SHD_074",
        "face": {
            "front": {
                "name": "Vambrace Grappleshot",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/074.png",
                "isHorizontal": false
            }
        },
        "name": "Vambrace Grappleshot",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "ITEM",
            "ARMOR",
            "WEAPON"
        ]
    },
    "SHD_347": {
        "id": "SHD_347",
        "face": {
            "front": {
                "name": "Vambrace Grappleshot",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/SHD/347.png",
                "isHorizontal": false
            }
        },
        "name": "Vambrace Grappleshot",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "ITEM",
            "ARMOR",
            "WEAPON"
        ]
    },
    "SHD_065": {
        "id": "SHD_065",
        "face": {
            "front": {
                "name": "Vigilant Pursuit Craft",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/065.png",
                "isHorizontal": false
            }
        },
        "name": "Vigilant Pursuit Craft",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SHD_339": {
        "id": "SHD_339",
        "face": {
            "front": {
                "name": "Vigilant Pursuit Craft",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/339.png",
                "isHorizontal": false
            }
        },
        "name": "Vigilant Pursuit Craft",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "SHD_043": {
        "id": "SHD_043",
        "face": {
            "front": {
                "name": "Village Protectors",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/043.png",
                "isHorizontal": false
            }
        },
        "name": "Village Protectors",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "FRINGE"
        ]
    },
    "SHD_319": {
        "id": "SHD_319",
        "face": {
            "front": {
                "name": "Village Protectors",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/319.png",
                "isHorizontal": false
            }
        },
        "name": "Village Protectors",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "FRINGE"
        ]
    },
    "SHD_221": {
        "id": "SHD_221",
        "face": {
            "front": {
                "name": "Wanted",
                "type": "Upgrade",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SHD/221.png",
                "isHorizontal": false
            }
        },
        "name": "Wanted",
        "type": "Upgrade",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "BOUNTY",
            "CONDITION"
        ]
    },
    "SHD_489": {
        "id": "SHD_489",
        "face": {
            "front": {
                "name": "Wanted",
                "type": "Upgrade",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/SHD/489.png",
                "isHorizontal": false
            }
        },
        "name": "Wanted",
        "type": "Upgrade",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "BOUNTY",
            "CONDITION"
        ]
    },
    "SHD_167": {
        "id": "SHD_167",
        "face": {
            "front": {
                "name": "Wanted Insurgents",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/167.png",
                "isHorizontal": false
            }
        },
        "name": "Wanted Insurgents",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "REBEL"
        ]
    },
    "SHD_436": {
        "id": "SHD_436",
        "face": {
            "front": {
                "name": "Wanted Insurgents",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/436.png",
                "isHorizontal": false
            }
        },
        "name": "Wanted Insurgents",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "REBEL"
        ]
    },
    "SHD_086": {
        "id": "SHD_086",
        "face": {
            "front": {
                "name": "Warbird Stowaway",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/086.png",
                "isHorizontal": false
            }
        },
        "name": "Warbird Stowaway",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_355": {
        "id": "SHD_355",
        "face": {
            "front": {
                "name": "Warbird Stowaway",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/355.png",
                "isHorizontal": false
            }
        },
        "name": "Warbird Stowaway",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_110": {
        "id": "SHD_110",
        "face": {
            "front": {
                "name": "Warzone Lieutenant",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/110.png",
                "isHorizontal": false
            }
        },
        "name": "Warzone Lieutenant",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TROOPER"
        ]
    },
    "SHD_379": {
        "id": "SHD_379",
        "face": {
            "front": {
                "name": "Warzone Lieutenant",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/SHD/379.png",
                "isHorizontal": false
            }
        },
        "name": "Warzone Lieutenant",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TROOPER"
        ]
    },
    "SHD_119": {
        "id": "SHD_119",
        "face": {
            "front": {
                "name": "Weequay Pirate Gang",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/119.png",
                "isHorizontal": false
            }
        },
        "name": "Weequay Pirate Gang",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_388": {
        "id": "SHD_388",
        "face": {
            "front": {
                "name": "Weequay Pirate Gang",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/388.png",
                "isHorizontal": false
            }
        },
        "name": "Weequay Pirate Gang",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_158": {
        "id": "SHD_158",
        "face": {
            "front": {
                "name": "Wild Rancor",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/158.png",
                "isHorizontal": false
            }
        },
        "name": "Wild Rancor",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Rare",
        "power": 6,
        "HP": 8,
        "aspects": [
            "Aggression",
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "CREATURE"
        ]
    },
    "SHD_427": {
        "id": "SHD_427",
        "face": {
            "front": {
                "name": "Wild Rancor",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/427.png",
                "isHorizontal": false
            }
        },
        "name": "Wild Rancor",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Rare",
        "power": 6,
        "HP": 8,
        "aspects": [
            "Aggression",
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "CREATURE"
        ]
    },
    "SHD_249": {
        "id": "SHD_249",
        "face": {
            "front": {
                "name": "Wookiee Warrior",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/249.png",
                "isHorizontal": false
            }
        },
        "name": "Wookiee Warrior",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "WOOKIEE"
        ]
    },
    "SHD_511": {
        "id": "SHD_511",
        "face": {
            "front": {
                "name": "Wookiee Warrior",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/SHD/511.png",
                "isHorizontal": false
            }
        },
        "name": "Wookiee Warrior",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "WOOKIEE"
        ]
    },
    "SHD_154": {
        "id": "SHD_154",
        "face": {
            "front": {
                "name": "Wrecker, Boom!",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/154.png",
                "isHorizontal": false
            }
        },
        "name": "Wrecker, Boom!",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Rare",
        "power": 7,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "CLONE"
        ]
    },
    "SHD_423": {
        "id": "SHD_423",
        "face": {
            "front": {
                "name": "Wrecker, Boom!",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/423.png",
                "isHorizontal": false
            }
        },
        "name": "Wrecker, Boom!",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Rare",
        "power": 7,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "CLONE"
        ]
    },
    "SHD_061": {
        "id": "SHD_061",
        "face": {
            "front": {
                "name": "Wroshyr Tree Tender",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/061.png",
                "isHorizontal": false
            }
        },
        "name": "Wroshyr Tree Tender",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "WOOKIEE"
        ]
    },
    "SHD_336": {
        "id": "SHD_336",
        "face": {
            "front": {
                "name": "Wroshyr Tree Tender",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/SHD/336.png",
                "isHorizontal": false
            }
        },
        "name": "Wroshyr Tree Tender",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "WOOKIEE"
        ]
    },
    "SHD_191": {
        "id": "SHD_191",
        "face": {
            "front": {
                "name": "Xanadu Blood, Cad Bane's Reward",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/191.png",
                "isHorizontal": false
            }
        },
        "name": "Xanadu Blood, Cad Bane's Reward",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_460": {
        "id": "SHD_460",
        "face": {
            "front": {
                "name": "Xanadu Blood, Cad Bane's Reward",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/SHD/460.png",
                "isHorizontal": false
            }
        },
        "name": "Xanadu Blood, Cad Bane's Reward",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "SHD_203": {
        "id": "SHD_203",
        "face": {
            "front": {
                "name": "Zorii Bliss, Valiant Smuggler",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/203.png",
                "isHorizontal": false
            }
        },
        "name": "Zorii Bliss, Valiant Smuggler",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Rare",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_471": {
        "id": "SHD_471",
        "face": {
            "front": {
                "name": "Zorii Bliss, Valiant Smuggler",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/471.png",
                "isHorizontal": false
            }
        },
        "name": "Zorii Bliss, Valiant Smuggler",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Rare",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "SHD_190": {
        "id": "SHD_190",
        "face": {
            "front": {
                "name": "Zuckuss, Bounty Hunter for Hire",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/190.png",
                "isHorizontal": false
            }
        },
        "name": "Zuckuss, Bounty Hunter for Hire",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 6,
        "HP": 6,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "SHD_459": {
        "id": "SHD_459",
        "face": {
            "front": {
                "name": "Zuckuss, Bounty Hunter for Hire",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/SHD/459.png",
                "isHorizontal": false
            }
        },
        "name": "Zuckuss, Bounty Hunter for Hire",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 6,
        "HP": 6,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "TWI_240": {
        "id": "TWI_240",
        "face": {
            "front": {
                "name": "332nd Stalwart",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/240.png",
                "isHorizontal": false
            }
        },
        "name": "332nd Stalwart",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Special",
        "power": 1,
        "HP": 2,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_045": {
        "id": "TWI_045",
        "face": {
            "front": {
                "name": "41st Elite Corps",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/045.png",
                "isHorizontal": false
            }
        },
        "name": "41st Elite Corps",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_318": {
        "id": "TWI_318",
        "face": {
            "front": {
                "name": "41st Elite Corps",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/318.png",
                "isHorizontal": false
            }
        },
        "name": "41st Elite Corps",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_109": {
        "id": "TWI_109",
        "face": {
            "front": {
                "name": "501st Liberator",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/109.png",
                "isHorizontal": false
            }
        },
        "name": "501st Liberator",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_379": {
        "id": "TWI_379",
        "face": {
            "front": {
                "name": "501st Liberator",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/379.png",
                "isHorizontal": false
            }
        },
        "name": "501st Liberator",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_040": {
        "id": "TWI_040",
        "face": {
            "front": {
                "name": "A Fine Addition",
                "type": "Event",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/TWI/040.png",
                "isHorizontal": false
            }
        },
        "name": "A Fine Addition",
        "type": "Event",
        "cost": 0,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "TWI_313": {
        "id": "TWI_313",
        "face": {
            "front": {
                "name": "A Fine Addition",
                "type": "Event",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/TWI/313.png",
                "isHorizontal": false
            }
        },
        "name": "A Fine Addition",
        "type": "Event",
        "cost": 0,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "TWI_247": {
        "id": "TWI_247",
        "face": {
            "front": {
                "name": "AT-TE Vanguard",
                "type": "Unit - Ground",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/TWI/247.png",
                "isHorizontal": false
            }
        },
        "name": "AT-TE Vanguard",
        "type": "Unit - Ground",
        "cost": 8,
        "rarity": "Uncommon",
        "power": 6,
        "HP": 9,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "WALKER"
        ]
    },
    "TWI_508": {
        "id": "TWI_508",
        "face": {
            "front": {
                "name": "AT-TE Vanguard",
                "type": "Unit - Ground",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/TWI/508.png",
                "isHorizontal": false
            }
        },
        "name": "AT-TE Vanguard",
        "type": "Unit - Ground",
        "cost": 8,
        "rarity": "Uncommon",
        "power": 6,
        "HP": 9,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "WALKER"
        ]
    },
    "TWI_096": {
        "id": "TWI_096",
        "face": {
            "front": {
                "name": "Aayla Secura, Master of the Blade",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/096.png",
                "isHorizontal": false
            }
        },
        "name": "Aayla Secura, Master of the Blade",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Legendary",
        "power": 6,
        "HP": 5,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_368": {
        "id": "TWI_368",
        "face": {
            "front": {
                "name": "Aayla Secura, Master of the Blade",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/368.png",
                "isHorizontal": false
            }
        },
        "name": "Aayla Secura, Master of the Blade",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Legendary",
        "power": 6,
        "HP": 5,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_086": {
        "id": "TWI_086",
        "face": {
            "front": {
                "name": "Admiral Trench, Holding the Line",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/TWI/086.png",
                "isHorizontal": false
            }
        },
        "name": "Admiral Trench, Holding the Line",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Uncommon",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "OFFICIAL"
        ]
    },
    "TWI_358": {
        "id": "TWI_358",
        "face": {
            "front": {
                "name": "Admiral Trench, Holding the Line",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/TWI/358.png",
                "isHorizontal": false
            }
        },
        "name": "Admiral Trench, Holding the Line",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Uncommon",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "OFFICIAL"
        ]
    },
    "TWI_092": {
        "id": "TWI_092",
        "face": {
            "front": {
                "name": "Admiral Yularen, Advising Caution",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/092.png",
                "isHorizontal": false
            }
        },
        "name": "Admiral Yularen, Advising Caution",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Rare",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "OFFICIAL"
        ]
    },
    "TWI_364": {
        "id": "TWI_364",
        "face": {
            "front": {
                "name": "Admiral Yularen, Advising Caution",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/364.png",
                "isHorizontal": false
            }
        },
        "name": "Admiral Yularen, Advising Caution",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Rare",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "OFFICIAL"
        ]
    },
    "TWI_093": {
        "id": "TWI_093",
        "face": {
            "front": {
                "name": "Advanced Recon Commando",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/093.png",
                "isHorizontal": false
            }
        },
        "name": "Advanced Recon Commando",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 4,
        "HP": 3,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_365": {
        "id": "TWI_365",
        "face": {
            "front": {
                "name": "Advanced Recon Commando",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/365.png",
                "isHorizontal": false
            }
        },
        "name": "Advanced Recon Commando",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 4,
        "HP": 3,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_252": {
        "id": "TWI_252",
        "face": {
            "front": {
                "name": "Aggrieved Parliamentarian",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/252.png",
                "isHorizontal": false
            }
        },
        "name": "Aggrieved Parliamentarian",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "OFFICIAL"
        ]
    },
    "TWI_512": {
        "id": "TWI_512",
        "face": {
            "front": {
                "name": "Aggrieved Parliamentarian",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/512.png",
                "isHorizontal": false
            }
        },
        "name": "Aggrieved Parliamentarian",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "OFFICIAL"
        ]
    },
    "TWI_011": {
        "id": "TWI_011",
        "face": {
            "front": {
                "name": "Ahsoka Tano, Snips",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/011-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Ahsoka Tano, Snips",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/TWI/011-b.png"
            }
        },
        "name": "Ahsoka Tano, Snips",
        "type": "Leader",
        "cost": 5,
        "rarity": "Special",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_194": {
        "id": "TWI_194",
        "face": {
            "front": {
                "name": "Ahsoka Tano, Always Ready For Trouble",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/194.png",
                "isHorizontal": false
            }
        },
        "name": "Ahsoka Tano, Always Ready For Trouble",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Legendary",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_268": {
        "id": "TWI_268",
        "face": {
            "front": {
                "name": "Ahsoka Tano, Snips",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/268-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Ahsoka Tano, Snips",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/TWI/268-b.png"
            }
        },
        "name": "Ahsoka Tano, Snips",
        "type": "Leader",
        "cost": 5,
        "rarity": "Special",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_459": {
        "id": "TWI_459",
        "face": {
            "front": {
                "name": "Ahsoka Tano, Always Ready For Trouble",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/459.png",
                "isHorizontal": false
            }
        },
        "name": "Ahsoka Tano, Always Ready For Trouble",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Legendary",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_248": {
        "id": "TWI_248",
        "face": {
            "front": {
                "name": "Ahsoka's Padawan Lightsaber",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/248.png",
                "isHorizontal": false
            }
        },
        "name": "Ahsoka's Padawan Lightsaber",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Special",
        "power": 2,
        "HP": 0,
        "aspects": [
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "ITEM",
            "WEAPON",
            "LIGHTSABER"
        ]
    },
    "TWI_201": {
        "id": "TWI_201",
        "face": {
            "front": {
                "name": "Aid from the Innocent",
                "type": "Event",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/201.png",
                "isHorizontal": false
            }
        },
        "name": "Aid from the Innocent",
        "type": "Event",
        "cost": 5,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "TWI_466": {
        "id": "TWI_466",
        "face": {
            "front": {
                "name": "Aid from the Innocent",
                "type": "Event",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/466.png",
                "isHorizontal": false
            }
        },
        "name": "Aid from the Innocent",
        "type": "Event",
        "cost": 5,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "TWI_012": {
        "id": "TWI_012",
        "face": {
            "front": {
                "name": "Anakin Skywalker, What it Takes to Win",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/012-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Anakin Skywalker, What it Takes to Win",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/TWI/012-b.png"
            }
        },
        "name": "Anakin Skywalker, What it Takes to Win",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 5,
        "HP": 7,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_147": {
        "id": "TWI_147",
        "face": {
            "front": {
                "name": "Anakin Skywalker, Maverick Mentor",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/147.png",
                "isHorizontal": false
            }
        },
        "name": "Anakin Skywalker, Maverick Mentor",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Special",
        "power": 6,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_269": {
        "id": "TWI_269",
        "face": {
            "front": {
                "name": "Anakin Skywalker, What it Takes to Win",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/269-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Anakin Skywalker, What it Takes to Win",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/TWI/269-b.png"
            }
        },
        "name": "Anakin Skywalker, What it Takes to Win",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 5,
        "HP": 7,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_287": {
        "id": "TWI_287",
        "face": {
            "front": {
                "name": "Anakin Skywalker, What it Takes to Win",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/287-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Anakin Skywalker, What it Takes to Win",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/TWI/287-b.png"
            }
        },
        "name": "Anakin Skywalker, What it Takes to Win",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 5,
        "HP": 7,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_142": {
        "id": "TWI_142",
        "face": {
            "front": {
                "name": "Anakin's Interceptor, Where the Fun Begins",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/142.png",
                "isHorizontal": false
            }
        },
        "name": "Anakin's Interceptor, Where the Fun Begins",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "JEDI",
            "REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_410": {
        "id": "TWI_410",
        "face": {
            "front": {
                "name": "Anakin's Interceptor, Where the Fun Begins",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/410.png",
                "isHorizontal": false
            }
        },
        "name": "Anakin's Interceptor, Where the Fun Begins",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "JEDI",
            "REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_245": {
        "id": "TWI_245",
        "face": {
            "front": {
                "name": "Armored Saber Tank",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/245.png",
                "isHorizontal": false
            }
        },
        "name": "Armored Saber Tank",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "TANK"
        ]
    },
    "TWI_506": {
        "id": "TWI_506",
        "face": {
            "front": {
                "name": "Armored Saber Tank",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/506.png",
                "isHorizontal": false
            }
        },
        "name": "Armored Saber Tank",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "TANK"
        ]
    },
    "TWI_014": {
        "id": "TWI_014",
        "face": {
            "front": {
                "name": "Asajj Ventress, Unparalleled Adversary",
                "type": "Leader",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/014-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Asajj Ventress, Unparalleled Adversary",
                "type": "Leader",
                "cost": "4",
                "image": "https://cdn.swu-db.com/images/cards/TWI/014-b.png"
            }
        },
        "name": "Asajj Ventress, Unparalleled Adversary",
        "type": "Leader",
        "cost": 4,
        "rarity": "Rare",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "SEPARATIST",
            "SITH"
        ]
    },
    "TWI_134": {
        "id": "TWI_134",
        "face": {
            "front": {
                "name": "Asajj Ventress, Count Dooku's Assassin",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/134.png",
                "isHorizontal": false
            }
        },
        "name": "Asajj Ventress, Count Dooku's Assassin",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "SEPARATIST",
            "SITH"
        ]
    },
    "TWI_271": {
        "id": "TWI_271",
        "face": {
            "front": {
                "name": "Asajj Ventress, Unparalleled Adversary",
                "type": "Leader",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/271-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Asajj Ventress, Unparalleled Adversary",
                "type": "Leader",
                "cost": "4",
                "image": "https://cdn.swu-db.com/images/cards/TWI/271-b.png"
            }
        },
        "name": "Asajj Ventress, Unparalleled Adversary",
        "type": "Leader",
        "cost": 4,
        "rarity": "Rare",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "SEPARATIST",
            "SITH"
        ]
    },
    "TWI_289": {
        "id": "TWI_289",
        "face": {
            "front": {
                "name": "Asajj Ventress, Unparalleled Adversary",
                "type": "Leader",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/289-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Asajj Ventress, Unparalleled Adversary",
                "type": "Leader",
                "cost": "4",
                "image": "https://cdn.swu-db.com/images/cards/TWI/289-b.png"
            }
        },
        "name": "Asajj Ventress, Unparalleled Adversary",
        "type": "Leader",
        "cost": 4,
        "rarity": "Rare",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "SEPARATIST",
            "SITH"
        ]
    },
    "TWI_402": {
        "id": "TWI_402",
        "face": {
            "front": {
                "name": "Asajj Ventress, Count Dooku's Assassin",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/402.png",
                "isHorizontal": false
            }
        },
        "name": "Asajj Ventress, Count Dooku's Assassin",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "SEPARATIST",
            "SITH"
        ]
    },
    "TWI_166": {
        "id": "TWI_166",
        "face": {
            "front": {
                "name": "Aurra Sing, Crackshot Sniper",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/TWI/166.png",
                "isHorizontal": false
            }
        },
        "name": "Aurra Sing, Crackshot Sniper",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Uncommon",
        "power": 7,
        "HP": 6,
        "aspects": [
            "Aggression"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "TWI_433": {
        "id": "TWI_433",
        "face": {
            "front": {
                "name": "Aurra Sing, Crackshot Sniper",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/TWI/433.png",
                "isHorizontal": false
            }
        },
        "name": "Aurra Sing, Crackshot Sniper",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Uncommon",
        "power": 7,
        "HP": 6,
        "aspects": [
            "Aggression"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "TWI_133": {
        "id": "TWI_133",
        "face": {
            "front": {
                "name": "B1 Attack Platform",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/133.png",
                "isHorizontal": false
            }
        },
        "name": "B1 Attack Platform",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 5,
        "HP": 2,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "TROOPER"
        ]
    },
    "TWI_401": {
        "id": "TWI_401",
        "face": {
            "front": {
                "name": "B1 Attack Platform",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/401.png",
                "isHorizontal": false
            }
        },
        "name": "B1 Attack Platform",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 5,
        "HP": 2,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "TROOPER"
        ]
    },
    "TWI_207": {
        "id": "TWI_207",
        "face": {
            "front": {
                "name": "B1 Security Team",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/207.png",
                "isHorizontal": false
            }
        },
        "name": "B1 Security Team",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 3,
        "HP": 1,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "TROOPER"
        ]
    },
    "TWI_472": {
        "id": "TWI_472",
        "face": {
            "front": {
                "name": "B1 Security Team",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/472.png",
                "isHorizontal": false
            }
        },
        "name": "B1 Security Team",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 3,
        "HP": 1,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "TROOPER"
        ]
    },
    "TWI_113": {
        "id": "TWI_113",
        "face": {
            "front": {
                "name": "B2 Legionnaires",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/113.png",
                "isHorizontal": false
            }
        },
        "name": "B2 Legionnaires",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Common",
        "power": 5,
        "HP": 3,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "TROOPER"
        ]
    },
    "TWI_383": {
        "id": "TWI_383",
        "face": {
            "front": {
                "name": "B2 Legionnaires",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/383.png",
                "isHorizontal": false
            }
        },
        "name": "B2 Legionnaires",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Common",
        "power": 5,
        "HP": 3,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "TROOPER"
        ]
    },
    "TWI_117": {
        "id": "TWI_117",
        "face": {
            "front": {
                "name": "Baktoid Spider Droid",
                "type": "Unit - Ground",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/TWI/117.png",
                "isHorizontal": false
            }
        },
        "name": "Baktoid Spider Droid",
        "type": "Unit - Ground",
        "cost": 8,
        "rarity": "Common",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Command"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "DROID",
            "WALKER"
        ]
    },
    "TWI_387": {
        "id": "TWI_387",
        "face": {
            "front": {
                "name": "Baktoid Spider Droid",
                "type": "Unit - Ground",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/TWI/387.png",
                "isHorizontal": false
            }
        },
        "name": "Baktoid Spider Droid",
        "type": "Unit - Ground",
        "cost": 8,
        "rarity": "Common",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Command"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "DROID",
            "WALKER"
        ]
    },
    "TWI_042": {
        "id": "TWI_042",
        "face": {
            "front": {
                "name": "Barriss Offee, Unassuming Apprentice",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/042.png",
                "isHorizontal": false
            }
        },
        "name": "Barriss Offee, Unassuming Apprentice",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Rare",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_315": {
        "id": "TWI_315",
        "face": {
            "front": {
                "name": "Barriss Offee, Unassuming Apprentice",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/315.png",
                "isHorizontal": false
            }
        },
        "name": "Barriss Offee, Unassuming Apprentice",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Rare",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_144": {
        "id": "TWI_144",
        "face": {
            "front": {
                "name": "Batch Brothers",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/144.png",
                "isHorizontal": false
            }
        },
        "name": "Batch Brothers",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_412": {
        "id": "TWI_412",
        "face": {
            "front": {
                "name": "Batch Brothers",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/412.png",
                "isHorizontal": false
            }
        },
        "name": "Batch Brothers",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_229": {
        "id": "TWI_229",
        "face": {
            "front": {
                "name": "Battle Droid Escort",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/229.png",
                "isHorizontal": false
            }
        },
        "name": "Battle Droid Escort",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Special",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "TROOPER"
        ]
    },
    "TWI_235": {
        "id": "TWI_235",
        "face": {
            "front": {
                "name": "Battle Droid Legion",
                "type": "Unit - Ground",
                "cost": 9,
                "image": "https://cdn.swu-db.com/images/cards/TWI/235.png",
                "isHorizontal": false
            }
        },
        "name": "Battle Droid Legion",
        "type": "Unit - Ground",
        "cost": 9,
        "rarity": "Uncommon",
        "power": 6,
        "HP": 5,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "TROOPER"
        ]
    },
    "TWI_498": {
        "id": "TWI_498",
        "face": {
            "front": {
                "name": "Battle Droid Legion",
                "type": "Unit - Ground",
                "cost": 9,
                "image": "https://cdn.swu-db.com/images/cards/TWI/498.png",
                "isHorizontal": false
            }
        },
        "name": "Battle Droid Legion",
        "type": "Unit - Ground",
        "cost": 9,
        "rarity": "Uncommon",
        "power": 6,
        "HP": 5,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "TROOPER"
        ]
    },
    "TWI_173": {
        "id": "TWI_173",
        "face": {
            "front": {
                "name": "Blood Sport",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/173.png",
                "isHorizontal": false
            }
        },
        "name": "Blood Sport",
        "type": "Event",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "FRINGE"
        ]
    },
    "TWI_440": {
        "id": "TWI_440",
        "face": {
            "front": {
                "name": "Blood Sport",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/440.png",
                "isHorizontal": false
            }
        },
        "name": "Blood Sport",
        "type": "Event",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "FRINGE"
        ]
    },
    "TWI_130": {
        "id": "TWI_130",
        "face": {
            "front": {
                "name": "Bo-Katan Kryze, Death Watch Lieutenant",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/130.png",
                "isHorizontal": false
            }
        },
        "name": "Bo-Katan Kryze, Death Watch Lieutenant",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "TROOPER"
        ]
    },
    "TWI_398": {
        "id": "TWI_398",
        "face": {
            "front": {
                "name": "Bo-Katan Kryze, Death Watch Lieutenant",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/398.png",
                "isHorizontal": false
            }
        },
        "name": "Bo-Katan Kryze, Death Watch Lieutenant",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "TROOPER"
        ]
    },
    "TWI_161": {
        "id": "TWI_161",
        "face": {
            "front": {
                "name": "Bold Recon Commando",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/161.png",
                "isHorizontal": false
            }
        },
        "name": "Bold Recon Commando",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_428": {
        "id": "TWI_428",
        "face": {
            "front": {
                "name": "Bold Recon Commando",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/428.png",
                "isHorizontal": false
            }
        },
        "name": "Bold Recon Commando",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_153": {
        "id": "TWI_153",
        "face": {
            "front": {
                "name": "Bold Resistance",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/153.png",
                "isHorizontal": false
            }
        },
        "name": "Bold Resistance",
        "type": "Event",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_420": {
        "id": "TWI_420",
        "face": {
            "front": {
                "name": "Bold Resistance",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/420.png",
                "isHorizontal": false
            }
        },
        "name": "Bold Resistance",
        "type": "Event",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_255": {
        "id": "TWI_255",
        "face": {
            "front": {
                "name": "Brain Invaders",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/255.png",
                "isHorizontal": false
            }
        },
        "name": "Brain Invaders",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 2,
        "HP": 4,
        "aspects": [],
        "unique": false,
        "traits": [
            "FRINGE"
        ]
    },
    "TWI_515": {
        "id": "TWI_515",
        "face": {
            "front": {
                "name": "Brain Invaders",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/515.png",
                "isHorizontal": false
            }
        },
        "name": "Brain Invaders",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 2,
        "HP": 4,
        "aspects": [],
        "unique": false,
        "traits": [
            "FRINGE"
        ]
    },
    "TWI_224": {
        "id": "TWI_224",
        "face": {
            "front": {
                "name": "Breaking In",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/224.png",
                "isHorizontal": false
            }
        },
        "name": "Breaking In",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_489": {
        "id": "TWI_489",
        "face": {
            "front": {
                "name": "Breaking In",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/489.png",
                "isHorizontal": false
            }
        },
        "name": "Breaking In",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_187": {
        "id": "TWI_187",
        "face": {
            "front": {
                "name": "Cad Bane, Hostage Taker",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/TWI/187.png",
                "isHorizontal": false
            }
        },
        "name": "Cad Bane, Hostage Taker",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Legendary",
        "power": 7,
        "HP": 7,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "TWI_452": {
        "id": "TWI_452",
        "face": {
            "front": {
                "name": "Cad Bane, Hostage Taker",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/TWI/452.png",
                "isHorizontal": false
            }
        },
        "name": "Cad Bane, Hostage Taker",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Legendary",
        "power": 7,
        "HP": 7,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "TWI_033": {
        "id": "TWI_033",
        "face": {
            "front": {
                "name": "Calculating MagnaGuard",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/033.png",
                "isHorizontal": false
            }
        },
        "name": "Calculating MagnaGuard",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID"
        ]
    },
    "TWI_306": {
        "id": "TWI_306",
        "face": {
            "front": {
                "name": "Calculating MagnaGuard",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/306.png",
                "isHorizontal": false
            }
        },
        "name": "Calculating MagnaGuard",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID"
        ]
    },
    "TWI_007": {
        "id": "TWI_007",
        "face": {
            "front": {
                "name": "Captain Rex, Fighting For His Brothers",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/007-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Captain Rex, Fighting For His Brothers",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/TWI/007-b.png"
            }
        },
        "name": "Captain Rex, Fighting For His Brothers",
        "type": "Leader",
        "cost": 5,
        "rarity": "Rare",
        "power": 2,
        "HP": 6,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_097": {
        "id": "TWI_097",
        "face": {
            "front": {
                "name": "Captain Rex, Lead by Example",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/097.png",
                "isHorizontal": false
            }
        },
        "name": "Captain Rex, Lead by Example",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Special",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_264": {
        "id": "TWI_264",
        "face": {
            "front": {
                "name": "Captain Rex, Fighting For His Brothers",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/264-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Captain Rex, Fighting For His Brothers",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/TWI/264-b.png"
            }
        },
        "name": "Captain Rex, Fighting For His Brothers",
        "type": "Leader",
        "cost": 5,
        "rarity": "Rare",
        "power": 2,
        "HP": 6,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_282": {
        "id": "TWI_282",
        "face": {
            "front": {
                "name": "Captain Rex, Fighting For His Brothers",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/282-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Captain Rex, Fighting For His Brothers",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/TWI/282-b.png"
            }
        },
        "name": "Captain Rex, Fighting For His Brothers",
        "type": "Leader",
        "cost": 5,
        "rarity": "Rare",
        "power": 2,
        "HP": 6,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_046": {
        "id": "TWI_046",
        "face": {
            "front": {
                "name": "Captain Typho, Protecting the Senator",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/046.png",
                "isHorizontal": false
            }
        },
        "name": "Captain Typho, Protecting the Senator",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "NABOO",
            "REPUBLIC",
            "TROOPER"
        ]
    },
    "TWI_319": {
        "id": "TWI_319",
        "face": {
            "front": {
                "name": "Captain Typho, Protecting the Senator",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/319.png",
                "isHorizontal": false
            }
        },
        "name": "Captain Typho, Protecting the Senator",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "NABOO",
            "REPUBLIC",
            "TROOPER"
        ]
    },
    "TWI_176": {
        "id": "TWI_176",
        "face": {
            "front": {
                "name": "Caught in the Crossfire",
                "type": "Event",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/176.png",
                "isHorizontal": false
            }
        },
        "name": "Caught in the Crossfire",
        "type": "Event",
        "cost": 6,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "DISASTER"
        ]
    },
    "TWI_442": {
        "id": "TWI_442",
        "face": {
            "front": {
                "name": "Caught in the Crossfire",
                "type": "Event",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/442.png",
                "isHorizontal": false
            }
        },
        "name": "Caught in the Crossfire",
        "type": "Event",
        "cost": 6,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "DISASTER"
        ]
    },
    "TWI_203": {
        "id": "TWI_203",
        "face": {
            "front": {
                "name": "Chancellor Palpatine, Wartime Chancellor",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/203.png",
                "isHorizontal": false
            }
        },
        "name": "Chancellor Palpatine, Wartime Chancellor",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Legendary",
        "power": 2,
        "HP": 6,
        "aspects": [
            "Cunning",
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "OFFICIAL"
        ]
    },
    "TWI_468": {
        "id": "TWI_468",
        "face": {
            "front": {
                "name": "Chancellor Palpatine, Wartime Chancellor",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/468.png",
                "isHorizontal": false
            }
        },
        "name": "Chancellor Palpatine, Wartime Chancellor",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Legendary",
        "power": 2,
        "HP": 6,
        "aspects": [
            "Cunning",
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "OFFICIAL"
        ]
    },
    "TWI_017": {
        "id": "TWI_017",
        "face": {
            "front": {
                "name": "Chancellor Palpatine // Darth Sidious, Playing Both Sides",
                "type": "Leader",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/TWI/017-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Chancellor Palpatine // Darth Sidious, Playing Both Sides",
                "type": "Leader",
                "cost": "0",
                "image": "https://i.imgur.com/K7OHGks.jpeg",
                "isHorizontal": true
            }
        },
        "name": "Chancellor Palpatine // Darth Sidious, Playing Both Sides",
        "type": "Leader",
        "cost": 0,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Heroism",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "SEPARATIST",
            "SITH",
            "REPUBLIC",
            "OFFICIAL"
        ]
    },
    "TWI_274": {
        "id": "TWI_274",
        "face": {
            "front": {
                "name": "Chancellor Palpatine // Darth Sidious, Playing Both Sides",
                "type": "Leader",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/TWI/274-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Chancellor Palpatine // Darth Sidious, Playing Both Sides",
                "type": "Leader",
                "cost": "0",
                "image": "https://i.imgur.com/ebf32dn.jpeg",
                "isHorizontal": true
            }
        },
        "name": "Chancellor Palpatine // Darth Sidious, Playing Both Sides",
        "type": "Leader",
        "cost": 0,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Heroism",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "SEPARATIST",
            "SITH",
            "REPUBLIC",
            "OFFICIAL"
        ]
    },
    "TWI_292": {
        "id": "TWI_292",
        "face": {
            "front": {
                "name": "Chancellor Palpatine // Darth Sidious, Playing Both Sides",
                "type": "Leader",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/TWI/292-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Chancellor Palpatine // Darth Sidious, Playing Both Sides",
                "type": "Leader",
                "cost": "0",
                "image": "https://i.imgur.com/NdC8Vct.jpeg",
                "isHorizontal": true
            }
        },
        "name": "Chancellor Palpatine // Darth Sidious, Playing Both Sides",
        "type": "Leader",
        "cost": 0,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Heroism",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "SEPARATIST",
            "SITH",
            "REPUBLIC",
            "OFFICIAL"
        ]
    },
    "TWI_199": {
        "id": "TWI_199",
        "face": {
            "front": {
                "name": "Clear the Field",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/199.png",
                "isHorizontal": false
            }
        },
        "name": "Clear the Field",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_464": {
        "id": "TWI_464",
        "face": {
            "front": {
                "name": "Clear the Field",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/464.png",
                "isHorizontal": false
            }
        },
        "name": "Clear the Field",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_116": {
        "id": "TWI_116",
        "face": {
            "front": {
                "name": "Clone",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/TWI/116.png",
                "isHorizontal": false
            }
        },
        "name": "Clone",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "CLONE"
        ]
    },
    "TWI_386": {
        "id": "TWI_386",
        "face": {
            "front": {
                "name": "Clone",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/TWI/386.png",
                "isHorizontal": false
            }
        },
        "name": "Clone",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "CLONE"
        ]
    },
    "TWI_169": {
        "id": "TWI_169",
        "face": {
            "front": {
                "name": "Clone Cohort",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/169.png",
                "isHorizontal": false
            }
        },
        "name": "Clone Cohort",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "TWI_436": {
        "id": "TWI_436",
        "face": {
            "front": {
                "name": "Clone Cohort",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/436.png",
                "isHorizontal": false
            }
        },
        "name": "Clone Cohort",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "TWI_114": {
        "id": "TWI_114",
        "face": {
            "front": {
                "name": "Clone Commander Cody, Commanding the 212th",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/114.png",
                "isHorizontal": false
            }
        },
        "name": "Clone Commander Cody, Commanding the 212th",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Command"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_384": {
        "id": "TWI_384",
        "face": {
            "front": {
                "name": "Clone Commander Cody, Commanding the 212th",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/384.png",
                "isHorizontal": false
            }
        },
        "name": "Clone Commander Cody, Commanding the 212th",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Command"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_205": {
        "id": "TWI_205",
        "face": {
            "front": {
                "name": "Clone Dive Trooper",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/205.png",
                "isHorizontal": false
            }
        },
        "name": "Clone Dive Trooper",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_470": {
        "id": "TWI_470",
        "face": {
            "front": {
                "name": "Clone Dive Trooper",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/470.png",
                "isHorizontal": false
            }
        },
        "name": "Clone Dive Trooper",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_158": {
        "id": "TWI_158",
        "face": {
            "front": {
                "name": "Clone Heavy Gunner",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/158.png",
                "isHorizontal": false
            }
        },
        "name": "Clone Heavy Gunner",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_425": {
        "id": "TWI_425",
        "face": {
            "front": {
                "name": "Clone Heavy Gunner",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/425.png",
                "isHorizontal": false
            }
        },
        "name": "Clone Heavy Gunner",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_056": {
        "id": "TWI_056",
        "face": {
            "front": {
                "name": "Compassionate Senator",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/056.png",
                "isHorizontal": false
            }
        },
        "name": "Compassionate Senator",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 4,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "OFFICIAL"
        ]
    },
    "TWI_329": {
        "id": "TWI_329",
        "face": {
            "front": {
                "name": "Compassionate Senator",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/329.png",
                "isHorizontal": false
            }
        },
        "name": "Compassionate Senator",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 4,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "OFFICIAL"
        ]
    },
    "TWI_079": {
        "id": "TWI_079",
        "face": {
            "front": {
                "name": "Confederate Courier",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/079.png",
                "isHorizontal": false
            }
        },
        "name": "Confederate Courier",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_352": {
        "id": "TWI_352",
        "face": {
            "front": {
                "name": "Confederate Courier",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/352.png",
                "isHorizontal": false
            }
        },
        "name": "Confederate Courier",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_132": {
        "id": "TWI_132",
        "face": {
            "front": {
                "name": "Confederate Tri-Fighter",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/132.png",
                "isHorizontal": false
            }
        },
        "name": "Confederate Tri-Fighter",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_400": {
        "id": "TWI_400",
        "face": {
            "front": {
                "name": "Confederate Tri-Fighter",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/400.png",
                "isHorizontal": false
            }
        },
        "name": "Confederate Tri-Fighter",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_089": {
        "id": "TWI_089",
        "face": {
            "front": {
                "name": "Consolidation of Power",
                "type": "Event",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/089.png",
                "isHorizontal": false
            }
        },
        "name": "Consolidation of Power",
        "type": "Event",
        "cost": 6,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "TWI_361": {
        "id": "TWI_361",
        "face": {
            "front": {
                "name": "Consolidation of Power",
                "type": "Event",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/361.png",
                "isHorizontal": false
            }
        },
        "name": "Consolidation of Power",
        "type": "Event",
        "cost": 6,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "TWI_139": {
        "id": "TWI_139",
        "face": {
            "front": {
                "name": "Corner the Prey",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/139.png",
                "isHorizontal": false
            }
        },
        "name": "Corner the Prey",
        "type": "Event",
        "cost": 1,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_407": {
        "id": "TWI_407",
        "face": {
            "front": {
                "name": "Corner the Prey",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/407.png",
                "isHorizontal": false
            }
        },
        "name": "Corner the Prey",
        "type": "Event",
        "cost": 1,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_106": {
        "id": "TWI_106",
        "face": {
            "front": {
                "name": "Coruscant Guard",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/106.png",
                "isHorizontal": false
            }
        },
        "name": "Coruscant Guard",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_377": {
        "id": "TWI_377",
        "face": {
            "front": {
                "name": "Coruscant Guard",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/377.png",
                "isHorizontal": false
            }
        },
        "name": "Coruscant Guard",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_005": {
        "id": "TWI_005",
        "face": {
            "front": {
                "name": "Count Dooku, Face of the Confederacy",
                "type": "Leader",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/TWI/005-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Count Dooku, Face of the Confederacy",
                "type": "Leader",
                "cost": "7",
                "image": "https://cdn.swu-db.com/images/cards/TWI/005-b.png"
            }
        },
        "name": "Count Dooku, Face of the Confederacy",
        "type": "Leader",
        "cost": 7,
        "rarity": "Common",
        "power": 5,
        "HP": 9,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "SEPARATIST",
            "SITH"
        ]
    },
    "TWI_138": {
        "id": "TWI_138",
        "face": {
            "front": {
                "name": "Count Dooku, Fallen Jedi",
                "type": "Unit - Ground",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/TWI/138.png",
                "isHorizontal": false
            }
        },
        "name": "Count Dooku, Fallen Jedi",
        "type": "Unit - Ground",
        "cost": 8,
        "rarity": "Rare",
        "power": 6,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "SEPARATIST",
            "SITH"
        ]
    },
    "TWI_262": {
        "id": "TWI_262",
        "face": {
            "front": {
                "name": "Count Dooku, Face of the Confederacy",
                "type": "Leader",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/TWI/262-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Count Dooku, Face of the Confederacy",
                "type": "Leader",
                "cost": "7",
                "image": "https://cdn.swu-db.com/images/cards/TWI/262-b.png"
            }
        },
        "name": "Count Dooku, Face of the Confederacy",
        "type": "Leader",
        "cost": 7,
        "rarity": "Common",
        "power": 5,
        "HP": 9,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "SEPARATIST",
            "SITH"
        ]
    },
    "TWI_280": {
        "id": "TWI_280",
        "face": {
            "front": {
                "name": "Count Dooku, Face of the Confederacy",
                "type": "Leader",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/TWI/280-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Count Dooku, Face of the Confederacy",
                "type": "Leader",
                "cost": "7",
                "image": "https://cdn.swu-db.com/images/cards/TWI/280-b.png"
            }
        },
        "name": "Count Dooku, Face of the Confederacy",
        "type": "Leader",
        "cost": 7,
        "rarity": "Common",
        "power": 5,
        "HP": 9,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "SEPARATIST",
            "SITH"
        ]
    },
    "TWI_406": {
        "id": "TWI_406",
        "face": {
            "front": {
                "name": "Count Dooku, Fallen Jedi",
                "type": "Unit - Ground",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/TWI/406.png",
                "isHorizontal": false
            }
        },
        "name": "Count Dooku, Fallen Jedi",
        "type": "Unit - Ground",
        "cost": 8,
        "rarity": "Rare",
        "power": 6,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "SEPARATIST",
            "SITH"
        ]
    },
    "TWI_200": {
        "id": "TWI_200",
        "face": {
            "front": {
                "name": "Creative Thinking",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/200.png",
                "isHorizontal": false
            }
        },
        "name": "Creative Thinking",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "TWI_465": {
        "id": "TWI_465",
        "face": {
            "front": {
                "name": "Creative Thinking",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/465.png",
                "isHorizontal": false
            }
        },
        "name": "Creative Thinking",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "TWI_170": {
        "id": "TWI_170",
        "face": {
            "front": {
                "name": "Daring Raid",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/170.png",
                "isHorizontal": false
            }
        },
        "name": "Daring Raid",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_437": {
        "id": "TWI_437",
        "face": {
            "front": {
                "name": "Daring Raid",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/437.png",
                "isHorizontal": false
            }
        },
        "name": "Daring Raid",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_135": {
        "id": "TWI_135",
        "face": {
            "front": {
                "name": "Darth Maul, Revenge At Last",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/135.png",
                "isHorizontal": false
            }
        },
        "name": "Darth Maul, Revenge At Last",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Legendary",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "SITH"
        ]
    },
    "TWI_403": {
        "id": "TWI_403",
        "face": {
            "front": {
                "name": "Darth Maul, Revenge At Last",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/403.png",
                "isHorizontal": false
            }
        },
        "name": "Darth Maul, Revenge At Last",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Legendary",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "SITH"
        ]
    },
    "TWI_062": {
        "id": "TWI_062",
        "face": {
            "front": {
                "name": "Daughter of Dathomir",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/062.png",
                "isHorizontal": false
            }
        },
        "name": "Daughter of Dathomir",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "FORCE",
            "NIGHT"
        ]
    },
    "TWI_335": {
        "id": "TWI_335",
        "face": {
            "front": {
                "name": "Daughter of Dathomir",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/335.png",
                "isHorizontal": false
            }
        },
        "name": "Daughter of Dathomir",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "FORCE",
            "NIGHT"
        ]
    },
    "TWI_076": {
        "id": "TWI_076",
        "face": {
            "front": {
                "name": "Death by Droids",
                "type": "Event",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/076.png",
                "isHorizontal": false
            }
        },
        "name": "Death by Droids",
        "type": "Event",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_349": {
        "id": "TWI_349",
        "face": {
            "front": {
                "name": "Death by Droids",
                "type": "Event",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/349.png",
                "isHorizontal": false
            }
        },
        "name": "Death by Droids",
        "type": "Event",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_159": {
        "id": "TWI_159",
        "face": {
            "front": {
                "name": "Dendup's Loyalist",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/159.png",
                "isHorizontal": false
            }
        },
        "name": "Dendup's Loyalist",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "TROOPER"
        ]
    },
    "TWI_426": {
        "id": "TWI_426",
        "face": {
            "front": {
                "name": "Dendup's Loyalist",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/426.png",
                "isHorizontal": false
            }
        },
        "name": "Dendup's Loyalist",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "TROOPER"
        ]
    },
    "TWI_036": {
        "id": "TWI_036",
        "face": {
            "front": {
                "name": "Devastating Gunship",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/036.png",
                "isHorizontal": false
            }
        },
        "name": "Devastating Gunship",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "TWI_309": {
        "id": "TWI_309",
        "face": {
            "front": {
                "name": "Devastating Gunship",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/309.png",
                "isHorizontal": false
            }
        },
        "name": "Devastating Gunship",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "TWI_157": {
        "id": "TWI_157",
        "face": {
            "front": {
                "name": "Disaffected Senator",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/157.png",
                "isHorizontal": false
            }
        },
        "name": "Disaffected Senator",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 4,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "OFFICIAL"
        ]
    },
    "TWI_424": {
        "id": "TWI_424",
        "face": {
            "front": {
                "name": "Disaffected Senator",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/424.png",
                "isHorizontal": false
            }
        },
        "name": "Disaffected Senator",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 4,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "OFFICIAL"
        ]
    },
    "TWI_075": {
        "id": "TWI_075",
        "face": {
            "front": {
                "name": "Disruptive Burst",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/075.png",
                "isHorizontal": false
            }
        },
        "name": "Disruptive Burst",
        "type": "Event",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_348": {
        "id": "TWI_348",
        "face": {
            "front": {
                "name": "Disruptive Burst",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/348.png",
                "isHorizontal": false
            }
        },
        "name": "Disruptive Burst",
        "type": "Event",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_218": {
        "id": "TWI_218",
        "face": {
            "front": {
                "name": "Droid Cohort",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/218.png",
                "isHorizontal": false
            }
        },
        "name": "Droid Cohort",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "TWI_483": {
        "id": "TWI_483",
        "face": {
            "front": {
                "name": "Droid Cohort",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/483.png",
                "isHorizontal": false
            }
        },
        "name": "Droid Cohort",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "TWI_081": {
        "id": "TWI_081",
        "face": {
            "front": {
                "name": "Droid Commando",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/081.png",
                "isHorizontal": false
            }
        },
        "name": "Droid Commando",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 4,
        "HP": 3,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "TROOPER"
        ]
    },
    "TWI_354": {
        "id": "TWI_354",
        "face": {
            "front": {
                "name": "Droid Commando",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/354.png",
                "isHorizontal": false
            }
        },
        "name": "Droid Commando",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 4,
        "HP": 3,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "TROOPER"
        ]
    },
    "TWI_237": {
        "id": "TWI_237",
        "face": {
            "front": {
                "name": "Droid Deployment",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/237.png",
                "isHorizontal": false
            }
        },
        "name": "Droid Deployment",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "TWI_499": {
        "id": "TWI_499",
        "face": {
            "front": {
                "name": "Droid Deployment",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/499.png",
                "isHorizontal": false
            }
        },
        "name": "Droid Deployment",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "TWI_022": {
        "id": "TWI_022",
        "face": {
            "front": {
                "name": "Droid Manufactory, Geonosis",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/TWI/022-r.png",
                "isHorizontal": true
            }
        },
        "name": "Droid Manufactory, Geonosis",
        "type": "Base",
        "cost": 0,
        "rarity": "Rare",
        "power": 0,
        "HP": 24,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": []
    },
    "TWI_297": {
        "id": "TWI_297",
        "face": {
            "front": {
                "name": "Droid Manufactory, Geonosis",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/TWI/297-r.png",
                "isHorizontal": true
            }
        },
        "name": "Droid Manufactory, Geonosis",
        "type": "Base",
        "cost": 0,
        "rarity": "Rare",
        "power": 0,
        "HP": 24,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": []
    },
    "TWI_228": {
        "id": "TWI_228",
        "face": {
            "front": {
                "name": "Droid Starfighter",
                "type": "Unit - Space",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/228.png",
                "isHorizontal": false
            }
        },
        "name": "Droid Starfighter",
        "type": "Unit - Space",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 2,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_492": {
        "id": "TWI_492",
        "face": {
            "front": {
                "name": "Droid Starfighter",
                "type": "Unit - Space",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/492.png",
                "isHorizontal": false
            }
        },
        "name": "Droid Starfighter",
        "type": "Unit - Space",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 2,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_037": {
        "id": "TWI_037",
        "face": {
            "front": {
                "name": "Droideka Security",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/037.png",
                "isHorizontal": false
            }
        },
        "name": "Droideka Security",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID"
        ]
    },
    "TWI_310": {
        "id": "TWI_310",
        "face": {
            "front": {
                "name": "Droideka Security",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/310.png",
                "isHorizontal": false
            }
        },
        "name": "Droideka Security",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID"
        ]
    },
    "TWI_251": {
        "id": "TWI_251",
        "face": {
            "front": {
                "name": "Drop In",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/251.png",
                "isHorizontal": false
            }
        },
        "name": "Drop In",
        "type": "Event",
        "cost": 4,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "TWI_511": {
        "id": "TWI_511",
        "face": {
            "front": {
                "name": "Drop In",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/511.png",
                "isHorizontal": false
            }
        },
        "name": "Drop In",
        "type": "Event",
        "cost": 4,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "TWI_054": {
        "id": "TWI_054",
        "face": {
            "front": {
                "name": "Duchess's Champion",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/054.png",
                "isHorizontal": false
            }
        },
        "name": "Duchess's Champion",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 8,
        "aspects": [
            "Vigilance",
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN"
        ]
    },
    "TWI_327": {
        "id": "TWI_327",
        "face": {
            "front": {
                "name": "Duchess's Champion",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/327.png",
                "isHorizontal": false
            }
        },
        "name": "Duchess's Champion",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 8,
        "aspects": [
            "Vigilance",
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "MANDALORIAN"
        ]
    },
    "TWI_231": {
        "id": "TWI_231",
        "face": {
            "front": {
                "name": "Dwarf Spider Droid",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/231.png",
                "isHorizontal": false
            }
        },
        "name": "Dwarf Spider Droid",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID"
        ]
    },
    "TWI_494": {
        "id": "TWI_494",
        "face": {
            "front": {
                "name": "Dwarf Spider Droid",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/494.png",
                "isHorizontal": false
            }
        },
        "name": "Dwarf Spider Droid",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID"
        ]
    },
    "TWI_090": {
        "id": "TWI_090",
        "face": {
            "front": {
                "name": "Echo, Valiant ARC Trooper",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/090.png",
                "isHorizontal": false
            }
        },
        "name": "Echo, Valiant ARC Trooper",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_362": {
        "id": "TWI_362",
        "face": {
            "front": {
                "name": "Echo, Valiant ARC Trooper",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/362.png",
                "isHorizontal": false
            }
        },
        "name": "Echo, Valiant ARC Trooper",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_181": {
        "id": "TWI_181",
        "face": {
            "front": {
                "name": "Elite P-38 Starfighter",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/181.png",
                "isHorizontal": false
            }
        },
        "name": "Elite P-38 Starfighter",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_446": {
        "id": "TWI_446",
        "face": {
            "front": {
                "name": "Elite P-38 Starfighter",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/446.png",
                "isHorizontal": false
            }
        },
        "name": "Elite P-38 Starfighter",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_126": {
        "id": "TWI_126",
        "face": {
            "front": {
                "name": "Encouraging Leadership",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/126.png",
                "isHorizontal": false
            }
        },
        "name": "Encouraging Leadership",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "LEARNED"
        ]
    },
    "TWI_394": {
        "id": "TWI_394",
        "face": {
            "front": {
                "name": "Encouraging Leadership",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/394.png",
                "isHorizontal": false
            }
        },
        "name": "Encouraging Leadership",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "LEARNED"
        ]
    },
    "TWI_198": {
        "id": "TWI_198",
        "face": {
            "front": {
                "name": "Enfys Nest, Champion of Justice",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/TWI/198.png",
                "isHorizontal": false
            }
        },
        "name": "Enfys Nest, Champion of Justice",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Rare",
        "power": 5,
        "HP": 7,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "TWI_463": {
        "id": "TWI_463",
        "face": {
            "front": {
                "name": "Enfys Nest, Champion of Justice",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/TWI/463.png",
                "isHorizontal": false
            }
        },
        "name": "Enfys Nest, Champion of Justice",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Rare",
        "power": 5,
        "HP": 7,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "TWI_055": {
        "id": "TWI_055",
        "face": {
            "front": {
                "name": "Equalize",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/055.png",
                "isHorizontal": false
            }
        },
        "name": "Equalize",
        "type": "Event",
        "cost": 3,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance",
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_328": {
        "id": "TWI_328",
        "face": {
            "front": {
                "name": "Equalize",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/328.png",
                "isHorizontal": false
            }
        },
        "name": "Equalize",
        "type": "Event",
        "cost": 3,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance",
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_244": {
        "id": "TWI_244",
        "face": {
            "front": {
                "name": "Eta-2 Light Interceptor",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/244.png",
                "isHorizontal": false
            }
        },
        "name": "Eta-2 Light Interceptor",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_505": {
        "id": "TWI_505",
        "face": {
            "front": {
                "name": "Eta-2 Light Interceptor",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/505.png",
                "isHorizontal": false
            }
        },
        "name": "Eta-2 Light Interceptor",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_239": {
        "id": "TWI_239",
        "face": {
            "front": {
                "name": "Execute Order 66",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/239.png",
                "isHorizontal": false
            }
        },
        "name": "Execute Order 66",
        "type": "Event",
        "cost": 4,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "TWI_501": {
        "id": "TWI_501",
        "face": {
            "front": {
                "name": "Execute Order 66",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/501.png",
                "isHorizontal": false
            }
        },
        "name": "Execute Order 66",
        "type": "Event",
        "cost": 4,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "TWI_065": {
        "id": "TWI_065",
        "face": {
            "front": {
                "name": "Falchion Ion Tank",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/065.png",
                "isHorizontal": false
            }
        },
        "name": "Falchion Ion Tank",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "TANK"
        ]
    },
    "TWI_338": {
        "id": "TWI_338",
        "face": {
            "front": {
                "name": "Falchion Ion Tank",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/338.png",
                "isHorizontal": false
            }
        },
        "name": "Falchion Ion Tank",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "TANK"
        ]
    },
    "TWI_208": {
        "id": "TWI_208",
        "face": {
            "front": {
                "name": "Favorable Delegate",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/208.png",
                "isHorizontal": false
            }
        },
        "name": "Favorable Delegate",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 5,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "OFFICIAL"
        ]
    },
    "TWI_473": {
        "id": "TWI_473",
        "face": {
            "front": {
                "name": "Favorable Delegate",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/473.png",
                "isHorizontal": false
            }
        },
        "name": "Favorable Delegate",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 5,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "OFFICIAL"
        ]
    },
    "TWI_053": {
        "id": "TWI_053",
        "face": {
            "front": {
                "name": "Finn, On the Run",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/053.png",
                "isHorizontal": false
            }
        },
        "name": "Finn, On the Run",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Rare",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Vigilance",
            "Vigilance"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "TROOPER"
        ]
    },
    "TWI_326": {
        "id": "TWI_326",
        "face": {
            "front": {
                "name": "Finn, On the Run",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/326.png",
                "isHorizontal": false
            }
        },
        "name": "Finn, On the Run",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Rare",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Vigilance",
            "Vigilance"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "TROOPER"
        ]
    },
    "TWI_216": {
        "id": "TWI_216",
        "face": {
            "front": {
                "name": "Fives, In Search of Truth",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/216.png",
                "isHorizontal": false
            }
        },
        "name": "Fives, In Search of Truth",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Rare",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_481": {
        "id": "TWI_481",
        "face": {
            "front": {
                "name": "Fives, In Search of Truth",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/481.png",
                "isHorizontal": false
            }
        },
        "name": "Fives, In Search of Truth",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Rare",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_051": {
        "id": "TWI_051",
        "face": {
            "front": {
                "name": "For The Republic",
                "type": "Upgrade",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/051.png",
                "isHorizontal": false
            }
        },
        "name": "For The Republic",
        "type": "Upgrade",
        "cost": 3,
        "rarity": "Rare",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC"
        ]
    },
    "TWI_324": {
        "id": "TWI_324",
        "face": {
            "front": {
                "name": "For The Republic",
                "type": "Upgrade",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/324.png",
                "isHorizontal": false
            }
        },
        "name": "For The Republic",
        "type": "Upgrade",
        "cost": 3,
        "rarity": "Rare",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC"
        ]
    },
    "TWI_068": {
        "id": "TWI_068",
        "face": {
            "front": {
                "name": "Foresight",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/068.png",
                "isHorizontal": false
            }
        },
        "name": "Foresight",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Rare",
        "power": 0,
        "HP": 2,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "LEARNED"
        ]
    },
    "TWI_341": {
        "id": "TWI_341",
        "face": {
            "front": {
                "name": "Foresight",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/341.png",
                "isHorizontal": false
            }
        },
        "name": "Foresight",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Rare",
        "power": 0,
        "HP": 2,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "LEARNED"
        ]
    },
    "TWI_212": {
        "id": "TWI_212",
        "face": {
            "front": {
                "name": "Freelance Assassin",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/212.png",
                "isHorizontal": false
            }
        },
        "name": "Freelance Assassin",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 4,
        "HP": 2,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "TWI_477": {
        "id": "TWI_477",
        "face": {
            "front": {
                "name": "Freelance Assassin",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/477.png",
                "isHorizontal": false
            }
        },
        "name": "Freelance Assassin",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 4,
        "HP": 2,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "TWI_015": {
        "id": "TWI_015",
        "face": {
            "front": {
                "name": "General Grievous, General of the Droid Armies",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/015-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "General Grievous, General of the Droid Armies",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/TWI/015-b.png"
            }
        },
        "name": "General Grievous, General of the Droid Armies",
        "type": "Leader",
        "cost": 6,
        "rarity": "Special",
        "power": 4,
        "HP": 8,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "OFFICIAL"
        ]
    },
    "TWI_034": {
        "id": "TWI_034",
        "face": {
            "front": {
                "name": "General Grievous, Trophy Collector",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/034.png",
                "isHorizontal": false
            }
        },
        "name": "General Grievous, Trophy Collector",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Legendary",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "OFFICIAL"
        ]
    },
    "TWI_272": {
        "id": "TWI_272",
        "face": {
            "front": {
                "name": "General Grievous, General of the Droid Armies",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/272-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "General Grievous, General of the Droid Armies",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/TWI/272-b.png"
            }
        },
        "name": "General Grievous, General of the Droid Armies",
        "type": "Leader",
        "cost": 6,
        "rarity": "Special",
        "power": 4,
        "HP": 8,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "OFFICIAL"
        ]
    },
    "TWI_307": {
        "id": "TWI_307",
        "face": {
            "front": {
                "name": "General Grievous, Trophy Collector",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/307.png",
                "isHorizontal": false
            }
        },
        "name": "General Grievous, Trophy Collector",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Legendary",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "OFFICIAL"
        ]
    },
    "TWI_121": {
        "id": "TWI_121",
        "face": {
            "front": {
                "name": "General's Blade",
                "type": "Upgrade",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/121.png",
                "isHorizontal": false
            }
        },
        "name": "General's Blade",
        "type": "Upgrade",
        "cost": 3,
        "rarity": "Rare",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "ITEM",
            "WEAPON",
            "LIGHTSABER"
        ]
    },
    "TWI_391": {
        "id": "TWI_391",
        "face": {
            "front": {
                "name": "General's Blade",
                "type": "Upgrade",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/391.png",
                "isHorizontal": false
            }
        },
        "name": "General's Blade",
        "type": "Upgrade",
        "cost": 3,
        "rarity": "Rare",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "ITEM",
            "WEAPON",
            "LIGHTSABER"
        ]
    },
    "TWI_083": {
        "id": "TWI_083",
        "face": {
            "front": {
                "name": "General's Guardian",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/083.png",
                "isHorizontal": false
            }
        },
        "name": "General's Guardian",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Special",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID"
        ]
    },
    "TWI_215": {
        "id": "TWI_215",
        "face": {
            "front": {
                "name": "Geonosis Patrol Fighter",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/215.png",
                "isHorizontal": false
            }
        },
        "name": "Geonosis Patrol Fighter",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_480": {
        "id": "TWI_480",
        "face": {
            "front": {
                "name": "Geonosis Patrol Fighter",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/480.png",
                "isHorizontal": false
            }
        },
        "name": "Geonosis Patrol Fighter",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_118": {
        "id": "TWI_118",
        "face": {
            "front": {
                "name": "Gor, Grievous's Pet",
                "type": "Unit - Ground",
                "cost": 12,
                "image": "https://cdn.swu-db.com/images/cards/TWI/118.png",
                "isHorizontal": false
            }
        },
        "name": "Gor, Grievous's Pet",
        "type": "Unit - Ground",
        "cost": 12,
        "rarity": "Legendary",
        "power": 7,
        "HP": 7,
        "aspects": [
            "Command"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "CREATURE"
        ]
    },
    "TWI_388": {
        "id": "TWI_388",
        "face": {
            "front": {
                "name": "Gor, Grievous's Pet",
                "type": "Unit - Ground",
                "cost": 12,
                "image": "https://cdn.swu-db.com/images/cards/TWI/388.png",
                "isHorizontal": false
            }
        },
        "name": "Gor, Grievous's Pet",
        "type": "Unit - Ground",
        "cost": 12,
        "rarity": "Legendary",
        "power": 7,
        "HP": 7,
        "aspects": [
            "Command"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "CREATURE"
        ]
    },
    "TWI_171": {
        "id": "TWI_171",
        "face": {
            "front": {
                "name": "Grenade Strike",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/171.png",
                "isHorizontal": false
            }
        },
        "name": "Grenade Strike",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_438": {
        "id": "TWI_438",
        "face": {
            "front": {
                "name": "Grenade Strike",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/438.png",
                "isHorizontal": false
            }
        },
        "name": "Grenade Strike",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_073": {
        "id": "TWI_073",
        "face": {
            "front": {
                "name": "Grievous Reassembly",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/073.png",
                "isHorizontal": false
            }
        },
        "name": "Grievous Reassembly",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "TWI_346": {
        "id": "TWI_346",
        "face": {
            "front": {
                "name": "Grievous Reassembly",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/346.png",
                "isHorizontal": false
            }
        },
        "name": "Grievous Reassembly",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "TWI_236": {
        "id": "TWI_236",
        "face": {
            "front": {
                "name": "Grievous's Wheel Bike",
                "type": "Upgrade",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/236.png",
                "isHorizontal": false
            }
        },
        "name": "Grievous's Wheel Bike",
        "type": "Upgrade",
        "cost": 4,
        "rarity": "Special",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "VEHICLE"
        ]
    },
    "TWI_172": {
        "id": "TWI_172",
        "face": {
            "front": {
                "name": "Grim Resolve",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/172.png",
                "isHorizontal": false
            }
        },
        "name": "Grim Resolve",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_439": {
        "id": "TWI_439",
        "face": {
            "front": {
                "name": "Grim Resolve",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/439.png",
                "isHorizontal": false
            }
        },
        "name": "Grim Resolve",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_074": {
        "id": "TWI_074",
        "face": {
            "front": {
                "name": "Guarding the Way",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/074.png",
                "isHorizontal": false
            }
        },
        "name": "Guarding the Way",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_347": {
        "id": "TWI_347",
        "face": {
            "front": {
                "name": "Guarding the Way",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/347.png",
                "isHorizontal": false
            }
        },
        "name": "Guarding the Way",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_177": {
        "id": "TWI_177",
        "face": {
            "front": {
                "name": "Guerilla Insurgency",
                "type": "Event",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/TWI/177.png",
                "isHorizontal": false
            }
        },
        "name": "Guerilla Insurgency",
        "type": "Event",
        "cost": 8,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_443": {
        "id": "TWI_443",
        "face": {
            "front": {
                "name": "Guerilla Insurgency",
                "type": "Event",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/TWI/443.png",
                "isHorizontal": false
            }
        },
        "name": "Guerilla Insurgency",
        "type": "Event",
        "cost": 8,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_233": {
        "id": "TWI_233",
        "face": {
            "front": {
                "name": "Hailfire Tank",
                "type": "Unit - Ground",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/TWI/233.png",
                "isHorizontal": false
            }
        },
        "name": "Hailfire Tank",
        "type": "Unit - Ground",
        "cost": 8,
        "rarity": "Common",
        "power": 7,
        "HP": 6,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "VEHICLE",
            "TANK"
        ]
    },
    "TWI_496": {
        "id": "TWI_496",
        "face": {
            "front": {
                "name": "Hailfire Tank",
                "type": "Unit - Ground",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/TWI/496.png",
                "isHorizontal": false
            }
        },
        "name": "Hailfire Tank",
        "type": "Unit - Ground",
        "cost": 8,
        "rarity": "Common",
        "power": 7,
        "HP": 6,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "VEHICLE",
            "TANK"
        ]
    },
    "TWI_253": {
        "id": "TWI_253",
        "face": {
            "front": {
                "name": "Headhunter Squadron ",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/253.png",
                "isHorizontal": false
            }
        },
        "name": "Headhunter Squadron ",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 4,
        "aspects": [],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_513": {
        "id": "TWI_513",
        "face": {
            "front": {
                "name": "Headhunter Squadron ",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/513.png",
                "isHorizontal": false
            }
        },
        "name": "Headhunter Squadron ",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 4,
        "aspects": [],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_167": {
        "id": "TWI_167",
        "face": {
            "front": {
                "name": "Heavy Persuader Tank",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/TWI/167.png",
                "isHorizontal": false
            }
        },
        "name": "Heavy Persuader Tank",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Common",
        "power": 6,
        "HP": 5,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "VEHICLE",
            "TANK"
        ]
    },
    "TWI_434": {
        "id": "TWI_434",
        "face": {
            "front": {
                "name": "Heavy Persuader Tank",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/TWI/434.png",
                "isHorizontal": false
            }
        },
        "name": "Heavy Persuader Tank",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Common",
        "power": 6,
        "HP": 5,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "VEHICLE",
            "TANK"
        ]
    },
    "TWI_052": {
        "id": "TWI_052",
        "face": {
            "front": {
                "name": "Hello There",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/052.png",
                "isHorizontal": false
            }
        },
        "name": "Hello There",
        "type": "Event",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "TWI_325": {
        "id": "TWI_325",
        "face": {
            "front": {
                "name": "Hello There",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/325.png",
                "isHorizontal": false
            }
        },
        "name": "Hello There",
        "type": "Event",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "TWI_249": {
        "id": "TWI_249",
        "face": {
            "front": {
                "name": "Heroes on Both Sides",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/249.png",
                "isHorizontal": false
            }
        },
        "name": "Heroes on Both Sides",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "SEPARATIST"
        ]
    },
    "TWI_509": {
        "id": "TWI_509",
        "face": {
            "front": {
                "name": "Heroes on Both Sides",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/509.png",
                "isHorizontal": false
            }
        },
        "name": "Heroes on Both Sides",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "SEPARATIST"
        ]
    },
    "TWI_164": {
        "id": "TWI_164",
        "face": {
            "front": {
                "name": "Hevy, Staunch Martyr",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/164.png",
                "isHorizontal": false
            }
        },
        "name": "Hevy, Staunch Martyr",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Aggression"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_431": {
        "id": "TWI_431",
        "face": {
            "front": {
                "name": "Hevy, Staunch Martyr",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/431.png",
                "isHorizontal": false
            }
        },
        "name": "Hevy, Staunch Martyr",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Aggression"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_214": {
        "id": "TWI_214",
        "face": {
            "front": {
                "name": "Hidden Sharpshooter",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/214.png",
                "isHorizontal": false
            }
        },
        "name": "Hidden Sharpshooter",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 4,
        "HP": 3,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_479": {
        "id": "TWI_479",
        "face": {
            "front": {
                "name": "Hidden Sharpshooter",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/479.png",
                "isHorizontal": false
            }
        },
        "name": "Hidden Sharpshooter",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 4,
        "HP": 3,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_256": {
        "id": "TWI_256",
        "face": {
            "front": {
                "name": "Hold-Out Blaster",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/256.png",
                "isHorizontal": false
            }
        },
        "name": "Hold-Out Blaster",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 0,
        "aspects": [],
        "unique": false,
        "traits": [
            "ITEM",
            "WEAPON"
        ]
    },
    "TWI_516": {
        "id": "TWI_516",
        "face": {
            "front": {
                "name": "Hold-Out Blaster",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/516.png",
                "isHorizontal": false
            }
        },
        "name": "Hold-Out Blaster",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 0,
        "aspects": [],
        "unique": false,
        "traits": [
            "ITEM",
            "WEAPON"
        ]
    },
    "TWI_209": {
        "id": "TWI_209",
        "face": {
            "front": {
                "name": "Hotshot V-Wing",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/209.png",
                "isHorizontal": false
            }
        },
        "name": "Hotshot V-Wing",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_474": {
        "id": "TWI_474",
        "face": {
            "front": {
                "name": "Hotshot V-Wing",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/474.png",
                "isHorizontal": false
            }
        },
        "name": "Hotshot V-Wing",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_110": {
        "id": "TWI_110",
        "face": {
            "front": {
                "name": "Huyang, Enduring Instructor",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/110.png",
                "isHorizontal": false
            }
        },
        "name": "Huyang, Enduring Instructor",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Rare",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Command"
        ],
        "unique": true,
        "traits": [
            "JEDI",
            "DROID"
        ]
    },
    "TWI_380": {
        "id": "TWI_380",
        "face": {
            "front": {
                "name": "Huyang, Enduring Instructor",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/380.png",
                "isHorizontal": false
            }
        },
        "name": "Huyang, Enduring Instructor",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Rare",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Command"
        ],
        "unique": true,
        "traits": [
            "JEDI",
            "DROID"
        ]
    },
    "TWI_072": {
        "id": "TWI_072",
        "face": {
            "front": {
                "name": "I Have the High Ground",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/072.png",
                "isHorizontal": false
            }
        },
        "name": "I Have the High Ground",
        "type": "Event",
        "cost": 1,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_345": {
        "id": "TWI_345",
        "face": {
            "front": {
                "name": "I Have the High Ground",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/345.png",
                "isHorizontal": false
            }
        },
        "name": "I Have the High Ground",
        "type": "Event",
        "cost": 1,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_204": {
        "id": "TWI_204",
        "face": {
            "front": {
                "name": "Impropriety Among Thieves",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/204.png",
                "isHorizontal": false
            }
        },
        "name": "Impropriety Among Thieves",
        "type": "Event",
        "cost": 4,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "TWI_469": {
        "id": "TWI_469",
        "face": {
            "front": {
                "name": "Impropriety Among Thieves",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/469.png",
                "isHorizontal": false
            }
        },
        "name": "Impropriety Among Thieves",
        "type": "Event",
        "cost": 4,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "TWI_129": {
        "id": "TWI_129",
        "face": {
            "front": {
                "name": "In Defense of Kamino",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/129.png",
                "isHorizontal": false
            }
        },
        "name": "In Defense of Kamino",
        "type": "Event",
        "cost": 4,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC"
        ]
    },
    "TWI_397": {
        "id": "TWI_397",
        "face": {
            "front": {
                "name": "In Defense of Kamino",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/397.png",
                "isHorizontal": false
            }
        },
        "name": "In Defense of Kamino",
        "type": "Event",
        "cost": 4,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC"
        ]
    },
    "TWI_221": {
        "id": "TWI_221",
        "face": {
            "front": {
                "name": "In Pursuit",
                "type": "Event",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/TWI/221.png",
                "isHorizontal": false
            }
        },
        "name": "In Pursuit",
        "type": "Event",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_486": {
        "id": "TWI_486",
        "face": {
            "front": {
                "name": "In Pursuit",
                "type": "Event",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/TWI/486.png",
                "isHorizontal": false
            }
        },
        "name": "In Pursuit",
        "type": "Event",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_206": {
        "id": "TWI_206",
        "face": {
            "front": {
                "name": "Independent Senator",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/206.png",
                "isHorizontal": false
            }
        },
        "name": "Independent Senator",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 4,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "OFFICIAL"
        ]
    },
    "TWI_471": {
        "id": "TWI_471",
        "face": {
            "front": {
                "name": "Independent Senator",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/471.png",
                "isHorizontal": false
            }
        },
        "name": "Independent Senator",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 4,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "OFFICIAL"
        ]
    },
    "TWI_061": {
        "id": "TWI_061",
        "face": {
            "front": {
                "name": "Infantry of the 212th",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/061.png",
                "isHorizontal": false
            }
        },
        "name": "Infantry of the 212th",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_334": {
        "id": "TWI_334",
        "face": {
            "front": {
                "name": "Infantry of the 212th",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/334.png",
                "isHorizontal": false
            }
        },
        "name": "Infantry of the 212th",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_182": {
        "id": "TWI_182",
        "face": {
            "front": {
                "name": "Infiltrating Demolisher",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/182.png",
                "isHorizontal": false
            }
        },
        "name": "Infiltrating Demolisher",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID"
        ]
    },
    "TWI_447": {
        "id": "TWI_447",
        "face": {
            "front": {
                "name": "Infiltrating Demolisher",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/447.png",
                "isHorizontal": false
            }
        },
        "name": "Infiltrating Demolisher",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID"
        ]
    },
    "TWI_016": {
        "id": "TWI_016",
        "face": {
            "front": {
                "name": "Jango Fett, Concealing the Conspiracy",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/016-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Jango Fett, Concealing the Conspiracy",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/TWI/016-b.png"
            }
        },
        "name": "Jango Fett, Concealing the Conspiracy",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 7,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "TWI_273": {
        "id": "TWI_273",
        "face": {
            "front": {
                "name": "Jango Fett, Concealing the Conspiracy",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/273-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Jango Fett, Concealing the Conspiracy",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/TWI/273-b.png"
            }
        },
        "name": "Jango Fett, Concealing the Conspiracy",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 7,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "TWI_291": {
        "id": "TWI_291",
        "face": {
            "front": {
                "name": "Jango Fett, Concealing the Conspiracy",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/291-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Jango Fett, Concealing the Conspiracy",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/TWI/291-b.png"
            }
        },
        "name": "Jango Fett, Concealing the Conspiracy",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 7,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "TWI_202": {
        "id": "TWI_202",
        "face": {
            "front": {
                "name": "Jar Jar Binks, Foolish Gungan",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/202.png",
                "isHorizontal": false
            }
        },
        "name": "Jar Jar Binks, Foolish Gungan",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "GUNGAN"
        ]
    },
    "TWI_467": {
        "id": "TWI_467",
        "face": {
            "front": {
                "name": "Jar Jar Binks, Foolish Gungan",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/467.png",
                "isHorizontal": false
            }
        },
        "name": "Jar Jar Binks, Foolish Gungan",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "GUNGAN"
        ]
    },
    "TWI_145": {
        "id": "TWI_145",
        "face": {
            "front": {
                "name": "Jesse, Hard-Fighting Patriot",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/145.png",
                "isHorizontal": false
            }
        },
        "name": "Jesse, Hard-Fighting Patriot",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_413": {
        "id": "TWI_413",
        "face": {
            "front": {
                "name": "Jesse, Hard-Fighting Patriot",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/413.png",
                "isHorizontal": false
            }
        },
        "name": "Jesse, Hard-Fighting Patriot",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_143": {
        "id": "TWI_143",
        "face": {
            "front": {
                "name": "Jyn Erso, Stardust",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/143.png",
                "isHorizontal": false
            }
        },
        "name": "Jyn Erso, Stardust",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL"
        ]
    },
    "TWI_411": {
        "id": "TWI_411",
        "face": {
            "front": {
                "name": "Jyn Erso, Stardust",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/411.png",
                "isHorizontal": false
            }
        },
        "name": "Jyn Erso, Stardust",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL"
        ]
    },
    "TWI_026": {
        "id": "TWI_026",
        "face": {
            "front": {
                "name": "KCM Mining Facility, Mustafar",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/TWI/026-r.png",
                "isHorizontal": true
            }
        },
        "name": "KCM Mining Facility, Mustafar",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": []
    },
    "TWI_301": {
        "id": "TWI_301",
        "face": {
            "front": {
                "name": "KCM Mining Facility, Mustafar",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/TWI/301-r.png",
                "isHorizontal": true
            }
        },
        "name": "KCM Mining Facility, Mustafar",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": []
    },
    "TWI_085": {
        "id": "TWI_085",
        "face": {
            "front": {
                "name": "Kalani, Analytical General",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/085.png",
                "isHorizontal": false
            }
        },
        "name": "Kalani, Analytical General",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Rare",
        "power": 5,
        "HP": 7,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "DROID"
        ]
    },
    "TWI_357": {
        "id": "TWI_357",
        "face": {
            "front": {
                "name": "Kalani, Analytical General",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/357.png",
                "isHorizontal": false
            }
        },
        "name": "Kalani, Analytical General",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Rare",
        "power": 5,
        "HP": 7,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "DROID"
        ]
    },
    "TWI_044": {
        "id": "TWI_044",
        "face": {
            "front": {
                "name": "Kashyyyk Defender",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/044.png",
                "isHorizontal": false
            }
        },
        "name": "Kashyyyk Defender",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "WOOKIEE"
        ]
    },
    "TWI_317": {
        "id": "TWI_317",
        "face": {
            "front": {
                "name": "Kashyyyk Defender",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/317.png",
                "isHorizontal": false
            }
        },
        "name": "Kashyyyk Defender",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "WOOKIEE"
        ]
    },
    "TWI_064": {
        "id": "TWI_064",
        "face": {
            "front": {
                "name": "Ki-Adi-Mundi, Composed and Confident",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/064.png",
                "isHorizontal": false
            }
        },
        "name": "Ki-Adi-Mundi, Composed and Confident",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Legendary",
        "power": 5,
        "HP": 7,
        "aspects": [
            "Vigilance"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_337": {
        "id": "TWI_337",
        "face": {
            "front": {
                "name": "Ki-Adi-Mundi, Composed and Confident",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/337.png",
                "isHorizontal": false
            }
        },
        "name": "Ki-Adi-Mundi, Composed and Confident",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Legendary",
        "power": 5,
        "HP": 7,
        "aspects": [
            "Vigilance"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_165": {
        "id": "TWI_165",
        "face": {
            "front": {
                "name": "Kit Fisto, The Smiling Jedi",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/165.png",
                "isHorizontal": false
            }
        },
        "name": "Kit Fisto, The Smiling Jedi",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Rare",
        "power": 7,
        "HP": 6,
        "aspects": [
            "Aggression"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_432": {
        "id": "TWI_432",
        "face": {
            "front": {
                "name": "Kit Fisto, The Smiling Jedi",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/432.png",
                "isHorizontal": false
            }
        },
        "name": "Kit Fisto, The Smiling Jedi",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Rare",
        "power": 7,
        "HP": 6,
        "aspects": [
            "Aggression"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_049": {
        "id": "TWI_049",
        "face": {
            "front": {
                "name": "Knight of the Republic",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/049.png",
                "isHorizontal": false
            }
        },
        "name": "Knight of the Republic",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_322": {
        "id": "TWI_322",
        "face": {
            "front": {
                "name": "Knight of the Republic",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/322.png",
                "isHorizontal": false
            }
        },
        "name": "Knight of the Republic",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_084": {
        "id": "TWI_084",
        "face": {
            "front": {
                "name": "Kraken, Confederate Tactician",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/084.png",
                "isHorizontal": false
            }
        },
        "name": "Kraken, Confederate Tactician",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "DROID"
        ]
    },
    "TWI_356": {
        "id": "TWI_356",
        "face": {
            "front": {
                "name": "Kraken, Confederate Tactician",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/356.png",
                "isHorizontal": false
            }
        },
        "name": "Kraken, Confederate Tactician",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "DROID"
        ]
    },
    "TWI_023": {
        "id": "TWI_023",
        "face": {
            "front": {
                "name": "Lair of Grievous, Vassek",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/TWI/023-r.png",
                "isHorizontal": true
            }
        },
        "name": "Lair of Grievous, Vassek",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": []
    },
    "TWI_298": {
        "id": "TWI_298",
        "face": {
            "front": {
                "name": "Lair of Grievous, Vassek",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/TWI/298-r.png",
                "isHorizontal": true
            }
        },
        "name": "Lair of Grievous, Vassek",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": []
    },
    "TWI_041": {
        "id": "TWI_041",
        "face": {
            "front": {
                "name": "Lethal Crackdown",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/041.png",
                "isHorizontal": false
            }
        },
        "name": "Lethal Crackdown",
        "type": "Event",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_314": {
        "id": "TWI_314",
        "face": {
            "front": {
                "name": "Lethal Crackdown",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/314.png",
                "isHorizontal": false
            }
        },
        "name": "Lethal Crackdown",
        "type": "Event",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_029": {
        "id": "TWI_029",
        "face": {
            "front": {
                "name": "Level 1313, Coruscant",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/TWI/029-r.png",
                "isHorizontal": true
            }
        },
        "name": "Level 1313, Coruscant",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": []
    },
    "TWI_518": {
        "id": "TWI_518",
        "face": {
            "front": {
                "name": "Level 1313, Coruscant",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/TWI/518-r.png",
                "isHorizontal": true
            }
        },
        "name": "Level 1313, Coruscant",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": []
    },
    "TWI_149": {
        "id": "TWI_149",
        "face": {
            "front": {
                "name": "Low Altitude Gunship",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/149.png",
                "isHorizontal": false
            }
        },
        "name": "Low Altitude Gunship",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Uncommon",
        "power": 6,
        "HP": 5,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "TWI_416": {
        "id": "TWI_416",
        "face": {
            "front": {
                "name": "Low Altitude Gunship",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/416.png",
                "isHorizontal": false
            }
        },
        "name": "Low Altitude Gunship",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Uncommon",
        "power": 6,
        "HP": 5,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "TWI_050": {
        "id": "TWI_050",
        "face": {
            "front": {
                "name": "Luminara Unduli, Soft-Spoken Master",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/TWI/050.png",
                "isHorizontal": false
            }
        },
        "name": "Luminara Unduli, Soft-Spoken Master",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Rare",
        "power": 4,
        "HP": 9,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_323": {
        "id": "TWI_323",
        "face": {
            "front": {
                "name": "Luminara Unduli, Soft-Spoken Master",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/TWI/323.png",
                "isHorizontal": false
            }
        },
        "name": "Luminara Unduli, Soft-Spoken Master",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Rare",
        "power": 4,
        "HP": 9,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_210": {
        "id": "TWI_210",
        "face": {
            "front": {
                "name": "Lux Bonteri, Renegade Separatist",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/210.png",
                "isHorizontal": false
            }
        },
        "name": "Lux Bonteri, Renegade Separatist",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST"
        ]
    },
    "TWI_475": {
        "id": "TWI_475",
        "face": {
            "front": {
                "name": "Lux Bonteri, Renegade Separatist",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/475.png",
                "isHorizontal": false
            }
        },
        "name": "Lux Bonteri, Renegade Separatist",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST"
        ]
    },
    "TWI_013": {
        "id": "TWI_013",
        "face": {
            "front": {
                "name": "Mace Windu, Vaapad Form Master",
                "type": "Leader",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/TWI/013-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Mace Windu, Vaapad Form Master",
                "type": "Leader",
                "cost": "7",
                "image": "https://cdn.swu-db.com/images/cards/TWI/013-b.png"
            }
        },
        "name": "Mace Windu, Vaapad Form Master",
        "type": "Leader",
        "cost": 7,
        "rarity": "Rare",
        "power": 5,
        "HP": 8,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_270": {
        "id": "TWI_270",
        "face": {
            "front": {
                "name": "Mace Windu, Vaapad Form Master",
                "type": "Leader",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/TWI/270-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Mace Windu, Vaapad Form Master",
                "type": "Leader",
                "cost": "7",
                "image": "https://cdn.swu-db.com/images/cards/TWI/270-b.png"
            }
        },
        "name": "Mace Windu, Vaapad Form Master",
        "type": "Leader",
        "cost": 7,
        "rarity": "Rare",
        "power": 5,
        "HP": 8,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_288": {
        "id": "TWI_288",
        "face": {
            "front": {
                "name": "Mace Windu, Vaapad Form Master",
                "type": "Leader",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/TWI/288-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Mace Windu, Vaapad Form Master",
                "type": "Leader",
                "cost": "7",
                "image": "https://cdn.swu-db.com/images/cards/TWI/288-b.png"
            }
        },
        "name": "Mace Windu, Vaapad Form Master",
        "type": "Leader",
        "cost": 7,
        "rarity": "Rare",
        "power": 5,
        "HP": 8,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_152": {
        "id": "TWI_152",
        "face": {
            "front": {
                "name": "Mace Windu's Lightsaber",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/152.png",
                "isHorizontal": false
            }
        },
        "name": "Mace Windu's Lightsaber",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Rare",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "ITEM",
            "WEAPON",
            "LIGHTSABER"
        ]
    },
    "TWI_419": {
        "id": "TWI_419",
        "face": {
            "front": {
                "name": "Mace Windu's Lightsaber",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/419.png",
                "isHorizontal": false
            }
        },
        "name": "Mace Windu's Lightsaber",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Rare",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "ITEM",
            "WEAPON",
            "LIGHTSABER"
        ]
    },
    "TWI_082": {
        "id": "TWI_082",
        "face": {
            "front": {
                "name": "MagnaGuard Wing Leader",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/082.png",
                "isHorizontal": false
            }
        },
        "name": "MagnaGuard Wing Leader",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_355": {
        "id": "TWI_355",
        "face": {
            "front": {
                "name": "MagnaGuard Wing Leader",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/355.png",
                "isHorizontal": false
            }
        },
        "name": "MagnaGuard Wing Leader",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_039": {
        "id": "TWI_039",
        "face": {
            "front": {
                "name": "Malevolence, Grievous's Secret Weapon",
                "type": "Unit - Space",
                "cost": 9,
                "image": "https://cdn.swu-db.com/images/cards/TWI/039.png",
                "isHorizontal": false
            }
        },
        "name": "Malevolence, Grievous's Secret Weapon",
        "type": "Unit - Space",
        "cost": 9,
        "rarity": "Rare",
        "power": 7,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "TWI_312": {
        "id": "TWI_312",
        "face": {
            "front": {
                "name": "Malevolence, Grievous's Secret Weapon",
                "type": "Unit - Space",
                "cost": 9,
                "image": "https://cdn.swu-db.com/images/cards/TWI/312.png",
                "isHorizontal": false
            }
        },
        "name": "Malevolence, Grievous's Secret Weapon",
        "type": "Unit - Space",
        "cost": 9,
        "rarity": "Rare",
        "power": 7,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "TWI_102": {
        "id": "TWI_102",
        "face": {
            "front": {
                "name": "Manufactured Soldiers",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/102.png",
                "isHorizontal": false
            }
        },
        "name": "Manufactured Soldiers",
        "type": "Event",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Command"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "TWI_373": {
        "id": "TWI_373",
        "face": {
            "front": {
                "name": "Manufactured Soldiers",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/373.png",
                "isHorizontal": false
            }
        },
        "name": "Manufactured Soldiers",
        "type": "Event",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Command"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "TWI_101": {
        "id": "TWI_101",
        "face": {
            "front": {
                "name": "Mas Amedda, Vice Chair",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/101.png",
                "isHorizontal": false
            }
        },
        "name": "Mas Amedda, Vice Chair",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 4,
        "aspects": [
            "Command",
            "Command"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "OFFICIAL"
        ]
    },
    "TWI_372": {
        "id": "TWI_372",
        "face": {
            "front": {
                "name": "Mas Amedda, Vice Chair",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/372.png",
                "isHorizontal": false
            }
        },
        "name": "Mas Amedda, Vice Chair",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 4,
        "aspects": [
            "Command",
            "Command"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "OFFICIAL"
        ]
    },
    "TWI_009": {
        "id": "TWI_009",
        "face": {
            "front": {
                "name": "Maul, A Rival in Darkness",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/009-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Maul, A Rival in Darkness",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/TWI/009-b.png"
            }
        },
        "name": "Maul, A Rival in Darkness",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 6,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "UNDERWORLD"
        ]
    },
    "TWI_266": {
        "id": "TWI_266",
        "face": {
            "front": {
                "name": "Maul, A Rival in Darkness",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/266-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Maul, A Rival in Darkness",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/TWI/266-b.png"
            }
        },
        "name": "Maul, A Rival in Darkness",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 6,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "UNDERWORLD"
        ]
    },
    "TWI_284": {
        "id": "TWI_284",
        "face": {
            "front": {
                "name": "Maul, A Rival in Darkness",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/284-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Maul, A Rival in Darkness",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/TWI/284-b.png"
            }
        },
        "name": "Maul, A Rival in Darkness",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 6,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "UNDERWORLD"
        ]
    },
    "TWI_238": {
        "id": "TWI_238",
        "face": {
            "front": {
                "name": "Merciless Contest",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/238.png",
                "isHorizontal": false
            }
        },
        "name": "Merciless Contest",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_500": {
        "id": "TWI_500",
        "face": {
            "front": {
                "name": "Merciless Contest",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/500.png",
                "isHorizontal": false
            }
        },
        "name": "Merciless Contest",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_154": {
        "id": "TWI_154",
        "face": {
            "front": {
                "name": "Mister Bones, I Performed Violence",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/154.png",
                "isHorizontal": false
            }
        },
        "name": "Mister Bones, I Performed Violence",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Rare",
        "power": 3,
        "HP": 1,
        "aspects": [
            "Aggression",
            "Aggression"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "DROID"
        ]
    },
    "TWI_421": {
        "id": "TWI_421",
        "face": {
            "front": {
                "name": "Mister Bones, I Performed Violence",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/421.png",
                "isHorizontal": false
            }
        },
        "name": "Mister Bones, I Performed Violence",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Rare",
        "power": 3,
        "HP": 1,
        "aspects": [
            "Aggression",
            "Aggression"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "DROID"
        ]
    },
    "TWI_035": {
        "id": "TWI_035",
        "face": {
            "front": {
                "name": "Morgan Elsbeth, Keeper of Many Secrets",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/035.png",
                "isHorizontal": false
            }
        },
        "name": "Morgan Elsbeth, Keeper of Many Secrets",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "TWI_308": {
        "id": "TWI_308",
        "face": {
            "front": {
                "name": "Morgan Elsbeth, Keeper of Many Secrets",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/308.png",
                "isHorizontal": false
            }
        },
        "name": "Morgan Elsbeth, Keeper of Many Secrets",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "TWI_066": {
        "id": "TWI_066",
        "face": {
            "front": {
                "name": "Multi-Troop Transport",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/TWI/066.png",
                "isHorizontal": false
            }
        },
        "name": "Multi-Troop Transport",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Common",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "TANK"
        ]
    },
    "TWI_339": {
        "id": "TWI_339",
        "face": {
            "front": {
                "name": "Multi-Troop Transport",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/TWI/339.png",
                "isHorizontal": false
            }
        },
        "name": "Multi-Troop Transport",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Common",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "TANK"
        ]
    },
    "TWI_001": {
        "id": "TWI_001",
        "face": {
            "front": {
                "name": "Nala Se, Clone Engineer",
                "type": "Leader",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/001-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Nala Se, Clone Engineer",
                "type": "Leader",
                "cost": "4",
                "image": "https://cdn.swu-db.com/images/cards/TWI/001-b.png"
            }
        },
        "name": "Nala Se, Clone Engineer",
        "type": "Leader",
        "cost": 4,
        "rarity": "Rare",
        "power": 1,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "KAMINOAN"
        ]
    },
    "TWI_258": {
        "id": "TWI_258",
        "face": {
            "front": {
                "name": "Nala Se, Clone Engineer",
                "type": "Leader",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/258-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Nala Se, Clone Engineer",
                "type": "Leader",
                "cost": "4",
                "image": "https://cdn.swu-db.com/images/cards/TWI/258-b.png"
            }
        },
        "name": "Nala Se, Clone Engineer",
        "type": "Leader",
        "cost": 4,
        "rarity": "Rare",
        "power": 1,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "KAMINOAN"
        ]
    },
    "TWI_276": {
        "id": "TWI_276",
        "face": {
            "front": {
                "name": "Nala Se, Clone Engineer",
                "type": "Leader",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/276-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Nala Se, Clone Engineer",
                "type": "Leader",
                "cost": "4",
                "image": "https://cdn.swu-db.com/images/cards/TWI/276-b.png"
            }
        },
        "name": "Nala Se, Clone Engineer",
        "type": "Leader",
        "cost": 4,
        "rarity": "Rare",
        "power": 1,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "KAMINOAN"
        ]
    },
    "TWI_119": {
        "id": "TWI_119",
        "face": {
            "front": {
                "name": "Nameless Valor",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/119.png",
                "isHorizontal": false
            }
        },
        "name": "Nameless Valor",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "LEARNED"
        ]
    },
    "TWI_389": {
        "id": "TWI_389",
        "face": {
            "front": {
                "name": "Nameless Valor",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/389.png",
                "isHorizontal": false
            }
        },
        "name": "Nameless Valor",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "LEARNED"
        ]
    },
    "TWI_225": {
        "id": "TWI_225",
        "face": {
            "front": {
                "name": "Now There Are Two of Them",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/225.png",
                "isHorizontal": false
            }
        },
        "name": "Now There Are Two of Them",
        "type": "Event",
        "cost": 3,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "TWI_490": {
        "id": "TWI_490",
        "face": {
            "front": {
                "name": "Now There Are Two of Them",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/490.png",
                "isHorizontal": false
            }
        },
        "name": "Now There Are Two of Them",
        "type": "Event",
        "cost": 3,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "TWI_002": {
        "id": "TWI_002",
        "face": {
            "front": {
                "name": "Nute Gunray, Vindictive Viceroy",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/002-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Nute Gunray, Vindictive Viceroy",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/TWI/002-b.png"
            }
        },
        "name": "Nute Gunray, Vindictive Viceroy",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 2,
        "HP": 8,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "OFFICIAL"
        ]
    },
    "TWI_259": {
        "id": "TWI_259",
        "face": {
            "front": {
                "name": "Nute Gunray, Vindictive Viceroy",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/259-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Nute Gunray, Vindictive Viceroy",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/TWI/259-b.png"
            }
        },
        "name": "Nute Gunray, Vindictive Viceroy",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 2,
        "HP": 8,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "OFFICIAL"
        ]
    },
    "TWI_277": {
        "id": "TWI_277",
        "face": {
            "front": {
                "name": "Nute Gunray, Vindictive Viceroy",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/277-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Nute Gunray, Vindictive Viceroy",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/TWI/277-b.png"
            }
        },
        "name": "Nute Gunray, Vindictive Viceroy",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 2,
        "HP": 8,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "OFFICIAL"
        ]
    },
    "TWI_131": {
        "id": "TWI_131",
        "face": {
            "front": {
                "name": "OOM-Series Officer",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/131.png",
                "isHorizontal": false
            }
        },
        "name": "OOM-Series Officer",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID"
        ]
    },
    "TWI_399": {
        "id": "TWI_399",
        "face": {
            "front": {
                "name": "OOM-Series Officer",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/399.png",
                "isHorizontal": false
            }
        },
        "name": "OOM-Series Officer",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID"
        ]
    },
    "TWI_104": {
        "id": "TWI_104",
        "face": {
            "front": {
                "name": "Obedient Vanguard",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/104.png",
                "isHorizontal": false
            }
        },
        "name": "Obedient Vanguard",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "TROOPER"
        ]
    },
    "TWI_375": {
        "id": "TWI_375",
        "face": {
            "front": {
                "name": "Obedient Vanguard",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/375.png",
                "isHorizontal": false
            }
        },
        "name": "Obedient Vanguard",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "TROOPER"
        ]
    },
    "TWI_003": {
        "id": "TWI_003",
        "face": {
            "front": {
                "name": "Obi-Wan Kenobi, Patient Mentor",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/003-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Obi-Wan Kenobi, Patient Mentor",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/TWI/003-b.png"
            }
        },
        "name": "Obi-Wan Kenobi, Patient Mentor",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_260": {
        "id": "TWI_260",
        "face": {
            "front": {
                "name": "Obi-Wan Kenobi, Patient Mentor",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/260-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Obi-Wan Kenobi, Patient Mentor",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/TWI/260-b.png"
            }
        },
        "name": "Obi-Wan Kenobi, Patient Mentor",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_278": {
        "id": "TWI_278",
        "face": {
            "front": {
                "name": "Obi-Wan Kenobi, Patient Mentor",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/278-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Obi-Wan Kenobi, Patient Mentor",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/TWI/278-b.png"
            }
        },
        "name": "Obi-Wan Kenobi, Patient Mentor",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_048": {
        "id": "TWI_048",
        "face": {
            "front": {
                "name": "Obi-Wan's Aethersprite, This is Why I Hate Flying",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/048.png",
                "isHorizontal": false
            }
        },
        "name": "Obi-Wan's Aethersprite, This is Why I Hate Flying",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "JEDI",
            "REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_321": {
        "id": "TWI_321",
        "face": {
            "front": {
                "name": "Obi-Wan's Aethersprite, This is Why I Hate Flying",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/321.png",
                "isHorizontal": false
            }
        },
        "name": "Obi-Wan's Aethersprite, This is Why I Hate Flying",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "JEDI",
            "REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_168": {
        "id": "TWI_168",
        "face": {
            "front": {
                "name": "Old Access Codes",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/168.png",
                "isHorizontal": false
            }
        },
        "name": "Old Access Codes",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "ITEM"
        ]
    },
    "TWI_435": {
        "id": "TWI_435",
        "face": {
            "front": {
                "name": "Old Access Codes",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/435.png",
                "isHorizontal": false
            }
        },
        "name": "Old Access Codes",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "ITEM"
        ]
    },
    "TWI_219": {
        "id": "TWI_219",
        "face": {
            "front": {
                "name": "On Top of Things",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/219.png",
                "isHorizontal": false
            }
        },
        "name": "On Top of Things",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "TWI_484": {
        "id": "TWI_484",
        "face": {
            "front": {
                "name": "On Top of Things",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/484.png",
                "isHorizontal": false
            }
        },
        "name": "On Top of Things",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "TWI_190": {
        "id": "TWI_190",
        "face": {
            "front": {
                "name": "On the Doorstep",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/190.png",
                "isHorizontal": false
            }
        },
        "name": "On the Doorstep",
        "type": "Event",
        "cost": 4,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "TWI_455": {
        "id": "TWI_455",
        "face": {
            "front": {
                "name": "On the Doorstep",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/455.png",
                "isHorizontal": false
            }
        },
        "name": "On the Doorstep",
        "type": "Event",
        "cost": 4,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "TWI_174": {
        "id": "TWI_174",
        "face": {
            "front": {
                "name": "Open Fire",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/174.png",
                "isHorizontal": false
            }
        },
        "name": "Open Fire",
        "type": "Event",
        "cost": 3,
        "rarity": "Special",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_115": {
        "id": "TWI_115",
        "face": {
            "front": {
                "name": "Osi Sobeck, Warden of the Citadel",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/115.png",
                "isHorizontal": false
            }
        },
        "name": "Osi Sobeck, Warden of the Citadel",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Command"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST"
        ]
    },
    "TWI_385": {
        "id": "TWI_385",
        "face": {
            "front": {
                "name": "Osi Sobeck, Warden of the Citadel",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/385.png",
                "isHorizontal": false
            }
        },
        "name": "Osi Sobeck, Warden of the Citadel",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Command"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST"
        ]
    },
    "TWI_123": {
        "id": "TWI_123",
        "face": {
            "front": {
                "name": "Outflank",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/123.png",
                "isHorizontal": false
            }
        },
        "name": "Outflank",
        "type": "Event",
        "cost": 1,
        "rarity": "Special",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_043": {
        "id": "TWI_043",
        "face": {
            "front": {
                "name": "Outspoken Representative",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/043.png",
                "isHorizontal": false
            }
        },
        "name": "Outspoken Representative",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "OFFICIAL"
        ]
    },
    "TWI_316": {
        "id": "TWI_316",
        "face": {
            "front": {
                "name": "Outspoken Representative",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/316.png",
                "isHorizontal": false
            }
        },
        "name": "Outspoken Representative",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "OFFICIAL"
        ]
    },
    "TWI_058": {
        "id": "TWI_058",
        "face": {
            "front": {
                "name": "Padawan Starfighter",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/058.png",
                "isHorizontal": false
            }
        },
        "name": "Padawan Starfighter",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "JEDI",
            "REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_331": {
        "id": "TWI_331",
        "face": {
            "front": {
                "name": "Padawan Starfighter",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/331.png",
                "isHorizontal": false
            }
        },
        "name": "Padawan Starfighter",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "JEDI",
            "REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_008": {
        "id": "TWI_008",
        "face": {
            "front": {
                "name": "Padmé Amidala, Serving the Republic",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/008-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Padmé Amidala, Serving the Republic",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/TWI/008-b.png"
            }
        },
        "name": "Padmé Amidala, Serving the Republic",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 2,
        "HP": 7,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "NABOO",
            "REPUBLIC",
            "OFFICIAL"
        ]
    },
    "TWI_192": {
        "id": "TWI_192",
        "face": {
            "front": {
                "name": "Padmé Amidala, Pursuing Peace",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/192.png",
                "isHorizontal": false
            }
        },
        "name": "Padmé Amidala, Pursuing Peace",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "NABOO",
            "REPUBLIC",
            "OFFICIAL"
        ]
    },
    "TWI_265": {
        "id": "TWI_265",
        "face": {
            "front": {
                "name": "Padmé Amidala, Serving the Republic",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/265-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Padmé Amidala, Serving the Republic",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/TWI/265-b.png"
            }
        },
        "name": "Padmé Amidala, Serving the Republic",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 2,
        "HP": 7,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "NABOO",
            "REPUBLIC",
            "OFFICIAL"
        ]
    },
    "TWI_283": {
        "id": "TWI_283",
        "face": {
            "front": {
                "name": "Padmé Amidala, Serving the Republic",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/283-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Padmé Amidala, Serving the Republic",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/TWI/283-b.png"
            }
        },
        "name": "Padmé Amidala, Serving the Republic",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 2,
        "HP": 7,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "NABOO",
            "REPUBLIC",
            "OFFICIAL"
        ]
    },
    "TWI_457": {
        "id": "TWI_457",
        "face": {
            "front": {
                "name": "Padmé Amidala, Pursuing Peace",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/457.png",
                "isHorizontal": false
            }
        },
        "name": "Padmé Amidala, Pursuing Peace",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "NABOO",
            "REPUBLIC",
            "OFFICIAL"
        ]
    },
    "TWI_232": {
        "id": "TWI_232",
        "face": {
            "front": {
                "name": "Patrolling AAT",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/232.png",
                "isHorizontal": false
            }
        },
        "name": "Patrolling AAT",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "TANK"
        ]
    },
    "TWI_495": {
        "id": "TWI_495",
        "face": {
            "front": {
                "name": "Patrolling AAT",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/495.png",
                "isHorizontal": false
            }
        },
        "name": "Patrolling AAT",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "TANK"
        ]
    },
    "TWI_107": {
        "id": "TWI_107",
        "face": {
            "front": {
                "name": "Patrolling V-Wing",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/107.png",
                "isHorizontal": false
            }
        },
        "name": "Patrolling V-Wing",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Special",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_019": {
        "id": "TWI_019",
        "face": {
            "front": {
                "name": "Pau City, Utapau",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/TWI/019-r.png",
                "isHorizontal": true
            }
        },
        "name": "Pau City, Utapau",
        "type": "Base",
        "cost": 0,
        "rarity": "Rare",
        "power": 0,
        "HP": 26,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": []
    },
    "TWI_294": {
        "id": "TWI_294",
        "face": {
            "front": {
                "name": "Pau City, Utapau",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/TWI/294-r.png",
                "isHorizontal": true
            }
        },
        "name": "Pau City, Utapau",
        "type": "Base",
        "cost": 0,
        "rarity": "Rare",
        "power": 0,
        "HP": 26,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": []
    },
    "TWI_095": {
        "id": "TWI_095",
        "face": {
            "front": {
                "name": "Pelta Supply Frigate",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/095.png",
                "isHorizontal": false
            }
        },
        "name": "Pelta Supply Frigate",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "TWI_367": {
        "id": "TWI_367",
        "face": {
            "front": {
                "name": "Pelta Supply Frigate",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/367.png",
                "isHorizontal": false
            }
        },
        "name": "Pelta Supply Frigate",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "TWI_070": {
        "id": "TWI_070",
        "face": {
            "front": {
                "name": "Perilous Position",
                "type": "Upgrade",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/070.png",
                "isHorizontal": false
            }
        },
        "name": "Perilous Position",
        "type": "Upgrade",
        "cost": 3,
        "rarity": "Common",
        "power": -2,
        "HP": -2,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "CONDITION"
        ]
    },
    "TWI_343": {
        "id": "TWI_343",
        "face": {
            "front": {
                "name": "Perilous Position",
                "type": "Upgrade",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/343.png",
                "isHorizontal": false
            }
        },
        "name": "Perilous Position",
        "type": "Upgrade",
        "cost": 3,
        "rarity": "Common",
        "power": -2,
        "HP": -2,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "CONDITION"
        ]
    },
    "TWI_100": {
        "id": "TWI_100",
        "face": {
            "front": {
                "name": "Petition the Senate",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/100.png",
                "isHorizontal": false
            }
        },
        "name": "Petition the Senate",
        "type": "Event",
        "cost": 3,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_371": {
        "id": "TWI_371",
        "face": {
            "front": {
                "name": "Petition the Senate",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/371.png",
                "isHorizontal": false
            }
        },
        "name": "Petition the Senate",
        "type": "Event",
        "cost": 3,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_028": {
        "id": "TWI_028",
        "face": {
            "front": {
                "name": "Petranaki Arena, Geonosis",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/TWI/028-r.png",
                "isHorizontal": true
            }
        },
        "name": "Petranaki Arena, Geonosis",
        "type": "Base",
        "cost": 0,
        "rarity": "Rare",
        "power": 0,
        "HP": 26,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": []
    },
    "TWI_303": {
        "id": "TWI_303",
        "face": {
            "front": {
                "name": "Petranaki Arena, Geonosis",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/TWI/303-r.png",
                "isHorizontal": true
            }
        },
        "name": "Petranaki Arena, Geonosis",
        "type": "Base",
        "cost": 0,
        "rarity": "Rare",
        "power": 0,
        "HP": 26,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": []
    },
    "TWI_241": {
        "id": "TWI_241",
        "face": {
            "front": {
                "name": "Phase I Clone Trooper",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/241.png",
                "isHorizontal": false
            }
        },
        "name": "Phase I Clone Trooper",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_502": {
        "id": "TWI_502",
        "face": {
            "front": {
                "name": "Phase I Clone Trooper",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/502.png",
                "isHorizontal": false
            }
        },
        "name": "Phase I Clone Trooper",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_242": {
        "id": "TWI_242",
        "face": {
            "front": {
                "name": "Phase II Clone Trooper",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/242.png",
                "isHorizontal": false
            }
        },
        "name": "Phase II Clone Trooper",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_503": {
        "id": "TWI_503",
        "face": {
            "front": {
                "name": "Phase II Clone Trooper",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/503.png",
                "isHorizontal": false
            }
        },
        "name": "Phase II Clone Trooper",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_178": {
        "id": "TWI_178",
        "face": {
            "front": {
                "name": "Planetary Invasion",
                "type": "Event",
                "cost": 12,
                "image": "https://cdn.swu-db.com/images/cards/TWI/178.png",
                "isHorizontal": false
            }
        },
        "name": "Planetary Invasion",
        "type": "Event",
        "cost": 12,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "PLAN"
        ]
    },
    "TWI_444": {
        "id": "TWI_444",
        "face": {
            "front": {
                "name": "Planetary Invasion",
                "type": "Event",
                "cost": 12,
                "image": "https://cdn.swu-db.com/images/cards/TWI/444.png",
                "isHorizontal": false
            }
        },
        "name": "Planetary Invasion",
        "type": "Event",
        "cost": 12,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "PLAN"
        ]
    },
    "TWI_196": {
        "id": "TWI_196",
        "face": {
            "front": {
                "name": "Plo Koon, Koh-to-yah!",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/196.png",
                "isHorizontal": false
            }
        },
        "name": "Plo Koon, Koh-to-yah!",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_461": {
        "id": "TWI_461",
        "face": {
            "front": {
                "name": "Plo Koon, Koh-to-yah!",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/461.png",
                "isHorizontal": false
            }
        },
        "name": "Plo Koon, Koh-to-yah!",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_080": {
        "id": "TWI_080",
        "face": {
            "front": {
                "name": "Poggle the Lesser, Archduke of the Stalgasin Hive",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/080.png",
                "isHorizontal": false
            }
        },
        "name": "Poggle the Lesser, Archduke of the Stalgasin Hive",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "OFFICIAL"
        ]
    },
    "TWI_353": {
        "id": "TWI_353",
        "face": {
            "front": {
                "name": "Poggle the Lesser, Archduke of the Stalgasin Hive",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/353.png",
                "isHorizontal": false
            }
        },
        "name": "Poggle the Lesser, Archduke of the Stalgasin Hive",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "OFFICIAL"
        ]
    },
    "TWI_222": {
        "id": "TWI_222",
        "face": {
            "front": {
                "name": "Political Pressure",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/222.png",
                "isHorizontal": false
            }
        },
        "name": "Political Pressure",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "TWI_487": {
        "id": "TWI_487",
        "face": {
            "front": {
                "name": "Political Pressure",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/487.png",
                "isHorizontal": false
            }
        },
        "name": "Political Pressure",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "TWI_010": {
        "id": "TWI_010",
        "face": {
            "front": {
                "name": "Pre Vizsla, Pursuing the Throne",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/010-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Pre Vizsla, Pursuing the Throne",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/TWI/010-b.png"
            }
        },
        "name": "Pre Vizsla, Pursuing the Throne",
        "type": "Leader",
        "cost": 5,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "TROOPER"
        ]
    },
    "TWI_267": {
        "id": "TWI_267",
        "face": {
            "front": {
                "name": "Pre Vizsla, Pursuing the Throne",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/267-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Pre Vizsla, Pursuing the Throne",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/TWI/267-b.png"
            }
        },
        "name": "Pre Vizsla, Pursuing the Throne",
        "type": "Leader",
        "cost": 5,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "TROOPER"
        ]
    },
    "TWI_285": {
        "id": "TWI_285",
        "face": {
            "front": {
                "name": "Pre Vizsla, Pursuing the Throne",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/285-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Pre Vizsla, Pursuing the Throne",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/TWI/285-b.png"
            }
        },
        "name": "Pre Vizsla, Pursuing the Throne",
        "type": "Leader",
        "cost": 5,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "TROOPER"
        ]
    },
    "TWI_227": {
        "id": "TWI_227",
        "face": {
            "front": {
                "name": "Prisoner of War",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/227.png",
                "isHorizontal": false
            }
        },
        "name": "Prisoner of War",
        "type": "Event",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_491": {
        "id": "TWI_491",
        "face": {
            "front": {
                "name": "Prisoner of War",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/491.png",
                "isHorizontal": false
            }
        },
        "name": "Prisoner of War",
        "type": "Event",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_257": {
        "id": "TWI_257",
        "face": {
            "front": {
                "name": "Private Manufacturing",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/257.png",
                "isHorizontal": false
            }
        },
        "name": "Private Manufacturing",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "TWI_517": {
        "id": "TWI_517",
        "face": {
            "front": {
                "name": "Private Manufacturing",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/517.png",
                "isHorizontal": false
            }
        },
        "name": "Private Manufacturing",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "TWI_038": {
        "id": "TWI_038",
        "face": {
            "front": {
                "name": "Providence Destroyer",
                "type": "Unit - Space",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/TWI/038.png",
                "isHorizontal": false
            }
        },
        "name": "Providence Destroyer",
        "type": "Unit - Space",
        "cost": 8,
        "rarity": "Uncommon",
        "power": 5,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "TWI_311": {
        "id": "TWI_311",
        "face": {
            "front": {
                "name": "Providence Destroyer",
                "type": "Unit - Space",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/TWI/311.png",
                "isHorizontal": false
            }
        },
        "name": "Providence Destroyer",
        "type": "Unit - Space",
        "cost": 8,
        "rarity": "Uncommon",
        "power": 5,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "TWI_030": {
        "id": "TWI_030",
        "face": {
            "front": {
                "name": "Pyke Palace, Oba Diah",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/TWI/030-r.png",
                "isHorizontal": true
            }
        },
        "name": "Pyke Palace, Oba Diah",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": []
    },
    "TWI_519": {
        "id": "TWI_519",
        "face": {
            "front": {
                "name": "Pyke Palace, Oba Diah",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/TWI/519-r.png",
                "isHorizontal": true
            }
        },
        "name": "Pyke Palace, Oba Diah",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": []
    },
    "TWI_103": {
        "id": "TWI_103",
        "face": {
            "front": {
                "name": "Pyrrhic Assault",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/103.png",
                "isHorizontal": false
            }
        },
        "name": "Pyrrhic Assault",
        "type": "Event",
        "cost": 3,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Command"
        ],
        "unique": false,
        "traits": [
            "DISASTER"
        ]
    },
    "TWI_374": {
        "id": "TWI_374",
        "face": {
            "front": {
                "name": "Pyrrhic Assault",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/374.png",
                "isHorizontal": false
            }
        },
        "name": "Pyrrhic Assault",
        "type": "Event",
        "cost": 3,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Command"
        ],
        "unique": false,
        "traits": [
            "DISASTER"
        ]
    },
    "TWI_018": {
        "id": "TWI_018",
        "face": {
            "front": {
                "name": "Quinlan Vos, Sticking the Landing",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/018-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Quinlan Vos, Sticking the Landing",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/TWI/018-b.png"
            }
        },
        "name": "Quinlan Vos, Sticking the Landing",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 7,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_275": {
        "id": "TWI_275",
        "face": {
            "front": {
                "name": "Quinlan Vos, Sticking the Landing",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/275-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Quinlan Vos, Sticking the Landing",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/TWI/275-b.png"
            }
        },
        "name": "Quinlan Vos, Sticking the Landing",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 7,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_293": {
        "id": "TWI_293",
        "face": {
            "front": {
                "name": "Quinlan Vos, Sticking the Landing",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/293-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Quinlan Vos, Sticking the Landing",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/TWI/293-b.png"
            }
        },
        "name": "Quinlan Vos, Sticking the Landing",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 7,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_193": {
        "id": "TWI_193",
        "face": {
            "front": {
                "name": "R2-D2, Full of Solutions",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/193.png",
                "isHorizontal": false
            }
        },
        "name": "R2-D2, Full of Solutions",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "DROID"
        ]
    },
    "TWI_458": {
        "id": "TWI_458",
        "face": {
            "front": {
                "name": "R2-D2, Full of Solutions",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/458.png",
                "isHorizontal": false
            }
        },
        "name": "R2-D2, Full of Solutions",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "DROID"
        ]
    },
    "TWI_162": {
        "id": "TWI_162",
        "face": {
            "front": {
                "name": "Reckless Torrent",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/162.png",
                "isHorizontal": false
            }
        },
        "name": "Reckless Torrent",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 1,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_429": {
        "id": "TWI_429",
        "face": {
            "front": {
                "name": "Reckless Torrent",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/429.png",
                "isHorizontal": false
            }
        },
        "name": "Reckless Torrent",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 1,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_163": {
        "id": "TWI_163",
        "face": {
            "front": {
                "name": "Relentless Rocket Droid",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/163.png",
                "isHorizontal": false
            }
        },
        "name": "Relentless Rocket Droid",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "TROOPER"
        ]
    },
    "TWI_430": {
        "id": "TWI_430",
        "face": {
            "front": {
                "name": "Relentless Rocket Droid",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/430.png",
                "isHorizontal": false
            }
        },
        "name": "Relentless Rocket Droid",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "TROOPER"
        ]
    },
    "TWI_088": {
        "id": "TWI_088",
        "face": {
            "front": {
                "name": "Reprocess",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/088.png",
                "isHorizontal": false
            }
        },
        "name": "Reprocess",
        "type": "Event",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "TWI_360": {
        "id": "TWI_360",
        "face": {
            "front": {
                "name": "Reprocess",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/360.png",
                "isHorizontal": false
            }
        },
        "name": "Reprocess",
        "type": "Event",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "TWI_111": {
        "id": "TWI_111",
        "face": {
            "front": {
                "name": "Republic ARC-170",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/111.png",
                "isHorizontal": false
            }
        },
        "name": "Republic ARC-170",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_381": {
        "id": "TWI_381",
        "face": {
            "front": {
                "name": "Republic ARC-170",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/381.png",
                "isHorizontal": false
            }
        },
        "name": "Republic ARC-170",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_197": {
        "id": "TWI_197",
        "face": {
            "front": {
                "name": "Republic Attack Pod",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/197.png",
                "isHorizontal": false
            }
        },
        "name": "Republic Attack Pod",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 6,
        "HP": 7,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "WALKER"
        ]
    },
    "TWI_462": {
        "id": "TWI_462",
        "face": {
            "front": {
                "name": "Republic Attack Pod",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/462.png",
                "isHorizontal": false
            }
        },
        "name": "Republic Attack Pod",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 6,
        "HP": 7,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "WALKER"
        ]
    },
    "TWI_243": {
        "id": "TWI_243",
        "face": {
            "front": {
                "name": "Republic Commando",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/243.png",
                "isHorizontal": false
            }
        },
        "name": "Republic Commando",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_504": {
        "id": "TWI_504",
        "face": {
            "front": {
                "name": "Republic Commando",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/504.png",
                "isHorizontal": false
            }
        },
        "name": "Republic Commando",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_098": {
        "id": "TWI_098",
        "face": {
            "front": {
                "name": "Republic Defense Carrier",
                "type": "Unit - Space",
                "cost": 11,
                "image": "https://cdn.swu-db.com/images/cards/TWI/098.png",
                "isHorizontal": false
            }
        },
        "name": "Republic Defense Carrier",
        "type": "Unit - Space",
        "cost": 11,
        "rarity": "Uncommon",
        "power": 6,
        "HP": 7,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "TWI_369": {
        "id": "TWI_369",
        "face": {
            "front": {
                "name": "Republic Defense Carrier",
                "type": "Unit - Space",
                "cost": 11,
                "image": "https://cdn.swu-db.com/images/cards/TWI/369.png",
                "isHorizontal": false
            }
        },
        "name": "Republic Defense Carrier",
        "type": "Unit - Space",
        "cost": 11,
        "rarity": "Uncommon",
        "power": 6,
        "HP": 7,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "TWI_091": {
        "id": "TWI_091",
        "face": {
            "front": {
                "name": "Republic Tactical Officer",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/091.png",
                "isHorizontal": false
            }
        },
        "name": "Republic Tactical Officer",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE"
        ]
    },
    "TWI_363": {
        "id": "TWI_363",
        "face": {
            "front": {
                "name": "Republic Tactical Officer",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/363.png",
                "isHorizontal": false
            }
        },
        "name": "Republic Tactical Officer",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE"
        ]
    },
    "TWI_151": {
        "id": "TWI_151",
        "face": {
            "front": {
                "name": "Resolute, Under Anakin's Command",
                "type": "Unit - Space",
                "cost": 10,
                "image": "https://cdn.swu-db.com/images/cards/TWI/151.png",
                "isHorizontal": false
            }
        },
        "name": "Resolute, Under Anakin's Command",
        "type": "Unit - Space",
        "cost": 10,
        "rarity": "Legendary",
        "power": 8,
        "HP": 8,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "TWI_418": {
        "id": "TWI_418",
        "face": {
            "front": {
                "name": "Resolute, Under Anakin's Command",
                "type": "Unit - Space",
                "cost": 10,
                "image": "https://cdn.swu-db.com/images/cards/TWI/418.png",
                "isHorizontal": false
            }
        },
        "name": "Resolute, Under Anakin's Command",
        "type": "Unit - Space",
        "cost": 10,
        "rarity": "Legendary",
        "power": 8,
        "HP": 8,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "TWI_127": {
        "id": "TWI_127",
        "face": {
            "front": {
                "name": "Resupply",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/127.png",
                "isHorizontal": false
            }
        },
        "name": "Resupply",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "TWI_395": {
        "id": "TWI_395",
        "face": {
            "front": {
                "name": "Resupply",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/395.png",
                "isHorizontal": false
            }
        },
        "name": "Resupply",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "TWI_069": {
        "id": "TWI_069",
        "face": {
            "front": {
                "name": "Roger Roger",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/069.png",
                "isHorizontal": false
            }
        },
        "name": "Roger Roger",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Rare",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "LEARNED"
        ]
    },
    "TWI_342": {
        "id": "TWI_342",
        "face": {
            "front": {
                "name": "Roger Roger",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/342.png",
                "isHorizontal": false
            }
        },
        "name": "Roger Roger",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Rare",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "LEARNED"
        ]
    },
    "TWI_059": {
        "id": "TWI_059",
        "face": {
            "front": {
                "name": "Royal Guard Attaché",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/059.png",
                "isHorizontal": false
            }
        },
        "name": "Royal Guard Attaché",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "NABOO",
            "TROOPER"
        ]
    },
    "TWI_332": {
        "id": "TWI_332",
        "face": {
            "front": {
                "name": "Royal Guard Attaché",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/332.png",
                "isHorizontal": false
            }
        },
        "name": "Royal Guard Attaché",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "NABOO",
            "TROOPER"
        ]
    },
    "TWI_031": {
        "id": "TWI_031",
        "face": {
            "front": {
                "name": "Rune Haako, Scheming Second",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/031.png",
                "isHorizontal": false
            }
        },
        "name": "Rune Haako, Scheming Second",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "OFFICIAL"
        ]
    },
    "TWI_304": {
        "id": "TWI_304",
        "face": {
            "front": {
                "name": "Rune Haako, Scheming Second",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/304.png",
                "isHorizontal": false
            }
        },
        "name": "Rune Haako, Scheming Second",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "OFFICIAL"
        ]
    },
    "TWI_183": {
        "id": "TWI_183",
        "face": {
            "front": {
                "name": "Rush Clovis, Banking Clan Scion",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/183.png",
                "isHorizontal": false
            }
        },
        "name": "Rush Clovis, Banking Clan Scion",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "OFFICIAL"
        ]
    },
    "TWI_448": {
        "id": "TWI_448",
        "face": {
            "front": {
                "name": "Rush Clovis, Banking Clan Scion",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/448.png",
                "isHorizontal": false
            }
        },
        "name": "Rush Clovis, Banking Clan Scion",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "OFFICIAL"
        ]
    },
    "TWI_108": {
        "id": "TWI_108",
        "face": {
            "front": {
                "name": "Ryloth Militia",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/108.png",
                "isHorizontal": false
            }
        },
        "name": "Ryloth Militia",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TWI'LEK",
            "TROOPER"
        ]
    },
    "TWI_378": {
        "id": "TWI_378",
        "face": {
            "front": {
                "name": "Ryloth Militia",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/378.png",
                "isHorizontal": false
            }
        },
        "name": "Ryloth Militia",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TWI'LEK",
            "TROOPER"
        ]
    },
    "TWI_195": {
        "id": "TWI_195",
        "face": {
            "front": {
                "name": "Sabine Wren, You Can Count On Me",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/195.png",
                "isHorizontal": false
            }
        },
        "name": "Sabine Wren, You Can Count On Me",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "MANDALORIAN",
            "SPECTRE"
        ]
    },
    "TWI_460": {
        "id": "TWI_460",
        "face": {
            "front": {
                "name": "Sabine Wren, You Can Count On Me",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/460.png",
                "isHorizontal": false
            }
        },
        "name": "Sabine Wren, You Can Count On Me",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "MANDALORIAN",
            "SPECTRE"
        ]
    },
    "TWI_186": {
        "id": "TWI_186",
        "face": {
            "front": {
                "name": "San Hill, Chairman of the Banking Clan",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/186.png",
                "isHorizontal": false
            }
        },
        "name": "San Hill, Chairman of the Banking Clan",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Rare",
        "power": 3,
        "HP": 7,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "OFFICIAL"
        ]
    },
    "TWI_451": {
        "id": "TWI_451",
        "face": {
            "front": {
                "name": "San Hill, Chairman of the Banking Clan",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/451.png",
                "isHorizontal": false
            }
        },
        "name": "San Hill, Chairman of the Banking Clan",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Rare",
        "power": 3,
        "HP": 7,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "OFFICIAL"
        ]
    },
    "TWI_213": {
        "id": "TWI_213",
        "face": {
            "front": {
                "name": "Sanctioner's Shuttle",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/213.png",
                "isHorizontal": false
            }
        },
        "name": "Sanctioner's Shuttle",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "TWI_478": {
        "id": "TWI_478",
        "face": {
            "front": {
                "name": "Sanctioner's Shuttle",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/478.png",
                "isHorizontal": false
            }
        },
        "name": "Sanctioner's Shuttle",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "TWI_047": {
        "id": "TWI_047",
        "face": {
            "front": {
                "name": "Satine Kryze, Committed to Peace",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/047.png",
                "isHorizontal": false
            }
        },
        "name": "Satine Kryze, Committed to Peace",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Legendary",
        "power": 0,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "OFFICIAL"
        ]
    },
    "TWI_320": {
        "id": "TWI_320",
        "face": {
            "front": {
                "name": "Satine Kryze, Committed to Peace",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/320.png",
                "isHorizontal": false
            }
        },
        "name": "Satine Kryze, Committed to Peace",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Legendary",
        "power": 0,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "OFFICIAL"
        ]
    },
    "TWI_137": {
        "id": "TWI_137",
        "face": {
            "front": {
                "name": "Savage Opress, Monster",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/TWI/137.png",
                "isHorizontal": false
            }
        },
        "name": "Savage Opress, Monster",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Uncommon",
        "power": 7,
        "HP": 7,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "NIGHT",
            "UNDERWORLD"
        ]
    },
    "TWI_405": {
        "id": "TWI_405",
        "face": {
            "front": {
                "name": "Savage Opress, Monster",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/TWI/405.png",
                "isHorizontal": false
            }
        },
        "name": "Savage Opress, Monster",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Uncommon",
        "power": 7,
        "HP": 7,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "NIGHT",
            "UNDERWORLD"
        ]
    },
    "TWI_150": {
        "id": "TWI_150",
        "face": {
            "front": {
                "name": "Saw Gerrera, Resistance is Not Terrorism",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/150.png",
                "isHorizontal": false
            }
        },
        "name": "Saw Gerrera, Resistance is Not Terrorism",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Rare",
        "power": 4,
        "HP": 8,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "TROOPER"
        ]
    },
    "TWI_417": {
        "id": "TWI_417",
        "face": {
            "front": {
                "name": "Saw Gerrera, Resistance is Not Terrorism",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/417.png",
                "isHorizontal": false
            }
        },
        "name": "Saw Gerrera, Resistance is Not Terrorism",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Rare",
        "power": 4,
        "HP": 8,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "TROOPER"
        ]
    },
    "TWI_140": {
        "id": "TWI_140",
        "face": {
            "front": {
                "name": "Self-Destruct",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/140.png",
                "isHorizontal": false
            }
        },
        "name": "Self-Destruct",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_408": {
        "id": "TWI_408",
        "face": {
            "front": {
                "name": "Self-Destruct",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/408.png",
                "isHorizontal": false
            }
        },
        "name": "Self-Destruct",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_148": {
        "id": "TWI_148",
        "face": {
            "front": {
                "name": "Senatorial Corvette",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/148.png",
                "isHorizontal": false
            }
        },
        "name": "Senatorial Corvette",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "TWI_415": {
        "id": "TWI_415",
        "face": {
            "front": {
                "name": "Senatorial Corvette",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/415.png",
                "isHorizontal": false
            }
        },
        "name": "Senatorial Corvette",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "TWI_180": {
        "id": "TWI_180",
        "face": {
            "front": {
                "name": "Separatist Commando",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/180.png",
                "isHorizontal": false
            }
        },
        "name": "Separatist Commando",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Special",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "TROOPER"
        ]
    },
    "TWI_087": {
        "id": "TWI_087",
        "face": {
            "front": {
                "name": "Separatist Super Tank",
                "type": "Unit - Ground",
                "cost": 9,
                "image": "https://cdn.swu-db.com/images/cards/TWI/087.png",
                "isHorizontal": false
            }
        },
        "name": "Separatist Super Tank",
        "type": "Unit - Ground",
        "cost": 9,
        "rarity": "Common",
        "power": 8,
        "HP": 8,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "TANK"
        ]
    },
    "TWI_359": {
        "id": "TWI_359",
        "face": {
            "front": {
                "name": "Separatist Super Tank",
                "type": "Unit - Ground",
                "cost": 9,
                "image": "https://cdn.swu-db.com/images/cards/TWI/359.png",
                "isHorizontal": false
            }
        },
        "name": "Separatist Super Tank",
        "type": "Unit - Ground",
        "cost": 9,
        "rarity": "Common",
        "power": 8,
        "HP": 8,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "TANK"
        ]
    },
    "TWI_094": {
        "id": "TWI_094",
        "face": {
            "front": {
                "name": "Shaak Ti, Unity Wins Wars",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/094.png",
                "isHorizontal": false
            }
        },
        "name": "Shaak Ti, Unity Wins Wars",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_366": {
        "id": "TWI_366",
        "face": {
            "front": {
                "name": "Shaak Ti, Unity Wins Wars",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/366.png",
                "isHorizontal": false
            }
        },
        "name": "Shaak Ti, Unity Wins Wars",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_025": {
        "id": "TWI_025",
        "face": {
            "front": {
                "name": "Shadow Collective Camp, Zanbar",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/TWI/025-r.png",
                "isHorizontal": true
            }
        },
        "name": "Shadow Collective Camp, Zanbar",
        "type": "Base",
        "cost": 0,
        "rarity": "Rare",
        "power": 0,
        "HP": 25,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": []
    },
    "TWI_300": {
        "id": "TWI_300",
        "face": {
            "front": {
                "name": "Shadow Collective Camp, Zanbar",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/TWI/300-r.png",
                "isHorizontal": true
            }
        },
        "name": "Shadow Collective Camp, Zanbar",
        "type": "Base",
        "cost": 0,
        "rarity": "Rare",
        "power": 0,
        "HP": 25,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": []
    },
    "TWI_220": {
        "id": "TWI_220",
        "face": {
            "front": {
                "name": "Shadowed Intentions",
                "type": "Upgrade",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/220.png",
                "isHorizontal": false
            }
        },
        "name": "Shadowed Intentions",
        "type": "Upgrade",
        "cost": 3,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "TWI_485": {
        "id": "TWI_485",
        "face": {
            "front": {
                "name": "Shadowed Intentions",
                "type": "Upgrade",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/485.png",
                "isHorizontal": false
            }
        },
        "name": "Shadowed Intentions",
        "type": "Upgrade",
        "cost": 3,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "TWI_211": {
        "id": "TWI_211",
        "face": {
            "front": {
                "name": "Sly Moore, Secretive Advisor",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/211.png",
                "isHorizontal": false
            }
        },
        "name": "Sly Moore, Secretive Advisor",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Rare",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "OFFICIAL"
        ]
    },
    "TWI_476": {
        "id": "TWI_476",
        "face": {
            "front": {
                "name": "Sly Moore, Secretive Advisor",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/476.png",
                "isHorizontal": false
            }
        },
        "name": "Sly Moore, Secretive Advisor",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Rare",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "OFFICIAL"
        ]
    },
    "TWI_141": {
        "id": "TWI_141",
        "face": {
            "front": {
                "name": "Soldier of the 501st",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/141.png",
                "isHorizontal": false
            }
        },
        "name": "Soldier of the 501st",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_409": {
        "id": "TWI_409",
        "face": {
            "front": {
                "name": "Soldier of the 501st",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/409.png",
                "isHorizontal": false
            }
        },
        "name": "Soldier of the 501st",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "TROOPER"
        ]
    },
    "TWI_179": {
        "id": "TWI_179",
        "face": {
            "front": {
                "name": "Soulless One, Customized for Grievous",
                "type": "Unit - Space",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/179.png",
                "isHorizontal": false
            }
        },
        "name": "Soulless One, Customized for Grievous",
        "type": "Unit - Space",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 2,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_445": {
        "id": "TWI_445",
        "face": {
            "front": {
                "name": "Soulless One, Customized for Grievous",
                "type": "Unit - Space",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/445.png",
                "isHorizontal": false
            }
        },
        "name": "Soulless One, Customized for Grievous",
        "type": "Unit - Space",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 2,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_122": {
        "id": "TWI_122",
        "face": {
            "front": {
                "name": "Squad Support",
                "type": "Upgrade",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/122.png",
                "isHorizontal": false
            }
        },
        "name": "Squad Support",
        "type": "Upgrade",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "LEARNED"
        ]
    },
    "TWI_392": {
        "id": "TWI_392",
        "face": {
            "front": {
                "name": "Squad Support",
                "type": "Upgrade",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/392.png",
                "isHorizontal": false
            }
        },
        "name": "Squad Support",
        "type": "Upgrade",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "LEARNED"
        ]
    },
    "TWI_136": {
        "id": "TWI_136",
        "face": {
            "front": {
                "name": "Squadron of Vultures",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/136.png",
                "isHorizontal": false
            }
        },
        "name": "Squadron of Vultures",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Common",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_404": {
        "id": "TWI_404",
        "face": {
            "front": {
                "name": "Squadron of Vultures",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/404.png",
                "isHorizontal": false
            }
        },
        "name": "Squadron of Vultures",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Common",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_105": {
        "id": "TWI_105",
        "face": {
            "front": {
                "name": "Steadfast Senator",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/105.png",
                "isHorizontal": false
            }
        },
        "name": "Steadfast Senator",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 4,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "OFFICIAL"
        ]
    },
    "TWI_376": {
        "id": "TWI_376",
        "face": {
            "front": {
                "name": "Steadfast Senator",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/376.png",
                "isHorizontal": false
            }
        },
        "name": "Steadfast Senator",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 4,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "OFFICIAL"
        ]
    },
    "TWI_146": {
        "id": "TWI_146",
        "face": {
            "front": {
                "name": "Steela Gerrera, Beloved Tactician",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/146.png",
                "isHorizontal": false
            }
        },
        "name": "Steela Gerrera, Beloved Tactician",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 4,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FRINGE"
        ]
    },
    "TWI_414": {
        "id": "TWI_414",
        "face": {
            "front": {
                "name": "Steela Gerrera, Beloved Tactician",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/414.png",
                "isHorizontal": false
            }
        },
        "name": "Steela Gerrera, Beloved Tactician",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 4,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FRINGE"
        ]
    },
    "TWI_120": {
        "id": "TWI_120",
        "face": {
            "front": {
                "name": "Strategic Acumen",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/120.png",
                "isHorizontal": false
            }
        },
        "name": "Strategic Acumen",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 2,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "LEARNED"
        ]
    },
    "TWI_390": {
        "id": "TWI_390",
        "face": {
            "front": {
                "name": "Strategic Acumen",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/390.png",
                "isHorizontal": false
            }
        },
        "name": "Strategic Acumen",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 2,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "LEARNED"
        ]
    },
    "TWI_175": {
        "id": "TWI_175",
        "face": {
            "front": {
                "name": "Strategic Analysis",
                "type": "Event",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/175.png",
                "isHorizontal": false
            }
        },
        "name": "Strategic Analysis",
        "type": "Event",
        "cost": 5,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "TWI_441": {
        "id": "TWI_441",
        "face": {
            "front": {
                "name": "Strategic Analysis",
                "type": "Event",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/441.png",
                "isHorizontal": false
            }
        },
        "name": "Strategic Analysis",
        "type": "Event",
        "cost": 5,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "TWI_112": {
        "id": "TWI_112",
        "face": {
            "front": {
                "name": "Subjugating Starfighter",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/112.png",
                "isHorizontal": false
            }
        },
        "name": "Subjugating Starfighter",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_382": {
        "id": "TWI_382",
        "face": {
            "front": {
                "name": "Subjugating Starfighter",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/382.png",
                "isHorizontal": false
            }
        },
        "name": "Subjugating Starfighter",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_020": {
        "id": "TWI_020",
        "face": {
            "front": {
                "name": "Sundari, Mandalore",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/TWI/020-r.png",
                "isHorizontal": true
            }
        },
        "name": "Sundari, Mandalore",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": []
    },
    "TWI_295": {
        "id": "TWI_295",
        "face": {
            "front": {
                "name": "Sundari, Mandalore",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/TWI/295-r.png",
                "isHorizontal": true
            }
        },
        "name": "Sundari, Mandalore",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": []
    },
    "TWI_230": {
        "id": "TWI_230",
        "face": {
            "front": {
                "name": "Super Battle Droid",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/230.png",
                "isHorizontal": false
            }
        },
        "name": "Super Battle Droid",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 4,
        "HP": 3,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "TROOPER"
        ]
    },
    "TWI_493": {
        "id": "TWI_493",
        "face": {
            "front": {
                "name": "Super Battle Droid",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/493.png",
                "isHorizontal": false
            }
        },
        "name": "Super Battle Droid",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 4,
        "HP": 3,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "TROOPER"
        ]
    },
    "TWI_250": {
        "id": "TWI_250",
        "face": {
            "front": {
                "name": "Sword and Shield Maneuver",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/250.png",
                "isHorizontal": false
            }
        },
        "name": "Sword and Shield Maneuver",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "JEDI",
            "REPUBLIC",
            "TACTIC"
        ]
    },
    "TWI_510": {
        "id": "TWI_510",
        "face": {
            "front": {
                "name": "Sword and Shield Maneuver",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/510.png",
                "isHorizontal": false
            }
        },
        "name": "Sword and Shield Maneuver",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "JEDI",
            "REPUBLIC",
            "TACTIC"
        ]
    },
    "TWI_099": {
        "id": "TWI_099",
        "face": {
            "front": {
                "name": "Synchronized Strike",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/099.png",
                "isHorizontal": false
            }
        },
        "name": "Synchronized Strike",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_370": {
        "id": "TWI_370",
        "face": {
            "front": {
                "name": "Synchronized Strike",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/370.png",
                "isHorizontal": false
            }
        },
        "name": "Synchronized Strike",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_124": {
        "id": "TWI_124",
        "face": {
            "front": {
                "name": "Tactical Advantage",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/124.png",
                "isHorizontal": false
            }
        },
        "name": "Tactical Advantage",
        "type": "Event",
        "cost": 1,
        "rarity": "Special",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_184": {
        "id": "TWI_184",
        "face": {
            "front": {
                "name": "Tactical Droid Commander",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/184.png",
                "isHorizontal": false
            }
        },
        "name": "Tactical Droid Commander",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID"
        ]
    },
    "TWI_449": {
        "id": "TWI_449",
        "face": {
            "front": {
                "name": "Tactical Droid Commander",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/449.png",
                "isHorizontal": false
            }
        },
        "name": "Tactical Droid Commander",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID"
        ]
    },
    "TWI_128": {
        "id": "TWI_128",
        "face": {
            "front": {
                "name": "Take Captive",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/128.png",
                "isHorizontal": false
            }
        },
        "name": "Take Captive",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_396": {
        "id": "TWI_396",
        "face": {
            "front": {
                "name": "Take Captive",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/396.png",
                "isHorizontal": false
            }
        },
        "name": "Take Captive",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_125": {
        "id": "TWI_125",
        "face": {
            "front": {
                "name": "The Clone Wars",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/125.png",
                "isHorizontal": false
            }
        },
        "name": "The Clone Wars",
        "type": "Event",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "DISASTER"
        ]
    },
    "TWI_393": {
        "id": "TWI_393",
        "face": {
            "front": {
                "name": "The Clone Wars",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/393.png",
                "isHorizontal": false
            }
        },
        "name": "The Clone Wars",
        "type": "Event",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "DISASTER"
        ]
    },
    "TWI_021": {
        "id": "TWI_021",
        "face": {
            "front": {
                "name": "The Crystal City, Christophsis",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/TWI/021-r.png",
                "isHorizontal": true
            }
        },
        "name": "The Crystal City, Christophsis",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": []
    },
    "TWI_296": {
        "id": "TWI_296",
        "face": {
            "front": {
                "name": "The Crystal City, Christophsis",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/TWI/296-r.png",
                "isHorizontal": true
            }
        },
        "name": "The Crystal City, Christophsis",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": []
    },
    "TWI_078": {
        "id": "TWI_078",
        "face": {
            "front": {
                "name": "The Invasion of Christophsis",
                "type": "Event",
                "cost": 15,
                "image": "https://cdn.swu-db.com/images/cards/TWI/078.png",
                "isHorizontal": false
            }
        },
        "name": "The Invasion of Christophsis",
        "type": "Event",
        "cost": 15,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "PLAN"
        ]
    },
    "TWI_351": {
        "id": "TWI_351",
        "face": {
            "front": {
                "name": "The Invasion of Christophsis",
                "type": "Event",
                "cost": 15,
                "image": "https://cdn.swu-db.com/images/cards/TWI/351.png",
                "isHorizontal": false
            }
        },
        "name": "The Invasion of Christophsis",
        "type": "Event",
        "cost": 15,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "PLAN"
        ]
    },
    "TWI_234": {
        "id": "TWI_234",
        "face": {
            "front": {
                "name": "The Invisible Hand, Imposing Flagship",
                "type": "Unit - Space",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/TWI/234.png",
                "isHorizontal": false
            }
        },
        "name": "The Invisible Hand, Imposing Flagship",
        "type": "Unit - Space",
        "cost": 8,
        "rarity": "Rare",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "TWI_497": {
        "id": "TWI_497",
        "face": {
            "front": {
                "name": "The Invisible Hand, Imposing Flagship",
                "type": "Unit - Space",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/TWI/497.png",
                "isHorizontal": false
            }
        },
        "name": "The Invisible Hand, Imposing Flagship",
        "type": "Unit - Space",
        "cost": 8,
        "rarity": "Rare",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "TWI_027": {
        "id": "TWI_027",
        "face": {
            "front": {
                "name": "The Nest, Onderon",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/TWI/027-r.png",
                "isHorizontal": true
            }
        },
        "name": "The Nest, Onderon",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": []
    },
    "TWI_302": {
        "id": "TWI_302",
        "face": {
            "front": {
                "name": "The Nest, Onderon",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/TWI/302-r.png",
                "isHorizontal": true
            }
        },
        "name": "The Nest, Onderon",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": []
    },
    "TWI_067": {
        "id": "TWI_067",
        "face": {
            "front": {
                "name": "The Zillo Beast, Awoken From The Depths",
                "type": "Unit - Ground",
                "cost": 9,
                "image": "https://cdn.swu-db.com/images/cards/TWI/067.png",
                "isHorizontal": false
            }
        },
        "name": "The Zillo Beast, Awoken From The Depths",
        "type": "Unit - Ground",
        "cost": 9,
        "rarity": "Rare",
        "power": 10,
        "HP": 10,
        "aspects": [
            "Vigilance"
        ],
        "unique": true,
        "traits": [
            "CREATURE"
        ]
    },
    "TWI_340": {
        "id": "TWI_340",
        "face": {
            "front": {
                "name": "The Zillo Beast, Awoken From The Depths",
                "type": "Unit - Ground",
                "cost": 9,
                "image": "https://cdn.swu-db.com/images/cards/TWI/340.png",
                "isHorizontal": false
            }
        },
        "name": "The Zillo Beast, Awoken From The Depths",
        "type": "Unit - Ground",
        "cost": 9,
        "rarity": "Rare",
        "power": 10,
        "HP": 10,
        "aspects": [
            "Vigilance"
        ],
        "unique": true,
        "traits": [
            "CREATURE"
        ]
    },
    "TWI_024": {
        "id": "TWI_024",
        "face": {
            "front": {
                "name": "Tipoca City, Kamino",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/TWI/024-r.png",
                "isHorizontal": true
            }
        },
        "name": "Tipoca City, Kamino",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": []
    },
    "TWI_299": {
        "id": "TWI_299",
        "face": {
            "front": {
                "name": "Tipoca City, Kamino",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/TWI/299-r.png",
                "isHorizontal": true
            }
        },
        "name": "Tipoca City, Kamino",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": []
    },
    "TWI_060": {
        "id": "TWI_060",
        "face": {
            "front": {
                "name": "Trade Federation Shuttle",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/060.png",
                "isHorizontal": false
            }
        },
        "name": "Trade Federation Shuttle",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "TWI_333": {
        "id": "TWI_333",
        "face": {
            "front": {
                "name": "Trade Federation Shuttle",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/333.png",
                "isHorizontal": false
            }
        },
        "name": "Trade Federation Shuttle",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "TWI_246": {
        "id": "TWI_246",
        "face": {
            "front": {
                "name": "Tranquility, Inspiring Flagship",
                "type": "Unit - Space",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/TWI/246.png",
                "isHorizontal": false
            }
        },
        "name": "Tranquility, Inspiring Flagship",
        "type": "Unit - Space",
        "cost": 7,
        "rarity": "Rare",
        "power": 7,
        "HP": 6,
        "aspects": [
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "TWI_507": {
        "id": "TWI_507",
        "face": {
            "front": {
                "name": "Tranquility, Inspiring Flagship",
                "type": "Unit - Space",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/TWI/507.png",
                "isHorizontal": false
            }
        },
        "name": "Tranquility, Inspiring Flagship",
        "type": "Unit - Space",
        "cost": 7,
        "rarity": "Rare",
        "power": 7,
        "HP": 6,
        "aspects": [
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "TWI_217": {
        "id": "TWI_217",
        "face": {
            "front": {
                "name": "Tri-Droid Suppressor",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/TWI/217.png",
                "isHorizontal": false
            }
        },
        "name": "Tri-Droid Suppressor",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Common",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "VEHICLE",
            "WALKER"
        ]
    },
    "TWI_482": {
        "id": "TWI_482",
        "face": {
            "front": {
                "name": "Tri-Droid Suppressor",
                "type": "Unit - Ground",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/TWI/482.png",
                "isHorizontal": false
            }
        },
        "name": "Tri-Droid Suppressor",
        "type": "Unit - Ground",
        "cost": 7,
        "rarity": "Common",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "VEHICLE",
            "WALKER"
        ]
    },
    "TWI_155": {
        "id": "TWI_155",
        "face": {
            "front": {
                "name": "Twice the Pride",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/155.png",
                "isHorizontal": false
            }
        },
        "name": "Twice the Pride",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "TWI_422": {
        "id": "TWI_422",
        "face": {
            "front": {
                "name": "Twice the Pride",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/422.png",
                "isHorizontal": false
            }
        },
        "name": "Twice the Pride",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "TWI_156": {
        "id": "TWI_156",
        "face": {
            "front": {
                "name": "Unlimited Power",
                "type": "Event",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/156.png",
                "isHorizontal": false
            }
        },
        "name": "Unlimited Power",
        "type": "Event",
        "cost": 6,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "FORCE"
        ]
    },
    "TWI_423": {
        "id": "TWI_423",
        "face": {
            "front": {
                "name": "Unlimited Power",
                "type": "Event",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/TWI/423.png",
                "isHorizontal": false
            }
        },
        "name": "Unlimited Power",
        "type": "Event",
        "cost": 6,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "FORCE"
        ]
    },
    "TWI_223": {
        "id": "TWI_223",
        "face": {
            "front": {
                "name": "Unmasking the Conspiracy",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/223.png",
                "isHorizontal": false
            }
        },
        "name": "Unmasking the Conspiracy",
        "type": "Event",
        "cost": 1,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "TWI_488": {
        "id": "TWI_488",
        "face": {
            "front": {
                "name": "Unmasking the Conspiracy",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/488.png",
                "isHorizontal": false
            }
        },
        "name": "Unmasking the Conspiracy",
        "type": "Event",
        "cost": 1,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "TWI_189": {
        "id": "TWI_189",
        "face": {
            "front": {
                "name": "Unnatural Life",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/189.png",
                "isHorizontal": false
            }
        },
        "name": "Unnatural Life",
        "type": "Event",
        "cost": 3,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "FORCE"
        ]
    },
    "TWI_454": {
        "id": "TWI_454",
        "face": {
            "front": {
                "name": "Unnatural Life",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/454.png",
                "isHorizontal": false
            }
        },
        "name": "Unnatural Life",
        "type": "Event",
        "cost": 3,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "FORCE"
        ]
    },
    "TWI_071": {
        "id": "TWI_071",
        "face": {
            "front": {
                "name": "Unshakeable Will",
                "type": "Upgrade",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/071.png",
                "isHorizontal": false
            }
        },
        "name": "Unshakeable Will",
        "type": "Upgrade",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "TWI_344": {
        "id": "TWI_344",
        "face": {
            "front": {
                "name": "Unshakeable Will",
                "type": "Upgrade",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/344.png",
                "isHorizontal": false
            }
        },
        "name": "Unshakeable Will",
        "type": "Upgrade",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "TWI_160": {
        "id": "TWI_160",
        "face": {
            "front": {
                "name": "Vanguard Droid Bomber",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/160.png",
                "isHorizontal": false
            }
        },
        "name": "Vanguard Droid Bomber",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_427": {
        "id": "TWI_427",
        "face": {
            "front": {
                "name": "Vanguard Droid Bomber",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/427.png",
                "isHorizontal": false
            }
        },
        "name": "Vanguard Droid Bomber",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_077": {
        "id": "TWI_077",
        "face": {
            "front": {
                "name": "Vanquish",
                "type": "Event",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/077.png",
                "isHorizontal": false
            }
        },
        "name": "Vanquish",
        "type": "Event",
        "cost": 5,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_350": {
        "id": "TWI_350",
        "face": {
            "front": {
                "name": "Vanquish",
                "type": "Event",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/350.png",
                "isHorizontal": false
            }
        },
        "name": "Vanquish",
        "type": "Event",
        "cost": 5,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "TWI_254": {
        "id": "TWI_254",
        "face": {
            "front": {
                "name": "Volunteer Soldier",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/254.png",
                "isHorizontal": false
            }
        },
        "name": "Volunteer Soldier",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [],
        "unique": false,
        "traits": [
            "TROOPER"
        ]
    },
    "TWI_514": {
        "id": "TWI_514",
        "face": {
            "front": {
                "name": "Volunteer Soldier",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/514.png",
                "isHorizontal": false
            }
        },
        "name": "Volunteer Soldier",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [],
        "unique": false,
        "traits": [
            "TROOPER"
        ]
    },
    "TWI_063": {
        "id": "TWI_063",
        "face": {
            "front": {
                "name": "Vulture Interceptor Wing",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/063.png",
                "isHorizontal": false
            }
        },
        "name": "Vulture Interceptor Wing",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_336": {
        "id": "TWI_336",
        "face": {
            "front": {
                "name": "Vulture Interceptor Wing",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/TWI/336.png",
                "isHorizontal": false
            }
        },
        "name": "Vulture Interceptor Wing",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_057": {
        "id": "TWI_057",
        "face": {
            "front": {
                "name": "Warrior Drone",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/057.png",
                "isHorizontal": false
            }
        },
        "name": "Warrior Drone",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST"
        ]
    },
    "TWI_330": {
        "id": "TWI_330",
        "face": {
            "front": {
                "name": "Warrior Drone",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/330.png",
                "isHorizontal": false
            }
        },
        "name": "Warrior Drone",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST"
        ]
    },
    "TWI_188": {
        "id": "TWI_188",
        "face": {
            "front": {
                "name": "Wartime Profiteering",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/188.png",
                "isHorizontal": false
            }
        },
        "name": "Wartime Profiteering",
        "type": "Event",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "TWI_453": {
        "id": "TWI_453",
        "face": {
            "front": {
                "name": "Wartime Profiteering",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/453.png",
                "isHorizontal": false
            }
        },
        "name": "Wartime Profiteering",
        "type": "Event",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "TWI_032": {
        "id": "TWI_032",
        "face": {
            "front": {
                "name": "Wartime Trade Official",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/032.png",
                "isHorizontal": false
            }
        },
        "name": "Wartime Trade Official",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "OFFICIAL"
        ]
    },
    "TWI_305": {
        "id": "TWI_305",
        "face": {
            "front": {
                "name": "Wartime Trade Official",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/TWI/305.png",
                "isHorizontal": false
            }
        },
        "name": "Wartime Trade Official",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "OFFICIAL"
        ]
    },
    "TWI_006": {
        "id": "TWI_006",
        "face": {
            "front": {
                "name": "Wat Tambor, Techno Union Foreman",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/006-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Wat Tambor, Techno Union Foreman",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/TWI/006-b.png"
            }
        },
        "name": "Wat Tambor, Techno Union Foreman",
        "type": "Leader",
        "cost": 5,
        "rarity": "Rare",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "OFFICIAL"
        ]
    },
    "TWI_263": {
        "id": "TWI_263",
        "face": {
            "front": {
                "name": "Wat Tambor, Techno Union Foreman",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/263-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Wat Tambor, Techno Union Foreman",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/TWI/263-b.png"
            }
        },
        "name": "Wat Tambor, Techno Union Foreman",
        "type": "Leader",
        "cost": 5,
        "rarity": "Rare",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "OFFICIAL"
        ]
    },
    "TWI_281": {
        "id": "TWI_281",
        "face": {
            "front": {
                "name": "Wat Tambor, Techno Union Foreman",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/281-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Wat Tambor, Techno Union Foreman",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/TWI/281-b.png"
            }
        },
        "name": "Wat Tambor, Techno Union Foreman",
        "type": "Leader",
        "cost": 5,
        "rarity": "Rare",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "OFFICIAL"
        ]
    },
    "TWI_226": {
        "id": "TWI_226",
        "face": {
            "front": {
                "name": "Waylay",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/TWI/226.png",
                "isHorizontal": false
            }
        },
        "name": "Waylay",
        "type": "Event",
        "cost": 3,
        "rarity": "Special",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "TWI_191": {
        "id": "TWI_191",
        "face": {
            "front": {
                "name": "Wolf Pack Escort",
                "type": "Unit - Space",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/191.png",
                "isHorizontal": false
            }
        },
        "name": "Wolf Pack Escort",
        "type": "Unit - Space",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_456": {
        "id": "TWI_456",
        "face": {
            "front": {
                "name": "Wolf Pack Escort",
                "type": "Unit - Space",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/TWI/456.png",
                "isHorizontal": false
            }
        },
        "name": "Wolf Pack Escort",
        "type": "Unit - Space",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "TWI_004": {
        "id": "TWI_004",
        "face": {
            "front": {
                "name": "Yoda, Sensing Darkness",
                "type": "Leader",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/TWI/004-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Yoda, Sensing Darkness",
                "type": "Leader",
                "cost": "7",
                "image": "https://cdn.swu-db.com/images/cards/TWI/004-b.png"
            }
        },
        "name": "Yoda, Sensing Darkness",
        "type": "Leader",
        "cost": 7,
        "rarity": "Rare",
        "power": 4,
        "HP": 9,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_261": {
        "id": "TWI_261",
        "face": {
            "front": {
                "name": "Yoda, Sensing Darkness",
                "type": "Leader",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/TWI/261-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Yoda, Sensing Darkness",
                "type": "Leader",
                "cost": "7",
                "image": "https://cdn.swu-db.com/images/cards/TWI/261-b.png"
            }
        },
        "name": "Yoda, Sensing Darkness",
        "type": "Leader",
        "cost": 7,
        "rarity": "Rare",
        "power": 4,
        "HP": 9,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_279": {
        "id": "TWI_279",
        "face": {
            "front": {
                "name": "Yoda, Sensing Darkness",
                "type": "Leader",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/TWI/279-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Yoda, Sensing Darkness",
                "type": "Leader",
                "cost": "7",
                "image": "https://cdn.swu-db.com/images/cards/TWI/279-b.png"
            }
        },
        "name": "Yoda, Sensing Darkness",
        "type": "Leader",
        "cost": 7,
        "rarity": "Rare",
        "power": 4,
        "HP": 9,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "JEDI",
            "REPUBLIC"
        ]
    },
    "TWI_185": {
        "id": "TWI_185",
        "face": {
            "front": {
                "name": "Ziro the Hutt, Colorful Schemer",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/185.png",
                "isHorizontal": false
            }
        },
        "name": "Ziro the Hutt, Colorful Schemer",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 8,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "HUTT"
        ]
    },
    "TWI_450": {
        "id": "TWI_450",
        "face": {
            "front": {
                "name": "Ziro the Hutt, Colorful Schemer",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/TWI/450.png",
                "isHorizontal": false
            }
        },
        "name": "Ziro the Hutt, Colorful Schemer",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 8,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "HUTT"
        ]
    },
    "JTL_163": {
        "id": "JTL_163",
        "face": {
            "front": {
                "name": "AT-DP Occupier",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/163.png",
                "isHorizontal": false
            }
        },
        "name": "AT-DP Occupier",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "WALKER"
        ]
    },
    "JTL_425": {
        "id": "JTL_425",
        "face": {
            "front": {
                "name": "AT-DP Occupier",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/425.png",
                "isHorizontal": false
            }
        },
        "name": "AT-DP Occupier",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "WALKER"
        ]
    },
    "JTL_058": {
        "id": "JTL_058",
        "face": {
            "front": {
                "name": "Academy Graduate",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/058.png",
                "isHorizontal": false
            }
        },
        "name": "Academy Graduate",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 2,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "PILOT"
        ]
    },
    "JTL_320": {
        "id": "JTL_320",
        "face": {
            "front": {
                "name": "Academy Graduate",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/320.png",
                "isHorizontal": false
            }
        },
        "name": "Academy Graduate",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 2,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "PILOT"
        ]
    },
    "JTL_114": {
        "id": "JTL_114",
        "face": {
            "front": {
                "name": "Adept ARC-170",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/114.png",
                "isHorizontal": false
            }
        },
        "name": "Adept ARC-170",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_376": {
        "id": "JTL_376",
        "face": {
            "front": {
                "name": "Adept ARC-170",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/376.png",
                "isHorizontal": false
            }
        },
        "name": "Adept ARC-170",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_016": {
        "id": "JTL_016",
        "face": {
            "front": {
                "name": "Admiral Ackbar, It's A Trap!",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/016-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Admiral Ackbar, It's A Trap!",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/JTL/016-b.png"
            }
        },
        "name": "Admiral Ackbar, It's A Trap!",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 3,
        "HP": 8,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "OFFICIAL"
        ]
    },
    "JTL_1012": {
        "id": "JTL_1012",
        "face": {
            "front": {
                "name": "Admiral Ackbar, It's A Trap!",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1012-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Admiral Ackbar, It's A Trap!",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/JTL/1012-b.png"
            }
        },
        "name": "Admiral Ackbar, It's A Trap!",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 3,
        "HP": 8,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "OFFICIAL"
        ]
    },
    "JTL_278": {
        "id": "JTL_278",
        "face": {
            "front": {
                "name": "Admiral Ackbar, It's A Trap!",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/278-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Admiral Ackbar, It's A Trap!",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/JTL/278-b.png"
            }
        },
        "name": "Admiral Ackbar, It's A Trap!",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 3,
        "HP": 8,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "OFFICIAL"
        ]
    },
    "JTL_007": {
        "id": "JTL_007",
        "face": {
            "front": {
                "name": "Admiral Holdo, We're Not Alone",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/007-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Admiral Holdo, We're Not Alone",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/JTL/007-b.png"
            }
        },
        "name": "Admiral Holdo, We're Not Alone",
        "type": "Leader",
        "cost": 6,
        "rarity": "Rare",
        "power": 3,
        "HP": 8,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE",
            "OFFICIAL"
        ]
    },
    "JTL_1003": {
        "id": "JTL_1003",
        "face": {
            "front": {
                "name": "Admiral Holdo, We're Not Alone",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1003-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Admiral Holdo, We're Not Alone",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/JTL/1003-b.png"
            }
        },
        "name": "Admiral Holdo, We're Not Alone",
        "type": "Leader",
        "cost": 6,
        "rarity": "Rare",
        "power": 3,
        "HP": 8,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE",
            "OFFICIAL"
        ]
    },
    "JTL_269": {
        "id": "JTL_269",
        "face": {
            "front": {
                "name": "Admiral Holdo, We're Not Alone",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/269-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Admiral Holdo, We're Not Alone",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/JTL/269-b.png"
            }
        },
        "name": "Admiral Holdo, We're Not Alone",
        "type": "Leader",
        "cost": 6,
        "rarity": "Rare",
        "power": 3,
        "HP": 8,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE",
            "OFFICIAL"
        ]
    },
    "JTL_005": {
        "id": "JTL_005",
        "face": {
            "front": {
                "name": "Admiral Piett, Commanding the Armada",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/005-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Admiral Piett, Commanding the Armada",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/JTL/005-b.png"
            }
        },
        "name": "Admiral Piett, Commanding the Armada",
        "type": "Leader",
        "cost": 5,
        "rarity": "Rare",
        "power": 2,
        "HP": 7,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "JTL_1001": {
        "id": "JTL_1001",
        "face": {
            "front": {
                "name": "Admiral Piett, Commanding the Armada",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1001-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Admiral Piett, Commanding the Armada",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/JTL/1001-b.png"
            }
        },
        "name": "Admiral Piett, Commanding the Armada",
        "type": "Leader",
        "cost": 5,
        "rarity": "Rare",
        "power": 2,
        "HP": 7,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "JTL_267": {
        "id": "JTL_267",
        "face": {
            "front": {
                "name": "Admiral Piett, Commanding the Armada",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/267-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Admiral Piett, Commanding the Armada",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/JTL/267-b.png"
            }
        },
        "name": "Admiral Piett, Commanding the Armada",
        "type": "Leader",
        "cost": 5,
        "rarity": "Rare",
        "power": 2,
        "HP": 7,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "JTL_014": {
        "id": "JTL_014",
        "face": {
            "front": {
                "name": "Admiral Trench, chk-chk-chk-chk",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/014-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Admiral Trench, chk-chk-chk-chk",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/JTL/014-b.png"
            }
        },
        "name": "Admiral Trench, chk-chk-chk-chk",
        "type": "Leader",
        "cost": 6,
        "rarity": "Rare",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "OFFICIAL"
        ]
    },
    "JTL_1010": {
        "id": "JTL_1010",
        "face": {
            "front": {
                "name": "Admiral Trench, chk-chk-chk-chk",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1010-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Admiral Trench, chk-chk-chk-chk",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/JTL/1010-b.png"
            }
        },
        "name": "Admiral Trench, chk-chk-chk-chk",
        "type": "Leader",
        "cost": 6,
        "rarity": "Rare",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "OFFICIAL"
        ]
    },
    "JTL_276": {
        "id": "JTL_276",
        "face": {
            "front": {
                "name": "Admiral Trench, chk-chk-chk-chk",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/276-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Admiral Trench, chk-chk-chk-chk",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/JTL/276-b.png"
            }
        },
        "name": "Admiral Trench, chk-chk-chk-chk",
        "type": "Leader",
        "cost": 6,
        "rarity": "Rare",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "OFFICIAL"
        ]
    },
    "JTL_047": {
        "id": "JTL_047",
        "face": {
            "front": {
                "name": "Admiral Yularen, Fleet Coordinator",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/047.png",
                "isHorizontal": false
            }
        },
        "name": "Admiral Yularen, Fleet Coordinator",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Rare",
        "power": 1,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "OFFICIAL"
        ]
    },
    "JTL_309": {
        "id": "JTL_309",
        "face": {
            "front": {
                "name": "Admiral Yularen, Fleet Coordinator",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/309.png",
                "isHorizontal": false
            }
        },
        "name": "Admiral Yularen, Fleet Coordinator",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Rare",
        "power": 1,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "OFFICIAL"
        ]
    },
    "JTL_201": {
        "id": "JTL_201",
        "face": {
            "front": {
                "name": "Ahsoka Tano, Chasing Whispers",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/201.png",
                "isHorizontal": false
            }
        },
        "name": "Ahsoka Tano, Chasing Whispers",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "FORCE"
        ]
    },
    "JTL_463": {
        "id": "JTL_463",
        "face": {
            "front": {
                "name": "Ahsoka Tano, Chasing Whispers",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/463.png",
                "isHorizontal": false
            }
        },
        "name": "Ahsoka Tano, Chasing Whispers",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "FORCE"
        ]
    },
    "JTL_125": {
        "id": "JTL_125",
        "face": {
            "front": {
                "name": "Air Superiority",
                "type": "Event",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/125.png",
                "isHorizontal": false
            }
        },
        "name": "Air Superiority",
        "type": "Event",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_387": {
        "id": "JTL_387",
        "face": {
            "front": {
                "name": "Air Superiority",
                "type": "Event",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/387.png",
                "isHorizontal": false
            }
        },
        "name": "Air Superiority",
        "type": "Event",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_122": {
        "id": "JTL_122",
        "face": {
            "front": {
                "name": "All Wings Report In",
                "type": "Event",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/122.png",
                "isHorizontal": false
            }
        },
        "name": "All Wings Report In",
        "type": "Event",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "JTL_384": {
        "id": "JTL_384",
        "face": {
            "front": {
                "name": "All Wings Report In",
                "type": "Event",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/384.png",
                "isHorizontal": false
            }
        },
        "name": "All Wings Report In",
        "type": "Event",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "JTL_133": {
        "id": "JTL_133",
        "face": {
            "front": {
                "name": "Allegiant General Pryde, Ruthless and Loyal",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/133.png",
                "isHorizontal": false
            }
        },
        "name": "Allegiant General Pryde, Ruthless and Loyal",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FIRST ORDER",
            "OFFICIAL"
        ]
    },
    "JTL_395": {
        "id": "JTL_395",
        "face": {
            "front": {
                "name": "Allegiant General Pryde, Ruthless and Loyal",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/395.png",
                "isHorizontal": false
            }
        },
        "name": "Allegiant General Pryde, Ruthless and Loyal",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FIRST ORDER",
            "OFFICIAL"
        ]
    },
    "JTL_197": {
        "id": "JTL_197",
        "face": {
            "front": {
                "name": "Anakin Skywalker, I'll Try Spinning",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/197.png",
                "isHorizontal": false
            }
        },
        "name": "Anakin Skywalker, I'll Try Spinning",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "FRINGE",
            "PILOT"
        ]
    },
    "JTL_459": {
        "id": "JTL_459",
        "face": {
            "front": {
                "name": "Anakin Skywalker, I'll Try Spinning",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/459.png",
                "isHorizontal": false
            }
        },
        "name": "Anakin Skywalker, I'll Try Spinning",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "FRINGE",
            "PILOT"
        ]
    },
    "JTL_041": {
        "id": "JTL_041",
        "face": {
            "front": {
                "name": "Annihilator, Tagge's Flagship",
                "type": "Unit - Space",
                "cost": 11,
                "image": "https://cdn.swu-db.com/images/cards/JTL/041.png",
                "isHorizontal": false
            }
        },
        "name": "Annihilator, Tagge's Flagship",
        "type": "Unit - Space",
        "cost": 11,
        "rarity": "Legendary",
        "power": 12,
        "HP": 12,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_1018": {
        "id": "JTL_1018",
        "face": {
            "front": {
                "name": "Annihilator, Tagge's Flagship",
                "type": "Unit - Space",
                "cost": 11,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1018.png",
                "isHorizontal": false
            }
        },
        "name": "Annihilator, Tagge's Flagship",
        "type": "Unit - Space",
        "cost": 11,
        "rarity": "Legendary",
        "power": 12,
        "HP": 12,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_303": {
        "id": "JTL_303",
        "face": {
            "front": {
                "name": "Annihilator, Tagge's Flagship",
                "type": "Unit - Space",
                "cost": 11,
                "image": "https://cdn.swu-db.com/images/cards/JTL/303.png",
                "isHorizontal": false
            }
        },
        "name": "Annihilator, Tagge's Flagship",
        "type": "Unit - Space",
        "cost": 11,
        "rarity": "Legendary",
        "power": 12,
        "HP": 12,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_091": {
        "id": "JTL_091",
        "face": {
            "front": {
                "name": "Apology Accepted",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/091.png",
                "isHorizontal": false
            }
        },
        "name": "Apology Accepted",
        "type": "Event",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_353": {
        "id": "JTL_353",
        "face": {
            "front": {
                "name": "Apology Accepted",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/353.png",
                "isHorizontal": false
            }
        },
        "name": "Apology Accepted",
        "type": "Event",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_001": {
        "id": "JTL_001",
        "face": {
            "front": {
                "name": "Asajj Ventress, I Work Alone",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/001-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Asajj Ventress, I Work Alone",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/JTL/001-b.png"
            }
        },
        "name": "Asajj Ventress, I Work Alone",
        "type": "Leader",
        "cost": 6,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "NIGHT",
            "BOUNTY HUNTER",
            "PILOT"
        ]
    },
    "JTL_263": {
        "id": "JTL_263",
        "face": {
            "front": {
                "name": "Asajj Ventress, I Work Alone",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/263-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Asajj Ventress, I Work Alone",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/JTL/263-b.png"
            }
        },
        "name": "Asajj Ventress, I Work Alone",
        "type": "Leader",
        "cost": 6,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "NIGHT",
            "BOUNTY HUNTER",
            "PILOT"
        ]
    },
    "JTL_997": {
        "id": "JTL_997",
        "face": {
            "front": {
                "name": "Asajj Ventress, I Work Alone",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/997-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Asajj Ventress, I Work Alone",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/JTL/997-b.png"
            }
        },
        "name": "Asajj Ventress, I Work Alone",
        "type": "Leader",
        "cost": 6,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "NIGHT",
            "BOUNTY HUNTER",
            "PILOT"
        ]
    },
    "JTL_057": {
        "id": "JTL_057",
        "face": {
            "front": {
                "name": "Astromech Pilot",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/057.png",
                "isHorizontal": false
            }
        },
        "name": "Astromech Pilot",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "DROID",
            "PILOT"
        ]
    },
    "JTL_319": {
        "id": "JTL_319",
        "face": {
            "front": {
                "name": "Astromech Pilot",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/319.png",
                "isHorizontal": false
            }
        },
        "name": "Astromech Pilot",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "DROID",
            "PILOT"
        ]
    },
    "JTL_261": {
        "id": "JTL_261",
        "face": {
            "front": {
                "name": "Attack Run",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/261.png",
                "isHorizontal": false
            }
        },
        "name": "Attack Run",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_523": {
        "id": "JTL_523",
        "face": {
            "front": {
                "name": "Attack Run",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/523.png",
                "isHorizontal": false
            }
        },
        "name": "Attack Run",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_145": {
        "id": "JTL_145",
        "face": {
            "front": {
                "name": "BB-8, Happy Beeps",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/145.png",
                "isHorizontal": false
            }
        },
        "name": "BB-8, Happy Beeps",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE",
            "DROID",
            "PILOT"
        ]
    },
    "JTL_407": {
        "id": "JTL_407",
        "face": {
            "front": {
                "name": "BB-8, Happy Beeps",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/407.png",
                "isHorizontal": false
            }
        },
        "name": "BB-8, Happy Beeps",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE",
            "DROID",
            "PILOT"
        ]
    },
    "JTL_037": {
        "id": "JTL_037",
        "face": {
            "front": {
                "name": "Banshee, Crippling Command",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/037.png",
                "isHorizontal": false
            }
        },
        "name": "Banshee, Crippling Command",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_1015": {
        "id": "JTL_1015",
        "face": {
            "front": {
                "name": "Banshee, Crippling Command",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1015.png",
                "isHorizontal": false
            }
        },
        "name": "Banshee, Crippling Command",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_299": {
        "id": "JTL_299",
        "face": {
            "front": {
                "name": "Banshee, Crippling Command",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/299.png",
                "isHorizontal": false
            }
        },
        "name": "Banshee, Crippling Command",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_228": {
        "id": "JTL_228",
        "face": {
            "front": {
                "name": "Barrel Roll",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/228.png",
                "isHorizontal": false
            }
        },
        "name": "Barrel Roll",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_490": {
        "id": "JTL_490",
        "face": {
            "front": {
                "name": "Barrel Roll",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/490.png",
                "isHorizontal": false
            }
        },
        "name": "Barrel Roll",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_150": {
        "id": "JTL_150",
        "face": {
            "front": {
                "name": "Biggs Darklighter, They'll Never Stop Us",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/150.png",
                "isHorizontal": false
            }
        },
        "name": "Biggs Darklighter, They'll Never Stop Us",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "PILOT"
        ]
    },
    "JTL_412": {
        "id": "JTL_412",
        "face": {
            "front": {
                "name": "Biggs Darklighter, They'll Never Stop Us",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/412.png",
                "isHorizontal": false
            }
        },
        "name": "Biggs Darklighter, They'll Never Stop Us",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "PILOT"
        ]
    },
    "JTL_1033": {
        "id": "JTL_1033",
        "face": {
            "front": {
                "name": "Black One, Straight At Them",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1033.png",
                "isHorizontal": false
            }
        },
        "name": "Black One, Straight At Them",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Rare",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_147": {
        "id": "JTL_147",
        "face": {
            "front": {
                "name": "Black One, Straight At Them",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/147.png",
                "isHorizontal": false
            }
        },
        "name": "Black One, Straight At Them",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Rare",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_409": {
        "id": "JTL_409",
        "face": {
            "front": {
                "name": "Black One, Straight At Them",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/409.png",
                "isHorizontal": false
            }
        },
        "name": "Black One, Straight At Them",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Rare",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_202": {
        "id": "JTL_202",
        "face": {
            "front": {
                "name": "Black Squadron Scout Wing",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/202.png",
                "isHorizontal": false
            }
        },
        "name": "Black Squadron Scout Wing",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "RESISTANCE",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_464": {
        "id": "JTL_464",
        "face": {
            "front": {
                "name": "Black Squadron Scout Wing",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/464.png",
                "isHorizontal": false
            }
        },
        "name": "Black Squadron Scout Wing",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "RESISTANCE",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_199": {
        "id": "JTL_199",
        "face": {
            "front": {
                "name": "Blade Squadron B-Wing",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/199.png",
                "isHorizontal": false
            }
        },
        "name": "Blade Squadron B-Wing",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_461": {
        "id": "JTL_461",
        "face": {
            "front": {
                "name": "Blade Squadron B-Wing",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/461.png",
                "isHorizontal": false
            }
        },
        "name": "Blade Squadron B-Wing",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_096": {
        "id": "JTL_096",
        "face": {
            "front": {
                "name": "Blue Leader, Scarif Air Support",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/096.png",
                "isHorizontal": false
            }
        },
        "name": "Blue Leader, Scarif Air Support",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_1026": {
        "id": "JTL_1026",
        "face": {
            "front": {
                "name": "Blue Leader, Scarif Air Support",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1026.png",
                "isHorizontal": false
            }
        },
        "name": "Blue Leader, Scarif Air Support",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_358": {
        "id": "JTL_358",
        "face": {
            "front": {
                "name": "Blue Leader, Scarif Air Support",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/358.png",
                "isHorizontal": false
            }
        },
        "name": "Blue Leader, Scarif Air Support",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_215": {
        "id": "JTL_215",
        "face": {
            "front": {
                "name": "BoShek, Charismatic Smuggler",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/215.png",
                "isHorizontal": false
            }
        },
        "name": "BoShek, Charismatic Smuggler",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "PILOT"
        ]
    },
    "JTL_477": {
        "id": "JTL_477",
        "face": {
            "front": {
                "name": "BoShek, Charismatic Smuggler",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/477.png",
                "isHorizontal": false
            }
        },
        "name": "BoShek, Charismatic Smuggler",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "PILOT"
        ]
    },
    "JTL_009": {
        "id": "JTL_009",
        "face": {
            "front": {
                "name": "Boba Fett, Any Methods Necessary",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/009-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Boba Fett, Any Methods Necessary",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/JTL/009-b.png"
            }
        },
        "name": "Boba Fett, Any Methods Necessary",
        "type": "Leader",
        "cost": 6,
        "rarity": "Special",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER",
            "PILOT"
        ]
    },
    "JTL_1005": {
        "id": "JTL_1005",
        "face": {
            "front": {
                "name": "Boba Fett, Any Methods Necessary",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1005-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Boba Fett, Any Methods Necessary",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/JTL/1005-b.png"
            }
        },
        "name": "Boba Fett, Any Methods Necessary",
        "type": "Leader",
        "cost": 6,
        "rarity": "Special",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER",
            "PILOT"
        ]
    },
    "JTL_189": {
        "id": "JTL_189",
        "face": {
            "front": {
                "name": "Boba Fett, Feared Bounty Hunter",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/189.png",
                "isHorizontal": false
            }
        },
        "name": "Boba Fett, Feared Bounty Hunter",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Rare",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER",
            "PILOT"
        ]
    },
    "JTL_271": {
        "id": "JTL_271",
        "face": {
            "front": {
                "name": "Boba Fett, Any Methods Necessary",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/271-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Boba Fett, Any Methods Necessary",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/JTL/271-b.png"
            }
        },
        "name": "Boba Fett, Any Methods Necessary",
        "type": "Leader",
        "cost": 6,
        "rarity": "Special",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER",
            "PILOT"
        ]
    },
    "JTL_451": {
        "id": "JTL_451",
        "face": {
            "front": {
                "name": "Boba Fett, Feared Bounty Hunter",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/451.png",
                "isHorizontal": false
            }
        },
        "name": "Boba Fett, Feared Bounty Hunter",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Rare",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER",
            "PILOT"
        ]
    },
    "JTL_187": {
        "id": "JTL_187",
        "face": {
            "front": {
                "name": "Bossk, Hunt By Instinct",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/187.png",
                "isHorizontal": false
            }
        },
        "name": "Bossk, Hunt By Instinct",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Special",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER",
            "PILOT"
        ]
    },
    "JTL_449": {
        "id": "JTL_449",
        "face": {
            "front": {
                "name": "Bossk, Hunt By Instinct",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/449.png",
                "isHorizontal": false
            }
        },
        "name": "Bossk, Hunt By Instinct",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Special",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER",
            "PILOT"
        ]
    },
    "JTL_107": {
        "id": "JTL_107",
        "face": {
            "front": {
                "name": "Bunker Defender",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/107.png",
                "isHorizontal": false
            }
        },
        "name": "Bunker Defender",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "JTL_369": {
        "id": "JTL_369",
        "face": {
            "front": {
                "name": "Bunker Defender",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/369.png",
                "isHorizontal": false
            }
        },
        "name": "Bunker Defender",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "TROOPER"
        ]
    },
    "JTL_071": {
        "id": "JTL_071",
        "face": {
            "front": {
                "name": "CR90 Relief Runner",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/071.png",
                "isHorizontal": false
            }
        },
        "name": "CR90 Relief Runner",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_333": {
        "id": "JTL_333",
        "face": {
            "front": {
                "name": "CR90 Relief Runner",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/333.png",
                "isHorizontal": false
            }
        },
        "name": "CR90 Relief Runner",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_010": {
        "id": "JTL_010",
        "face": {
            "front": {
                "name": "Captain Phasma, Chrome Dome",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/010-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Captain Phasma, Chrome Dome",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/JTL/010-b.png"
            }
        },
        "name": "Captain Phasma, Chrome Dome",
        "type": "Leader",
        "cost": 5,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FIRST ORDER",
            "TROOPER"
        ]
    },
    "JTL_088": {
        "id": "JTL_088",
        "face": {
            "front": {
                "name": "Captain Phasma, On My Command",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/088.png",
                "isHorizontal": false
            }
        },
        "name": "Captain Phasma, On My Command",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FIRST ORDER",
            "TROOPER"
        ]
    },
    "JTL_1006": {
        "id": "JTL_1006",
        "face": {
            "front": {
                "name": "Captain Phasma, Chrome Dome",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1006-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Captain Phasma, Chrome Dome",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/JTL/1006-b.png"
            }
        },
        "name": "Captain Phasma, Chrome Dome",
        "type": "Leader",
        "cost": 5,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FIRST ORDER",
            "TROOPER"
        ]
    },
    "JTL_272": {
        "id": "JTL_272",
        "face": {
            "front": {
                "name": "Captain Phasma, Chrome Dome",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/272-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Captain Phasma, Chrome Dome",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/JTL/272-b.png"
            }
        },
        "name": "Captain Phasma, Chrome Dome",
        "type": "Leader",
        "cost": 5,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FIRST ORDER",
            "TROOPER"
        ]
    },
    "JTL_350": {
        "id": "JTL_350",
        "face": {
            "front": {
                "name": "Captain Phasma, On My Command",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/350.png",
                "isHorizontal": false
            }
        },
        "name": "Captain Phasma, On My Command",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FIRST ORDER",
            "TROOPER"
        ]
    },
    "JTL_161": {
        "id": "JTL_161",
        "face": {
            "front": {
                "name": "Captain Tarkin, Full Forward Assault",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/161.png",
                "isHorizontal": false
            }
        },
        "name": "Captain Tarkin, Full Forward Assault",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Aggression"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "OFFICIAL"
        ]
    },
    "JTL_423": {
        "id": "JTL_423",
        "face": {
            "front": {
                "name": "Captain Tarkin, Full Forward Assault",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/423.png",
                "isHorizontal": false
            }
        },
        "name": "Captain Tarkin, Full Forward Assault",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Aggression"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "OFFICIAL"
        ]
    },
    "JTL_048": {
        "id": "JTL_048",
        "face": {
            "front": {
                "name": "Cassian Andor, Threading the Eye",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/048.png",
                "isHorizontal": false
            }
        },
        "name": "Cassian Andor, Threading the Eye",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Rare",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "PILOT"
        ]
    },
    "JTL_310": {
        "id": "JTL_310",
        "face": {
            "front": {
                "name": "Cassian Andor, Threading the Eye",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/310.png",
                "isHorizontal": false
            }
        },
        "name": "Cassian Andor, Threading the Eye",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Rare",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "PILOT"
        ]
    },
    "JTL_195": {
        "id": "JTL_195",
        "face": {
            "front": {
                "name": "Cat and Mouse",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/195.png",
                "isHorizontal": false
            }
        },
        "name": "Cat and Mouse",
        "type": "Event",
        "cost": 3,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_457": {
        "id": "JTL_457",
        "face": {
            "front": {
                "name": "Cat and Mouse",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/457.png",
                "isHorizontal": false
            }
        },
        "name": "Cat and Mouse",
        "type": "Event",
        "cost": 3,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_164": {
        "id": "JTL_164",
        "face": {
            "front": {
                "name": "Cham Syndulla, Rallying Ryloth",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/164.png",
                "isHorizontal": false
            }
        },
        "name": "Cham Syndulla, Rallying Ryloth",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Aggression"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "TWI'LEK"
        ]
    },
    "JTL_426": {
        "id": "JTL_426",
        "face": {
            "front": {
                "name": "Cham Syndulla, Rallying Ryloth",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/426.png",
                "isHorizontal": false
            }
        },
        "name": "Cham Syndulla, Rallying Ryloth",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Aggression"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "TWI'LEK"
        ]
    },
    "JTL_103": {
        "id": "JTL_103",
        "face": {
            "front": {
                "name": "Chewbacca, Faithful First Mate",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/103.png",
                "isHorizontal": false
            }
        },
        "name": "Chewbacca, Faithful First Mate",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Special",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "WOOKIEE",
            "PILOT"
        ]
    },
    "JTL_365": {
        "id": "JTL_365",
        "face": {
            "front": {
                "name": "Chewbacca, Faithful First Mate",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/365.png",
                "isHorizontal": false
            }
        },
        "name": "Chewbacca, Faithful First Mate",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Special",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "WOOKIEE",
            "PILOT"
        ]
    },
    "JTL_039": {
        "id": "JTL_039",
        "face": {
            "front": {
                "name": "Chimaera, Reinforcing the Center",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/039.png",
                "isHorizontal": false
            }
        },
        "name": "Chimaera, Reinforcing the Center",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Uncommon",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_1017": {
        "id": "JTL_1017",
        "face": {
            "front": {
                "name": "Chimaera, Reinforcing the Center",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1017.png",
                "isHorizontal": false
            }
        },
        "name": "Chimaera, Reinforcing the Center",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Uncommon",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_301": {
        "id": "JTL_301",
        "face": {
            "front": {
                "name": "Chimaera, Reinforcing the Center",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/301.png",
                "isHorizontal": false
            }
        },
        "name": "Chimaera, Reinforcing the Center",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Uncommon",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_029": {
        "id": "JTL_029",
        "face": {
            "front": {
                "name": "Chopper Base, Atollon",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/029-r.png",
                "isHorizontal": true
            }
        },
        "name": "Chopper Base, Atollon",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": []
    },
    "JTL_291": {
        "id": "JTL_291",
        "face": {
            "front": {
                "name": "Chopper Base, Atollon",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/291-r.png",
                "isHorizontal": true
            }
        },
        "name": "Chopper Base, Atollon",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": []
    },
    "JTL_019": {
        "id": "JTL_019",
        "face": {
            "front": {
                "name": "City in the Clouds, Cloud City",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/019-r.png",
                "isHorizontal": true
            }
        },
        "name": "City in the Clouds, Cloud City",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": []
    },
    "JTL_281": {
        "id": "JTL_281",
        "face": {
            "front": {
                "name": "City in the Clouds, Cloud City",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/281-r.png",
                "isHorizontal": true
            }
        },
        "name": "City in the Clouds, Cloud City",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": []
    },
    "JTL_067": {
        "id": "JTL_067",
        "face": {
            "front": {
                "name": "Cloaked StarViper",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/067.png",
                "isHorizontal": false
            }
        },
        "name": "Cloaked StarViper",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_329": {
        "id": "JTL_329",
        "face": {
            "front": {
                "name": "Cloaked StarViper",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/329.png",
                "isHorizontal": false
            }
        },
        "name": "Cloaked StarViper",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_115": {
        "id": "JTL_115",
        "face": {
            "front": {
                "name": "Clone Combat Squadron",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/115.png",
                "isHorizontal": false
            }
        },
        "name": "Clone Combat Squadron",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_377": {
        "id": "JTL_377",
        "face": {
            "front": {
                "name": "Clone Combat Squadron",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/377.png",
                "isHorizontal": false
            }
        },
        "name": "Clone Combat Squadron",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_108": {
        "id": "JTL_108",
        "face": {
            "front": {
                "name": "Clone Pilot",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/108.png",
                "isHorizontal": false
            }
        },
        "name": "Clone Pilot",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "PILOT"
        ]
    },
    "JTL_370": {
        "id": "JTL_370",
        "face": {
            "front": {
                "name": "Clone Pilot",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/370.png",
                "isHorizontal": false
            }
        },
        "name": "Clone Pilot",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "CLONE",
            "PILOT"
        ]
    },
    "JTL_074": {
        "id": "JTL_074",
        "face": {
            "front": {
                "name": "Close the Shield Gate",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/074.png",
                "isHorizontal": false
            }
        },
        "name": "Close the Shield Gate",
        "type": "Event",
        "cost": 1,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_336": {
        "id": "JTL_336",
        "face": {
            "front": {
                "name": "Close the Shield Gate",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/336.png",
                "isHorizontal": false
            }
        },
        "name": "Close the Shield Gate",
        "type": "Event",
        "cost": 1,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_021": {
        "id": "JTL_021",
        "face": {
            "front": {
                "name": "Colossus, Castilon",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/021-r.png",
                "isHorizontal": true
            }
        },
        "name": "Colossus, Castilon",
        "type": "Base",
        "cost": 0,
        "rarity": "Rare",
        "power": 0,
        "HP": 35,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": []
    },
    "JTL_283": {
        "id": "JTL_283",
        "face": {
            "front": {
                "name": "Colossus, Castilon",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/283-r.png",
                "isHorizontal": true
            }
        },
        "name": "Colossus, Castilon",
        "type": "Base",
        "cost": 0,
        "rarity": "Rare",
        "power": 0,
        "HP": 35,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": []
    },
    "JTL_235": {
        "id": "JTL_235",
        "face": {
            "front": {
                "name": "Commandeer",
                "type": "Event",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/235.png",
                "isHorizontal": false
            }
        },
        "name": "Commandeer",
        "type": "Event",
        "cost": 5,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "JTL_497": {
        "id": "JTL_497",
        "face": {
            "front": {
                "name": "Commandeer",
                "type": "Event",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/497.png",
                "isHorizontal": false
            }
        },
        "name": "Commandeer",
        "type": "Event",
        "cost": 5,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "JTL_205": {
        "id": "JTL_205",
        "face": {
            "front": {
                "name": "Commence Patrol",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/205.png",
                "isHorizontal": false
            }
        },
        "name": "Commence Patrol",
        "type": "Event",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_467": {
        "id": "JTL_467",
        "face": {
            "front": {
                "name": "Commence Patrol",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/467.png",
                "isHorizontal": false
            }
        },
        "name": "Commence Patrol",
        "type": "Event",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_216": {
        "id": "JTL_216",
        "face": {
            "front": {
                "name": "Contracted Hunter",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/216.png",
                "isHorizontal": false
            }
        },
        "name": "Contracted Hunter",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "JTL_478": {
        "id": "JTL_478",
        "face": {
            "front": {
                "name": "Contracted Hunter",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/478.png",
                "isHorizontal": false
            }
        },
        "name": "Contracted Hunter",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "JTL_184": {
        "id": "JTL_184",
        "face": {
            "front": {
                "name": "Contracted Jumpmaster",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/184.png",
                "isHorizontal": false
            }
        },
        "name": "Contracted Jumpmaster",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_446": {
        "id": "JTL_446",
        "face": {
            "front": {
                "name": "Contracted Jumpmaster",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/446.png",
                "isHorizontal": false
            }
        },
        "name": "Contracted Jumpmaster",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_253": {
        "id": "JTL_253",
        "face": {
            "front": {
                "name": "Coordinated Front",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/253.png",
                "isHorizontal": false
            }
        },
        "name": "Coordinated Front",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "JTL_515": {
        "id": "JTL_515",
        "face": {
            "front": {
                "name": "Coordinated Front",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/515.png",
                "isHorizontal": false
            }
        },
        "name": "Coordinated Front",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "JTL_258": {
        "id": "JTL_258",
        "face": {
            "front": {
                "name": "Corellian Freighter",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/258.png",
                "isHorizontal": false
            }
        },
        "name": "Corellian Freighter",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 4,
        "aspects": [],
        "unique": false,
        "traits": [
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_520": {
        "id": "JTL_520",
        "face": {
            "front": {
                "name": "Corellian Freighter",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/520.png",
                "isHorizontal": false
            }
        },
        "name": "Corellian Freighter",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 4,
        "aspects": [],
        "unique": false,
        "traits": [
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_059": {
        "id": "JTL_059",
        "face": {
            "front": {
                "name": "Corporate Defense Shuttle",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/059.png",
                "isHorizontal": false
            }
        },
        "name": "Corporate Defense Shuttle",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Rare",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_321": {
        "id": "JTL_321",
        "face": {
            "front": {
                "name": "Corporate Defense Shuttle",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/321.png",
                "isHorizontal": false
            }
        },
        "name": "Corporate Defense Shuttle",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Rare",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_225": {
        "id": "JTL_225",
        "face": {
            "front": {
                "name": "Corporate Light Cruiser",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/225.png",
                "isHorizontal": false
            }
        },
        "name": "Corporate Light Cruiser",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_487": {
        "id": "JTL_487",
        "face": {
            "front": {
                "name": "Corporate Light Cruiser",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/487.png",
                "isHorizontal": false
            }
        },
        "name": "Corporate Light Cruiser",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_038": {
        "id": "JTL_038",
        "face": {
            "front": {
                "name": "Corvus, Inferno Squadron Raider",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/038.png",
                "isHorizontal": false
            }
        },
        "name": "Corvus, Inferno Squadron Raider",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Rare",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_1016": {
        "id": "JTL_1016",
        "face": {
            "front": {
                "name": "Corvus, Inferno Squadron Raider",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1016.png",
                "isHorizontal": false
            }
        },
        "name": "Corvus, Inferno Squadron Raider",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Rare",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_300": {
        "id": "JTL_300",
        "face": {
            "front": {
                "name": "Corvus, Inferno Squadron Raider",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/300.png",
                "isHorizontal": false
            }
        },
        "name": "Corvus, Inferno Squadron Raider",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Rare",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_076": {
        "id": "JTL_076",
        "face": {
            "front": {
                "name": "Covering the Wing",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/076.png",
                "isHorizontal": false
            }
        },
        "name": "Covering the Wing",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_338": {
        "id": "JTL_338",
        "face": {
            "front": {
                "name": "Covering the Wing",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/338.png",
                "isHorizontal": false
            }
        },
        "name": "Covering the Wing",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_158": {
        "id": "JTL_158",
        "face": {
            "front": {
                "name": "Crackshot V-Wing",
                "type": "Unit - Space",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/158.png",
                "isHorizontal": false
            }
        },
        "name": "Crackshot V-Wing",
        "type": "Unit - Space",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_420": {
        "id": "JTL_420",
        "face": {
            "front": {
                "name": "Crackshot V-Wing",
                "type": "Unit - Space",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/420.png",
                "isHorizontal": false
            }
        },
        "name": "Crackshot V-Wing",
        "type": "Unit - Space",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_052": {
        "id": "JTL_052",
        "face": {
            "front": {
                "name": "D'Qar Cargo Frigate",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/052.png",
                "isHorizontal": false
            }
        },
        "name": "D'Qar Cargo Frigate",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 6,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "RESISTANCE",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_314": {
        "id": "JTL_314",
        "face": {
            "front": {
                "name": "D'Qar Cargo Frigate",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/314.png",
                "isHorizontal": false
            }
        },
        "name": "D'Qar Cargo Frigate",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 6,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "RESISTANCE",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_196": {
        "id": "JTL_196",
        "face": {
            "front": {
                "name": "Dagger Squadron Pilot",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/196.png",
                "isHorizontal": false
            }
        },
        "name": "Dagger Squadron Pilot",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "PILOT"
        ]
    },
    "JTL_458": {
        "id": "JTL_458",
        "face": {
            "front": {
                "name": "Dagger Squadron Pilot",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/458.png",
                "isHorizontal": false
            }
        },
        "name": "Dagger Squadron Pilot",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "PILOT"
        ]
    },
    "JTL_006": {
        "id": "JTL_006",
        "face": {
            "front": {
                "name": "Darth Vader, Victor Squadron Leader",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/006-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Darth Vader, Victor Squadron Leader",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/JTL/006-b.png"
            }
        },
        "name": "Darth Vader, Victor Squadron Leader",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "IMPERIAL",
            "SITH",
            "PILOT"
        ]
    },
    "JTL_1002": {
        "id": "JTL_1002",
        "face": {
            "front": {
                "name": "Darth Vader, Victor Squadron Leader",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1002-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Darth Vader, Victor Squadron Leader",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/JTL/1002-b.png"
            }
        },
        "name": "Darth Vader, Victor Squadron Leader",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "IMPERIAL",
            "SITH",
            "PILOT"
        ]
    },
    "JTL_142": {
        "id": "JTL_142",
        "face": {
            "front": {
                "name": "Darth Vader, Scourge of Squadrons",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/142.png",
                "isHorizontal": false
            }
        },
        "name": "Darth Vader, Scourge of Squadrons",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Legendary",
        "power": 7,
        "HP": 7,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "IMPERIAL",
            "SITH",
            "PILOT"
        ]
    },
    "JTL_268": {
        "id": "JTL_268",
        "face": {
            "front": {
                "name": "Darth Vader, Victor Squadron Leader",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/268-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Darth Vader, Victor Squadron Leader",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/JTL/268-b.png"
            }
        },
        "name": "Darth Vader, Victor Squadron Leader",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "IMPERIAL",
            "SITH",
            "PILOT"
        ]
    },
    "JTL_404": {
        "id": "JTL_404",
        "face": {
            "front": {
                "name": "Darth Vader, Scourge of Squadrons",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/404.png",
                "isHorizontal": false
            }
        },
        "name": "Darth Vader, Scourge of Squadrons",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Legendary",
        "power": 7,
        "HP": 7,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "IMPERIAL",
            "SITH",
            "PILOT"
        ]
    },
    "JTL_024": {
        "id": "JTL_024",
        "face": {
            "front": {
                "name": "Data Vault, Scarif",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/024-r.png",
                "isHorizontal": true
            }
        },
        "name": "Data Vault, Scarif",
        "type": "Base",
        "cost": 0,
        "rarity": "Rare",
        "power": 0,
        "HP": 33,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": []
    },
    "JTL_286": {
        "id": "JTL_286",
        "face": {
            "front": {
                "name": "Data Vault, Scarif",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/286-r.png",
                "isHorizontal": true
            }
        },
        "name": "Data Vault, Scarif",
        "type": "Base",
        "cost": 0,
        "rarity": "Rare",
        "power": 0,
        "HP": 33,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": []
    },
    "JTL_217": {
        "id": "JTL_217",
        "face": {
            "front": {
                "name": "Death Space Skirmisher",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/217.png",
                "isHorizontal": false
            }
        },
        "name": "Death Space Skirmisher",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_479": {
        "id": "JTL_479",
        "face": {
            "front": {
                "name": "Death Space Skirmisher",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/479.png",
                "isHorizontal": false
            }
        },
        "name": "Death Space Skirmisher",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_260": {
        "id": "JTL_260",
        "face": {
            "front": {
                "name": "Death Star Plans",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/260.png",
                "isHorizontal": false
            }
        },
        "name": "Death Star Plans",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [],
        "unique": false,
        "traits": [
            "ITEM"
        ]
    },
    "JTL_522": {
        "id": "JTL_522",
        "face": {
            "front": {
                "name": "Death Star Plans",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/522.png",
                "isHorizontal": false
            }
        },
        "name": "Death Star Plans",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [],
        "unique": false,
        "traits": [
            "ITEM"
        ]
    },
    "JTL_138": {
        "id": "JTL_138",
        "face": {
            "front": {
                "name": "Decimator of Dissidents",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/138.png",
                "isHorizontal": false
            }
        },
        "name": "Decimator of Dissidents",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_400": {
        "id": "JTL_400",
        "face": {
            "front": {
                "name": "Decimator of Dissidents",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/400.png",
                "isHorizontal": false
            }
        },
        "name": "Decimator of Dissidents",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_254": {
        "id": "JTL_254",
        "face": {
            "front": {
                "name": "Dedicated Wingmen",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/254.png",
                "isHorizontal": false
            }
        },
        "name": "Dedicated Wingmen",
        "type": "Event",
        "cost": 4,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "JTL_516": {
        "id": "JTL_516",
        "face": {
            "front": {
                "name": "Dedicated Wingmen",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/516.png",
                "isHorizontal": false
            }
        },
        "name": "Dedicated Wingmen",
        "type": "Event",
        "cost": 4,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "JTL_139": {
        "id": "JTL_139",
        "face": {
            "front": {
                "name": "Dengar, Crude and Slovenly",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/139.png",
                "isHorizontal": false
            }
        },
        "name": "Dengar, Crude and Slovenly",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER",
            "PILOT"
        ]
    },
    "JTL_401": {
        "id": "JTL_401",
        "face": {
            "front": {
                "name": "Dengar, Crude and Slovenly",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/401.png",
                "isHorizontal": false
            }
        },
        "name": "Dengar, Crude and Slovenly",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER",
            "PILOT"
        ]
    },
    "JTL_060": {
        "id": "JTL_060",
        "face": {
            "front": {
                "name": "Desperate Commando",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/060.png",
                "isHorizontal": false
            }
        },
        "name": "Desperate Commando",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "RESISTANCE",
            "TROOPER"
        ]
    },
    "JTL_322": {
        "id": "JTL_322",
        "face": {
            "front": {
                "name": "Desperate Commando",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/322.png",
                "isHorizontal": false
            }
        },
        "name": "Desperate Commando",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "RESISTANCE",
            "TROOPER"
        ]
    },
    "JTL_159": {
        "id": "JTL_159",
        "face": {
            "front": {
                "name": "Determined Recruit",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/159.png",
                "isHorizontal": false
            }
        },
        "name": "Determined Recruit",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 3,
        "HP": 1,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "RESISTANCE",
            "PILOT"
        ]
    },
    "JTL_421": {
        "id": "JTL_421",
        "face": {
            "front": {
                "name": "Determined Recruit",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/421.png",
                "isHorizontal": false
            }
        },
        "name": "Determined Recruit",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 3,
        "HP": 1,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "RESISTANCE",
            "PILOT"
        ]
    },
    "JTL_1032": {
        "id": "JTL_1032",
        "face": {
            "front": {
                "name": "Devastator, Hunting the Rebellion",
                "type": "Unit - Space",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1032.png",
                "isHorizontal": false
            }
        },
        "name": "Devastator, Hunting the Rebellion",
        "type": "Unit - Space",
        "cost": 8,
        "rarity": "Legendary",
        "power": 9,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_143": {
        "id": "JTL_143",
        "face": {
            "front": {
                "name": "Devastator, Hunting the Rebellion",
                "type": "Unit - Space",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/JTL/143.png",
                "isHorizontal": false
            }
        },
        "name": "Devastator, Hunting the Rebellion",
        "type": "Unit - Space",
        "cost": 8,
        "rarity": "Legendary",
        "power": 9,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_405": {
        "id": "JTL_405",
        "face": {
            "front": {
                "name": "Devastator, Hunting the Rebellion",
                "type": "Unit - Space",
                "cost": 8,
                "image": "https://cdn.swu-db.com/images/cards/JTL/405.png",
                "isHorizontal": false
            }
        },
        "name": "Devastator, Hunting the Rebellion",
        "type": "Unit - Space",
        "cost": 8,
        "rarity": "Legendary",
        "power": 9,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_248": {
        "id": "JTL_248",
        "face": {
            "front": {
                "name": "Dilapidated Ski Speeder",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/248.png",
                "isHorizontal": false
            }
        },
        "name": "Dilapidated Ski Speeder",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 7,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "RESISTANCE",
            "VEHICLE",
            "SPEEDER"
        ]
    },
    "JTL_510": {
        "id": "JTL_510",
        "face": {
            "front": {
                "name": "Dilapidated Ski Speeder",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/510.png",
                "isHorizontal": false
            }
        },
        "name": "Dilapidated Ski Speeder",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 7,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "RESISTANCE",
            "VEHICLE",
            "SPEEDER"
        ]
    },
    "JTL_078": {
        "id": "JTL_078",
        "face": {
            "front": {
                "name": "Direct Hit",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/078.png",
                "isHorizontal": false
            }
        },
        "name": "Direct Hit",
        "type": "Event",
        "cost": 4,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_340": {
        "id": "JTL_340",
        "face": {
            "front": {
                "name": "Direct Hit",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/340.png",
                "isHorizontal": false
            }
        },
        "name": "Direct Hit",
        "type": "Event",
        "cost": 4,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_032": {
        "id": "JTL_032",
        "face": {
            "front": {
                "name": "Director Krennic, On the Verge Of Greatness",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/032.png",
                "isHorizontal": false
            }
        },
        "name": "Director Krennic, On the Verge Of Greatness",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "JTL_294": {
        "id": "JTL_294",
        "face": {
            "front": {
                "name": "Director Krennic, On the Verge Of Greatness",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/294.png",
                "isHorizontal": false
            }
        },
        "name": "Director Krennic, On the Verge Of Greatness",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "JTL_229": {
        "id": "JTL_229",
        "face": {
            "front": {
                "name": "Diversion",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/229.png",
                "isHorizontal": false
            }
        },
        "name": "Diversion",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "JTL_491": {
        "id": "JTL_491",
        "face": {
            "front": {
                "name": "Diversion",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/491.png",
                "isHorizontal": false
            }
        },
        "name": "Diversion",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "JTL_123": {
        "id": "JTL_123",
        "face": {
            "front": {
                "name": "Dogfight",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/123.png",
                "isHorizontal": false
            }
        },
        "name": "Dogfight",
        "type": "Event",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_385": {
        "id": "JTL_385",
        "face": {
            "front": {
                "name": "Dogfight",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/385.png",
                "isHorizontal": false
            }
        },
        "name": "Dogfight",
        "type": "Event",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_116": {
        "id": "JTL_116",
        "face": {
            "front": {
                "name": "Dornean Gunship",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/116.png",
                "isHorizontal": false
            }
        },
        "name": "Dornean Gunship",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_378": {
        "id": "JTL_378",
        "face": {
            "front": {
                "name": "Dornean Gunship",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/378.png",
                "isHorizontal": false
            }
        },
        "name": "Dornean Gunship",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_120": {
        "id": "JTL_120",
        "face": {
            "front": {
                "name": "Dorsal Turret",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/120.png",
                "isHorizontal": false
            }
        },
        "name": "Dorsal Turret",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "MODIFICATION",
            "WEAPON"
        ]
    },
    "JTL_382": {
        "id": "JTL_382",
        "face": {
            "front": {
                "name": "Dorsal Turret",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/382.png",
                "isHorizontal": false
            }
        },
        "name": "Dorsal Turret",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "MODIFICATION",
            "WEAPON"
        ]
    },
    "JTL_162": {
        "id": "JTL_162",
        "face": {
            "front": {
                "name": "Droid Missile Platform",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/162.png",
                "isHorizontal": false
            }
        },
        "name": "Droid Missile Platform",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 4,
        "HP": 2,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_424": {
        "id": "JTL_424",
        "face": {
            "front": {
                "name": "Droid Missile Platform",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/424.png",
                "isHorizontal": false
            }
        },
        "name": "Droid Missile Platform",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 4,
        "HP": 2,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_112": {
        "id": "JTL_112",
        "face": {
            "front": {
                "name": "Eager Escort Fighter",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/112.png",
                "isHorizontal": false
            }
        },
        "name": "Eager Escort Fighter",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 4,
        "HP": 1,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "NEW REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_374": {
        "id": "JTL_374",
        "face": {
            "front": {
                "name": "Eager Escort Fighter",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/374.png",
                "isHorizontal": false
            }
        },
        "name": "Eager Escort Fighter",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 4,
        "HP": 1,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "NEW REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_044": {
        "id": "JTL_044",
        "face": {
            "front": {
                "name": "Echo Base Engineer",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/044.png",
                "isHorizontal": false
            }
        },
        "name": "Echo Base Engineer",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL"
        ]
    },
    "JTL_306": {
        "id": "JTL_306",
        "face": {
            "front": {
                "name": "Echo Base Engineer",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/306.png",
                "isHorizontal": false
            }
        },
        "name": "Echo Base Engineer",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL"
        ]
    },
    "JTL_126": {
        "id": "JTL_126",
        "face": {
            "front": {
                "name": "Eject",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/126.png",
                "isHorizontal": false
            }
        },
        "name": "Eject",
        "type": "Event",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "JTL_388": {
        "id": "JTL_388",
        "face": {
            "front": {
                "name": "Eject",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/388.png",
                "isHorizontal": false
            }
        },
        "name": "Eject",
        "type": "Event",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "JTL_230": {
        "id": "JTL_230",
        "face": {
            "front": {
                "name": "Electromagnetic Pulse",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/230.png",
                "isHorizontal": false
            }
        },
        "name": "Electromagnetic Pulse",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_492": {
        "id": "JTL_492",
        "face": {
            "front": {
                "name": "Electromagnetic Pulse",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/492.png",
                "isHorizontal": false
            }
        },
        "name": "Electromagnetic Pulse",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_262": {
        "id": "JTL_262",
        "face": {
            "front": {
                "name": "Evasive Maneuver",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/262.png",
                "isHorizontal": false
            }
        },
        "name": "Evasive Maneuver",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "JTL_524": {
        "id": "JTL_524",
        "face": {
            "front": {
                "name": "Evasive Maneuver",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/524.png",
                "isHorizontal": false
            }
        },
        "name": "Evasive Maneuver",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "JTL_090": {
        "id": "JTL_090",
        "face": {
            "front": {
                "name": "Executor, Might of the Empire",
                "type": "Unit - Space",
                "cost": 11,
                "image": "https://cdn.swu-db.com/images/cards/JTL/090.png",
                "isHorizontal": false
            }
        },
        "name": "Executor, Might of the Empire",
        "type": "Unit - Space",
        "cost": 11,
        "rarity": "Legendary",
        "power": 12,
        "HP": 12,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_1025": {
        "id": "JTL_1025",
        "face": {
            "front": {
                "name": "Executor, Might of the Empire",
                "type": "Unit - Space",
                "cost": 11,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1025.png",
                "isHorizontal": false
            }
        },
        "name": "Executor, Might of the Empire",
        "type": "Unit - Space",
        "cost": 11,
        "rarity": "Legendary",
        "power": 12,
        "HP": 12,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_352": {
        "id": "JTL_352",
        "face": {
            "front": {
                "name": "Executor, Might of the Empire",
                "type": "Unit - Space",
                "cost": 11,
                "image": "https://cdn.swu-db.com/images/cards/JTL/352.png",
                "isHorizontal": false
            }
        },
        "name": "Executor, Might of the Empire",
        "type": "Unit - Space",
        "cost": 11,
        "rarity": "Legendary",
        "power": 12,
        "HP": 12,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_178": {
        "id": "JTL_178",
        "face": {
            "front": {
                "name": "Face Off",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/178.png",
                "isHorizontal": false
            }
        },
        "name": "Face Off",
        "type": "Event",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_440": {
        "id": "JTL_440",
        "face": {
            "front": {
                "name": "Face Off",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/440.png",
                "isHorizontal": false
            }
        },
        "name": "Face Off",
        "type": "Event",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_1046": {
        "id": "JTL_1046",
        "face": {
            "front": {
                "name": "Fett's Firespray, Feared Silhouette",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1046.png",
                "isHorizontal": false
            }
        },
        "name": "Fett's Firespray, Feared Silhouette",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Special",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_240": {
        "id": "JTL_240",
        "face": {
            "front": {
                "name": "Fett's Firespray, Feared Silhouette",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/240.png",
                "isHorizontal": false
            }
        },
        "name": "Fett's Firespray, Feared Silhouette",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Special",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_502": {
        "id": "JTL_502",
        "face": {
            "front": {
                "name": "Fett's Firespray, Feared Silhouette",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/502.png",
                "isHorizontal": false
            }
        },
        "name": "Fett's Firespray, Feared Silhouette",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Special",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_173": {
        "id": "JTL_173",
        "face": {
            "front": {
                "name": "Fight Fire With Fire",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/173.png",
                "isHorizontal": false
            }
        },
        "name": "Fight Fire With Fire",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "JTL_435": {
        "id": "JTL_435",
        "face": {
            "front": {
                "name": "Fight Fire With Fire",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/435.png",
                "isHorizontal": false
            }
        },
        "name": "Fight Fire With Fire",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "JTL_1041": {
        "id": "JTL_1041",
        "face": {
            "front": {
                "name": "Fireball, An Explosion With Wings",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1041.png",
                "isHorizontal": false
            }
        },
        "name": "Fireball, An Explosion With Wings",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_198": {
        "id": "JTL_198",
        "face": {
            "front": {
                "name": "Fireball, An Explosion With Wings",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/198.png",
                "isHorizontal": false
            }
        },
        "name": "Fireball, An Explosion With Wings",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_460": {
        "id": "JTL_460",
        "face": {
            "front": {
                "name": "Fireball, An Explosion With Wings",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/460.png",
                "isHorizontal": false
            }
        },
        "name": "Fireball, An Explosion With Wings",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_132": {
        "id": "JTL_132",
        "face": {
            "front": {
                "name": "First Order Stormtrooper",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/132.png",
                "isHorizontal": false
            }
        },
        "name": "First Order Stormtrooper",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "FIRST ORDER",
            "TROOPER"
        ]
    },
    "JTL_394": {
        "id": "JTL_394",
        "face": {
            "front": {
                "name": "First Order Stormtrooper",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/394.png",
                "isHorizontal": false
            }
        },
        "name": "First Order Stormtrooper",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "FIRST ORDER",
            "TROOPER"
        ]
    },
    "JTL_081": {
        "id": "JTL_081",
        "face": {
            "front": {
                "name": "First Order TIE Fighter",
                "type": "Unit - Space",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/081.png",
                "isHorizontal": false
            }
        },
        "name": "First Order TIE Fighter",
        "type": "Unit - Space",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "FIRST ORDER",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_343": {
        "id": "JTL_343",
        "face": {
            "front": {
                "name": "First Order TIE Fighter",
                "type": "Unit - Space",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/343.png",
                "isHorizontal": false
            }
        },
        "name": "First Order TIE Fighter",
        "type": "Unit - Space",
        "cost": 1,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "FIRST ORDER",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_257": {
        "id": "JTL_257",
        "face": {
            "front": {
                "name": "Flanking Fang Fighter",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/257.png",
                "isHorizontal": false
            }
        },
        "name": "Flanking Fang Fighter",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [],
        "unique": false,
        "traits": [
            "MANDALORIAN",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_519": {
        "id": "JTL_519",
        "face": {
            "front": {
                "name": "Flanking Fang Fighter",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/519.png",
                "isHorizontal": false
            }
        },
        "name": "Flanking Fang Fighter",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [],
        "unique": false,
        "traits": [
            "MANDALORIAN",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_040": {
        "id": "JTL_040",
        "face": {
            "front": {
                "name": "Fleet Interdictor",
                "type": "Unit - Space",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/JTL/040.png",
                "isHorizontal": false
            }
        },
        "name": "Fleet Interdictor",
        "type": "Unit - Space",
        "cost": 7,
        "rarity": "Common",
        "power": 6,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_302": {
        "id": "JTL_302",
        "face": {
            "front": {
                "name": "Fleet Interdictor",
                "type": "Unit - Space",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/JTL/302.png",
                "isHorizontal": false
            }
        },
        "name": "Fleet Interdictor",
        "type": "Unit - Space",
        "cost": 7,
        "rarity": "Common",
        "power": 6,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_206": {
        "id": "JTL_206",
        "face": {
            "front": {
                "name": "Fly Casual",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/206.png",
                "isHorizontal": false
            }
        },
        "name": "Fly Casual",
        "type": "Event",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "JTL_468": {
        "id": "JTL_468",
        "face": {
            "front": {
                "name": "Fly Casual",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/468.png",
                "isHorizontal": false
            }
        },
        "name": "Fly Casual",
        "type": "Event",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "JTL_129": {
        "id": "JTL_129",
        "face": {
            "front": {
                "name": "Focus Fire",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/129.png",
                "isHorizontal": false
            }
        },
        "name": "Focus Fire",
        "type": "Event",
        "cost": 4,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_391": {
        "id": "JTL_391",
        "face": {
            "front": {
                "name": "Focus Fire",
                "type": "Event",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/391.png",
                "isHorizontal": false
            }
        },
        "name": "Focus Fire",
        "type": "Event",
        "cost": 4,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_148": {
        "id": "JTL_148",
        "face": {
            "front": {
                "name": "Frisk, Vanguard Loudmouth",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/148.png",
                "isHorizontal": false
            }
        },
        "name": "Frisk, Vanguard Loudmouth",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "NEW REPUBLIC",
            "PILOT"
        ]
    },
    "JTL_410": {
        "id": "JTL_410",
        "face": {
            "front": {
                "name": "Frisk, Vanguard Loudmouth",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/410.png",
                "isHorizontal": false
            }
        },
        "name": "Frisk, Vanguard Loudmouth",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "NEW REPUBLIC",
            "PILOT"
        ]
    },
    "JTL_117": {
        "id": "JTL_117",
        "face": {
            "front": {
                "name": "General Draven, Doing What Must Be Done",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/117.png",
                "isHorizontal": false
            }
        },
        "name": "General Draven, Doing What Must Be Done",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Rare",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Command"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "OFFICIAL"
        ]
    },
    "JTL_379": {
        "id": "JTL_379",
        "face": {
            "front": {
                "name": "General Draven, Doing What Must Be Done",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/379.png",
                "isHorizontal": false
            }
        },
        "name": "General Draven, Doing What Must Be Done",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Rare",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Command"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "OFFICIAL"
        ]
    },
    "JTL_134": {
        "id": "JTL_134",
        "face": {
            "front": {
                "name": "General Hux, No Terms, No Surrender",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/134.png",
                "isHorizontal": false
            }
        },
        "name": "General Hux, No Terms, No Surrender",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FIRST ORDER",
            "OFFICIAL"
        ]
    },
    "JTL_396": {
        "id": "JTL_396",
        "face": {
            "front": {
                "name": "General Hux, No Terms, No Surrender",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/396.png",
                "isHorizontal": false
            }
        },
        "name": "General Hux, No Terms, No Surrender",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FIRST ORDER",
            "OFFICIAL"
        ]
    },
    "JTL_054": {
        "id": "JTL_054",
        "face": {
            "front": {
                "name": "Gold Leader, Fastest Ship in the Fleet",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/054.png",
                "isHorizontal": false
            }
        },
        "name": "Gold Leader, Fastest Ship in the Fleet",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Uncommon",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_1021": {
        "id": "JTL_1021",
        "face": {
            "front": {
                "name": "Gold Leader, Fastest Ship in the Fleet",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1021.png",
                "isHorizontal": false
            }
        },
        "name": "Gold Leader, Fastest Ship in the Fleet",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Uncommon",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_316": {
        "id": "JTL_316",
        "face": {
            "front": {
                "name": "Gold Leader, Fastest Ship in the Fleet",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/316.png",
                "isHorizontal": false
            }
        },
        "name": "Gold Leader, Fastest Ship in the Fleet",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Uncommon",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_002": {
        "id": "JTL_002",
        "face": {
            "front": {
                "name": "Grand Admiral Thrawn, ...How Unfortunate",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/002-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Grand Admiral Thrawn, ...How Unfortunate",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/JTL/002-b.png"
            }
        },
        "name": "Grand Admiral Thrawn, ...How Unfortunate",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "JTL_264": {
        "id": "JTL_264",
        "face": {
            "front": {
                "name": "Grand Admiral Thrawn, ...How Unfortunate",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/264-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Grand Admiral Thrawn, ...How Unfortunate",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/JTL/264-b.png"
            }
        },
        "name": "Grand Admiral Thrawn, ...How Unfortunate",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "JTL_998": {
        "id": "JTL_998",
        "face": {
            "front": {
                "name": "Grand Admiral Thrawn, ...How Unfortunate",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/998-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Grand Admiral Thrawn, ...How Unfortunate",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/JTL/998-b.png"
            }
        },
        "name": "Grand Admiral Thrawn, ...How Unfortunate",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "JTL_073": {
        "id": "JTL_073",
        "face": {
            "front": {
                "name": "Grim Valor",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/073.png",
                "isHorizontal": false
            }
        },
        "name": "Grim Valor",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "JTL_335": {
        "id": "JTL_335",
        "face": {
            "front": {
                "name": "Grim Valor",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/335.png",
                "isHorizontal": false
            }
        },
        "name": "Grim Valor",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "JTL_218": {
        "id": "JTL_218",
        "face": {
            "front": {
                "name": "Guerilla Soldier",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/218.png",
                "isHorizontal": false
            }
        },
        "name": "Guerilla Soldier",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "TWI'LEK",
            "TROOPER"
        ]
    },
    "JTL_480": {
        "id": "JTL_480",
        "face": {
            "front": {
                "name": "Guerilla Soldier",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/480.png",
                "isHorizontal": false
            }
        },
        "name": "Guerilla Soldier",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "TWI'LEK",
            "TROOPER"
        ]
    },
    "JTL_017": {
        "id": "JTL_017",
        "face": {
            "front": {
                "name": "Han Solo, Never Tell Me the Odds",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/017-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Han Solo, Never Tell Me the Odds",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/JTL/017-b.png"
            }
        },
        "name": "Han Solo, Never Tell Me the Odds",
        "type": "Leader",
        "cost": 5,
        "rarity": "Special",
        "power": 3,
        "HP": 7,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "PILOT"
        ]
    },
    "JTL_1013": {
        "id": "JTL_1013",
        "face": {
            "front": {
                "name": "Han Solo, Never Tell Me the Odds",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1013-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Han Solo, Never Tell Me the Odds",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/JTL/1013-b.png"
            }
        },
        "name": "Han Solo, Never Tell Me the Odds",
        "type": "Leader",
        "cost": 5,
        "rarity": "Special",
        "power": 3,
        "HP": 7,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "PILOT"
        ]
    },
    "JTL_203": {
        "id": "JTL_203",
        "face": {
            "front": {
                "name": "Han Solo, Has His Moments",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/203.png",
                "isHorizontal": false
            }
        },
        "name": "Han Solo, Has His Moments",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Legendary",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "PILOT"
        ]
    },
    "JTL_279": {
        "id": "JTL_279",
        "face": {
            "front": {
                "name": "Han Solo, Never Tell Me the Odds",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/279-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Han Solo, Never Tell Me the Odds",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/JTL/279-b.png"
            }
        },
        "name": "Han Solo, Never Tell Me the Odds",
        "type": "Leader",
        "cost": 5,
        "rarity": "Special",
        "power": 3,
        "HP": 7,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "PILOT"
        ]
    },
    "JTL_465": {
        "id": "JTL_465",
        "face": {
            "front": {
                "name": "Han Solo, Has His Moments",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/465.png",
                "isHorizontal": false
            }
        },
        "name": "Han Solo, Has His Moments",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Legendary",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "PILOT"
        ]
    },
    "JTL_194": {
        "id": "JTL_194",
        "face": {
            "front": {
                "name": "Heartless Tactics",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/194.png",
                "isHorizontal": false
            }
        },
        "name": "Heartless Tactics",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_456": {
        "id": "JTL_456",
        "face": {
            "front": {
                "name": "Heartless Tactics",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/456.png",
                "isHorizontal": false
            }
        },
        "name": "Heartless Tactics",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_045": {
        "id": "JTL_045",
        "face": {
            "front": {
                "name": "Hera Syndulla, We've Lost Enough",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/045.png",
                "isHorizontal": false
            }
        },
        "name": "Hera Syndulla, We've Lost Enough",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "TWI'LEK",
            "SPECTRE",
            "PILOT"
        ]
    },
    "JTL_307": {
        "id": "JTL_307",
        "face": {
            "front": {
                "name": "Hera Syndulla, We've Lost Enough",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/307.png",
                "isHorizontal": false
            }
        },
        "name": "Hera Syndulla, We've Lost Enough",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "TWI'LEK",
            "SPECTRE",
            "PILOT"
        ]
    },
    "JTL_1043": {
        "id": "JTL_1043",
        "face": {
            "front": {
                "name": "Home One, On My Mark",
                "type": "Unit - Space",
                "cost": 9,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1043.png",
                "isHorizontal": false
            }
        },
        "name": "Home One, On My Mark",
        "type": "Unit - Space",
        "cost": 9,
        "rarity": "Legendary",
        "power": 7,
        "HP": 8,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_204": {
        "id": "JTL_204",
        "face": {
            "front": {
                "name": "Home One, On My Mark",
                "type": "Unit - Space",
                "cost": 9,
                "image": "https://cdn.swu-db.com/images/cards/JTL/204.png",
                "isHorizontal": false
            }
        },
        "name": "Home One, On My Mark",
        "type": "Unit - Space",
        "cost": 9,
        "rarity": "Legendary",
        "power": 7,
        "HP": 8,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_466": {
        "id": "JTL_466",
        "face": {
            "front": {
                "name": "Home One, On My Mark",
                "type": "Unit - Space",
                "cost": 9,
                "image": "https://cdn.swu-db.com/images/cards/JTL/466.png",
                "isHorizontal": false
            }
        },
        "name": "Home One, On My Mark",
        "type": "Unit - Space",
        "cost": 9,
        "rarity": "Legendary",
        "power": 7,
        "HP": 8,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_113": {
        "id": "JTL_113",
        "face": {
            "front": {
                "name": "Homestead Militia",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/113.png",
                "isHorizontal": false
            }
        },
        "name": "Homestead Militia",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "TROOPER"
        ]
    },
    "JTL_375": {
        "id": "JTL_375",
        "face": {
            "front": {
                "name": "Homestead Militia",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/375.png",
                "isHorizontal": false
            }
        },
        "name": "Homestead Militia",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "TROOPER"
        ]
    },
    "JTL_056": {
        "id": "JTL_056",
        "face": {
            "front": {
                "name": "Hondo Ohnaka, Superfluous Swindler",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/056.png",
                "isHorizontal": false
            }
        },
        "name": "Hondo Ohnaka, Superfluous Swindler",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Legendary",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Vigilance"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "JTL_318": {
        "id": "JTL_318",
        "face": {
            "front": {
                "name": "Hondo Ohnaka, Superfluous Swindler",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/318.png",
                "isHorizontal": false
            }
        },
        "name": "Hondo Ohnaka, Superfluous Swindler",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Legendary",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Vigilance"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "JTL_246": {
        "id": "JTL_246",
        "face": {
            "front": {
                "name": "Hopeful Volunteer",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/246.png",
                "isHorizontal": false
            }
        },
        "name": "Hopeful Volunteer",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "PILOT"
        ]
    },
    "JTL_508": {
        "id": "JTL_508",
        "face": {
            "front": {
                "name": "Hopeful Volunteer",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/508.png",
                "isHorizontal": false
            }
        },
        "name": "Hopeful Volunteer",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "PILOT"
        ]
    },
    "JTL_174": {
        "id": "JTL_174",
        "face": {
            "front": {
                "name": "Hotshot Maneuver",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/174.png",
                "isHorizontal": false
            }
        },
        "name": "Hotshot Maneuver",
        "type": "Event",
        "cost": 1,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_436": {
        "id": "JTL_436",
        "face": {
            "front": {
                "name": "Hotshot Maneuver",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/436.png",
                "isHorizontal": false
            }
        },
        "name": "Hotshot Maneuver",
        "type": "Event",
        "cost": 1,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_1038": {
        "id": "JTL_1038",
        "face": {
            "front": {
                "name": "Hound's Tooth, Reliable and Deadly",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1038.png",
                "isHorizontal": false
            }
        },
        "name": "Hound's Tooth, Reliable and Deadly",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Special",
        "power": 4,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_185": {
        "id": "JTL_185",
        "face": {
            "front": {
                "name": "Hound's Tooth, Reliable and Deadly",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/185.png",
                "isHorizontal": false
            }
        },
        "name": "Hound's Tooth, Reliable and Deadly",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Special",
        "power": 4,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_447": {
        "id": "JTL_447",
        "face": {
            "front": {
                "name": "Hound's Tooth, Reliable and Deadly",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/447.png",
                "isHorizontal": false
            }
        },
        "name": "Hound's Tooth, Reliable and Deadly",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Special",
        "power": 4,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_165": {
        "id": "JTL_165",
        "face": {
            "front": {
                "name": "Hunting Aggressor",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/165.png",
                "isHorizontal": false
            }
        },
        "name": "Hunting Aggressor",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_427": {
        "id": "JTL_427",
        "face": {
            "front": {
                "name": "Hunting Aggressor",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/427.png",
                "isHorizontal": false
            }
        },
        "name": "Hunting Aggressor",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_193": {
        "id": "JTL_193",
        "face": {
            "front": {
                "name": "I Have You Now",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/193.png",
                "isHorizontal": false
            }
        },
        "name": "I Have You Now",
        "type": "Event",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_455": {
        "id": "JTL_455",
        "face": {
            "front": {
                "name": "I Have You Now",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/455.png",
                "isHorizontal": false
            }
        },
        "name": "I Have You Now",
        "type": "Event",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_1031": {
        "id": "JTL_1031",
        "face": {
            "front": {
                "name": "IG-2000, Assassin's Aggressor",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1031.png",
                "isHorizontal": false
            }
        },
        "name": "IG-2000, Assassin's Aggressor",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Rare",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_140": {
        "id": "JTL_140",
        "face": {
            "front": {
                "name": "IG-2000, Assassin's Aggressor",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/140.png",
                "isHorizontal": false
            }
        },
        "name": "IG-2000, Assassin's Aggressor",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Rare",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_402": {
        "id": "JTL_402",
        "face": {
            "front": {
                "name": "IG-2000, Assassin's Aggressor",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/402.png",
                "isHorizontal": false
            }
        },
        "name": "IG-2000, Assassin's Aggressor",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Rare",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_141": {
        "id": "JTL_141",
        "face": {
            "front": {
                "name": "IG-88, Murderous Phlutdroid",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/141.png",
                "isHorizontal": false
            }
        },
        "name": "IG-88, Murderous Phlutdroid",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Rare",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "DROID",
            "BOUNTY HUNTER",
            "PILOT"
        ]
    },
    "JTL_403": {
        "id": "JTL_403",
        "face": {
            "front": {
                "name": "IG-88, Murderous Phlutdroid",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/403.png",
                "isHorizontal": false
            }
        },
        "name": "IG-88, Murderous Phlutdroid",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Rare",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "DROID",
            "BOUNTY HUNTER",
            "PILOT"
        ]
    },
    "JTL_036": {
        "id": "JTL_036",
        "face": {
            "front": {
                "name": "Iden Versio, Adapt or Die",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/036.png",
                "isHorizontal": false
            }
        },
        "name": "Iden Versio, Adapt or Die",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 4,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "PILOT"
        ]
    },
    "JTL_298": {
        "id": "JTL_298",
        "face": {
            "front": {
                "name": "Iden Versio, Adapt or Die",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/298.png",
                "isHorizontal": false
            }
        },
        "name": "Iden Versio, Adapt or Die",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 4,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "PILOT"
        ]
    },
    "JTL_192": {
        "id": "JTL_192",
        "face": {
            "front": {
                "name": "In Debt to Crimson Dawn",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/192.png",
                "isHorizontal": false
            }
        },
        "name": "In Debt to Crimson Dawn",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "CONDITION"
        ]
    },
    "JTL_454": {
        "id": "JTL_454",
        "face": {
            "front": {
                "name": "In Debt to Crimson Dawn",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/454.png",
                "isHorizontal": false
            }
        },
        "name": "In Debt to Crimson Dawn",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "CONDITION"
        ]
    },
    "JTL_077": {
        "id": "JTL_077",
        "face": {
            "front": {
                "name": "In the Heat of Battle",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/077.png",
                "isHorizontal": false
            }
        },
        "name": "In the Heat of Battle",
        "type": "Event",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "DISASTER"
        ]
    },
    "JTL_339": {
        "id": "JTL_339",
        "face": {
            "front": {
                "name": "In the Heat of Battle",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/339.png",
                "isHorizontal": false
            }
        },
        "name": "In the Heat of Battle",
        "type": "Event",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "DISASTER"
        ]
    },
    "JTL_211": {
        "id": "JTL_211",
        "face": {
            "front": {
                "name": "Independent Smuggler",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/211.png",
                "isHorizontal": false
            }
        },
        "name": "Independent Smuggler",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "PILOT"
        ]
    },
    "JTL_473": {
        "id": "JTL_473",
        "face": {
            "front": {
                "name": "Independent Smuggler",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/473.png",
                "isHorizontal": false
            }
        },
        "name": "Independent Smuggler",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "PILOT"
        ]
    },
    "JTL_168": {
        "id": "JTL_168",
        "face": {
            "front": {
                "name": "Insurgent Saboteurs",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/168.png",
                "isHorizontal": false
            }
        },
        "name": "Insurgent Saboteurs",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 6,
        "HP": 5,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "TROOPER"
        ]
    },
    "JTL_430": {
        "id": "JTL_430",
        "face": {
            "front": {
                "name": "Insurgent Saboteurs",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/430.png",
                "isHorizontal": false
            }
        },
        "name": "Insurgent Saboteurs",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Common",
        "power": 6,
        "HP": 5,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "TROOPER"
        ]
    },
    "JTL_034": {
        "id": "JTL_034",
        "face": {
            "front": {
                "name": "Interceptor Ace",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/034.png",
                "isHorizontal": false
            }
        },
        "name": "Interceptor Ace",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "PILOT"
        ]
    },
    "JTL_296": {
        "id": "JTL_296",
        "face": {
            "front": {
                "name": "Interceptor Ace",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/296.png",
                "isHorizontal": false
            }
        },
        "name": "Interceptor Ace",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "PILOT"
        ]
    },
    "JTL_1040": {
        "id": "JTL_1040",
        "face": {
            "front": {
                "name": "Invincible, Naval Adversary",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1040.png",
                "isHorizontal": false
            }
        },
        "name": "Invincible, Naval Adversary",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Legendary",
        "power": 6,
        "HP": 6,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_191": {
        "id": "JTL_191",
        "face": {
            "front": {
                "name": "Invincible, Naval Adversary",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/191.png",
                "isHorizontal": false
            }
        },
        "name": "Invincible, Naval Adversary",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Legendary",
        "power": 6,
        "HP": 6,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_453": {
        "id": "JTL_453",
        "face": {
            "front": {
                "name": "Invincible, Naval Adversary",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/453.png",
                "isHorizontal": false
            }
        },
        "name": "Invincible, Naval Adversary",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Legendary",
        "power": 6,
        "HP": 6,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_209": {
        "id": "JTL_209",
        "face": {
            "front": {
                "name": "It's a Trap",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/209.png",
                "isHorizontal": false
            }
        },
        "name": "It's a Trap",
        "type": "Event",
        "cost": 3,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "JTL_471": {
        "id": "JTL_471",
        "face": {
            "front": {
                "name": "It's a Trap",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/471.png",
                "isHorizontal": false
            }
        },
        "name": "It's a Trap",
        "type": "Event",
        "cost": 3,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "JTL_207": {
        "id": "JTL_207",
        "face": {
            "front": {
                "name": "Jam Communications",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/207.png",
                "isHorizontal": false
            }
        },
        "name": "Jam Communications",
        "type": "Event",
        "cost": 1,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "JTL_469": {
        "id": "JTL_469",
        "face": {
            "front": {
                "name": "Jam Communications",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/469.png",
                "isHorizontal": false
            }
        },
        "name": "Jam Communications",
        "type": "Event",
        "cost": 1,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "TRICK"
        ]
    },
    "JTL_109": {
        "id": "JTL_109",
        "face": {
            "front": {
                "name": "Jarek Yeager, Coordinating With The Resistance",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/109.png",
                "isHorizontal": false
            }
        },
        "name": "Jarek Yeager, Coordinating With The Resistance",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Command"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE",
            "PILOT"
        ]
    },
    "JTL_371": {
        "id": "JTL_371",
        "face": {
            "front": {
                "name": "Jarek Yeager, Coordinating With The Resistance",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/371.png",
                "isHorizontal": false
            }
        },
        "name": "Jarek Yeager, Coordinating With The Resistance",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Command"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE",
            "PILOT"
        ]
    },
    "JTL_251": {
        "id": "JTL_251",
        "face": {
            "front": {
                "name": "Jedi Light Cruiser",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/251.png",
                "isHorizontal": false
            }
        },
        "name": "Jedi Light Cruiser",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Common",
        "power": 6,
        "HP": 7,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "JEDI",
            "REPUBLIC",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_513": {
        "id": "JTL_513",
        "face": {
            "front": {
                "name": "Jedi Light Cruiser",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/513.png",
                "isHorizontal": false
            }
        },
        "name": "Jedi Light Cruiser",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Common",
        "power": 6,
        "HP": 7,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "JEDI",
            "REPUBLIC",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_232": {
        "id": "JTL_232",
        "face": {
            "front": {
                "name": "Jump to Lightspeed",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/232.png",
                "isHorizontal": false
            }
        },
        "name": "Jump to Lightspeed",
        "type": "Event",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "JTL_494": {
        "id": "JTL_494",
        "face": {
            "front": {
                "name": "Jump to Lightspeed",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/494.png",
                "isHorizontal": false
            }
        },
        "name": "Jump to Lightspeed",
        "type": "Event",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "JTL_018": {
        "id": "JTL_018",
        "face": {
            "front": {
                "name": "Kazuda Xiono, Best Pilot in the Galaxy",
                "type": "Leader",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/018-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Kazuda Xiono, Best Pilot in the Galaxy",
                "type": "Leader",
                "cost": "4",
                "image": "https://cdn.swu-db.com/images/cards/JTL/018-b.png"
            }
        },
        "name": "Kazuda Xiono, Best Pilot in the Galaxy",
        "type": "Leader",
        "cost": 4,
        "rarity": "Rare",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE",
            "PILOT"
        ]
    },
    "JTL_1014": {
        "id": "JTL_1014",
        "face": {
            "front": {
                "name": "Kazuda Xiono, Best Pilot in the Galaxy",
                "type": "Leader",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1014-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Kazuda Xiono, Best Pilot in the Galaxy",
                "type": "Leader",
                "cost": "4",
                "image": "https://cdn.swu-db.com/images/cards/JTL/1014-b.png"
            }
        },
        "name": "Kazuda Xiono, Best Pilot in the Galaxy",
        "type": "Leader",
        "cost": 4,
        "rarity": "Rare",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE",
            "PILOT"
        ]
    },
    "JTL_280": {
        "id": "JTL_280",
        "face": {
            "front": {
                "name": "Kazuda Xiono, Best Pilot in the Galaxy",
                "type": "Leader",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/280-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Kazuda Xiono, Best Pilot in the Galaxy",
                "type": "Leader",
                "cost": "4",
                "image": "https://cdn.swu-db.com/images/cards/JTL/280-b.png"
            }
        },
        "name": "Kazuda Xiono, Best Pilot in the Galaxy",
        "type": "Leader",
        "cost": 4,
        "rarity": "Rare",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE",
            "PILOT"
        ]
    },
    "JTL_082": {
        "id": "JTL_082",
        "face": {
            "front": {
                "name": "Kijimi Patrollers",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/082.png",
                "isHorizontal": false
            }
        },
        "name": "Kijimi Patrollers",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "FIRST ORDER",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_344": {
        "id": "JTL_344",
        "face": {
            "front": {
                "name": "Kijimi Patrollers",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/344.png",
                "isHorizontal": false
            }
        },
        "name": "Kijimi Patrollers",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 1,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "FIRST ORDER",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_222": {
        "id": "JTL_222",
        "face": {
            "front": {
                "name": "Kimoglia Heavy Fighter",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/222.png",
                "isHorizontal": false
            }
        },
        "name": "Kimoglia Heavy Fighter",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_484": {
        "id": "JTL_484",
        "face": {
            "front": {
                "name": "Kimoglia Heavy Fighter",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/484.png",
                "isHorizontal": false
            }
        },
        "name": "Kimoglia Heavy Fighter",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_179": {
        "id": "JTL_179",
        "face": {
            "front": {
                "name": "Koiogran Turn",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/179.png",
                "isHorizontal": false
            }
        },
        "name": "Koiogran Turn",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_441": {
        "id": "JTL_441",
        "face": {
            "front": {
                "name": "Koiogran Turn",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/441.png",
                "isHorizontal": false
            }
        },
        "name": "Koiogran Turn",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_049": {
        "id": "JTL_049",
        "face": {
            "front": {
                "name": "L3-37, Get Out of My Seat",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/049.png",
                "isHorizontal": false
            }
        },
        "name": "L3-37, Get Out of My Seat",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Rare",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "DROID",
            "PILOT"
        ]
    },
    "JTL_311": {
        "id": "JTL_311",
        "face": {
            "front": {
                "name": "L3-37, Get Out of My Seat",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/311.png",
                "isHorizontal": false
            }
        },
        "name": "L3-37, Get Out of My Seat",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Rare",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "DROID",
            "PILOT"
        ]
    },
    "JTL_031": {
        "id": "JTL_031",
        "face": {
            "front": {
                "name": "Lake Country, Naboo",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/031-r.png",
                "isHorizontal": true
            }
        },
        "name": "Lake Country, Naboo",
        "type": "Base",
        "cost": 0,
        "rarity": "Rare",
        "power": 0,
        "HP": 34,
        "aspects": [],
        "unique": false,
        "traits": []
    },
    "JTL_293": {
        "id": "JTL_293",
        "face": {
            "front": {
                "name": "Lake Country, Naboo",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/293-r.png",
                "isHorizontal": true
            }
        },
        "name": "Lake Country, Naboo",
        "type": "Base",
        "cost": 0,
        "rarity": "Rare",
        "power": 0,
        "HP": 34,
        "aspects": [],
        "unique": false,
        "traits": []
    },
    "JTL_063": {
        "id": "JTL_063",
        "face": {
            "front": {
                "name": "Landing Shuttle",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/063.png",
                "isHorizontal": false
            }
        },
        "name": "Landing Shuttle",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_325": {
        "id": "JTL_325",
        "face": {
            "front": {
                "name": "Landing Shuttle",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/325.png",
                "isHorizontal": false
            }
        },
        "name": "Landing Shuttle",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_003": {
        "id": "JTL_003",
        "face": {
            "front": {
                "name": "Lando Calrissian, Buying Time",
                "type": "Leader",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/JTL/003-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Lando Calrissian, Buying Time",
                "type": "Leader",
                "cost": "7",
                "image": "https://cdn.swu-db.com/images/cards/JTL/003-b.png"
            }
        },
        "name": "Lando Calrissian, Buying Time",
        "type": "Leader",
        "cost": 7,
        "rarity": "Rare",
        "power": 5,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "OFFICIAL",
            "PILOT"
        ]
    },
    "JTL_265": {
        "id": "JTL_265",
        "face": {
            "front": {
                "name": "Lando Calrissian, Buying Time",
                "type": "Leader",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/JTL/265-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Lando Calrissian, Buying Time",
                "type": "Leader",
                "cost": "7",
                "image": "https://cdn.swu-db.com/images/cards/JTL/265-b.png"
            }
        },
        "name": "Lando Calrissian, Buying Time",
        "type": "Leader",
        "cost": 7,
        "rarity": "Rare",
        "power": 5,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "OFFICIAL",
            "PILOT"
        ]
    },
    "JTL_999": {
        "id": "JTL_999",
        "face": {
            "front": {
                "name": "Lando Calrissian, Buying Time",
                "type": "Leader",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/JTL/999-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Lando Calrissian, Buying Time",
                "type": "Leader",
                "cost": "7",
                "image": "https://cdn.swu-db.com/images/cards/JTL/999-b.png"
            }
        },
        "name": "Lando Calrissian, Buying Time",
        "type": "Leader",
        "cost": 7,
        "rarity": "Rare",
        "power": 5,
        "HP": 7,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "OFFICIAL",
            "PILOT"
        ]
    },
    "JTL_097": {
        "id": "JTL_097",
        "face": {
            "front": {
                "name": "Leia Organa, Pilots, To Your Stations",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/097.png",
                "isHorizontal": false
            }
        },
        "name": "Leia Organa, Pilots, To Your Stations",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "OFFICIAL"
        ]
    },
    "JTL_359": {
        "id": "JTL_359",
        "face": {
            "front": {
                "name": "Leia Organa, Pilots, To Your Stations",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/359.png",
                "isHorizontal": false
            }
        },
        "name": "Leia Organa, Pilots, To Your Stations",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "OFFICIAL"
        ]
    },
    "JTL_127": {
        "id": "JTL_127",
        "face": {
            "front": {
                "name": "Lightspeed Assault",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/127.png",
                "isHorizontal": false
            }
        },
        "name": "Lightspeed Assault",
        "type": "Event",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "JTL_389": {
        "id": "JTL_389",
        "face": {
            "front": {
                "name": "Lightspeed Assault",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/389.png",
                "isHorizontal": false
            }
        },
        "name": "Lightspeed Assault",
        "type": "Event",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "JTL_012": {
        "id": "JTL_012",
        "face": {
            "front": {
                "name": "Luke Skywalker, Hero of Yavin",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/012-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Luke Skywalker, Hero of Yavin",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/JTL/012-b.png"
            }
        },
        "name": "Luke Skywalker, Hero of Yavin",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "REBEL",
            "PILOT"
        ]
    },
    "JTL_094": {
        "id": "JTL_094",
        "face": {
            "front": {
                "name": "Luke Skywalker, You Still With Me?",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/094.png",
                "isHorizontal": false
            }
        },
        "name": "Luke Skywalker, You Still With Me?",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "REBEL",
            "PILOT"
        ]
    },
    "JTL_1008": {
        "id": "JTL_1008",
        "face": {
            "front": {
                "name": "Luke Skywalker, Hero of Yavin",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1008-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Luke Skywalker, Hero of Yavin",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/JTL/1008-b.png"
            }
        },
        "name": "Luke Skywalker, Hero of Yavin",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "REBEL",
            "PILOT"
        ]
    },
    "JTL_274": {
        "id": "JTL_274",
        "face": {
            "front": {
                "name": "Luke Skywalker, Hero of Yavin",
                "type": "Leader",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/274-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Luke Skywalker, Hero of Yavin",
                "type": "Leader",
                "cost": "6",
                "image": "https://cdn.swu-db.com/images/cards/JTL/274-b.png"
            }
        },
        "name": "Luke Skywalker, Hero of Yavin",
        "type": "Leader",
        "cost": 6,
        "rarity": "Common",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "REBEL",
            "PILOT"
        ]
    },
    "JTL_356": {
        "id": "JTL_356",
        "face": {
            "front": {
                "name": "Luke Skywalker, You Still With Me?",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/356.png",
                "isHorizontal": false
            }
        },
        "name": "Luke Skywalker, You Still With Me?",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "FORCE",
            "REBEL",
            "PILOT"
        ]
    },
    "JTL_118": {
        "id": "JTL_118",
        "face": {
            "front": {
                "name": "MC30 Assault Frigate",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/118.png",
                "isHorizontal": false
            }
        },
        "name": "MC30 Assault Frigate",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_380": {
        "id": "JTL_380",
        "face": {
            "front": {
                "name": "MC30 Assault Frigate",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/380.png",
                "isHorizontal": false
            }
        },
        "name": "MC30 Assault Frigate",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 5,
        "HP": 5,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_011": {
        "id": "JTL_011",
        "face": {
            "front": {
                "name": "Major Vonreg, Red Baron",
                "type": "Leader",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/011-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Major Vonreg, Red Baron",
                "type": "Leader",
                "cost": "4",
                "image": "https://cdn.swu-db.com/images/cards/JTL/011-b.png"
            }
        },
        "name": "Major Vonreg, Red Baron",
        "type": "Leader",
        "cost": 4,
        "rarity": "Common",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FIRST ORDER",
            "PILOT"
        ]
    },
    "JTL_1007": {
        "id": "JTL_1007",
        "face": {
            "front": {
                "name": "Major Vonreg, Red Baron",
                "type": "Leader",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1007-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Major Vonreg, Red Baron",
                "type": "Leader",
                "cost": "4",
                "image": "https://cdn.swu-db.com/images/cards/JTL/1007-b.png"
            }
        },
        "name": "Major Vonreg, Red Baron",
        "type": "Leader",
        "cost": 4,
        "rarity": "Common",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FIRST ORDER",
            "PILOT"
        ]
    },
    "JTL_273": {
        "id": "JTL_273",
        "face": {
            "front": {
                "name": "Major Vonreg, Red Baron",
                "type": "Leader",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/273-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Major Vonreg, Red Baron",
                "type": "Leader",
                "cost": "4",
                "image": "https://cdn.swu-db.com/images/cards/JTL/273-b.png"
            }
        },
        "name": "Major Vonreg, Red Baron",
        "type": "Leader",
        "cost": 4,
        "rarity": "Common",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FIRST ORDER",
            "PILOT"
        ]
    },
    "JTL_146": {
        "id": "JTL_146",
        "face": {
            "front": {
                "name": "Massassi Tactical Officer",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/146.png",
                "isHorizontal": false
            }
        },
        "name": "Massassi Tactical Officer",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL"
        ]
    },
    "JTL_408": {
        "id": "JTL_408",
        "face": {
            "front": {
                "name": "Massassi Tactical Officer",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/408.png",
                "isHorizontal": false
            }
        },
        "name": "Massassi Tactical Officer",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL"
        ]
    },
    "JTL_026": {
        "id": "JTL_026",
        "face": {
            "front": {
                "name": "Massassi Temple, Yavin 4",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/026-r.png",
                "isHorizontal": true
            }
        },
        "name": "Massassi Temple, Yavin 4",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": []
    },
    "JTL_288": {
        "id": "JTL_288",
        "face": {
            "front": {
                "name": "Massassi Temple, Yavin 4",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/288-r.png",
                "isHorizontal": true
            }
        },
        "name": "Massassi Temple, Yavin 4",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": []
    },
    "JTL_1048": {
        "id": "JTL_1048",
        "face": {
            "front": {
                "name": "Millennium Falcon, Get Out And Push",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1048.png",
                "isHorizontal": false
            }
        },
        "name": "Millennium Falcon, Get Out And Push",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Special",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_249": {
        "id": "JTL_249",
        "face": {
            "front": {
                "name": "Millennium Falcon, Get Out And Push",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/249.png",
                "isHorizontal": false
            }
        },
        "name": "Millennium Falcon, Get Out And Push",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Special",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_511": {
        "id": "JTL_511",
        "face": {
            "front": {
                "name": "Millennium Falcon, Get Out And Push",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/511.png",
                "isHorizontal": false
            }
        },
        "name": "Millennium Falcon, Get Out And Push",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Special",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_1039": {
        "id": "JTL_1039",
        "face": {
            "front": {
                "name": "Mist Hunter, The Findsman's Pursuit",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1039.png",
                "isHorizontal": false
            }
        },
        "name": "Mist Hunter, The Findsman's Pursuit",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_186": {
        "id": "JTL_186",
        "face": {
            "front": {
                "name": "Mist Hunter, The Findsman's Pursuit",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/186.png",
                "isHorizontal": false
            }
        },
        "name": "Mist Hunter, The Findsman's Pursuit",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_448": {
        "id": "JTL_448",
        "face": {
            "front": {
                "name": "Mist Hunter, The Findsman's Pursuit",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/448.png",
                "isHorizontal": false
            }
        },
        "name": "Mist Hunter, The Findsman's Pursuit",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_188": {
        "id": "JTL_188",
        "face": {
            "front": {
                "name": "Moff Gideon, I Know Everything",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/188.png",
                "isHorizontal": false
            }
        },
        "name": "Moff Gideon, I Know Everything",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "JTL_450": {
        "id": "JTL_450",
        "face": {
            "front": {
                "name": "Moff Gideon, I Know Everything",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/450.png",
                "isHorizontal": false
            }
        },
        "name": "Moff Gideon, I Know Everything",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Rare",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "OFFICIAL"
        ]
    },
    "JTL_030": {
        "id": "JTL_030",
        "face": {
            "front": {
                "name": "Mos Eisley, Tatooine",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/030-r.png",
                "isHorizontal": true
            }
        },
        "name": "Mos Eisley, Tatooine",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": []
    },
    "JTL_292": {
        "id": "JTL_292",
        "face": {
            "front": {
                "name": "Mos Eisley, Tatooine",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/292-r.png",
                "isHorizontal": true
            }
        },
        "name": "Mos Eisley, Tatooine",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": []
    },
    "JTL_069": {
        "id": "JTL_069",
        "face": {
            "front": {
                "name": "Munificent Frigate",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/069.png",
                "isHorizontal": false
            }
        },
        "name": "Munificent Frigate",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_331": {
        "id": "JTL_331",
        "face": {
            "front": {
                "name": "Munificent Frigate",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/331.png",
                "isHorizontal": false
            }
        },
        "name": "Munificent Frigate",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_028": {
        "id": "JTL_028",
        "face": {
            "front": {
                "name": "Nabat Village, Ryloth",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/028-r.png",
                "isHorizontal": true
            }
        },
        "name": "Nabat Village, Ryloth",
        "type": "Base",
        "cost": 0,
        "rarity": "Rare",
        "power": 0,
        "HP": 27,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": []
    },
    "JTL_290": {
        "id": "JTL_290",
        "face": {
            "front": {
                "name": "Nabat Village, Ryloth",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/290-r.png",
                "isHorizontal": true
            }
        },
        "name": "Nabat Village, Ryloth",
        "type": "Base",
        "cost": 0,
        "rarity": "Rare",
        "power": 0,
        "HP": 27,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": []
    },
    "JTL_027": {
        "id": "JTL_027",
        "face": {
            "front": {
                "name": "Nadiri Dockyards, Nadiri",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/027-r.png",
                "isHorizontal": true
            }
        },
        "name": "Nadiri Dockyards, Nadiri",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": []
    },
    "JTL_289": {
        "id": "JTL_289",
        "face": {
            "front": {
                "name": "Nadiri Dockyards, Nadiri",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/289-r.png",
                "isHorizontal": true
            }
        },
        "name": "Nadiri Dockyards, Nadiri",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": []
    },
    "JTL_080": {
        "id": "JTL_080",
        "face": {
            "front": {
                "name": "Nebula Ignition",
                "type": "Event",
                "cost": 9,
                "image": "https://cdn.swu-db.com/images/cards/JTL/080.png",
                "isHorizontal": false
            }
        },
        "name": "Nebula Ignition",
        "type": "Event",
        "cost": 9,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "DISASTER"
        ]
    },
    "JTL_342": {
        "id": "JTL_342",
        "face": {
            "front": {
                "name": "Nebula Ignition",
                "type": "Event",
                "cost": 9,
                "image": "https://cdn.swu-db.com/images/cards/JTL/342.png",
                "isHorizontal": false
            }
        },
        "name": "Nebula Ignition",
        "type": "Event",
        "cost": 9,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "DISASTER"
        ]
    },
    "JTL_208": {
        "id": "JTL_208",
        "face": {
            "front": {
                "name": "Never Tell Me the Odds",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/208.png",
                "isHorizontal": false
            }
        },
        "name": "Never Tell Me the Odds",
        "type": "Event",
        "cost": 3,
        "rarity": "Special",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "JTL_470": {
        "id": "JTL_470",
        "face": {
            "front": {
                "name": "Never Tell Me the Odds",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/470.png",
                "isHorizontal": false
            }
        },
        "name": "Never Tell Me the Odds",
        "type": "Event",
        "cost": 3,
        "rarity": "Special",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "JTL_093": {
        "id": "JTL_093",
        "face": {
            "front": {
                "name": "Nien Nunb, Loyal Co-Pilot",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/093.png",
                "isHorizontal": false
            }
        },
        "name": "Nien Nunb, Loyal Co-Pilot",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Rare",
        "power": 1,
        "HP": 2,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "PILOT"
        ]
    },
    "JTL_355": {
        "id": "JTL_355",
        "face": {
            "front": {
                "name": "Nien Nunb, Loyal Co-Pilot",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/355.png",
                "isHorizontal": false
            }
        },
        "name": "Nien Nunb, Loyal Co-Pilot",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Rare",
        "power": 1,
        "HP": 2,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "PILOT"
        ]
    },
    "JTL_144": {
        "id": "JTL_144",
        "face": {
            "front": {
                "name": "No Disintegrations",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/144.png",
                "isHorizontal": false
            }
        },
        "name": "No Disintegrations",
        "type": "Event",
        "cost": 3,
        "rarity": "Special",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "JTL_406": {
        "id": "JTL_406",
        "face": {
            "front": {
                "name": "No Disintegrations",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/406.png",
                "isHorizontal": false
            }
        },
        "name": "No Disintegrations",
        "type": "Event",
        "cost": 3,
        "rarity": "Special",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "JTL_043": {
        "id": "JTL_043",
        "face": {
            "front": {
                "name": "No Glory, Only Results",
                "type": "Event",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/043.png",
                "isHorizontal": false
            }
        },
        "name": "No Glory, Only Results",
        "type": "Event",
        "cost": 5,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_305": {
        "id": "JTL_305",
        "face": {
            "front": {
                "name": "No Glory, Only Results",
                "type": "Event",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/305.png",
                "isHorizontal": false
            }
        },
        "name": "No Glory, Only Results",
        "type": "Event",
        "cost": 5,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_167": {
        "id": "JTL_167",
        "face": {
            "front": {
                "name": "Occupier Siege Tank",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/167.png",
                "isHorizontal": false
            }
        },
        "name": "Occupier Siege Tank",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Common",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "TANK"
        ]
    },
    "JTL_429": {
        "id": "JTL_429",
        "face": {
            "front": {
                "name": "Occupier Siege Tank",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/429.png",
                "isHorizontal": false
            }
        },
        "name": "Occupier Siege Tank",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Common",
        "power": 5,
        "HP": 4,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "TANK"
        ]
    },
    "JTL_064": {
        "id": "JTL_064",
        "face": {
            "front": {
                "name": "Omicron Strike Craft",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/064.png",
                "isHorizontal": false
            }
        },
        "name": "Omicron Strike Craft",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_326": {
        "id": "JTL_326",
        "face": {
            "front": {
                "name": "Omicron Strike Craft",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/326.png",
                "isHorizontal": false
            }
        },
        "name": "Omicron Strike Craft",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_033": {
        "id": "JTL_033",
        "face": {
            "front": {
                "name": "Onyx Squadron Brute",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/033.png",
                "isHorizontal": false
            }
        },
        "name": "Onyx Squadron Brute",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_295": {
        "id": "JTL_295",
        "face": {
            "front": {
                "name": "Onyx Squadron Brute",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/295.png",
                "isHorizontal": false
            }
        },
        "name": "Onyx Squadron Brute",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_166": {
        "id": "JTL_166",
        "face": {
            "front": {
                "name": "Orbiting K-Wing",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/166.png",
                "isHorizontal": false
            }
        },
        "name": "Orbiting K-Wing",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Common",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_428": {
        "id": "JTL_428",
        "face": {
            "front": {
                "name": "Orbiting K-Wing",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/428.png",
                "isHorizontal": false
            }
        },
        "name": "Orbiting K-Wing",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Common",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_079": {
        "id": "JTL_079",
        "face": {
            "front": {
                "name": "Out the Airlock",
                "type": "Event",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/079.png",
                "isHorizontal": false
            }
        },
        "name": "Out the Airlock",
        "type": "Event",
        "cost": 5,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_341": {
        "id": "JTL_341",
        "face": {
            "front": {
                "name": "Out the Airlock",
                "type": "Event",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/341.png",
                "isHorizontal": false
            }
        },
        "name": "Out the Airlock",
        "type": "Event",
        "cost": 5,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_065": {
        "id": "JTL_065",
        "face": {
            "front": {
                "name": "Outer Rim Outlaws",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/065.png",
                "isHorizontal": false
            }
        },
        "name": "Outer Rim Outlaws",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "JTL_327": {
        "id": "JTL_327",
        "face": {
            "front": {
                "name": "Outer Rim Outlaws",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/327.png",
                "isHorizontal": false
            }
        },
        "name": "Outer Rim Outlaws",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "BOUNTY HUNTER"
        ]
    },
    "JTL_046": {
        "id": "JTL_046",
        "face": {
            "front": {
                "name": "Paige Tico, Dropping the Hammer",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/046.png",
                "isHorizontal": false
            }
        },
        "name": "Paige Tico, Dropping the Hammer",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE",
            "PILOT"
        ]
    },
    "JTL_308": {
        "id": "JTL_308",
        "face": {
            "front": {
                "name": "Paige Tico, Dropping the Hammer",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/308.png",
                "isHorizontal": false
            }
        },
        "name": "Paige Tico, Dropping the Hammer",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE",
            "PILOT"
        ]
    },
    "JTL_083": {
        "id": "JTL_083",
        "face": {
            "front": {
                "name": "Pantoran Starship Thief",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/083.png",
                "isHorizontal": false
            }
        },
        "name": "Pantoran Starship Thief",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "PILOT"
        ]
    },
    "JTL_345": {
        "id": "JTL_345",
        "face": {
            "front": {
                "name": "Pantoran Starship Thief",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/345.png",
                "isHorizontal": false
            }
        },
        "name": "Pantoran Starship Thief",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "PILOT"
        ]
    },
    "JTL_068": {
        "id": "JTL_068",
        "face": {
            "front": {
                "name": "Perimeter AT-RT",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/068.png",
                "isHorizontal": false
            }
        },
        "name": "Perimeter AT-RT",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "WALKER"
        ]
    },
    "JTL_330": {
        "id": "JTL_330",
        "face": {
            "front": {
                "name": "Perimeter AT-RT",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/330.png",
                "isHorizontal": false
            }
        },
        "name": "Perimeter AT-RT",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "WALKER"
        ]
    },
    "JTL_050": {
        "id": "JTL_050",
        "face": {
            "front": {
                "name": "Phantom II, Modified to Dock",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/050.png",
                "isHorizontal": false
            }
        },
        "name": "Phantom II, Modified to Dock",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Rare",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "TRANSPORT",
            "SPECTRE"
        ]
    },
    "JTL_1019": {
        "id": "JTL_1019",
        "face": {
            "front": {
                "name": "Phantom II, Modified to Dock",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1019.png",
                "isHorizontal": false
            }
        },
        "name": "Phantom II, Modified to Dock",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Rare",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "TRANSPORT",
            "SPECTRE"
        ]
    },
    "JTL_312": {
        "id": "JTL_312",
        "face": {
            "front": {
                "name": "Phantom II, Modified to Dock",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/312.png",
                "isHorizontal": false
            }
        },
        "name": "Phantom II, Modified to Dock",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Rare",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "TRANSPORT",
            "SPECTRE"
        ]
    },
    "JTL_095": {
        "id": "JTL_095",
        "face": {
            "front": {
                "name": "Phoenix Squadron A-Wing",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/095.png",
                "isHorizontal": false
            }
        },
        "name": "Phoenix Squadron A-Wing",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_357": {
        "id": "JTL_357",
        "face": {
            "front": {
                "name": "Phoenix Squadron A-Wing",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/357.png",
                "isHorizontal": false
            }
        },
        "name": "Phoenix Squadron A-Wing",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_180": {
        "id": "JTL_180",
        "face": {
            "front": {
                "name": "Piercing Shot",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/180.png",
                "isHorizontal": false
            }
        },
        "name": "Piercing Shot",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_442": {
        "id": "JTL_442",
        "face": {
            "front": {
                "name": "Piercing Shot",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/442.png",
                "isHorizontal": false
            }
        },
        "name": "Piercing Shot",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_181": {
        "id": "JTL_181",
        "face": {
            "front": {
                "name": "Planetary Bombardment",
                "type": "Event",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/181.png",
                "isHorizontal": false
            }
        },
        "name": "Planetary Bombardment",
        "type": "Event",
        "cost": 6,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_443": {
        "id": "JTL_443",
        "face": {
            "front": {
                "name": "Planetary Bombardment",
                "type": "Event",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/443.png",
                "isHorizontal": false
            }
        },
        "name": "Planetary Bombardment",
        "type": "Event",
        "cost": 6,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_013": {
        "id": "JTL_013",
        "face": {
            "front": {
                "name": "Poe Dameron, I Can Fly Anything",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/013-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Poe Dameron, I Can Fly Anything",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/JTL/013-b.png"
            }
        },
        "name": "Poe Dameron, I Can Fly Anything",
        "type": "Leader",
        "cost": 5,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE",
            "PILOT"
        ]
    },
    "JTL_100": {
        "id": "JTL_100",
        "face": {
            "front": {
                "name": "Poe Dameron, One Hell of a a Pilot",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/100.png",
                "isHorizontal": false
            }
        },
        "name": "Poe Dameron, One Hell of a a Pilot",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE",
            "PILOT"
        ]
    },
    "JTL_1009": {
        "id": "JTL_1009",
        "face": {
            "front": {
                "name": "Poe Dameron, I Can Fly Anything",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1009-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Poe Dameron, I Can Fly Anything",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/JTL/1009-b.png"
            }
        },
        "name": "Poe Dameron, I Can Fly Anything",
        "type": "Leader",
        "cost": 5,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE",
            "PILOT"
        ]
    },
    "JTL_275": {
        "id": "JTL_275",
        "face": {
            "front": {
                "name": "Poe Dameron, I Can Fly Anything",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/275-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Poe Dameron, I Can Fly Anything",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/JTL/275-b.png"
            }
        },
        "name": "Poe Dameron, I Can Fly Anything",
        "type": "Leader",
        "cost": 5,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE",
            "PILOT"
        ]
    },
    "JTL_362": {
        "id": "JTL_362",
        "face": {
            "front": {
                "name": "Poe Dameron, One Hell of a a Pilot",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/362.png",
                "isHorizontal": false
            }
        },
        "name": "Poe Dameron, One Hell of a a Pilot",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE",
            "PILOT"
        ]
    },
    "JTL_042": {
        "id": "JTL_042",
        "face": {
            "front": {
                "name": "Power from Pain",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/042.png",
                "isHorizontal": false
            }
        },
        "name": "Power from Pain",
        "type": "Event",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_304": {
        "id": "JTL_304",
        "face": {
            "front": {
                "name": "Power from Pain",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/304.png",
                "isHorizontal": false
            }
        },
        "name": "Power from Pain",
        "type": "Event",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_128": {
        "id": "JTL_128",
        "face": {
            "front": {
                "name": "Prepare for Takeoff",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/128.png",
                "isHorizontal": false
            }
        },
        "name": "Prepare for Takeoff",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "JTL_390": {
        "id": "JTL_390",
        "face": {
            "front": {
                "name": "Prepare for Takeoff",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/390.png",
                "isHorizontal": false
            }
        },
        "name": "Prepare for Takeoff",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "JTL_1035": {
        "id": "JTL_1035",
        "face": {
            "front": {
                "name": "Profundity, We Fight!",
                "type": "Unit - Space",
                "cost": 9,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1035.png",
                "isHorizontal": false
            }
        },
        "name": "Profundity, We Fight!",
        "type": "Unit - Space",
        "cost": 9,
        "rarity": "Legendary",
        "power": 8,
        "HP": 9,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_154": {
        "id": "JTL_154",
        "face": {
            "front": {
                "name": "Profundity, We Fight!",
                "type": "Unit - Space",
                "cost": 9,
                "image": "https://cdn.swu-db.com/images/cards/JTL/154.png",
                "isHorizontal": false
            }
        },
        "name": "Profundity, We Fight!",
        "type": "Unit - Space",
        "cost": 9,
        "rarity": "Legendary",
        "power": 8,
        "HP": 9,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_416": {
        "id": "JTL_416",
        "face": {
            "front": {
                "name": "Profundity, We Fight!",
                "type": "Unit - Space",
                "cost": 9,
                "image": "https://cdn.swu-db.com/images/cards/JTL/416.png",
                "isHorizontal": false
            }
        },
        "name": "Profundity, We Fight!",
        "type": "Unit - Space",
        "cost": 9,
        "rarity": "Legendary",
        "power": 8,
        "HP": 9,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_136": {
        "id": "JTL_136",
        "face": {
            "front": {
                "name": "Prototype TIE Advanced",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/136.png",
                "isHorizontal": false
            }
        },
        "name": "Prototype TIE Advanced",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 4,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_398": {
        "id": "JTL_398",
        "face": {
            "front": {
                "name": "Prototype TIE Advanced",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/398.png",
                "isHorizontal": false
            }
        },
        "name": "Prototype TIE Advanced",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 4,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_231": {
        "id": "JTL_231",
        "face": {
            "front": {
                "name": "Punch It",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/231.png",
                "isHorizontal": false
            }
        },
        "name": "Punch It",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_493": {
        "id": "JTL_493",
        "face": {
            "front": {
                "name": "Punch It",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/493.png",
                "isHorizontal": false
            }
        },
        "name": "Punch It",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_243": {
        "id": "JTL_243",
        "face": {
            "front": {
                "name": "Quasar TIE Carrier",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/243.png",
                "isHorizontal": false
            }
        },
        "name": "Quasar TIE Carrier",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Common",
        "power": 5,
        "HP": 7,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_505": {
        "id": "JTL_505",
        "face": {
            "front": {
                "name": "Quasar TIE Carrier",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/505.png",
                "isHorizontal": false
            }
        },
        "name": "Quasar TIE Carrier",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Common",
        "power": 5,
        "HP": 7,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_245": {
        "id": "JTL_245",
        "face": {
            "front": {
                "name": "R2-D2, Artooooooooo!",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/245.png",
                "isHorizontal": false
            }
        },
        "name": "R2-D2, Artooooooooo!",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "DROID",
            "PILOT"
        ]
    },
    "JTL_507": {
        "id": "JTL_507",
        "face": {
            "front": {
                "name": "R2-D2, Artooooooooo!",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/507.png",
                "isHorizontal": false
            }
        },
        "name": "R2-D2, Artooooooooo!",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Uncommon",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "DROID",
            "PILOT"
        ]
    },
    "JTL_1028": {
        "id": "JTL_1028",
        "face": {
            "front": {
                "name": "Raddus, Holdo's Final Command",
                "type": "Unit - Space",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1028.png",
                "isHorizontal": false
            }
        },
        "name": "Raddus, Holdo's Final Command",
        "type": "Unit - Space",
        "cost": 7,
        "rarity": "Rare",
        "power": 8,
        "HP": 6,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_104": {
        "id": "JTL_104",
        "face": {
            "front": {
                "name": "Raddus, Holdo's Final Command",
                "type": "Unit - Space",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/JTL/104.png",
                "isHorizontal": false
            }
        },
        "name": "Raddus, Holdo's Final Command",
        "type": "Unit - Space",
        "cost": 7,
        "rarity": "Rare",
        "power": 8,
        "HP": 6,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_366": {
        "id": "JTL_366",
        "face": {
            "front": {
                "name": "Raddus, Holdo's Final Command",
                "type": "Unit - Space",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/JTL/366.png",
                "isHorizontal": false
            }
        },
        "name": "Raddus, Holdo's Final Command",
        "type": "Unit - Space",
        "cost": 7,
        "rarity": "Rare",
        "power": 8,
        "HP": 6,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_1045": {
        "id": "JTL_1045",
        "face": {
            "front": {
                "name": "Radiant VII, Ambassadors' Arrival",
                "type": "Unit - Space",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1045.png",
                "isHorizontal": false
            }
        },
        "name": "Radiant VII, Ambassadors' Arrival",
        "type": "Unit - Space",
        "cost": 7,
        "rarity": "Legendary",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_226": {
        "id": "JTL_226",
        "face": {
            "front": {
                "name": "Radiant VII, Ambassadors' Arrival",
                "type": "Unit - Space",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/JTL/226.png",
                "isHorizontal": false
            }
        },
        "name": "Radiant VII, Ambassadors' Arrival",
        "type": "Unit - Space",
        "cost": 7,
        "rarity": "Legendary",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_488": {
        "id": "JTL_488",
        "face": {
            "front": {
                "name": "Radiant VII, Ambassadors' Arrival",
                "type": "Unit - Space",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/JTL/488.png",
                "isHorizontal": false
            }
        },
        "name": "Radiant VII, Ambassadors' Arrival",
        "type": "Unit - Space",
        "cost": 7,
        "rarity": "Legendary",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_219": {
        "id": "JTL_219",
        "face": {
            "front": {
                "name": "Rafa Martez, Shrewd Sister",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/219.png",
                "isHorizontal": false
            }
        },
        "name": "Rafa Martez, Shrewd Sister",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "JTL_481": {
        "id": "JTL_481",
        "face": {
            "front": {
                "name": "Rafa Martez, Shrewd Sister",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/481.png",
                "isHorizontal": false
            }
        },
        "name": "Rafa Martez, Shrewd Sister",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD"
        ]
    },
    "JTL_1037": {
        "id": "JTL_1037",
        "face": {
            "front": {
                "name": "Rampart, Enjoy the Exit",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1037.png",
                "isHorizontal": false
            }
        },
        "name": "Rampart, Enjoy the Exit",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Rare",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_182": {
        "id": "JTL_182",
        "face": {
            "front": {
                "name": "Rampart, Enjoy the Exit",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/182.png",
                "isHorizontal": false
            }
        },
        "name": "Rampart, Enjoy the Exit",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Rare",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_444": {
        "id": "JTL_444",
        "face": {
            "front": {
                "name": "Rampart, Enjoy the Exit",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/444.png",
                "isHorizontal": false
            }
        },
        "name": "Rampart, Enjoy the Exit",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Rare",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_1044": {
        "id": "JTL_1044",
        "face": {
            "front": {
                "name": "Razor Crest, Ride For Hire",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1044.png",
                "isHorizontal": false
            }
        },
        "name": "Razor Crest, Ride For Hire",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_223": {
        "id": "JTL_223",
        "face": {
            "front": {
                "name": "Razor Crest, Ride For Hire",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/223.png",
                "isHorizontal": false
            }
        },
        "name": "Razor Crest, Ride For Hire",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_485": {
        "id": "JTL_485",
        "face": {
            "front": {
                "name": "Razor Crest, Ride For Hire",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/485.png",
                "isHorizontal": false
            }
        },
        "name": "Razor Crest, Ride For Hire",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_153": {
        "id": "JTL_153",
        "face": {
            "front": {
                "name": "Rebellious Hammerhead",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/153.png",
                "isHorizontal": false
            }
        },
        "name": "Rebellious Hammerhead",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Common",
        "power": 5,
        "HP": 7,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_415": {
        "id": "JTL_415",
        "face": {
            "front": {
                "name": "Rebellious Hammerhead",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/415.png",
                "isHorizontal": false
            }
        },
        "name": "Rebellious Hammerhead",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Common",
        "power": 5,
        "HP": 7,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_1034": {
        "id": "JTL_1034",
        "face": {
            "front": {
                "name": "Red Five, Running the Trench",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1034.png",
                "isHorizontal": false
            }
        },
        "name": "Red Five, Running the Trench",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_151": {
        "id": "JTL_151",
        "face": {
            "front": {
                "name": "Red Five, Running the Trench",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/151.png",
                "isHorizontal": false
            }
        },
        "name": "Red Five, Running the Trench",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_413": {
        "id": "JTL_413",
        "face": {
            "front": {
                "name": "Red Five, Running the Trench",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/413.png",
                "isHorizontal": false
            }
        },
        "name": "Red Five, Running the Trench",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_101": {
        "id": "JTL_101",
        "face": {
            "front": {
                "name": "Red Leader, Form Up",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/101.png",
                "isHorizontal": false
            }
        },
        "name": "Red Leader, Form Up",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_1027": {
        "id": "JTL_1027",
        "face": {
            "front": {
                "name": "Red Leader, Form Up",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1027.png",
                "isHorizontal": false
            }
        },
        "name": "Red Leader, Form Up",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_363": {
        "id": "JTL_363",
        "face": {
            "front": {
                "name": "Red Leader, Form Up",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/363.png",
                "isHorizontal": false
            }
        },
        "name": "Red Leader, Form Up",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_051": {
        "id": "JTL_051",
        "face": {
            "front": {
                "name": "Red Squadron X-Wing",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/051.png",
                "isHorizontal": false
            }
        },
        "name": "Red Squadron X-Wing",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_313": {
        "id": "JTL_313",
        "face": {
            "front": {
                "name": "Red Squadron X-Wing",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/313.png",
                "isHorizontal": false
            }
        },
        "name": "Red Squadron X-Wing",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_149": {
        "id": "JTL_149",
        "face": {
            "front": {
                "name": "Red Squadron Y-Wing",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/149.png",
                "isHorizontal": false
            }
        },
        "name": "Red Squadron Y-Wing",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_411": {
        "id": "JTL_411",
        "face": {
            "front": {
                "name": "Red Squadron Y-Wing",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/411.png",
                "isHorizontal": false
            }
        },
        "name": "Red Squadron Y-Wing",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_157": {
        "id": "JTL_157",
        "face": {
            "front": {
                "name": "Relentless Firespray",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/157.png",
                "isHorizontal": false
            }
        },
        "name": "Relentless Firespray",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_419": {
        "id": "JTL_419",
        "face": {
            "front": {
                "name": "Relentless Firespray",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/419.png",
                "isHorizontal": false
            }
        },
        "name": "Relentless Firespray",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Rare",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Aggression",
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_075": {
        "id": "JTL_075",
        "face": {
            "front": {
                "name": "Repair",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/075.png",
                "isHorizontal": false
            }
        },
        "name": "Repair",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "JTL_337": {
        "id": "JTL_337",
        "face": {
            "front": {
                "name": "Repair",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/337.png",
                "isHorizontal": false
            }
        },
        "name": "Repair",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "JTL_212": {
        "id": "JTL_212",
        "face": {
            "front": {
                "name": "Republic Y-Wing",
                "type": "Unit - Space",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/212.png",
                "isHorizontal": false
            }
        },
        "name": "Republic Y-Wing",
        "type": "Unit - Space",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_474": {
        "id": "JTL_474",
        "face": {
            "front": {
                "name": "Republic Y-Wing",
                "type": "Unit - Space",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/474.png",
                "isHorizontal": false
            }
        },
        "name": "Republic Y-Wing",
        "type": "Unit - Space",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 3,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_102": {
        "id": "JTL_102",
        "face": {
            "front": {
                "name": "Resistance Blue Squadron",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/102.png",
                "isHorizontal": false
            }
        },
        "name": "Resistance Blue Squadron",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "RESISTANCE",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_364": {
        "id": "JTL_364",
        "face": {
            "front": {
                "name": "Resistance Blue Squadron",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/364.png",
                "isHorizontal": false
            }
        },
        "name": "Resistance Blue Squadron",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Common",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "RESISTANCE",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_022": {
        "id": "JTL_022",
        "face": {
            "front": {
                "name": "Resistance Headquarters, D'Qar",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/022-r.png",
                "isHorizontal": true
            }
        },
        "name": "Resistance Headquarters, D'Qar",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": []
    },
    "JTL_284": {
        "id": "JTL_284",
        "face": {
            "front": {
                "name": "Resistance Headquarters, D'Qar",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/284-r.png",
                "isHorizontal": true
            }
        },
        "name": "Resistance Headquarters, D'Qar",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": []
    },
    "JTL_247": {
        "id": "JTL_247",
        "face": {
            "front": {
                "name": "Resistance X-Wing",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/247.png",
                "isHorizontal": false
            }
        },
        "name": "Resistance X-Wing",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "RESISTANCE",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_509": {
        "id": "JTL_509",
        "face": {
            "front": {
                "name": "Resistance X-Wing",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/509.png",
                "isHorizontal": false
            }
        },
        "name": "Resistance X-Wing",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "RESISTANCE",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_119": {
        "id": "JTL_119",
        "face": {
            "front": {
                "name": "Resupply Carrier",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/119.png",
                "isHorizontal": false
            }
        },
        "name": "Resupply Carrier",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_381": {
        "id": "JTL_381",
        "face": {
            "front": {
                "name": "Resupply Carrier",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/381.png",
                "isHorizontal": false
            }
        },
        "name": "Resupply Carrier",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Common",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_259": {
        "id": "JTL_259",
        "face": {
            "front": {
                "name": "Retrofitted Airspeeder",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/259.png",
                "isHorizontal": false
            }
        },
        "name": "Retrofitted Airspeeder",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 6,
        "aspects": [],
        "unique": false,
        "traits": [
            "VEHICLE",
            "SPEEDER"
        ]
    },
    "JTL_521": {
        "id": "JTL_521",
        "face": {
            "front": {
                "name": "Retrofitted Airspeeder",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/521.png",
                "isHorizontal": false
            }
        },
        "name": "Retrofitted Airspeeder",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 6,
        "aspects": [],
        "unique": false,
        "traits": [
            "VEHICLE",
            "SPEEDER"
        ]
    },
    "JTL_015": {
        "id": "JTL_015",
        "face": {
            "front": {
                "name": "Rio Durant, Wisecracking Wheelman",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/015-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Rio Durant, Wisecracking Wheelman",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/JTL/015-b.png"
            }
        },
        "name": "Rio Durant, Wisecracking Wheelman",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "PILOT"
        ]
    },
    "JTL_1011": {
        "id": "JTL_1011",
        "face": {
            "front": {
                "name": "Rio Durant, Wisecracking Wheelman",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1011-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Rio Durant, Wisecracking Wheelman",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/JTL/1011-b.png"
            }
        },
        "name": "Rio Durant, Wisecracking Wheelman",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "PILOT"
        ]
    },
    "JTL_277": {
        "id": "JTL_277",
        "face": {
            "front": {
                "name": "Rio Durant, Wisecracking Wheelman",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/277-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Rio Durant, Wisecracking Wheelman",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/JTL/277-b.png"
            }
        },
        "name": "Rio Durant, Wisecracking Wheelman",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "PILOT"
        ]
    },
    "JTL_241": {
        "id": "JTL_241",
        "face": {
            "front": {
                "name": "Rogue-class Starfighter",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/241.png",
                "isHorizontal": false
            }
        },
        "name": "Rogue-class Starfighter",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Common",
        "power": 4,
        "HP": 3,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_503": {
        "id": "JTL_503",
        "face": {
            "front": {
                "name": "Rogue-class Starfighter",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/503.png",
                "isHorizontal": false
            }
        },
        "name": "Rogue-class Starfighter",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Common",
        "power": 4,
        "HP": 3,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_004": {
        "id": "JTL_004",
        "face": {
            "front": {
                "name": "Rose Tico, Saving What We Love",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/004-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Rose Tico, Saving What We Love",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/JTL/004-b.png"
            }
        },
        "name": "Rose Tico, Saving What We Love",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE"
        ]
    },
    "JTL_1000": {
        "id": "JTL_1000",
        "face": {
            "front": {
                "name": "Rose Tico, Saving What We Love",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1000-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Rose Tico, Saving What We Love",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/JTL/1000-b.png"
            }
        },
        "name": "Rose Tico, Saving What We Love",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE"
        ]
    },
    "JTL_266": {
        "id": "JTL_266",
        "face": {
            "front": {
                "name": "Rose Tico, Saving What We Love",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/266-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Rose Tico, Saving What We Love",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/JTL/266-b.png"
            }
        },
        "name": "Rose Tico, Saving What We Love",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE"
        ]
    },
    "JTL_061": {
        "id": "JTL_061",
        "face": {
            "front": {
                "name": "Royal Security Fighter",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/061.png",
                "isHorizontal": false
            }
        },
        "name": "Royal Security Fighter",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "NABOO",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_323": {
        "id": "JTL_323",
        "face": {
            "front": {
                "name": "Royal Security Fighter",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/323.png",
                "isHorizontal": false
            }
        },
        "name": "Royal Security Fighter",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "NABOO",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_1049": {
        "id": "JTL_1049",
        "face": {
            "front": {
                "name": "Sabine's Masterpiece, Crazy Colorful",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1049.png",
                "isHorizontal": false
            }
        },
        "name": "Sabine's Masterpiece, Crazy Colorful",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Rare",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER",
            "SPECTRE"
        ]
    },
    "JTL_250": {
        "id": "JTL_250",
        "face": {
            "front": {
                "name": "Sabine's Masterpiece, Crazy Colorful",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/250.png",
                "isHorizontal": false
            }
        },
        "name": "Sabine's Masterpiece, Crazy Colorful",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Rare",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER",
            "SPECTRE"
        ]
    },
    "JTL_512": {
        "id": "JTL_512",
        "face": {
            "front": {
                "name": "Sabine's Masterpiece, Crazy Colorful",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/512.png",
                "isHorizontal": false
            }
        },
        "name": "Sabine's Masterpiece, Crazy Colorful",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Rare",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "FIGHTER",
            "SPECTRE"
        ]
    },
    "JTL_121": {
        "id": "JTL_121",
        "face": {
            "front": {
                "name": "Salvage",
                "type": "Event",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/121.png",
                "isHorizontal": false
            }
        },
        "name": "Salvage",
        "type": "Event",
        "cost": 0,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "JTL_383": {
        "id": "JTL_383",
        "face": {
            "front": {
                "name": "Salvage",
                "type": "Event",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/383.png",
                "isHorizontal": false
            }
        },
        "name": "Salvage",
        "type": "Event",
        "cost": 0,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "JTL_110": {
        "id": "JTL_110",
        "face": {
            "front": {
                "name": "Scouting Headhunter",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/110.png",
                "isHorizontal": false
            }
        },
        "name": "Scouting Headhunter",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_372": {
        "id": "JTL_372",
        "face": {
            "front": {
                "name": "Scouting Headhunter",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/372.png",
                "isHorizontal": false
            }
        },
        "name": "Scouting Headhunter",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_092": {
        "id": "JTL_092",
        "face": {
            "front": {
                "name": "Scramble Fighters",
                "type": "Event",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/JTL/092.png",
                "isHorizontal": false
            }
        },
        "name": "Scramble Fighters",
        "type": "Event",
        "cost": 7,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "JTL_354": {
        "id": "JTL_354",
        "face": {
            "front": {
                "name": "Scramble Fighters",
                "type": "Event",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/JTL/354.png",
                "isHorizontal": false
            }
        },
        "name": "Scramble Fighters",
        "type": "Event",
        "cost": 7,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SUPPLY"
        ]
    },
    "JTL_111": {
        "id": "JTL_111",
        "face": {
            "front": {
                "name": "Seasoned Fleet Admiral",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/111.png",
                "isHorizontal": false
            }
        },
        "name": "Seasoned Fleet Admiral",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "TWI'LEK",
            "OFFICIAL"
        ]
    },
    "JTL_373": {
        "id": "JTL_373",
        "face": {
            "front": {
                "name": "Seasoned Fleet Admiral",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/373.png",
                "isHorizontal": false
            }
        },
        "name": "Seasoned Fleet Admiral",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 1,
        "HP": 4,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "TWI'LEK",
            "OFFICIAL"
        ]
    },
    "JTL_1036": {
        "id": "JTL_1036",
        "face": {
            "front": {
                "name": "Shadow Caster, Just Business",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1036.png",
                "isHorizontal": false
            }
        },
        "name": "Shadow Caster, Just Business",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Legendary",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Aggression"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_169": {
        "id": "JTL_169",
        "face": {
            "front": {
                "name": "Shadow Caster, Just Business",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/169.png",
                "isHorizontal": false
            }
        },
        "name": "Shadow Caster, Just Business",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Legendary",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Aggression"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_431": {
        "id": "JTL_431",
        "face": {
            "front": {
                "name": "Shadow Caster, Just Business",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/431.png",
                "isHorizontal": false
            }
        },
        "name": "Shadow Caster, Just Business",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Legendary",
        "power": 4,
        "HP": 7,
        "aspects": [
            "Aggression"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_224": {
        "id": "JTL_224",
        "face": {
            "front": {
                "name": "Shadowed Hover Tank",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/224.png",
                "isHorizontal": false
            }
        },
        "name": "Shadowed Hover Tank",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 5,
        "HP": 3,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "VEHICLE",
            "TANK"
        ]
    },
    "JTL_486": {
        "id": "JTL_486",
        "face": {
            "front": {
                "name": "Shadowed Hover Tank",
                "type": "Unit - Ground",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/486.png",
                "isHorizontal": false
            }
        },
        "name": "Shadowed Hover Tank",
        "type": "Unit - Ground",
        "cost": 4,
        "rarity": "Common",
        "power": 5,
        "HP": 3,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "VEHICLE",
            "TANK"
        ]
    },
    "JTL_020": {
        "id": "JTL_020",
        "face": {
            "front": {
                "name": "Shield Generator Complex, Endor",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/020-r.png",
                "isHorizontal": true
            }
        },
        "name": "Shield Generator Complex, Endor",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": []
    },
    "JTL_282": {
        "id": "JTL_282",
        "face": {
            "front": {
                "name": "Shield Generator Complex, Endor",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/282-r.png",
                "isHorizontal": true
            }
        },
        "name": "Shield Generator Complex, Endor",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": []
    },
    "JTL_176": {
        "id": "JTL_176",
        "face": {
            "front": {
                "name": "Shoot Down",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/176.png",
                "isHorizontal": false
            }
        },
        "name": "Shoot Down",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_438": {
        "id": "JTL_438",
        "face": {
            "front": {
                "name": "Shoot Down",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/438.png",
                "isHorizontal": false
            }
        },
        "name": "Shoot Down",
        "type": "Event",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_1047": {
        "id": "JTL_1047",
        "face": {
            "front": {
                "name": "Shuttle ST-149, Under Krennic's Authority",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1047.png",
                "isHorizontal": false
            }
        },
        "name": "Shuttle ST-149, Under Krennic's Authority",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_242": {
        "id": "JTL_242",
        "face": {
            "front": {
                "name": "Shuttle ST-149, Under Krennic's Authority",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/242.png",
                "isHorizontal": false
            }
        },
        "name": "Shuttle ST-149, Under Krennic's Authority",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_504": {
        "id": "JTL_504",
        "face": {
            "front": {
                "name": "Shuttle ST-149, Under Krennic's Authority",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/504.png",
                "isHorizontal": false
            }
        },
        "name": "Shuttle ST-149, Under Krennic's Authority",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_1042": {
        "id": "JTL_1042",
        "face": {
            "front": {
                "name": "Shuttle Tydirium, Fly Casual",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1042.png",
                "isHorizontal": false
            }
        },
        "name": "Shuttle Tydirium, Fly Casual",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Special",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_200": {
        "id": "JTL_200",
        "face": {
            "front": {
                "name": "Shuttle Tydirium, Fly Casual",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/200.png",
                "isHorizontal": false
            }
        },
        "name": "Shuttle Tydirium, Fly Casual",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Special",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_462": {
        "id": "JTL_462",
        "face": {
            "front": {
                "name": "Shuttle Tydirium, Fly Casual",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/462.png",
                "isHorizontal": false
            }
        },
        "name": "Shuttle Tydirium, Fly Casual",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Special",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Cunning",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_213": {
        "id": "JTL_213",
        "face": {
            "front": {
                "name": "Sidon Ithano, The Crimson Corsair",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/213.png",
                "isHorizontal": false
            }
        },
        "name": "Sidon Ithano, The Crimson Corsair",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "PILOT"
        ]
    },
    "JTL_475": {
        "id": "JTL_475",
        "face": {
            "front": {
                "name": "Sidon Ithano, The Crimson Corsair",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/475.png",
                "isHorizontal": false
            }
        },
        "name": "Sidon Ithano, The Crimson Corsair",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Rare",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "UNDERWORLD",
            "PILOT"
        ]
    },
    "JTL_062": {
        "id": "JTL_062",
        "face": {
            "front": {
                "name": "Silver Angel, Trace's Hope",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/062.png",
                "isHorizontal": false
            }
        },
        "name": "Silver Angel, Trace's Hope",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Vigilance"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_1022": {
        "id": "JTL_1022",
        "face": {
            "front": {
                "name": "Silver Angel, Trace's Hope",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1022.png",
                "isHorizontal": false
            }
        },
        "name": "Silver Angel, Trace's Hope",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Vigilance"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_324": {
        "id": "JTL_324",
        "face": {
            "front": {
                "name": "Silver Angel, Trace's Hope",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/324.png",
                "isHorizontal": false
            }
        },
        "name": "Silver Angel, Trace's Hope",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Vigilance"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_238": {
        "id": "JTL_238",
        "face": {
            "front": {
                "name": "Sith Trooper",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/238.png",
                "isHorizontal": false
            }
        },
        "name": "Sith Trooper",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "FIRST ORDER",
            "SITH",
            "TROOPER"
        ]
    },
    "JTL_500": {
        "id": "JTL_500",
        "face": {
            "front": {
                "name": "Sith Trooper",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/500.png",
                "isHorizontal": false
            }
        },
        "name": "Sith Trooper",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "FIRST ORDER",
            "SITH",
            "TROOPER"
        ]
    },
    "JTL_220": {
        "id": "JTL_220",
        "face": {
            "front": {
                "name": "Skyway Cloud Car",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/220.png",
                "isHorizontal": false
            }
        },
        "name": "Skyway Cloud Car",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_482": {
        "id": "JTL_482",
        "face": {
            "front": {
                "name": "Skyway Cloud Car",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/482.png",
                "isHorizontal": false
            }
        },
        "name": "Skyway Cloud Car",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 3,
        "HP": 3,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_098": {
        "id": "JTL_098",
        "face": {
            "front": {
                "name": "Snap Wexley, Resistance Recon Flier",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/098.png",
                "isHorizontal": false
            }
        },
        "name": "Snap Wexley, Resistance Recon Flier",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Rare",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE",
            "PILOT"
        ]
    },
    "JTL_360": {
        "id": "JTL_360",
        "face": {
            "front": {
                "name": "Snap Wexley, Resistance Recon Flier",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/360.png",
                "isHorizontal": false
            }
        },
        "name": "Snap Wexley, Resistance Recon Flier",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Rare",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "RESISTANCE",
            "PILOT"
        ]
    },
    "JTL_135": {
        "id": "JTL_135",
        "face": {
            "front": {
                "name": "Special Forces TIE Fighter",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/135.png",
                "isHorizontal": false
            }
        },
        "name": "Special Forces TIE Fighter",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "FIRST ORDER",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_397": {
        "id": "JTL_397",
        "face": {
            "front": {
                "name": "Special Forces TIE Fighter",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/397.png",
                "isHorizontal": false
            }
        },
        "name": "Special Forces TIE Fighter",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "FIRST ORDER",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_177": {
        "id": "JTL_177",
        "face": {
            "front": {
                "name": "Stay on Target",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/177.png",
                "isHorizontal": false
            }
        },
        "name": "Stay on Target",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_439": {
        "id": "JTL_439",
        "face": {
            "front": {
                "name": "Stay on Target",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/439.png",
                "isHorizontal": false
            }
        },
        "name": "Stay on Target",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_221": {
        "id": "JTL_221",
        "face": {
            "front": {
                "name": "Stolen AT-Hauler",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/221.png",
                "isHorizontal": false
            }
        },
        "name": "Stolen AT-Hauler",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Legendary",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_483": {
        "id": "JTL_483",
        "face": {
            "front": {
                "name": "Stolen AT-Hauler",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/483.png",
                "isHorizontal": false
            }
        },
        "name": "Stolen AT-Hauler",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Legendary",
        "power": 4,
        "HP": 5,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_255": {
        "id": "JTL_255",
        "face": {
            "front": {
                "name": "Sullustan Spacer",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/255.png",
                "isHorizontal": false
            }
        },
        "name": "Sullustan Spacer",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 1,
        "aspects": [],
        "unique": false,
        "traits": [
            "FRINGE",
            "PILOT"
        ]
    },
    "JTL_517": {
        "id": "JTL_517",
        "face": {
            "front": {
                "name": "Sullustan Spacer",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/517.png",
                "isHorizontal": false
            }
        },
        "name": "Sullustan Spacer",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 1,
        "aspects": [],
        "unique": false,
        "traits": [
            "FRINGE",
            "PILOT"
        ]
    },
    "JTL_227": {
        "id": "JTL_227",
        "face": {
            "front": {
                "name": "Superheavy Ion Cannon",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/227.png",
                "isHorizontal": false
            }
        },
        "name": "Superheavy Ion Cannon",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "MODIFICATION",
            "WEAPON"
        ]
    },
    "JTL_489": {
        "id": "JTL_489",
        "face": {
            "front": {
                "name": "Superheavy Ion Cannon",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/489.png",
                "isHorizontal": false
            }
        },
        "name": "Superheavy Ion Cannon",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "MODIFICATION",
            "WEAPON"
        ]
    },
    "JTL_160": {
        "id": "JTL_160",
        "face": {
            "front": {
                "name": "Supporting Eta-2",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/160.png",
                "isHorizontal": false
            }
        },
        "name": "Supporting Eta-2",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_422": {
        "id": "JTL_422",
        "face": {
            "front": {
                "name": "Supporting Eta-2",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/422.png",
                "isHorizontal": false
            }
        },
        "name": "Supporting Eta-2",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_256": {
        "id": "JTL_256",
        "face": {
            "front": {
                "name": "Swarming Vulture Droid",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/256.png",
                "isHorizontal": false
            }
        },
        "name": "Swarming Vulture Droid",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_518": {
        "id": "JTL_518",
        "face": {
            "front": {
                "name": "Swarming Vulture Droid",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/518.png",
                "isHorizontal": false
            }
        },
        "name": "Swarming Vulture Droid",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "DROID",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_233": {
        "id": "JTL_233",
        "face": {
            "front": {
                "name": "Sweep the Area",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/233.png",
                "isHorizontal": false
            }
        },
        "name": "Sweep the Area",
        "type": "Event",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_495": {
        "id": "JTL_495",
        "face": {
            "front": {
                "name": "Sweep the Area",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/495.png",
                "isHorizontal": false
            }
        },
        "name": "Sweep the Area",
        "type": "Event",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_175": {
        "id": "JTL_175",
        "face": {
            "front": {
                "name": "System Shock",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/175.png",
                "isHorizontal": false
            }
        },
        "name": "System Shock",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_437": {
        "id": "JTL_437",
        "face": {
            "front": {
                "name": "System Shock",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/437.png",
                "isHorizontal": false
            }
        },
        "name": "System Shock",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_087": {
        "id": "JTL_087",
        "face": {
            "front": {
                "name": "TIE Ambush Squadron",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/087.png",
                "isHorizontal": false
            }
        },
        "name": "TIE Ambush Squadron",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_349": {
        "id": "JTL_349",
        "face": {
            "front": {
                "name": "TIE Ambush Squadron",
                "type": "Unit - Space",
                "cost": 4,
                "image": "https://cdn.swu-db.com/images/cards/JTL/349.png",
                "isHorizontal": false
            }
        },
        "name": "TIE Ambush Squadron",
        "type": "Unit - Space",
        "cost": 4,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_237": {
        "id": "JTL_237",
        "face": {
            "front": {
                "name": "TIE Bomber",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/237.png",
                "isHorizontal": false
            }
        },
        "name": "TIE Bomber",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 4,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_499": {
        "id": "JTL_499",
        "face": {
            "front": {
                "name": "TIE Bomber",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/499.png",
                "isHorizontal": false
            }
        },
        "name": "TIE Bomber",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 4,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_239": {
        "id": "JTL_239",
        "face": {
            "front": {
                "name": "TIE Dagger Vanguard",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/239.png",
                "isHorizontal": false
            }
        },
        "name": "TIE Dagger Vanguard",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "FIRST ORDER",
            "SITH",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_501": {
        "id": "JTL_501",
        "face": {
            "front": {
                "name": "TIE Dagger Vanguard",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/501.png",
                "isHorizontal": false
            }
        },
        "name": "TIE Dagger Vanguard",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "FIRST ORDER",
            "SITH",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_152": {
        "id": "JTL_152",
        "face": {
            "front": {
                "name": "Tactical Heavy Bomber",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/152.png",
                "isHorizontal": false
            }
        },
        "name": "Tactical Heavy Bomber",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Rare",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "RESISTANCE",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_414": {
        "id": "JTL_414",
        "face": {
            "front": {
                "name": "Tactical Heavy Bomber",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/414.png",
                "isHorizontal": false
            }
        },
        "name": "Tactical Heavy Bomber",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Rare",
        "power": 3,
        "HP": 5,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "RESISTANCE",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_035": {
        "id": "JTL_035",
        "face": {
            "front": {
                "name": "Tam Ryvora",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/035.png",
                "isHorizontal": false
            }
        },
        "name": "Tam Ryvora",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Rare",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "FIRST ORDER",
            "PILOT"
        ]
    },
    "JTL_297": {
        "id": "JTL_297",
        "face": {
            "front": {
                "name": "Tam Ryvora",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/297.png",
                "isHorizontal": false
            }
        },
        "name": "Tam Ryvora",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Rare",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Vigilance",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "FIRST ORDER",
            "PILOT"
        ]
    },
    "JTL_124": {
        "id": "JTL_124",
        "face": {
            "front": {
                "name": "Tandem Assault",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/124.png",
                "isHorizontal": false
            }
        },
        "name": "Tandem Assault",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_386": {
        "id": "JTL_386",
        "face": {
            "front": {
                "name": "Tandem Assault",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/386.png",
                "isHorizontal": false
            }
        },
        "name": "Tandem Assault",
        "type": "Event",
        "cost": 1,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_1050": {
        "id": "JTL_1050",
        "face": {
            "front": {
                "name": "Tantive IV, Fleeing the Empire",
                "type": "Unit - Space",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1050.png",
                "isHorizontal": false
            }
        },
        "name": "Tantive IV, Fleeing the Empire",
        "type": "Unit - Space",
        "cost": 7,
        "rarity": "Uncommon",
        "power": 5,
        "HP": 7,
        "aspects": [
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_252": {
        "id": "JTL_252",
        "face": {
            "front": {
                "name": "Tantive IV, Fleeing the Empire",
                "type": "Unit - Space",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/JTL/252.png",
                "isHorizontal": false
            }
        },
        "name": "Tantive IV, Fleeing the Empire",
        "type": "Unit - Space",
        "cost": 7,
        "rarity": "Uncommon",
        "power": 5,
        "HP": 7,
        "aspects": [
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_514": {
        "id": "JTL_514",
        "face": {
            "front": {
                "name": "Tantive IV, Fleeing the Empire",
                "type": "Unit - Space",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/JTL/514.png",
                "isHorizontal": false
            }
        },
        "name": "Tantive IV, Fleeing the Empire",
        "type": "Unit - Space",
        "cost": 7,
        "rarity": "Uncommon",
        "power": 5,
        "HP": 7,
        "aspects": [
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_171": {
        "id": "JTL_171",
        "face": {
            "front": {
                "name": "Targeting Computer",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/171.png",
                "isHorizontal": false
            }
        },
        "name": "Targeting Computer",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "ITEM",
            "MODIFICATION"
        ]
    },
    "JTL_433": {
        "id": "JTL_433",
        "face": {
            "front": {
                "name": "Targeting Computer",
                "type": "Upgrade",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/433.png",
                "isHorizontal": false
            }
        },
        "name": "Targeting Computer",
        "type": "Upgrade",
        "cost": 1,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "ITEM",
            "MODIFICATION"
        ]
    },
    "JTL_190": {
        "id": "JTL_190",
        "face": {
            "front": {
                "name": "Techno Union Transport",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/190.png",
                "isHorizontal": false
            }
        },
        "name": "Techno Union Transport",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_452": {
        "id": "JTL_452",
        "face": {
            "front": {
                "name": "Techno Union Transport",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/452.png",
                "isHorizontal": false
            }
        },
        "name": "Techno Union Transport",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Common",
        "power": 4,
        "HP": 6,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_053": {
        "id": "JTL_053",
        "face": {
            "front": {
                "name": "The Ghost, Heart of the Family",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/053.png",
                "isHorizontal": false
            }
        },
        "name": "The Ghost, Heart of the Family",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Legendary",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "TRANSPORT",
            "SPECTRE"
        ]
    },
    "JTL_1020": {
        "id": "JTL_1020",
        "face": {
            "front": {
                "name": "The Ghost, Heart of the Family",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1020.png",
                "isHorizontal": false
            }
        },
        "name": "The Ghost, Heart of the Family",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Legendary",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "TRANSPORT",
            "SPECTRE"
        ]
    },
    "JTL_315": {
        "id": "JTL_315",
        "face": {
            "front": {
                "name": "The Ghost, Heart of the Family",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/315.png",
                "isHorizontal": false
            }
        },
        "name": "The Ghost, Heart of the Family",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Legendary",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "VEHICLE",
            "TRANSPORT",
            "SPECTRE"
        ]
    },
    "JTL_089": {
        "id": "JTL_089",
        "face": {
            "front": {
                "name": "The Invisible Hand, Crawling With Vultures",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/089.png",
                "isHorizontal": false
            }
        },
        "name": "The Invisible Hand, Crawling With Vultures",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Rare",
        "power": 6,
        "HP": 6,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_1024": {
        "id": "JTL_1024",
        "face": {
            "front": {
                "name": "The Invisible Hand, Crawling With Vultures",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1024.png",
                "isHorizontal": false
            }
        },
        "name": "The Invisible Hand, Crawling With Vultures",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Rare",
        "power": 6,
        "HP": 6,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_351": {
        "id": "JTL_351",
        "face": {
            "front": {
                "name": "The Invisible Hand, Crawling With Vultures",
                "type": "Unit - Space",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/351.png",
                "isHorizontal": false
            }
        },
        "name": "The Invisible Hand, Crawling With Vultures",
        "type": "Unit - Space",
        "cost": 6,
        "rarity": "Rare",
        "power": 6,
        "HP": 6,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "SEPARATIST",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_210": {
        "id": "JTL_210",
        "face": {
            "front": {
                "name": "The Mandalorian, Weathered Pilot",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/210.png",
                "isHorizontal": false
            }
        },
        "name": "The Mandalorian, Weathered Pilot",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Cunning",
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "BOUNTY HUNTER",
            "PILOT"
        ]
    },
    "JTL_472": {
        "id": "JTL_472",
        "face": {
            "front": {
                "name": "The Mandalorian, Weathered Pilot",
                "type": "Unit - Ground",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/472.png",
                "isHorizontal": false
            }
        },
        "name": "The Mandalorian, Weathered Pilot",
        "type": "Unit - Ground",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 5,
        "HP": 6,
        "aspects": [
            "Cunning",
            "Cunning"
        ],
        "unique": true,
        "traits": [
            "MANDALORIAN",
            "BOUNTY HUNTER",
            "PILOT"
        ]
    },
    "JTL_1029": {
        "id": "JTL_1029",
        "face": {
            "front": {
                "name": "The Starhawk, Prototype Battleship",
                "type": "Unit - Space",
                "cost": 9,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1029.png",
                "isHorizontal": false
            }
        },
        "name": "The Starhawk, Prototype Battleship",
        "type": "Unit - Space",
        "cost": 9,
        "rarity": "Legendary",
        "power": 6,
        "HP": 9,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "NEW REPUBLIC",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_105": {
        "id": "JTL_105",
        "face": {
            "front": {
                "name": "The Starhawk, Prototype Battleship",
                "type": "Unit - Space",
                "cost": 9,
                "image": "https://cdn.swu-db.com/images/cards/JTL/105.png",
                "isHorizontal": false
            }
        },
        "name": "The Starhawk, Prototype Battleship",
        "type": "Unit - Space",
        "cost": 9,
        "rarity": "Legendary",
        "power": 6,
        "HP": 9,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "NEW REPUBLIC",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_367": {
        "id": "JTL_367",
        "face": {
            "front": {
                "name": "The Starhawk, Prototype Battleship",
                "type": "Unit - Space",
                "cost": 9,
                "image": "https://cdn.swu-db.com/images/cards/JTL/367.png",
                "isHorizontal": false
            }
        },
        "name": "The Starhawk, Prototype Battleship",
        "type": "Unit - Space",
        "cost": 9,
        "rarity": "Legendary",
        "power": 6,
        "HP": 9,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "NEW REPUBLIC",
            "VEHICLE",
            "CAPITAL SHIP"
        ]
    },
    "JTL_023": {
        "id": "JTL_023",
        "face": {
            "front": {
                "name": "Theed Palace, Naboo",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/023-r.png",
                "isHorizontal": true
            }
        },
        "name": "Theed Palace, Naboo",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": []
    },
    "JTL_285": {
        "id": "JTL_285",
        "face": {
            "front": {
                "name": "Theed Palace, Naboo",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/285-r.png",
                "isHorizontal": true
            }
        },
        "name": "Theed Palace, Naboo",
        "type": "Base",
        "cost": 0,
        "rarity": "Common",
        "power": 0,
        "HP": 30,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": []
    },
    "JTL_244": {
        "id": "JTL_244",
        "face": {
            "front": {
                "name": "There Is No Escape",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/244.png",
                "isHorizontal": false
            }
        },
        "name": "There Is No Escape",
        "type": "Event",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_506": {
        "id": "JTL_506",
        "face": {
            "front": {
                "name": "There Is No Escape",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/506.png",
                "isHorizontal": false
            }
        },
        "name": "There Is No Escape",
        "type": "Event",
        "cost": 2,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_025": {
        "id": "JTL_025",
        "face": {
            "front": {
                "name": "Thermal Oscillator, Starkiller Base",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/025-r.png",
                "isHorizontal": true
            }
        },
        "name": "Thermal Oscillator, Starkiller Base",
        "type": "Base",
        "cost": 0,
        "rarity": "Rare",
        "power": 0,
        "HP": 27,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": []
    },
    "JTL_287": {
        "id": "JTL_287",
        "face": {
            "front": {
                "name": "Thermal Oscillator, Starkiller Base",
                "type": "Base",
                "cost": 0,
                "image": "https://cdn.swu-db.com/images/cards/JTL/287-r.png",
                "isHorizontal": true
            }
        },
        "name": "Thermal Oscillator, Starkiller Base",
        "type": "Base",
        "cost": 0,
        "rarity": "Rare",
        "power": 0,
        "HP": 27,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": []
    },
    "JTL_155": {
        "id": "JTL_155",
        "face": {
            "front": {
                "name": "They Hate That Ship",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/155.png",
                "isHorizontal": false
            }
        },
        "name": "They Hate That Ship",
        "type": "Event",
        "cost": 1,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "JTL_417": {
        "id": "JTL_417",
        "face": {
            "front": {
                "name": "They Hate That Ship",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/417.png",
                "isHorizontal": false
            }
        },
        "name": "They Hate That Ship",
        "type": "Event",
        "cost": 1,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "INNATE"
        ]
    },
    "JTL_130": {
        "id": "JTL_130",
        "face": {
            "front": {
                "name": "Timely Reinforcements",
                "type": "Event",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/130.png",
                "isHorizontal": false
            }
        },
        "name": "Timely Reinforcements",
        "type": "Event",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_392": {
        "id": "JTL_392",
        "face": {
            "front": {
                "name": "Timely Reinforcements",
                "type": "Event",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/392.png",
                "isHorizontal": false
            }
        },
        "name": "Timely Reinforcements",
        "type": "Event",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_234": {
        "id": "JTL_234",
        "face": {
            "front": {
                "name": "Torpedo Barrage",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/234.png",
                "isHorizontal": false
            }
        },
        "name": "Torpedo Barrage",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_496": {
        "id": "JTL_496",
        "face": {
            "front": {
                "name": "Torpedo Barrage",
                "type": "Event",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/496.png",
                "isHorizontal": false
            }
        },
        "name": "Torpedo Barrage",
        "type": "Event",
        "cost": 3,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_066": {
        "id": "JTL_066",
        "face": {
            "front": {
                "name": "Trace Martez, Trusting Sister",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/066.png",
                "isHorizontal": false
            }
        },
        "name": "Trace Martez, Trusting Sister",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Vigilance"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "PILOT"
        ]
    },
    "JTL_328": {
        "id": "JTL_328",
        "face": {
            "front": {
                "name": "Trace Martez, Trusting Sister",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/328.png",
                "isHorizontal": false
            }
        },
        "name": "Trace Martez, Trusting Sister",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 5,
        "aspects": [
            "Vigilance"
        ],
        "unique": true,
        "traits": [
            "FRINGE",
            "PILOT"
        ]
    },
    "JTL_156": {
        "id": "JTL_156",
        "face": {
            "front": {
                "name": "Trench Run",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/156.png",
                "isHorizontal": false
            }
        },
        "name": "Trench Run",
        "type": "Event",
        "cost": 1,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "JTL_418": {
        "id": "JTL_418",
        "face": {
            "front": {
                "name": "Trench Run",
                "type": "Event",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/418.png",
                "isHorizontal": false
            }
        },
        "name": "Trench Run",
        "type": "Event",
        "cost": 1,
        "rarity": "Rare",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "JTL_131": {
        "id": "JTL_131",
        "face": {
            "front": {
                "name": "Turbolaser Salvo",
                "type": "Event",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/JTL/131.png",
                "isHorizontal": false
            }
        },
        "name": "Turbolaser Salvo",
        "type": "Event",
        "cost": 7,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_393": {
        "id": "JTL_393",
        "face": {
            "front": {
                "name": "Turbolaser Salvo",
                "type": "Event",
                "cost": 7,
                "image": "https://cdn.swu-db.com/images/cards/JTL/393.png",
                "isHorizontal": false
            }
        },
        "name": "Turbolaser Salvo",
        "type": "Event",
        "cost": 7,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command"
        ],
        "unique": false,
        "traits": [
            "TACTIC"
        ]
    },
    "JTL_172": {
        "id": "JTL_172",
        "face": {
            "front": {
                "name": "Twin Laser Turret",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/172.png",
                "isHorizontal": false
            }
        },
        "name": "Twin Laser Turret",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "MODIFICATION",
            "WEAPON"
        ]
    },
    "JTL_434": {
        "id": "JTL_434",
        "face": {
            "front": {
                "name": "Twin Laser Turret",
                "type": "Upgrade",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/434.png",
                "isHorizontal": false
            }
        },
        "name": "Twin Laser Turret",
        "type": "Upgrade",
        "cost": 2,
        "rarity": "Common",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "MODIFICATION",
            "WEAPON"
        ]
    },
    "JTL_070": {
        "id": "JTL_070",
        "face": {
            "front": {
                "name": "U-Wing Lander",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/070.png",
                "isHorizontal": false
            }
        },
        "name": "U-Wing Lander",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_332": {
        "id": "JTL_332",
        "face": {
            "front": {
                "name": "U-Wing Lander",
                "type": "Unit - Space",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/332.png",
                "isHorizontal": false
            }
        },
        "name": "U-Wing Lander",
        "type": "Unit - Space",
        "cost": 5,
        "rarity": "Uncommon",
        "power": 2,
        "HP": 2,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "REBEL",
            "VEHICLE",
            "TRANSPORT"
        ]
    },
    "JTL_106": {
        "id": "JTL_106",
        "face": {
            "front": {
                "name": "Unity of Purpose",
                "type": "Event",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/106.png",
                "isHorizontal": false
            }
        },
        "name": "Unity of Purpose",
        "type": "Event",
        "cost": 6,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Command"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "JTL_368": {
        "id": "JTL_368",
        "face": {
            "front": {
                "name": "Unity of Purpose",
                "type": "Event",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/368.png",
                "isHorizontal": false
            }
        },
        "name": "Unity of Purpose",
        "type": "Event",
        "cost": 6,
        "rarity": "Legendary",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Command",
            "Command"
        ],
        "unique": false,
        "traits": [
            "PLAN"
        ]
    },
    "JTL_099": {
        "id": "JTL_099",
        "face": {
            "front": {
                "name": "Veteran Fleet Officer",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/099.png",
                "isHorizontal": false
            }
        },
        "name": "Veteran Fleet Officer",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "RESISTANCE"
        ]
    },
    "JTL_361": {
        "id": "JTL_361",
        "face": {
            "front": {
                "name": "Veteran Fleet Officer",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/361.png",
                "isHorizontal": false
            }
        },
        "name": "Veteran Fleet Officer",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Common",
        "power": 2,
        "HP": 1,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "RESISTANCE"
        ]
    },
    "JTL_085": {
        "id": "JTL_085",
        "face": {
            "front": {
                "name": "Victor Leader, Leading From the Front",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/085.png",
                "isHorizontal": false
            }
        },
        "name": "Victor Leader, Leading From the Front",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Rare",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_1023": {
        "id": "JTL_1023",
        "face": {
            "front": {
                "name": "Victor Leader, Leading From the Front",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1023.png",
                "isHorizontal": false
            }
        },
        "name": "Victor Leader, Leading From the Front",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Rare",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_347": {
        "id": "JTL_347",
        "face": {
            "front": {
                "name": "Victor Leader, Leading From the Front",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/347.png",
                "isHorizontal": false
            }
        },
        "name": "Victor Leader, Leading From the Front",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Rare",
        "power": 2,
        "HP": 4,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_1030": {
        "id": "JTL_1030",
        "face": {
            "front": {
                "name": "Vonreg's TIE Interceptor, Ace of the First Order",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1030.png",
                "isHorizontal": false
            }
        },
        "name": "Vonreg's TIE Interceptor, Ace of the First Order",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FIRST ORDER",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_137": {
        "id": "JTL_137",
        "face": {
            "front": {
                "name": "Vonreg's TIE Interceptor, Ace of the First Order",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/137.png",
                "isHorizontal": false
            }
        },
        "name": "Vonreg's TIE Interceptor, Ace of the First Order",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FIRST ORDER",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_399": {
        "id": "JTL_399",
        "face": {
            "front": {
                "name": "Vonreg's TIE Interceptor, Ace of the First Order",
                "type": "Unit - Space",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/399.png",
                "isHorizontal": false
            }
        },
        "name": "Vonreg's TIE Interceptor, Ace of the First Order",
        "type": "Unit - Space",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 4,
        "aspects": [
            "Aggression",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "FIRST ORDER",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_170": {
        "id": "JTL_170",
        "face": {
            "front": {
                "name": "War Juggernaut",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/170.png",
                "isHorizontal": false
            }
        },
        "name": "War Juggernaut",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 7,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "TANK"
        ]
    },
    "JTL_432": {
        "id": "JTL_432",
        "face": {
            "front": {
                "name": "War Juggernaut",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/432.png",
                "isHorizontal": false
            }
        },
        "name": "War Juggernaut",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 7,
        "aspects": [
            "Aggression"
        ],
        "unique": false,
        "traits": [
            "REPUBLIC",
            "VEHICLE",
            "TANK"
        ]
    },
    "JTL_008": {
        "id": "JTL_008",
        "face": {
            "front": {
                "name": "Wedge Antilles, Leader of Red Squadron",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/008-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Wedge Antilles, Leader of Red Squadron",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/JTL/008-b.png"
            }
        },
        "name": "Wedge Antilles, Leader of Red Squadron",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "PILOT"
        ]
    },
    "JTL_1004": {
        "id": "JTL_1004",
        "face": {
            "front": {
                "name": "Wedge Antilles, Leader of Red Squadron",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/1004-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Wedge Antilles, Leader of Red Squadron",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/JTL/1004-b.png"
            }
        },
        "name": "Wedge Antilles, Leader of Red Squadron",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "PILOT"
        ]
    },
    "JTL_270": {
        "id": "JTL_270",
        "face": {
            "front": {
                "name": "Wedge Antilles, Leader of Red Squadron",
                "type": "Leader",
                "cost": 5,
                "image": "https://cdn.swu-db.com/images/cards/JTL/270-r.png",
                "isHorizontal": true
            },
            "back": {
                "name": "Wedge Antilles, Leader of Red Squadron",
                "type": "Leader",
                "cost": "5",
                "image": "https://cdn.swu-db.com/images/cards/JTL/270-b.png"
            }
        },
        "name": "Wedge Antilles, Leader of Red Squadron",
        "type": "Leader",
        "cost": 5,
        "rarity": "Common",
        "power": 3,
        "HP": 6,
        "aspects": [
            "Command",
            "Heroism"
        ],
        "unique": true,
        "traits": [
            "REBEL",
            "PILOT"
        ]
    },
    "JTL_072": {
        "id": "JTL_072",
        "face": {
            "front": {
                "name": "Wing Guard Security Team",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/072.png",
                "isHorizontal": false
            }
        },
        "name": "Wing Guard Security Team",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "TROOPER"
        ]
    },
    "JTL_334": {
        "id": "JTL_334",
        "face": {
            "front": {
                "name": "Wing Guard Security Team",
                "type": "Unit - Ground",
                "cost": 6,
                "image": "https://cdn.swu-db.com/images/cards/JTL/334.png",
                "isHorizontal": false
            }
        },
        "name": "Wing Guard Security Team",
        "type": "Unit - Ground",
        "cost": 6,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 4,
        "aspects": [
            "Vigilance"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "TROOPER"
        ]
    },
    "JTL_086": {
        "id": "JTL_086",
        "face": {
            "front": {
                "name": "Wingman Victor Three, Backstabber",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/086.png",
                "isHorizontal": false
            }
        },
        "name": "Wingman Victor Three, Backstabber",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 3,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "PILOT"
        ]
    },
    "JTL_348": {
        "id": "JTL_348",
        "face": {
            "front": {
                "name": "Wingman Victor Three, Backstabber",
                "type": "Unit - Ground",
                "cost": 3,
                "image": "https://cdn.swu-db.com/images/cards/JTL/348.png",
                "isHorizontal": false
            }
        },
        "name": "Wingman Victor Three, Backstabber",
        "type": "Unit - Ground",
        "cost": 3,
        "rarity": "Uncommon",
        "power": 4,
        "HP": 3,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "PILOT"
        ]
    },
    "JTL_084": {
        "id": "JTL_084",
        "face": {
            "front": {
                "name": "Wingman Victor Two, Mauler Mithel",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/084.png",
                "isHorizontal": false
            }
        },
        "name": "Wingman Victor Two, Mauler Mithel",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "PILOT"
        ]
    },
    "JTL_346": {
        "id": "JTL_346",
        "face": {
            "front": {
                "name": "Wingman Victor Two, Mauler Mithel",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/346.png",
                "isHorizontal": false
            }
        },
        "name": "Wingman Victor Two, Mauler Mithel",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 3,
        "HP": 2,
        "aspects": [
            "Command",
            "Villainy"
        ],
        "unique": true,
        "traits": [
            "IMPERIAL",
            "PILOT"
        ]
    },
    "JTL_214": {
        "id": "JTL_214",
        "face": {
            "front": {
                "name": "X-34 Landspeeder",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/214.png",
                "isHorizontal": false
            }
        },
        "name": "X-34 Landspeeder",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "VEHICLE",
            "SPEEDER"
        ]
    },
    "JTL_476": {
        "id": "JTL_476",
        "face": {
            "front": {
                "name": "X-34 Landspeeder",
                "type": "Unit - Ground",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/476.png",
                "isHorizontal": false
            }
        },
        "name": "X-34 Landspeeder",
        "type": "Unit - Ground",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Cunning"
        ],
        "unique": false,
        "traits": [
            "FRINGE",
            "VEHICLE",
            "SPEEDER"
        ]
    },
    "JTL_055": {
        "id": "JTL_055",
        "face": {
            "front": {
                "name": "You're All Clear, Kid",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/055.png",
                "isHorizontal": false
            }
        },
        "name": "You're All Clear, Kid",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "JTL_317": {
        "id": "JTL_317",
        "face": {
            "front": {
                "name": "You're All Clear, Kid",
                "type": "Event",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/317.png",
                "isHorizontal": false
            }
        },
        "name": "You're All Clear, Kid",
        "type": "Event",
        "cost": 2,
        "rarity": "Uncommon",
        "power": 0,
        "HP": 0,
        "aspects": [
            "Vigilance",
            "Heroism"
        ],
        "unique": false,
        "traits": [
            "GAMBIT"
        ]
    },
    "JTL_183": {
        "id": "JTL_183",
        "face": {
            "front": {
                "name": "Zygerrian Starhopper",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/183.png",
                "isHorizontal": false
            }
        },
        "name": "Zygerrian Starhopper",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_445": {
        "id": "JTL_445",
        "face": {
            "front": {
                "name": "Zygerrian Starhopper",
                "type": "Unit - Space",
                "cost": 2,
                "image": "https://cdn.swu-db.com/images/cards/JTL/445.png",
                "isHorizontal": false
            }
        },
        "name": "Zygerrian Starhopper",
        "type": "Unit - Space",
        "cost": 2,
        "rarity": "Common",
        "power": 2,
        "HP": 3,
        "aspects": [
            "Cunning",
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "UNDERWORLD",
            "VEHICLE",
            "FIGHTER"
        ]
    },
    "JTL_236": {
        "id": "JTL_236",
        "face": {
            "front": {
                "name": "indoctrinated Conscript",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/236.png",
                "isHorizontal": false
            }
        },
        "name": "indoctrinated Conscript",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 2,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "FIRST ORDER",
            "PILOT"
        ]
    },
    "JTL_498": {
        "id": "JTL_498",
        "face": {
            "front": {
                "name": "indoctrinated Conscript",
                "type": "Unit - Ground",
                "cost": 1,
                "image": "https://cdn.swu-db.com/images/cards/JTL/498.png",
                "isHorizontal": false
            }
        },
        "name": "indoctrinated Conscript",
        "type": "Unit - Ground",
        "cost": 1,
        "rarity": "Common",
        "power": 1,
        "HP": 2,
        "aspects": [
            "Villainy"
        ],
        "unique": false,
        "traits": [
            "FIRST ORDER",
            "PILOT"
        ]
    }
}

export const defaultCardDataTest = {
    "id": { type: "Text" },
    "isToken": { type: "Bool" },
    "face": {
        "name": { type: "Text" },
        "type": { type: "Select" },
        "cost": { type: "Number" },
        "image": { type: "Text" },
        "isHorizontal": { type: "Bool" }
    },
    "name": { type: "Text" },
    "type": { type: "Select" },
    "cost": { type: "Number" }
}